/* eslint-disable */
export function getMasterDataMock() {
  return {
    'Categories': [
      {
        'CategoryId': 10,
        'Name': '07 Feestdagen',
        'Order': 0,
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 1150,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1150.png',
            'Order': 418,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_suikerfeest',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:26:21',
            'Categories': [],
            'Created': '07/24/2017 15:26:21',
            'ProductTypes': []
          }
        ],
        'Fonts': [],
        'Stickers': [
          {
            'StickerId': 103,
            'Active': 1,
            'Order': 94,
            'Title': 'Snowflake',
            'ImagePath': 'stickers/sticker-103.png',
            'Size': '{Width=922, Height=1000}',
            'LastModified': '10/11/2022 14:35:16',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:40',
            'ProductTypes': []
          },
          {
            'StickerId': 106,
            'Active': 1,
            'Order': 97,
            'Title': 'Bat',
            'ImagePath': 'stickers/sticker-106.png',
            'Size': '{Width=1042, Height=315}',
            'LastModified': '10/11/2022 14:35:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:07',
            'ProductTypes': []
          },
          {
            'StickerId': 109,
            'Active': 1,
            'Order': 100,
            'Title': 'Pumpkin',
            'ImagePath': 'stickers/sticker-109.png',
            'Size': '{Width=1042, Height=763}',
            'LastModified': '10/11/2022 14:35:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:47',
            'ProductTypes': []
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'CategoryId': 11,
        'Name': '08 Vaderdag',
        'Order': 1,
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 933,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-933.png',
            'Order': 201,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:18:39',
            'Categories': [],
            'Created': '07/24/2017 13:18:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 935,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-935.png',
            'Order': 203,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:20:10',
            'Categories': [],
            'Created': '07/24/2017 13:20:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 937,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-937.png',
            'Order': 205,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:20:40',
            'Categories': [],
            'Created': '07/24/2017 13:20:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 939,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-939.png',
            'Order': 207,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:21:51',
            'Categories': [],
            'Created': '07/24/2017 13:21:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 941,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-941.png',
            'Order': 209,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:22:43',
            'Categories': [],
            'Created': '07/24/2017 13:22:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 942,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-942.png',
            'Order': 210,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:27:41',
            'Categories': [],
            'Created': '07/24/2017 13:23:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 965,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-965.png',
            'Order': 233,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:34:23',
            'Categories': [],
            'Created': '07/24/2017 13:33:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 983,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-983.png',
            'Order': 251,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:36:20',
            'Categories': [],
            'Created': '07/24/2017 13:36:20',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 988,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-988.png',
            'Order': 256,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:54',
            'Categories': [],
            'Created': '07/24/2017 13:36:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1059,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1059.png',
            'Order': 327,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_moederdag',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:06:55',
            'Categories': [],
            'Created': '07/24/2017 14:22:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1062,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1062.png',
            'Order': 330,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:06:37',
            'Categories': [],
            'Created': '07/24/2017 14:24:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1115,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1115.png',
            'Order': 383,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_moederdag',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:08:31',
            'Categories': [],
            'Created': '07/24/2017 15:08:31',
            'ProductTypes': []
          }
        ],
        'Fonts': [],
        'Stickers': [
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          }
        ]
      },
      {
        'CategoryId': 4,
        'Name': '01 Algemeen',
        'Order': 2,
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 734,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-734.png',
            'Order': 5,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_stip',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'LastModified': '03/09/2022 11:47:53',
            'Categories': [],
            'Created': '07/24/2017 10:13:52',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 736,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-736.png',
            'Order': 6,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:32:37',
            'Categories': [],
            'Created': '07/24/2017 10:15:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 737,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-737.png',
            'Order': 7,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:39:42',
            'Categories': [],
            'Created': '07/24/2017 10:27:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 738,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-738.png',
            'Order': 8,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:28:37',
            'Categories': [],
            'Created': '07/24/2017 10:28:37',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 739,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-739.png',
            'Order': 9,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:32:56',
            'Categories': [],
            'Created': '07/24/2017 10:30:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 740,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-740.png',
            'Order': 10,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:31:48',
            'Categories': [],
            'Created': '07/24/2017 10:31:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 741,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-741.png',
            'Order': 11,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:33:04',
            'Categories': [],
            'Created': '07/24/2017 10:33:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 742,
            'EditorSpecificImagePath': 'backgrounds/editor/background-742.png',
            'ImagePath': 'backgrounds/background-742.png',
            'Order': 2,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_ster',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'LastModified': '09/11/2023 11:08:03',
            'Categories': [],
            'Created': '07/24/2017 10:33:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 743,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-743.png',
            'Order': 12,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:39:56',
            'Categories': [],
            'Created': '07/24/2017 10:34:16',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 744,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-744.png',
            'Order': 13,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:40:04',
            'Categories': [],
            'Created': '07/24/2017 10:34:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 745,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-745.png',
            'Order': 14,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:35:32',
            'Categories': [],
            'Created': '07/24/2017 10:35:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 746,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-746.png',
            'Order': 15,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:35:58',
            'Categories': [],
            'Created': '07/24/2017 10:35:58',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 747,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-747.png',
            'Order': 16,
            'Size': '{Width=1120, Height=457}',
            'Title': 'tompouce_kader_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:36:22',
            'Categories': [],
            'Created': '07/24/2017 10:36:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 748,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-748.png',
            'Order': 17,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:36:45',
            'Categories': [],
            'Created': '07/24/2017 10:36:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 749,
            'EditorSpecificImagePath': 'backgrounds/editor/background-749.png',
            'ImagePath': 'backgrounds/background-749.png',
            'Order': 1,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_streep',
            'LastModifiedBy': 'HEMALOCAL\\kooia',
            'LastModified': '01/08/2018 12:49:37',
            'Categories': [],
            'Created': '07/24/2017 10:37:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 750,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-750.png',
            'Order': 18,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:37:54',
            'Categories': [],
            'Created': '07/24/2017 10:37:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 751,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-751.png',
            'Order': 19,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:38:25',
            'Categories': [],
            'Created': '07/24/2017 10:38:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 752,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-752.png',
            'Order': 20,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:38:54',
            'Categories': [],
            'Created': '07/24/2017 10:38:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 753,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-753.png',
            'Order': 21,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:40:25',
            'Categories': [],
            'Created': '07/24/2017 10:39:20',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 754,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-754.png',
            'Order': 22,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:34:25',
            'Categories': [],
            'Created': '07/24/2017 10:40:58',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 755,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-755.png',
            'Order': 23,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:07:29',
            'Categories': [],
            'Created': '07/24/2017 11:07:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 756,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-756.png',
            'Order': 24,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:17:59',
            'Categories': [],
            'Created': '07/24/2017 11:17:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 757,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-757.png',
            'Order': 25,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:18:27',
            'Categories': [],
            'Created': '07/24/2017 11:18:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 758,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-758.png',
            'Order': 26,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:18:51',
            'Categories': [],
            'Created': '07/24/2017 11:18:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 759,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-759.png',
            'Order': 27,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:19:25',
            'Categories': [],
            'Created': '07/24/2017 11:19:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 760,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-760.png',
            'Order': 28,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:19:45',
            'Categories': [],
            'Created': '07/24/2017 11:19:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 761,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-761.png',
            'Order': 29,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:20:06',
            'Categories': [],
            'Created': '07/24/2017 11:20:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 762,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-762.png',
            'Order': 30,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:20:58',
            'Categories': [],
            'Created': '07/24/2017 11:20:58',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 763,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-763.png',
            'Order': 31,
            'Size': '{Width=1120, Height=457}',
            'Title': 'party cake_kader_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:21:54',
            'Categories': [],
            'Created': '07/24/2017 11:21:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 764,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-764.png',
            'Order': 32,
            'Size': '{Width=1119, Height=456}',
            'Title': 'party cake_overall_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:22:34',
            'Categories': [],
            'Created': '07/24/2017 11:22:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 765,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-765.png',
            'Order': 33,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:23:00',
            'Categories': [],
            'Created': '07/24/2017 11:23:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 766,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-766.png',
            'Order': 34,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_streep',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '08/29/2019 13:30:03',
            'Categories': [],
            'Created': '07/24/2017 11:23:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 767,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-767.png',
            'Order': 35,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:24:18',
            'Categories': [],
            'Created': '07/24/2017 11:24:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 768,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-768.png',
            'Order': 36,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:24:43',
            'Categories': [],
            'Created': '07/24/2017 11:24:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 769,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-769.png',
            'Order': 37,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:25:03',
            'Categories': [],
            'Created': '07/24/2017 11:25:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 770,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-770.png',
            'Order': 38,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:25:48',
            'Categories': [],
            'Created': '07/24/2017 11:25:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 771,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-771.png',
            'Order': 39,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:26:59',
            'Categories': [],
            'Created': '07/24/2017 11:26:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 772,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-772.png',
            'Order': 40,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:27:26',
            'Categories': [],
            'Created': '07/24/2017 11:27:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 773,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-773.png',
            'Order': 41,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:27:44',
            'Categories': [],
            'Created': '07/24/2017 11:27:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 774,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-774.png',
            'Order': 42,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:28:02',
            'Categories': [],
            'Created': '07/24/2017 11:28:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 775,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-775.png',
            'Order': 43,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:28:59',
            'Categories': [],
            'Created': '07/24/2017 11:28:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 777,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-777.png',
            'Order': 45,
            'Size': '{Width=2584, Height=1723}',
            'Title': 'party cake_overall_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:35:37',
            'Categories': [],
            'Created': '07/24/2017 11:35:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 778,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-778.png',
            'Order': 46,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:36:09',
            'Categories': [],
            'Created': '07/24/2017 11:36:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 779,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-779.png',
            'Order': 47,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:36:36',
            'Categories': [],
            'Created': '07/24/2017 11:36:36',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 780,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-780.png',
            'Order': 48,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:34:33',
            'Categories': [],
            'Created': '07/24/2017 11:37:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 784,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-784.png',
            'Order': 52,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:40:09',
            'Categories': [],
            'Created': '07/24/2017 11:40:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 785,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-785.png',
            'Order': 53,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:40:29',
            'Categories': [],
            'Created': '07/24/2017 11:40:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 786,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-786.png',
            'Order': 54,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:40:47',
            'Categories': [],
            'Created': '07/24/2017 11:40:47',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 788,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-788.png',
            'Order': 57,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:41:13',
            'Categories': [],
            'Created': '07/24/2017 11:41:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 789,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-789.png',
            'Order': 58,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:42:25',
            'Categories': [],
            'Created': '07/24/2017 11:42:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 790,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-790.png',
            'Order': 59,
            'Size': '{Width=2583, Height=1727}',
            'Title': 'party cake_overall_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:43:28',
            'Categories': [],
            'Created': '07/24/2017 11:43:28',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 792,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-792.png',
            'Order': 61,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:44:06',
            'Categories': [],
            'Created': '07/24/2017 11:44:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 794,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-794.png',
            'Order': 63,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:44:25',
            'Categories': [],
            'Created': '07/24/2017 11:44:25',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 795,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-795.png',
            'Order': 64,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:35:31',
            'Categories': [],
            'Created': '07/24/2017 11:44:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 797,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-797.png',
            'Order': 66,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:45:22',
            'Categories': [],
            'Created': '07/24/2017 11:45:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 799,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-799.png',
            'Order': 68,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:45:45',
            'Categories': [],
            'Created': '07/24/2017 11:45:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 801,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-801.png',
            'Order': 70,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:46:21',
            'Categories': [],
            'Created': '07/24/2017 11:46:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 802,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-802.png',
            'Order': 71,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:46:42',
            'Categories': [],
            'Created': '07/24/2017 11:46:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 803,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-803.png',
            'Order': 72,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:47:08',
            'Categories': [],
            'Created': '07/24/2017 11:47:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 804,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-804.png',
            'Order': 73,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:47:27',
            'Categories': [],
            'Created': '07/24/2017 11:47:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 805,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-805.png',
            'Order': 74,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:47:51',
            'Categories': [],
            'Created': '07/24/2017 11:47:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 806,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-806.png',
            'Order': 75,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:48:12',
            'Categories': [],
            'Created': '07/24/2017 11:48:12',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 807,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-807.png',
            'Order': 76,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:35:43',
            'Categories': [],
            'Created': '07/24/2017 11:49:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 808,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-808.png',
            'Order': 77,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:49:45',
            'Categories': [],
            'Created': '07/24/2017 11:49:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 809,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-809.png',
            'Order': 78,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:50:03',
            'Categories': [],
            'Created': '07/24/2017 11:50:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 810,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-810.png',
            'Order': 79,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:50:20',
            'Categories': [],
            'Created': '07/24/2017 11:50:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 814,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-814.png',
            'Order': 83,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:51:01',
            'Categories': [],
            'Created': '07/24/2017 11:51:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 817,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-817.png',
            'Order': 86,
            'Size': '{Width=2583, Height=1727}',
            'Title': 'party cake_overall_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:52:37',
            'Categories': [],
            'Created': '07/24/2017 11:52:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 818,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-818.png',
            'Order': 87,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:52:56',
            'Categories': [],
            'Created': '07/24/2017 11:52:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 820,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-820.png',
            'Order': 89,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:53:13',
            'Categories': [],
            'Created': '07/24/2017 11:53:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 821,
            'EditorSpecificImagePath': 'backgrounds/editor/background-821.png',
            'ImagePath': 'backgrounds/background-821.png',
            'Order': 3,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_blaadjes',
            'LastModifiedBy': 'HEMALOCAL\\kooia',
            'LastModified': '01/04/2018 16:21:56',
            'Categories': [],
            'Created': '07/24/2017 11:53:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1011,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1011.png',
            'Order': 279,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:44:02',
            'Categories': [],
            'Created': '07/24/2017 13:44:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1013,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1013.png',
            'Order': 281,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:44:32',
            'Categories': [],
            'Created': '07/24/2017 13:44:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1020,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1020.png',
            'Order': 288,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:52:07',
            'Categories': [],
            'Created': '07/24/2017 13:52:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1021,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1021.png',
            'Order': 289,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:52:28',
            'Categories': [],
            'Created': '07/24/2017 13:52:28',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1022,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1022.png',
            'Order': 290,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:53:20',
            'Categories': [],
            'Created': '07/24/2017 13:53:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1023,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1023.png',
            'Order': 291,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:54:42',
            'Categories': [],
            'Created': '07/24/2017 13:54:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1024,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1024.png',
            'Order': 292,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:56:09',
            'Categories': [],
            'Created': '07/24/2017 13:56:09',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1026,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 294,
            'Size': null,
            'Title': 'taart3d_overall_gras',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:40:35',
            'Categories': [],
            'Created': '07/24/2017 13:58:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1038,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1038.jpg',
            'Order': 306,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_roodstreep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:32:19',
            'Categories': [],
            'Created': '07/24/2017 14:08:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1048,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1048.jpg',
            'Order': 316,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_boom',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:39:05',
            'Categories': [],
            'Created': '07/24/2017 14:14:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1050,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1050.jpg',
            'Order': 318,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_bloem',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:40:17',
            'Categories': [],
            'Created': '07/24/2017 14:15:38',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1052,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1052.jpg',
            'Order': 320,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:40:51',
            'Categories': [],
            'Created': '07/24/2017 14:16:46',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1053,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1053.jpg',
            'Order': 321,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:02:19',
            'Categories': [],
            'Created': '07/24/2017 14:17:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1054,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1054.jpg',
            'Order': 322,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:02:51',
            'Categories': [],
            'Created': '07/24/2017 14:18:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1056,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1056.jpg',
            'Order': 324,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruitrood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:03:06',
            'Categories': [],
            'Created': '07/24/2017 14:19:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1057,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1057.jpg',
            'Order': 325,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_stip rood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:05:08',
            'Categories': [],
            'Created': '07/24/2017 14:21:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1064,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1064.png',
            'Order': 332,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_verkeer',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:10',
            'Categories': [],
            'Created': '07/24/2017 14:26:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1074,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1074.png',
            'Order': 342,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:35:27',
            'Categories': [],
            'Created': '07/24/2017 14:32:35',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1081,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1081.png',
            'Order': 349,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'taart3d_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:49',
            'Categories': [],
            'Created': '07/24/2017 14:39:59',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1085,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1085.png',
            'Order': 353,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'taart3d_overall_ster2',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:43:03',
            'Categories': [],
            'Created': '07/24/2017 14:42:53',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1182,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1182.jpg',
            'Order': 450,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_roodstreep',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:42:49',
            'Categories': [],
            'Created': '07/24/2017 15:42:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1198,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1198.jpg',
            'Order': 463,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_bruinzwart',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:56:13',
            'Categories': [],
            'Created': '07/24/2017 15:56:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1201,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1201.jpg',
            'Order': 466,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_bloem',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:58:23',
            'Categories': [],
            'Created': '07/24/2017 15:58:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1205,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1205.jpg',
            'Order': 470,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_rozeruit',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 16:01:45',
            'Categories': [],
            'Created': '07/24/2017 16:01:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1206,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1206.jpg',
            'Order': 471,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_blauwruit',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 16:04:34',
            'Categories': [],
            'Created': '07/24/2017 16:04:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1210,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1210.jpg',
            'Order': 474,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_roodstip',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 16:09:27',
            'Categories': [],
            'Created': '07/24/2017 16:09:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1213,
            'EditorSpecificImagePath': 'backgrounds/editor/background-1213.png',
            'ImagePath': 'backgrounds/background-1213.png',
            'Order': 55,
            'Size': '{Width=1740, Height=1740}',
            'Title': 'TEST MARTIN',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:49:22',
            'Categories': [],
            'Created': '10/20/2017 07:07:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1214,
            'EditorSpecificImagePath': 'backgrounds/editor/background-1214.png',
            'ImagePath': 'backgrounds/background-1214.png',
            'Order': 477,
            'Size': '{Width=1740, Height=1740}',
            'Title': 'Martin Test 2',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/13/2017 13:50:23',
            'Categories': [],
            'Created': '12/13/2017 13:50:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1215,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1215.png',
            'Order': 478,
            'Size': '{Width=921, Height=1276}',
            'Title': 'wijn_921x1276_overall_beertje',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'LastModified': '04/02/2019 11:49:01',
            'Categories': [],
            'Created': '06/27/2018 15:21:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1216,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1216.png',
            'Order': 479,
            'Size': '{Width=514, Height=324}',
            'Title': 'cadeau_514x324_overall_beertje',
            'LastModifiedBy': 'ad-acc\\Erica.Ly',
            'LastModified': '06/27/2018 15:22:54',
            'Categories': [],
            'Created': '06/27/2018 15:22:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1217,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1217.png',
            'Order': 480,
            'Size': '{Width=3671, Height=3693}',
            'Title': 'rainbow-round',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'LastModified': '11/18/2022 16:26:12',
            'Categories': [],
            'Created': '11/18/2022 16:24:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1218,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1218.png',
            'Order': 481,
            'Size': '{Width=3871, Height=3894}',
            'Title': 'rond-oranje',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'LastModified': '11/18/2022 17:06:07',
            'Categories': [],
            'Created': '11/18/2022 17:06:07',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 17,
            'Title': 'Montserrat',
            'ImagePath': 'fonts/font-17.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 14,
            'Order': 5,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '08/15/2017 12:04:47',
            'LastModifiedBy': 'HEMALOCAL\\emdvorobiova',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 22,
            'Title': 'Bungee',
            'ImagePath': 'fonts/font-22.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 9,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/22/2017 06:29:11',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:25:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 13,
            'Active': 1,
            'Order': 3,
            'Title': 'Strik',
            'ImagePath': 'stickers/sticker-13.png',
            'Size': '{Width=625, Height=335}',
            'LastModified': '05/09/2017 07:13:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:55',
            'ProductTypes': []
          },
          {
            'StickerId': 14,
            'Active': 1,
            'Order': 4,
            'Title': 'Cirkel',
            'ImagePath': 'stickers/sticker-14.png',
            'Size': '{Width=623, Height=624}',
            'LastModified': '05/09/2017 07:14:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:06',
            'ProductTypes': []
          },
          {
            'StickerId': 15,
            'Active': 1,
            'Order': 5,
            'Title': 'Spreekwolk',
            'ImagePath': 'stickers/sticker-15.png',
            'Size': '{Width=833, Height=736}',
            'LastModified': '05/09/2017 07:14:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:19',
            'ProductTypes': []
          },
          {
            'StickerId': 16,
            'Active': 1,
            'Order': 7,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-16.png',
            'Size': '{Width=662, Height=737}',
            'LastModified': '05/09/2017 07:14:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:27',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 19,
            'Active': 1,
            'Order': 10,
            'Title': 'Bril',
            'ImagePath': 'stickers/sticker-19.png',
            'Size': '{Width=688, Height=229}',
            'LastModified': '05/09/2017 07:15:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:01',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 21,
            'Active': 1,
            'Order': 12,
            'Title': 'Baby',
            'ImagePath': 'stickers/sticker-21.png',
            'Size': '{Width=729, Height=658}',
            'LastModified': '05/09/2017 07:15:47',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:47',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 23,
            'Active': 1,
            'Order': 14,
            'Title': 'Hart blauw',
            'ImagePath': 'stickers/sticker-23.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '05/09/2017 07:16:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:14',
            'ProductTypes': []
          },
          {
            'StickerId': 24,
            'Active': 1,
            'Order': 15,
            'Title': 'Ster blauw',
            'ImagePath': 'stickers/sticker-24.png',
            'Size': '{Width=625, Height=570}',
            'LastModified': '05/09/2017 07:16:24',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:24',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 26,
            'Active': 1,
            'Order': 17,
            'Title': 'Welkom kleintje',
            'ImagePath': 'stickers/sticker-26.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:16:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:56',
            'ProductTypes': []
          },
          {
            'StickerId': 27,
            'Active': 1,
            'Order': 18,
            'Title': 'Welkom kleintjes',
            'ImagePath': 'stickers/sticker-27.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:17:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:13',
            'ProductTypes': []
          },
          {
            'StickerId': 28,
            'Active': 1,
            'Order': 19,
            'Title': 'Sinasappel',
            'ImagePath': 'stickers/sticker-28.png',
            'Size': '{Width=729, Height=729}',
            'LastModified': '05/09/2017 07:17:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:25',
            'ProductTypes': []
          },
          {
            'StickerId': 29,
            'Active': 1,
            'Order': 20,
            'Title': 'Blaadje',
            'ImagePath': 'stickers/sticker-29.png',
            'Size': '{Width=717, Height=238}',
            'LastModified': '05/09/2017 07:17:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:37',
            'ProductTypes': []
          },
          {
            'StickerId': 30,
            'Active': 1,
            'Order': 21,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-30.png',
            'Size': '{Width=359, Height=931}',
            'LastModified': '05/09/2017 07:17:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:48',
            'ProductTypes': []
          },
          {
            'StickerId': 31,
            'Active': 1,
            'Order': 22,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-31.png',
            'Size': '{Width=383, Height=942}',
            'LastModified': '05/09/2017 07:18:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:02',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 33,
            'Active': 1,
            'Order': 24,
            'Title': 'Ananas',
            'ImagePath': 'stickers/sticker-33.png',
            'Size': '{Width=405, Height=738}',
            'LastModified': '05/09/2017 07:18:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:28',
            'ProductTypes': []
          },
          {
            'StickerId': 34,
            'Active': 1,
            'Order': 25,
            'Title': 'Herfst blaadjes',
            'ImagePath': 'stickers/sticker-34.png',
            'Size': '{Width=255, Height=546}',
            'LastModified': '05/09/2017 07:18:46',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:46',
            'ProductTypes': []
          },
          {
            'StickerId': 35,
            'Active': 1,
            'Order': 26,
            'Title': 'Winter',
            'ImagePath': 'stickers/sticker-35.png',
            'Size': '{Width=476, Height=785}',
            'LastModified': '05/09/2017 07:18:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:59',
            'ProductTypes': []
          },
          {
            'StickerId': 36,
            'Active': 1,
            'Order': 27,
            'Title': 'Astronaut',
            'ImagePath': 'stickers/sticker-36.png',
            'Size': '{Width=589, Height=988}',
            'LastModified': '05/09/2017 07:19:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:14',
            'ProductTypes': []
          },
          {
            'StickerId': 37,
            'Active': 1,
            'Order': 28,
            'Title': 'Jarig',
            'ImagePath': 'stickers/sticker-37.png',
            'Size': '{Width=1036, Height=1026}',
            'LastModified': '05/09/2017 07:19:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:26',
            'ProductTypes': []
          },
          {
            'StickerId': 38,
            'Active': 1,
            'Order': 29,
            'Title': 'Kikker',
            'ImagePath': 'stickers/sticker-38.png',
            'Size': '{Width=1042, Height=1040}',
            'LastModified': '05/09/2017 07:19:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:38',
            'ProductTypes': []
          },
          {
            'StickerId': 39,
            'Active': 1,
            'Order': 30,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-39.png',
            'Size': '{Width=1042, Height=651}',
            'LastModified': '05/09/2017 07:19:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:56',
            'ProductTypes': []
          },
          {
            'StickerId': 40,
            'Active': 1,
            'Order': 31,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-40.png',
            'Size': '{Width=988, Height=311}',
            'LastModified': '05/09/2017 07:20:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:13',
            'ProductTypes': []
          },
          {
            'StickerId': 41,
            'Active': 1,
            'Order': 32,
            'Title': 'Piratenmuts',
            'ImagePath': 'stickers/sticker-41.png',
            'Size': '{Width=1042, Height=591}',
            'LastModified': '05/09/2017 07:20:34',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:34',
            'ProductTypes': []
          },
          {
            'StickerId': 42,
            'Active': 1,
            'Order': 33,
            'Title': 'Takkie',
            'ImagePath': 'stickers/sticker-42.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:20:45',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:45',
            'ProductTypes': []
          },
          {
            'StickerId': 43,
            'Active': 1,
            'Order': 34,
            'Title': 'Ballon geel',
            'ImagePath': 'stickers/sticker-43.png',
            'Size': '{Width=377, Height=1024}',
            'LastModified': '05/09/2017 07:20:58',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:58',
            'ProductTypes': []
          },
          {
            'StickerId': 44,
            'Active': 1,
            'Order': 35,
            'Title': 'Getrouwd',
            'ImagePath': 'stickers/sticker-44.png',
            'Size': '{Width=1028, Height=349}',
            'LastModified': '05/09/2017 07:21:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:11',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 46,
            'Active': 1,
            'Order': 37,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-46.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:21:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:57',
            'ProductTypes': []
          },
          {
            'StickerId': 47,
            'Active': 1,
            'Order': 38,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-47.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:22:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:19',
            'ProductTypes': []
          },
          {
            'StickerId': 48,
            'Active': 1,
            'Order': 39,
            'Title': 'Papagaai',
            'ImagePath': 'stickers/sticker-48.png',
            'Size': '{Width=1042, Height=928}',
            'LastModified': '05/09/2017 07:22:30',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:30',
            'ProductTypes': []
          },
          {
            'StickerId': 49,
            'Active': 1,
            'Order': 40,
            'Title': 'Robot',
            'ImagePath': 'stickers/sticker-49.png',
            'Size': '{Width=674, Height=1009}',
            'LastModified': '05/09/2017 07:22:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:43',
            'ProductTypes': []
          },
          {
            'StickerId': 50,
            'Active': 1,
            'Order': 41,
            'Title': 'The king',
            'ImagePath': 'stickers/sticker-50.png',
            'Size': '{Width=1044, Height=197}',
            'LastModified': '05/09/2017 07:22:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:55',
            'ProductTypes': []
          },
          {
            'StickerId': 51,
            'Active': 1,
            'Order': 42,
            'Title': 'Ballonnen groen',
            'ImagePath': 'stickers/sticker-51.png',
            'Size': '{Width=785, Height=1007}',
            'LastModified': '05/09/2017 07:23:10',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:10',
            'ProductTypes': []
          },
          {
            'StickerId': 52,
            'Active': 1,
            'Order': 43,
            'Title': 'Je bent mijn liefste',
            'ImagePath': 'stickers/sticker-52.png',
            'Size': '{Width=487, Height=1042}',
            'LastModified': '05/09/2017 07:23:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:27',
            'ProductTypes': []
          },
          {
            'StickerId': 53,
            'Active': 1,
            'Order': 44,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-53.png',
            'Size': '{Width=1038, Height=948}',
            'LastModified': '05/09/2017 07:23:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:37',
            'ProductTypes': []
          },
          {
            'StickerId': 54,
            'Active': 1,
            'Order': 45,
            'Title': 'Racket',
            'ImagePath': 'stickers/sticker-54.png',
            'Size': '{Width=420, Height=1016}',
            'LastModified': '05/09/2017 07:23:49',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:49',
            'ProductTypes': []
          },
          {
            'StickerId': 55,
            'Active': 1,
            'Order': 46,
            'Title': 'Zwaard',
            'ImagePath': 'stickers/sticker-55.png',
            'Size': '{Width=461, Height=1042}',
            'LastModified': '05/09/2017 07:24:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:01',
            'ProductTypes': []
          },
          {
            'StickerId': 56,
            'Active': 1,
            'Order': 47,
            'Title': 'Hoeravlag',
            'ImagePath': 'stickers/sticker-56.png',
            'Size': '{Width=1045, Height=252}',
            'LastModified': '05/09/2017 07:24:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:13',
            'ProductTypes': []
          },
          {
            'StickerId': 57,
            'Active': 1,
            'Order': 48,
            'Title': 'Rood hartje',
            'ImagePath': 'stickers/sticker-57.png',
            'Size': '{Width=624, Height=1007}',
            'LastModified': '05/09/2017 07:24:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:27',
            'ProductTypes': []
          },
          {
            'StickerId': 58,
            'Active': 1,
            'Order': 49,
            'Title': 'Hoera banner',
            'ImagePath': 'stickers/sticker-58.png',
            'Size': '{Width=1029, Height=530}',
            'LastModified': '05/09/2017 07:24:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:48',
            'ProductTypes': []
          },
          {
            'StickerId': 59,
            'Active': 1,
            'Order': 50,
            'Title': 'Raket',
            'ImagePath': 'stickers/sticker-59.png',
            'Size': '{Width=659, Height=984}',
            'LastModified': '05/09/2017 07:25:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:05',
            'ProductTypes': []
          },
          {
            'StickerId': 60,
            'Active': 1,
            'Order': 51,
            'Title': 'Twee hartjes',
            'ImagePath': 'stickers/sticker-60.png',
            'Size': '{Width=968, Height=754}',
            'LastModified': '05/09/2017 07:25:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:18',
            'ProductTypes': []
          },
          {
            'StickerId': 61,
            'Active': 1,
            'Order': 52,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-61.png',
            'Size': '{Width=995, Height=543}',
            'LastModified': '05/09/2017 07:25:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:31',
            'ProductTypes': []
          },
          {
            'StickerId': 62,
            'Active': 1,
            'Order': 53,
            'Title': 'Lijn hartjes',
            'ImagePath': 'stickers/sticker-62.png',
            'Size': '{Width=982, Height=958}',
            'LastModified': '05/09/2017 07:25:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:43',
            'ProductTypes': []
          },
          {
            'StickerId': 63,
            'Active': 1,
            'Order': 54,
            'Title': 'Roze hartje',
            'ImagePath': 'stickers/sticker-63.png',
            'Size': '{Width=624, Height=1017}',
            'LastModified': '05/09/2017 07:26:23',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:23',
            'ProductTypes': []
          },
          {
            'StickerId': 64,
            'Active': 1,
            'Order': 55,
            'Title': 'Ufo',
            'ImagePath': 'stickers/sticker-64.png',
            'Size': '{Width=914, Height=958}',
            'LastModified': '05/09/2017 07:26:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:32',
            'ProductTypes': []
          },
          {
            'StickerId': 65,
            'Active': 1,
            'Order': 56,
            'Title': 'Kadootje',
            'ImagePath': 'stickers/sticker-65.png',
            'Size': '{Width=706, Height=1012}',
            'LastModified': '05/09/2017 07:26:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:42',
            'ProductTypes': []
          },
          {
            'StickerId': 66,
            'Active': 1,
            'Order': 57,
            'Title': 'Ring',
            'ImagePath': 'stickers/sticker-66.png',
            'Size': '{Width=620, Height=1001}',
            'LastModified': '05/09/2017 07:26:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:51',
            'ProductTypes': []
          },
          {
            'StickerId': 67,
            'Active': 1,
            'Order': 58,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-67.png',
            'Size': '{Width=1020, Height=947}',
            'LastModified': '05/09/2017 07:27:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:01',
            'ProductTypes': []
          },
          {
            'StickerId': 68,
            'Active': 1,
            'Order': 59,
            'Title': 'Bowtie',
            'ImagePath': 'stickers/sticker-68.png',
            'Size': '{Width=1017, Height=514}',
            'LastModified': '05/09/2017 07:27:09',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:09',
            'ProductTypes': []
          },
          {
            'StickerId': 69,
            'Active': 1,
            'Order': 60,
            'Title': 'Confetti',
            'ImagePath': 'stickers/sticker-69.png',
            'Size': '{Width=333, Height=995}',
            'LastModified': '05/09/2017 07:27:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:21',
            'ProductTypes': []
          },
          {
            'StickerId': 70,
            'Active': 1,
            'Order': 61,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-70.png',
            'Size': '{Width=898, Height=1006}',
            'LastModified': '05/09/2017 07:27:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:33',
            'ProductTypes': []
          },
          {
            'StickerId': 71,
            'Active': 1,
            'Order': 62,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-71.png',
            'Size': '{Width=1027, Height=573}',
            'LastModified': '05/09/2017 07:27:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:42',
            'ProductTypes': []
          },
          {
            'StickerId': 72,
            'Active': 1,
            'Order': 63,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-72.png',
            'Size': '{Width=797, Height=985}',
            'LastModified': '05/09/2017 07:27:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:55',
            'ProductTypes': []
          },
          {
            'StickerId': 73,
            'Active': 1,
            'Order': 64,
            'Title': 'Mr',
            'ImagePath': 'stickers/sticker-73.png',
            'Size': '{Width=1038, Height=932}',
            'LastModified': '05/09/2017 07:28:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:07',
            'ProductTypes': []
          },
          {
            'StickerId': 74,
            'Active': 1,
            'Order': 65,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-74.png',
            'Size': '{Width=708, Height=990}',
            'LastModified': '05/09/2017 07:28:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:18',
            'ProductTypes': []
          },
          {
            'StickerId': 75,
            'Active': 1,
            'Order': 66,
            'Title': 'Ms',
            'ImagePath': 'stickers/sticker-75.png',
            'Size': '{Width=1031, Height=971}',
            'LastModified': '05/09/2017 07:28:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:32',
            'ProductTypes': []
          },
          {
            'StickerId': 76,
            'Active': 1,
            'Order': 67,
            'Title': 'Rainbow',
            'ImagePath': 'stickers/sticker-76.png',
            'Size': '{Width=1010, Height=659}',
            'LastModified': '05/09/2017 07:28:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:42',
            'ProductTypes': []
          },
          {
            'StickerId': 77,
            'Active': 1,
            'Order': 68,
            'Title': 'Champagne',
            'ImagePath': 'stickers/sticker-77.png',
            'Size': '{Width=341, Height=1006}',
            'LastModified': '05/09/2017 07:28:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:56',
            'ProductTypes': []
          },
          {
            'StickerId': 78,
            'Active': 1,
            'Order': 69,
            'Title': 'Hartjes',
            'ImagePath': 'stickers/sticker-78.png',
            'Size': '{Width=951, Height=571}',
            'LastModified': '05/09/2017 07:29:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:06',
            'ProductTypes': []
          },
          {
            'StickerId': 79,
            'Active': 1,
            'Order': 70,
            'Title': 'You are just lovely',
            'ImagePath': 'stickers/sticker-79.png',
            'Size': '{Width=987, Height=899}',
            'LastModified': '05/09/2017 07:29:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:26',
            'ProductTypes': []
          },
          {
            'StickerId': 80,
            'Active': 1,
            'Order': 71,
            'Title': 'Medaille',
            'ImagePath': 'stickers/sticker-80.png',
            'Size': '{Width=591, Height=1018}',
            'LastModified': '05/09/2017 07:29:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:40',
            'ProductTypes': []
          },
          {
            'StickerId': 81,
            'Active': 1,
            'Order': 72,
            'Title': 'Pluk de dag',
            'ImagePath': 'stickers/sticker-81.png',
            'Size': '{Width=509, Height=1042}',
            'LastModified': '05/09/2017 07:29:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:51',
            'ProductTypes': []
          },
          {
            'StickerId': 82,
            'Active': 1,
            'Order': 73,
            'Title': 'Zon',
            'ImagePath': 'stickers/sticker-82.png',
            'Size': '{Width=1033, Height=1005}',
            'LastModified': '05/09/2017 07:30:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:01',
            'ProductTypes': []
          },
          {
            'StickerId': 83,
            'Active': 1,
            'Order': 74,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-83.png',
            'Size': '{Width=997, Height=646}',
            'LastModified': '05/09/2017 07:30:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:11',
            'ProductTypes': []
          },
          {
            'StickerId': 84,
            'Active': 1,
            'Order': 75,
            'Title': 'Hartjesdoos mama',
            'ImagePath': 'stickers/sticker-84.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:28',
            'ProductTypes': []
          },
          {
            'StickerId': 85,
            'Active': 1,
            'Order': 76,
            'Title': 'Hartjesdoos',
            'ImagePath': 'stickers/sticker-85.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:41',
            'ProductTypes': []
          },
          {
            'StickerId': 86,
            'Active': 1,
            'Order': 77,
            'Title': 'Wolk rain',
            'ImagePath': 'stickers/sticker-86.png',
            'Size': '{Width=1002, Height=948}',
            'LastModified': '05/09/2017 07:30:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:54',
            'ProductTypes': []
          },
          {
            'StickerId': 87,
            'Active': 1,
            'Order': 78,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-87.png',
            'Size': '{Width=1025, Height=721}',
            'LastModified': '05/09/2017 07:31:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:05',
            'ProductTypes': []
          },
          {
            'StickerId': 88,
            'Active': 1,
            'Order': 79,
            'Title': 'Hartje mama',
            'ImagePath': 'stickers/sticker-88.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:32',
            'ProductTypes': []
          },
          {
            'StickerId': 89,
            'Active': 1,
            'Order': 80,
            'Title': 'Hartje',
            'ImagePath': 'stickers/sticker-89.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:42',
            'ProductTypes': []
          },
          {
            'StickerId': 90,
            'Active': 1,
            'Order': 81,
            'Title': 'Wolk donder',
            'ImagePath': 'stickers/sticker-90.png',
            'Size': '{Width=878, Height=998}',
            'LastModified': '05/09/2017 07:40:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:00',
            'ProductTypes': []
          },
          {
            'StickerId': 91,
            'Active': 1,
            'Order': 82,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-91.png',
            'Size': '{Width=1013, Height=1013}',
            'LastModified': '05/09/2017 07:40:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:14',
            'ProductTypes': []
          },
          {
            'StickerId': 92,
            'Active': 1,
            'Order': 83,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-92.png',
            'Size': '{Width=768, Height=1013}',
            'LastModified': '05/09/2017 07:40:44',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:44',
            'ProductTypes': []
          },
          {
            'StickerId': 93,
            'Active': 1,
            'Order': 84,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-93.png',
            'Size': '{Width=1009, Height=1022}',
            'LastModified': '05/09/2017 07:40:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:54',
            'ProductTypes': []
          },
          {
            'StickerId': 94,
            'Active': 1,
            'Order': 85,
            'Title': 'Zwemband',
            'ImagePath': 'stickers/sticker-94.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:41:04',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:04',
            'ProductTypes': []
          },
          {
            'StickerId': 95,
            'Active': 1,
            'Order': 86,
            'Title': 'Plons',
            'ImagePath': 'stickers/sticker-95.png',
            'Size': '{Width=1033, Height=430}',
            'LastModified': '05/09/2017 07:41:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:17',
            'ProductTypes': []
          },
          {
            'StickerId': 96,
            'Active': 1,
            'Order': 87,
            'Title': 'Zwemdiploma',
            'ImagePath': 'stickers/sticker-96.png',
            'Size': '{Width=1019, Height=121}',
            'LastModified': '05/09/2017 07:41:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:29',
            'ProductTypes': []
          },
          {
            'StickerId': 97,
            'Active': 1,
            'Order': 88,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-97.png',
            'Size': '{Width=719, Height=1044}',
            'LastModified': '05/09/2017 07:41:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:41',
            'ProductTypes': []
          },
          {
            'StickerId': 98,
            'Active': 1,
            'Order': 89,
            'Title': 'New home',
            'ImagePath': 'stickers/sticker-98.png',
            'Size': '{Width=835, Height=1042}',
            'LastModified': '05/09/2017 07:41:52',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:52',
            'ProductTypes': []
          },
          {
            'StickerId': 99,
            'Active': 1,
            'Order': 90,
            'Title': 'Sportheld',
            'ImagePath': 'stickers/sticker-99.png',
            'Size': '{Width=925, Height=1040}',
            'LastModified': '05/09/2017 07:42:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:02',
            'ProductTypes': []
          },
          {
            'StickerId': 100,
            'Active': 1,
            'Order': 91,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-100.png',
            'Size': '{Width=855, Height=1042}',
            'LastModified': '05/09/2017 07:42:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:12',
            'ProductTypes': []
          },
          {
            'StickerId': 101,
            'Active': 1,
            'Order': 92,
            'Title': 'Present',
            'ImagePath': 'stickers/sticker-101.png',
            'Size': '{Width=714, Height=1004}',
            'LastModified': '05/09/2017 07:42:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:21',
            'ProductTypes': []
          },
          {
            'StickerId': 102,
            'Active': 1,
            'Order': 93,
            'Title': 'Bird',
            'ImagePath': 'stickers/sticker-102.png',
            'Size': '{Width=1031, Height=720}',
            'LastModified': '05/09/2017 07:42:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:31',
            'ProductTypes': []
          },
          {
            'StickerId': 104,
            'Active': 1,
            'Order': 95,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-104.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:53',
            'ProductTypes': []
          },
          {
            'StickerId': 105,
            'Active': 1,
            'Order': 96,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-105.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:57',
            'ProductTypes': []
          },
          {
            'StickerId': 107,
            'Active': 1,
            'Order': 98,
            'Title': 'Hoera een jongen',
            'ImagePath': 'stickers/sticker-107.png',
            'Size': '{Width=734, Height=1042}',
            'LastModified': '05/09/2017 07:43:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:21',
            'ProductTypes': []
          },
          {
            'StickerId': 108,
            'Active': 1,
            'Order': 99,
            'Title': 'Bedankt',
            'ImagePath': 'stickers/sticker-108.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:43:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:32',
            'ProductTypes': []
          },
          {
            'StickerId': 110,
            'Active': 1,
            'Order': 101,
            'Title': 'Stoplicht',
            'ImagePath': 'stickers/sticker-110.png',
            'Size': '{Width=288, Height=1032}',
            'LastModified': '05/09/2017 07:44:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:00',
            'ProductTypes': []
          },
          {
            'StickerId': 111,
            'Active': 1,
            'Order': 102,
            'Title': 'Hoera rijbewijs',
            'ImagePath': 'stickers/sticker-111.png',
            'Size': '{Width=1040, Height=632}',
            'LastModified': '05/09/2017 07:44:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:14',
            'ProductTypes': []
          },
          {
            'StickerId': 112,
            'Active': 1,
            'Order': 103,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-112.png',
            'Size': '{Width=997, Height=997}',
            'LastModified': '05/09/2017 07:44:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:25',
            'ProductTypes': []
          }
        ]
      },
      {
        'CategoryId': 5,
        'Name': '02 Verjaardag',
        'Order': 3,
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 991,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-991.png',
            'Order': 259,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:37:18',
            'Categories': [],
            'Created': '07/24/2017 13:37:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 993,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-993.png',
            'Order': 261,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:38:07',
            'Categories': [],
            'Created': '07/24/2017 13:38:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 998,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-998.png',
            'Order': 266,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:40:18',
            'Categories': [],
            'Created': '07/24/2017 13:40:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 999,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-999.png',
            'Order': 267,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:40:59',
            'Categories': [],
            'Created': '07/24/2017 13:40:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1001,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1001.png',
            'Order': 269,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:41:32',
            'Categories': [],
            'Created': '07/24/2017 13:41:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1003,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1003.png',
            'Order': 271,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:42:03',
            'Categories': [],
            'Created': '07/24/2017 13:42:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1005,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1005.png',
            'Order': 273,
            'Size': '{Width=3447, Height=2296}',
            'Title': 'maxi party cake_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:42:26',
            'Categories': [],
            'Created': '07/24/2017 13:42:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1007,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1007.png',
            'Order': 275,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:42:51',
            'Categories': [],
            'Created': '07/24/2017 13:42:51',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1009,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1009.png',
            'Order': 277,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:40:16',
            'Categories': [],
            'Created': '07/24/2017 13:43:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1098,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1098.png',
            'Order': 366,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:55:15',
            'Categories': [],
            'Created': '07/24/2017 14:55:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1100,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1100.png',
            'Order': 368,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:58:45',
            'Categories': [],
            'Created': '07/24/2017 14:58:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1102,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1102.png',
            'Order': 370,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:59:51',
            'Categories': [],
            'Created': '07/24/2017 14:59:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1103,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1103.png',
            'Order': 371,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:00:59',
            'Categories': [],
            'Created': '07/24/2017 15:00:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1104,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1104.png',
            'Order': 372,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:02:15',
            'Categories': [],
            'Created': '07/24/2017 15:02:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1109,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1109.png',
            'Order': 377,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:06:06',
            'Categories': [],
            'Created': '07/24/2017 15:06:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1113,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1113.png',
            'Order': 381,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:08:06',
            'Categories': [],
            'Created': '07/24/2017 15:08:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1117,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1117.png',
            'Order': 385,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:09:35',
            'Categories': [],
            'Created': '07/24/2017 15:09:35',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1124,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1124.png',
            'Order': 392,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_kado',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:47:54',
            'Categories': [],
            'Created': '07/24/2017 15:12:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1128,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1128.png',
            'Order': 396,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:14:43',
            'Categories': [],
            'Created': '07/24/2017 15:14:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1132,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1132.png',
            'Order': 400,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:16:02',
            'Categories': [],
            'Created': '07/24/2017 15:16:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1137,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1137.png',
            'Order': 405,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kado_kaderwit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:18:34',
            'Categories': [],
            'Created': '07/24/2017 15:18:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1140,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1140.png',
            'Order': 408,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:20:26',
            'Categories': [],
            'Created': '07/24/2017 15:20:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1141,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1141.png',
            'Order': 409,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:21:32',
            'Categories': [],
            'Created': '07/24/2017 15:21:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1142,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1142.png',
            'Order': 410,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:21:40',
            'Categories': [],
            'Created': '07/24/2017 15:21:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1145,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1145.png',
            'Order': 413,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:23:02',
            'Categories': [],
            'Created': '07/24/2017 15:23:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1149,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1149.png',
            'Order': 417,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:24:43',
            'Categories': [],
            'Created': '07/24/2017 15:24:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1151,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1151.png',
            'Order': 419,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:26:22',
            'Categories': [],
            'Created': '07/24/2017 15:26:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1153,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1153.png',
            'Order': 421,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:28:01',
            'Categories': [],
            'Created': '07/24/2017 15:28:01',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1156,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1156.png',
            'Order': 424,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:21',
            'Categories': [],
            'Created': '07/24/2017 15:29:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1160,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1160.png',
            'Order': 428,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:32:11',
            'Categories': [],
            'Created': '07/24/2017 15:32:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1162,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1162.png',
            'Order': 430,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:34:54',
            'Categories': [],
            'Created': '07/24/2017 15:34:54',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1166,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1166.png',
            'Order': 434,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:27',
            'Categories': [],
            'Created': '07/24/2017 15:35:46',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1170,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1170.png',
            'Order': 438,
            'Size': '{Width=1119, Height=459}',
            'Title': 'tompouce_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:38:32',
            'Categories': [],
            'Created': '07/24/2017 15:38:32',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1172,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1172.png',
            'Order': 440,
            'Size': '{Width=3460, Height=2296}',
            'Title': 'mega taart3D_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:46:43',
            'Categories': [],
            'Created': '07/24/2017 15:38:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1174,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1174.png',
            'Order': 442,
            'Size': '{Width=1120, Height=456}',
            'Title': 'tompouce_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:40:17',
            'Categories': [],
            'Created': '07/24/2017 15:40:17',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1176,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1176.png',
            'Order': 444,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:40:43',
            'Categories': [],
            'Created': '07/24/2017 15:40:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1183,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1183.png',
            'Order': 451,
            'Size': '{Width=2586, Height=1723}',
            'Title': 'taart_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:42:48',
            'Categories': [],
            'Created': '07/24/2017 15:42:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1185,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1185.png',
            'Order': 452,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\bressersa',
            'LastModified': '07/24/2017 15:43:10',
            'Categories': [],
            'Created': '07/24/2017 15:43:10',
            'ProductTypes': []
          }
        ],
        'Fonts': [],
        'Stickers': []
      },
      {
        'CategoryId': 7,
        'Name': '04 Geboorte',
        'Order': 4,
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 734,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-734.png',
            'Order': 5,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_stip',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'LastModified': '03/09/2022 11:47:53',
            'Categories': [],
            'Created': '07/24/2017 10:13:52',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 854,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-854.png',
            'Order': 122,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_stipblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:35:01',
            'Categories': [],
            'Created': '07/24/2017 12:35:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 858,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-858.png',
            'Order': 126,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:42:56',
            'Categories': [],
            'Created': '07/24/2017 12:42:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 861,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-861.png',
            'Order': 129,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:44:08',
            'Categories': [],
            'Created': '07/24/2017 12:44:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 864,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-864.png',
            'Order': 132,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:44:43',
            'Categories': [],
            'Created': '07/24/2017 12:44:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 866,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-866.png',
            'Order': 134,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:45:39',
            'Categories': [],
            'Created': '07/24/2017 12:45:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 869,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-869.png',
            'Order': 137,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:46:43',
            'Categories': [],
            'Created': '07/24/2017 12:46:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 871,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-871.png',
            'Order': 139,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:47:14',
            'Categories': [],
            'Created': '07/24/2017 12:47:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 874,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-874.png',
            'Order': 142,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:47:56',
            'Categories': [],
            'Created': '07/24/2017 12:47:56',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 877,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-877.png',
            'Order': 145,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_beertje',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:37:00',
            'Categories': [],
            'Created': '07/24/2017 12:49:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 879,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-879.png',
            'Order': 147,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:50:21',
            'Categories': [],
            'Created': '07/24/2017 12:50:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 880,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-880.png',
            'Order': 148,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:51:03',
            'Categories': [],
            'Created': '07/24/2017 12:51:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 881,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-881.png',
            'Order': 149,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:51:33',
            'Categories': [],
            'Created': '07/24/2017 12:51:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 882,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-882.png',
            'Order': 150,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:52:01',
            'Categories': [],
            'Created': '07/24/2017 12:52:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 883,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-883.png',
            'Order': 151,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:52:37',
            'Categories': [],
            'Created': '07/24/2017 12:52:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 884,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-884.png',
            'Order': 152,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:53:12',
            'Categories': [],
            'Created': '07/24/2017 12:53:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 886,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-886.png',
            'Order': 154,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:53:42',
            'Categories': [],
            'Created': '07/24/2017 12:53:42',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 887,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-887.png',
            'Order': 155,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:37:12',
            'Categories': [],
            'Created': '07/24/2017 12:54:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 889,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-889.png',
            'Order': 157,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:55:25',
            'Categories': [],
            'Created': '07/24/2017 12:55:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 891,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-891.png',
            'Order': 159,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:55:52',
            'Categories': [],
            'Created': '07/24/2017 12:55:52',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 893,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-893.png',
            'Order': 161,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:56:18',
            'Categories': [],
            'Created': '07/24/2017 12:56:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 894,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-894.png',
            'Order': 162,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:56:42',
            'Categories': [],
            'Created': '07/24/2017 12:56:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 896,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-896.png',
            'Order': 164,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:57:13',
            'Categories': [],
            'Created': '07/24/2017 12:57:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 898,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-898.png',
            'Order': 166,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:58:03',
            'Categories': [],
            'Created': '07/24/2017 12:58:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 900,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-900.png',
            'Order': 168,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:58:35',
            'Categories': [],
            'Created': '07/24/2017 12:58:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 902,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-902.png',
            'Order': 170,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:58:59',
            'Categories': [],
            'Created': '07/24/2017 12:58:59',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 904,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-904.png',
            'Order': 172,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:38:31',
            'Categories': [],
            'Created': '07/24/2017 12:59:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 907,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-907.png',
            'Order': 175,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:59:57',
            'Categories': [],
            'Created': '07/24/2017 12:59:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 908,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-908.png',
            'Order': 176,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:00:20',
            'Categories': [],
            'Created': '07/24/2017 13:00:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 910,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-910.png',
            'Order': 178,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:01:31',
            'Categories': [],
            'Created': '07/24/2017 13:01:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 912,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-912.png',
            'Order': 180,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:02:11',
            'Categories': [],
            'Created': '07/24/2017 13:02:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 914,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-914.png',
            'Order': 182,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:02:40',
            'Categories': [],
            'Created': '07/24/2017 13:02:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 915,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-915.png',
            'Order': 183,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:03:10',
            'Categories': [],
            'Created': '07/24/2017 13:03:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 917,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-917.png',
            'Order': 185,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:04:06',
            'Categories': [],
            'Created': '07/24/2017 13:04:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 920,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-920.png',
            'Order': 188,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:11:45',
            'Categories': [],
            'Created': '07/24/2017 13:11:45',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 922,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-922.png',
            'Order': 190,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:00',
            'Categories': [],
            'Created': '07/24/2017 13:12:17',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1066,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1066.png',
            'Order': 334,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geboorte meisje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:25',
            'Categories': [],
            'Created': '07/24/2017 14:28:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1143,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1143.jpg',
            'Order': 411,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_geboortemeisje',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:22:27',
            'Categories': [],
            'Created': '07/24/2017 15:22:27',
            'ProductTypes': []
          }
        ],
        'Fonts': [],
        'Stickers': []
      },
      {
        'CategoryId': 6,
        'Name': '03 Kind',
        'Order': 5,
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 885,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-885.png',
            'Order': 153,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_space',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:53:32',
            'Categories': [],
            'Created': '07/24/2017 12:53:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 888,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-888.png',
            'Order': 156,
            'Size': '{Width=1552, Height=1575}',
            'Title': 'mini tompouce_overall_space',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:54:14',
            'Categories': [],
            'Created': '07/24/2017 12:54:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 930,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-930.png',
            'Order': 198,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:16:01',
            'Categories': [],
            'Created': '07/24/2017 13:16:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 931,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-931.png',
            'Order': 199,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:16:33',
            'Categories': [],
            'Created': '07/24/2017 13:16:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 932,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-932.png',
            'Order': 200,
            'Size': '{Width=2676, Height=2716}',
            'Title': 'taart_kader_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:17:26',
            'Categories': [],
            'Created': '07/24/2017 13:17:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 934,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-934.png',
            'Order': 202,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_overall_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:19:45',
            'Categories': [],
            'Created': '07/24/2017 13:19:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 936,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-936.png',
            'Order': 204,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:20:20',
            'Categories': [],
            'Created': '07/24/2017 13:20:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 938,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-938.png',
            'Order': 206,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:20:47',
            'Categories': [],
            'Created': '07/24/2017 13:20:47',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 940,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-940.png',
            'Order': 208,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_space',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:06',
            'Categories': [],
            'Created': '07/24/2017 13:21:46',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 947,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-947.png',
            'Order': 215,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:27:40',
            'Categories': [],
            'Created': '07/24/2017 13:27:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 949,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-949.png',
            'Order': 217,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:28:13',
            'Categories': [],
            'Created': '07/24/2017 13:28:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 951,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-951.png',
            'Order': 219,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:29:21',
            'Categories': [],
            'Created': '07/24/2017 13:29:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 955,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-955.png',
            'Order': 223,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:29:58',
            'Categories': [],
            'Created': '07/24/2017 13:29:58',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 956,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-956.png',
            'Order': 224,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:30:29',
            'Categories': [],
            'Created': '07/24/2017 13:30:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 957,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-957.png',
            'Order': 225,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_overall_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:31:01',
            'Categories': [],
            'Created': '07/24/2017 13:31:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 959,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-959.png',
            'Order': 227,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:31:39',
            'Categories': [],
            'Created': '07/24/2017 13:31:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 961,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-961.png',
            'Order': 229,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:32:10',
            'Categories': [],
            'Created': '07/24/2017 13:32:10',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 963,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-963.png',
            'Order': 231,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_BFF',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:19',
            'Categories': [],
            'Created': '07/24/2017 13:32:41',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 970,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-970.png',
            'Order': 238,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:33:44',
            'Categories': [],
            'Created': '07/24/2017 13:33:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 973,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-973.png',
            'Order': 241,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:34:16',
            'Categories': [],
            'Created': '07/24/2017 13:34:16',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 979,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-979.png',
            'Order': 247,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:35:26',
            'Categories': [],
            'Created': '07/24/2017 13:35:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 981,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-981.png',
            'Order': 249,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:36:00',
            'Categories': [],
            'Created': '07/24/2017 13:36:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 986,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-986.png',
            'Order': 254,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:36:33',
            'Categories': [],
            'Created': '07/24/2017 13:36:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 990,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-990.png',
            'Order': 258,
            'Size': '{Width=2585, Height=1723}',
            'Title': 'taart_overall_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:37:03',
            'Categories': [],
            'Created': '07/24/2017 13:37:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 995,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-995.png',
            'Order': 263,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:38:49',
            'Categories': [],
            'Created': '07/24/2017 13:38:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 996,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-996.png',
            'Order': 264,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:39:31',
            'Categories': [],
            'Created': '07/24/2017 13:39:31',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 997,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-997.png',
            'Order': 265,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:40:02',
            'Categories': [],
            'Created': '07/24/2017 13:40:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1000,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1000.png',
            'Order': 268,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:41:09',
            'Categories': [],
            'Created': '07/24/2017 13:41:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1002,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1002.png',
            'Order': 270,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:41:41',
            'Categories': [],
            'Created': '07/24/2017 13:41:41',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1004,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1004.png',
            'Order': 272,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:42:14',
            'Categories': [],
            'Created': '07/24/2017 13:42:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1006,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1006.png',
            'Order': 274,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:42:44',
            'Categories': [],
            'Created': '07/24/2017 13:42:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1008,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1008.png',
            'Order': 276,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:43:15',
            'Categories': [],
            'Created': '07/24/2017 13:43:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1010,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1010.png',
            'Order': 278,
            'Size': '{Width=2585, Height=1723}',
            'Title': 'taart_overall_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:43:52',
            'Categories': [],
            'Created': '07/24/2017 13:43:52',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1012,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1012.png',
            'Order': 280,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:44:23',
            'Categories': [],
            'Created': '07/24/2017 13:44:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1014,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1014.png',
            'Order': 282,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:47:31',
            'Categories': [],
            'Created': '07/24/2017 13:47:31',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1015,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1015.png',
            'Order': 283,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:40:30',
            'Categories': [],
            'Created': '07/24/2017 13:48:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1016,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1016.png',
            'Order': 284,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:48:45',
            'Categories': [],
            'Created': '07/24/2017 13:48:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1017,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1017.png',
            'Order': 285,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:49:15',
            'Categories': [],
            'Created': '07/24/2017 13:49:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1018,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1018.png',
            'Order': 286,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:49:50',
            'Categories': [],
            'Created': '07/24/2017 13:49:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1019,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1019.png',
            'Order': 287,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:50:24',
            'Categories': [],
            'Created': '07/24/2017 13:50:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1025,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1025.png',
            'Order': 293,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:56:39',
            'Categories': [],
            'Created': '07/24/2017 13:56:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1027,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1027.png',
            'Order': 295,
            'Size': '{Width=2585, Height=1723}',
            'Title': 'taart_overall_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:58:24',
            'Categories': [],
            'Created': '07/24/2017 13:58:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1028,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1028.png',
            'Order': 296,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:00:29',
            'Categories': [],
            'Created': '07/24/2017 14:00:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1030,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1030.png',
            'Order': 298,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:02:05',
            'Categories': [],
            'Created': '07/24/2017 14:02:05',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1032,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1032.png',
            'Order': 300,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_monsters',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:40:41',
            'Categories': [],
            'Created': '07/24/2017 14:04:28',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1035,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1035.png',
            'Order': 303,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:06:34',
            'Categories': [],
            'Created': '07/24/2017 14:06:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1037,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1037.png',
            'Order': 305,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:08:05',
            'Categories': [],
            'Created': '07/24/2017 14:08:05',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1041,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1041.png',
            'Order': 309,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:09:41',
            'Categories': [],
            'Created': '07/24/2017 14:09:41',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1044,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1044.png',
            'Order': 312,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:12:09',
            'Categories': [],
            'Created': '07/24/2017 14:12:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1049,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1049.png',
            'Order': 317,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:14:11',
            'Categories': [],
            'Created': '07/24/2017 14:14:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1051,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1051.png',
            'Order': 319,
            'Size': '{Width=2584, Height=1723}',
            'Title': 'taart_overall_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:16:34',
            'Categories': [],
            'Created': '07/24/2017 14:16:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1055,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1055.png',
            'Order': 323,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:19:20',
            'Categories': [],
            'Created': '07/24/2017 14:19:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1065,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1065.png',
            'Order': 333,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:27:19',
            'Categories': [],
            'Created': '07/24/2017 14:27:19',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1068,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1068.png',
            'Order': 336,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_piraat',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:36',
            'Categories': [],
            'Created': '07/24/2017 14:29:41',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1072,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1072.png',
            'Order': 340,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:31:32',
            'Categories': [],
            'Created': '07/24/2017 14:31:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1076,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1076.png',
            'Order': 344,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:34:08',
            'Categories': [],
            'Created': '07/24/2017 14:34:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1086,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1086.png',
            'Order': 354,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:43:26',
            'Categories': [],
            'Created': '07/24/2017 14:43:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1101,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1101.png',
            'Order': 369,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:58:52',
            'Categories': [],
            'Created': '07/24/2017 14:58:52',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1106,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1106.png',
            'Order': 374,
            'Size': '{Width=2585, Height=1725}',
            'Title': 'taart_kader_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:02:21',
            'Categories': [],
            'Created': '07/24/2017 15:02:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1110,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1110.png',
            'Order': 378,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_overall_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:06:11',
            'Categories': [],
            'Created': '07/24/2017 15:06:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1119,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1119.png',
            'Order': 387,
            'Size': '{Width=3448, Height=2298}',
            'Title': 'mega taart_kader_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:10:04',
            'Categories': [],
            'Created': '07/24/2017 15:10:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1122,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1122.png',
            'Order': 390,
            'Size': '{Width=533, Height=456}',
            'Title': 'Minitompouce_kader_jipjannneke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:12:16',
            'Categories': [],
            'Created': '07/24/2017 15:12:16',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1125,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1125.png',
            'Order': 393,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:12:45',
            'Categories': [],
            'Created': '07/24/2017 15:12:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1126,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1126.png',
            'Order': 394,
            'Size': '{Width=533, Height=456}',
            'Title': 'Minitompouce_overall_jipjanneke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:13:25',
            'Categories': [],
            'Created': '07/24/2017 15:13:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1127,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1127.png',
            'Order': 395,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_ jongensstropdas',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:14:26',
            'Categories': [],
            'Created': '07/24/2017 15:14:26',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1130,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1130.png',
            'Order': 398,
            'Size': '{Width=3569, Height=3569}',
            'Title': 'taart3D_overall_princes',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:05',
            'Categories': [],
            'Created': '07/24/2017 15:15:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1131,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1131.png',
            'Order': 399,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_stropdasjongens',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:15:48',
            'Categories': [],
            'Created': '07/24/2017 15:15:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1133,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1133.png',
            'Order': 401,
            'Size': '{Width=1119, Height=456}',
            'Title': 'Tompouce_kader_jipjaneke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:17:25',
            'Categories': [],
            'Created': '07/24/2017 15:17:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1134,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1134.jpg',
            'Order': 402,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_verkeerjongens',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:17:56',
            'Categories': [],
            'Created': '07/24/2017 15:17:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1138,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1138.png',
            'Order': 406,
            'Size': '{Width=2652, Height=3103}',
            'Title': 'Tompouce_overall_jipjaneke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:19:20',
            'Categories': [],
            'Created': '07/24/2017 15:19:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1154,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1154.png',
            'Order': 422,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'Taart-L_kader_jipjannke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:28:35',
            'Categories': [],
            'Created': '07/24/2017 15:28:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1159,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1159.png',
            'Order': 427,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'Taart-L_overal_jipjannke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:31:03',
            'Categories': [],
            'Created': '07/24/2017 15:31:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1164,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1164.png',
            'Order': 432,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'MegaTaart-L_kader_jipjannke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:35:17',
            'Categories': [],
            'Created': '07/24/2017 15:35:17',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1169,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1169.png',
            'Order': 437,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'MegaTaart-L_overall_jipjannke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:38:27',
            'Categories': [],
            'Created': '07/24/2017 15:38:27',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1179,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1179.png',
            'Order': 447,
            'Size': '{Width=3567, Height=3567}',
            'Title': '3DTaart_overall_jipjannke',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:36',
            'Categories': [],
            'Created': '07/24/2017 15:41:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1192,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1192.png',
            'Order': 458,
            'Size': '{Width=533, Height=456}',
            'Title': 'Minitompouce_L_kader_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:47:54',
            'Categories': [],
            'Created': '07/24/2017 15:47:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1195,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1195.png',
            'Order': 460,
            'Size': '{Width=1131, Height=469}',
            'Title': 'Tompouce_L_kader_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:54:12',
            'Categories': [],
            'Created': '07/24/2017 15:54:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1200,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1200.png',
            'Order': 465,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'Taart_L_kader_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:57:48',
            'Categories': [],
            'Created': '07/24/2017 15:57:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1204,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1204.png',
            'Order': 469,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'Taart_L_overall_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 16:01:08',
            'Categories': [],
            'Created': '07/24/2017 16:01:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1207,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1207.png',
            'Order': 471,
            'Size': '{Width=3446, Height=2297}',
            'Title': 'MegaTaart_L_kader_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 16:04:32',
            'Categories': [],
            'Created': '07/24/2017 16:04:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1209,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1209.png',
            'Order': 473,
            'Size': '{Width=4535, Height=3236}',
            'Title': 'MegaTaart_L_overall_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 16:07:43',
            'Categories': [],
            'Created': '07/24/2017 16:07:43',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1211,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1211.png',
            'Order': 55,
            'Size': '{Width=3567, Height=3567}',
            'Title': '3DTaart_overall_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:34:41',
            'Categories': [],
            'Created': '07/24/2017 16:11:35',
            'ProductTypes': []
          }
        ],
        'Fonts': [],
        'Stickers': []
      },
      {
        'CategoryId': 8,
        'Name': '05 Effen kleuren',
        'Order': 6,
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 776,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-776.png',
            'Order': 44,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:37:04',
            'Categories': [],
            'Created': '07/24/2017 11:35:36',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 781,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-781.png',
            'Order': 49,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:38:37',
            'Categories': [],
            'Created': '07/24/2017 11:38:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 782,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-782.png',
            'Order': 50,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:39:27',
            'Categories': [],
            'Created': '07/24/2017 11:39:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 783,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-783.png',
            'Order': 51,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:39:58',
            'Categories': [],
            'Created': '07/24/2017 11:39:58',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 787,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-787.png',
            'Order': 56,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:34:49',
            'Categories': [],
            'Created': '07/24/2017 11:41:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 791,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-791.png',
            'Order': 60,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:43:39',
            'Categories': [],
            'Created': '07/24/2017 11:43:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 793,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-793.png',
            'Order': 62,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:44:22',
            'Categories': [],
            'Created': '07/24/2017 11:44:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 796,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-796.png',
            'Order': 65,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:45:00',
            'Categories': [],
            'Created': '07/24/2017 11:45:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 798,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-798.png',
            'Order': 67,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:45:28',
            'Categories': [],
            'Created': '07/24/2017 11:45:28',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 800,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-800.png',
            'Order': 69,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:35:32',
            'Categories': [],
            'Created': '07/24/2017 11:46:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 811,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-811.png',
            'Order': 80,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:50:23',
            'Categories': [],
            'Created': '07/24/2017 11:50:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 813,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-813.png',
            'Order': 82,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:50:56',
            'Categories': [],
            'Created': '07/24/2017 11:50:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 815,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-815.png',
            'Order': 84,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:51:26',
            'Categories': [],
            'Created': '07/24/2017 11:51:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 816,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-816.png',
            'Order': 85,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:52:21',
            'Categories': [],
            'Created': '07/24/2017 11:52:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 819,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-819.png',
            'Order': 88,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:53:10',
            'Categories': [],
            'Created': '07/24/2017 11:53:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 822,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-822.png',
            'Order': 90,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:54:25',
            'Categories': [],
            'Created': '07/24/2017 11:54:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 823,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-823.png',
            'Order': 91,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:54:59',
            'Categories': [],
            'Created': '07/24/2017 11:54:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 825,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-825.png',
            'Order': 93,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:57:19',
            'Categories': [],
            'Created': '07/24/2017 11:57:19',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 826,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-826.png',
            'Order': 94,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:00',
            'Categories': [],
            'Created': '07/24/2017 11:57:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 828,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-828.png',
            'Order': 96,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:00:35',
            'Categories': [],
            'Created': '07/24/2017 11:59:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 829,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-829.png',
            'Order': 97,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:01:06',
            'Categories': [],
            'Created': '07/24/2017 11:59:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 830,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-830.png',
            'Order': 98,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:06:15',
            'Categories': [],
            'Created': '07/24/2017 12:06:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 831,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-831.png',
            'Order': 99,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:06:45',
            'Categories': [],
            'Created': '07/24/2017 12:06:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 832,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-832.png',
            'Order': 100,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:07:21',
            'Categories': [],
            'Created': '07/24/2017 12:07:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 833,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-833.png',
            'Order': 101,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:07:45',
            'Categories': [],
            'Created': '07/24/2017 12:07:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 834,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-834.png',
            'Order': 102,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:08:10',
            'Categories': [],
            'Created': '07/24/2017 12:08:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 835,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-835.png',
            'Order': 103,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:08:39',
            'Categories': [],
            'Created': '07/24/2017 12:08:39',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 836,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-836.png',
            'Order': 104,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:21',
            'Categories': [],
            'Created': '07/24/2017 12:09:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 837,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-837.png',
            'Order': 105,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:10:05',
            'Categories': [],
            'Created': '07/24/2017 12:10:05',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 838,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-838.png',
            'Order': 106,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:10:29',
            'Categories': [],
            'Created': '07/24/2017 12:10:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 839,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-839.png',
            'Order': 107,
            'Size': '{Width=456, Height=1119}',
            'Title': 'tompouce_kader_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:19:04',
            'Categories': [],
            'Created': '07/24/2017 12:11:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 840,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-840.png',
            'Order': 108,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:12:03',
            'Categories': [],
            'Created': '07/24/2017 12:12:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 841,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-841.png',
            'Order': 109,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:12:30',
            'Categories': [],
            'Created': '07/24/2017 12:12:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 842,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-842.png',
            'Order': 110,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:13:18',
            'Categories': [],
            'Created': '07/24/2017 12:13:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 843,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-843.png',
            'Order': 111,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:13:42',
            'Categories': [],
            'Created': '07/24/2017 12:13:42',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 844,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-844.png',
            'Order': 112,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_oranje',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:27',
            'Categories': [],
            'Created': '07/24/2017 12:14:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 845,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-845.png',
            'Order': 113,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:15:11',
            'Categories': [],
            'Created': '07/24/2017 12:14:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 846,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-846.png',
            'Order': 114,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:15:40',
            'Categories': [],
            'Created': '07/24/2017 12:15:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 847,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-847.png',
            'Order': 115,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:17:19',
            'Categories': [],
            'Created': '07/24/2017 12:16:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 848,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-848.png',
            'Order': 116,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:20:20',
            'Categories': [],
            'Created': '07/24/2017 12:20:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 849,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-849.png',
            'Order': 117,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:21:13',
            'Categories': [],
            'Created': '07/24/2017 12:21:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 850,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-850.png',
            'Order': 118,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:21:37',
            'Categories': [],
            'Created': '07/24/2017 12:21:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 851,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-851.png',
            'Order': 119,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:22:37',
            'Categories': [],
            'Created': '07/24/2017 12:22:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 852,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-852.png',
            'Order': 120,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:23:00',
            'Categories': [],
            'Created': '07/24/2017 12:23:00',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 853,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-853.png',
            'Order': 121,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:33',
            'Categories': [],
            'Created': '07/24/2017 12:23:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1029,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1029.jpg',
            'Order': 297,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_blauw',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:29',
            'Categories': [],
            'Created': '07/24/2017 14:01:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1031,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1031.jpg',
            'Order': 299,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_groen',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:46',
            'Categories': [],
            'Created': '07/24/2017 14:03:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1034,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1034.jpg',
            'Order': 302,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geel',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:13',
            'Categories': [],
            'Created': '07/24/2017 14:05:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1042,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1042.jpg',
            'Order': 310,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_rozerood',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:40:53',
            'Categories': [],
            'Created': '07/24/2017 14:09:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1043,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1043.jpg',
            'Order': 311,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_roze',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:34:29',
            'Categories': [],
            'Created': '07/24/2017 14:10:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1046,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1046.jpg',
            'Order': 314,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_fuchsia',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:37:57',
            'Categories': [],
            'Created': '07/24/2017 14:13:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1111,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1111.jpg',
            'Order': 379,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'hart_taart_blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 15:07:29',
            'Categories': [],
            'Created': '07/24/2017 15:07:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1112,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1112.jpg',
            'Order': 380,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'hart_taart_groen',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 15:07:57',
            'Categories': [],
            'Created': '07/24/2017 15:07:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1116,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1116.jpg',
            'Order': 384,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'hart_taart_geel',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 15:09:12',
            'Categories': [],
            'Created': '07/24/2017 15:09:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1118,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1118.jpg',
            'Order': 386,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'hart_taart_rozerood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 15:10:03',
            'Categories': [],
            'Created': '07/24/2017 15:10:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1121,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1121.jpg',
            'Order': 389,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'hart_taart_fuchsia',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 15:11:05',
            'Categories': [],
            'Created': '07/24/2017 15:11:05',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1136,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1136.jpg',
            'Order': 404,
            'Size': '{Width=1712, Height=1712}',
            'Title': 'taart3d_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:13',
            'Categories': [],
            'Created': '07/24/2017 15:18:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1155,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1155.jpg',
            'Order': 423,
            'Size': '{Width=331, Height=331}',
            'Title': 'Choco_lolly_blauw',
            'LastModifiedBy': 'HEMALOCAL\\schroderr',
            'LastModified': '07/24/2017 15:28:58',
            'Categories': [],
            'Created': '07/24/2017 15:28:58',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1167,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1167.jpg',
            'Order': 435,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_blauw',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:37:07',
            'Categories': [],
            'Created': '07/24/2017 15:37:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1173,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1173.jpg',
            'Order': 441,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_groen',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:39:13',
            'Categories': [],
            'Created': '07/24/2017 15:39:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1177,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1177.jpg',
            'Order': 445,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_geel',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:40:57',
            'Categories': [],
            'Created': '07/24/2017 15:40:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1188,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1188.jpg',
            'Order': 455,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_fuchsia',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:45:13',
            'Categories': [],
            'Created': '07/24/2017 15:45:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1191,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1191.jpg',
            'Order': 457,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_roze',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:47:42',
            'Categories': [],
            'Created': '07/24/2017 15:47:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1196,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1196.jpg',
            'Order': 461,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_hardroze',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:54:24',
            'Categories': [],
            'Created': '07/24/2017 15:54:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1212,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1212.jpg',
            'Order': 476,
            'Size': '{Width=301, Height=537}',
            'Title': 'choco iphone_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:18:31',
            'Categories': [],
            'Created': '07/26/2017 08:18:31',
            'ProductTypes': []
          }
        ],
        'Fonts': [],
        'Stickers': []
      },
      {
        'CategoryId': 9,
        'Name': '06 Sport',
        'Order': 7,
        'Backgrounds': [],
        'Fonts': [],
        'Stickers': []
      },
      {
        'CategoryId': 12,
        'Name': '09 Geslaagd',
        'Order': 8,
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 855,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-855.png',
            'Order': 123,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:40:02',
            'Categories': [],
            'Created': '07/24/2017 12:40:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 856,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-856.png',
            'Order': 124,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:42:07',
            'Categories': [],
            'Created': '07/24/2017 12:42:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 857,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-857.png',
            'Order': 125,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:42:37',
            'Categories': [],
            'Created': '07/24/2017 12:42:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 859,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-859.png',
            'Order': 127,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:43:07',
            'Categories': [],
            'Created': '07/24/2017 12:43:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 860,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-860.png',
            'Order': 128,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:43:43',
            'Categories': [],
            'Created': '07/24/2017 12:43:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 862,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-862.png',
            'Order': 130,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:44:10',
            'Categories': [],
            'Created': '07/24/2017 12:44:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 863,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-863.png',
            'Order': 131,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:44:37',
            'Categories': [],
            'Created': '07/24/2017 12:44:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 865,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-865.png',
            'Order': 133,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:45:12',
            'Categories': [],
            'Created': '07/24/2017 12:45:12',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 867,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-867.png',
            'Order': 135,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:43',
            'Categories': [],
            'Created': '07/24/2017 12:45:48',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 868,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-868.png',
            'Order': 136,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_zwemdiploma_01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:51',
            'Categories': [],
            'Created': '07/24/2017 12:46:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 870,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-870.png',
            'Order': 138,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:46:56',
            'Categories': [],
            'Created': '07/24/2017 12:46:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 872,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-872.png',
            'Order': 140,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:47:24',
            'Categories': [],
            'Created': '07/24/2017 12:47:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 873,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-873.png',
            'Order': 141,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:47:30',
            'Categories': [],
            'Created': '07/24/2017 12:47:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 875,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-875.png',
            'Order': 143,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:48:11',
            'Categories': [],
            'Created': '07/24/2017 12:48:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 876,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-876.png',
            'Order': 144,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:49:11',
            'Categories': [],
            'Created': '07/24/2017 12:49:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 878,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-878.png',
            'Order': 146,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:49:51',
            'Categories': [],
            'Created': '07/24/2017 12:49:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 890,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-890.png',
            'Order': 158,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:55:50',
            'Categories': [],
            'Created': '07/24/2017 12:55:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 892,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-892.png',
            'Order': 160,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:56:17',
            'Categories': [],
            'Created': '07/24/2017 12:56:17',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 895,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-895.png',
            'Order': 163,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:56:48',
            'Categories': [],
            'Created': '07/24/2017 12:56:48',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 897,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-897.png',
            'Order': 165,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:37:33',
            'Categories': [],
            'Created': '07/24/2017 12:57:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 899,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-899.png',
            'Order': 167,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:58:11',
            'Categories': [],
            'Created': '07/24/2017 12:58:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 901,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-901.png',
            'Order': 169,
            'Size': '{Width=533, Height=457}',
            'Title': 'mini tompouce_overall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:58:42',
            'Categories': [],
            'Created': '07/24/2017 12:58:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 903,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-903.png',
            'Order': 171,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:59:09',
            'Categories': [],
            'Created': '07/24/2017 12:59:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 905,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-905.png',
            'Order': 173,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:59:33',
            'Categories': [],
            'Created': '07/24/2017 12:59:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 906,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-906.png',
            'Order': 174,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:59:57',
            'Categories': [],
            'Created': '07/24/2017 12:59:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 909,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-909.png',
            'Order': 177,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:01:27',
            'Categories': [],
            'Created': '07/24/2017 13:00:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 911,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-911.png',
            'Order': 179,
            'Size': '{Width=3446, Height=2299}',
            'Title': 'maxi party cake_kader_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:01:55',
            'Categories': [],
            'Created': '07/24/2017 13:01:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 913,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-913.png',
            'Order': 181,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_koverall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:02:33',
            'Categories': [],
            'Created': '07/24/2017 13:02:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 916,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-916.png',
            'Order': 184,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:03:11',
            'Categories': [],
            'Created': '07/24/2017 13:03:11',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 918,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-918.png',
            'Order': 186,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:38:51',
            'Categories': [],
            'Created': '07/24/2017 13:10:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 919,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-919.png',
            'Order': 187,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:11:07',
            'Categories': [],
            'Created': '07/24/2017 13:11:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 921,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-921.png',
            'Order': 189,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:11:49',
            'Categories': [],
            'Created': '07/24/2017 13:11:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 923,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-923.png',
            'Order': 191,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:12:19',
            'Categories': [],
            'Created': '07/24/2017 13:12:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 924,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-924.png',
            'Order': 192,
            'Size': '{Width=1119, Height=457}',
            'Title': 'tompouce_overall_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:12:48',
            'Categories': [],
            'Created': '07/24/2017 13:12:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 925,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-925.png',
            'Order': 193,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:13:37',
            'Categories': [],
            'Created': '07/24/2017 13:13:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 926,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-926.png',
            'Order': 194,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:14:09',
            'Categories': [],
            'Created': '07/24/2017 13:14:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 927,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-927.png',
            'Order': 195,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:14:40',
            'Categories': [],
            'Created': '07/24/2017 13:14:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 928,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-928.png',
            'Order': 196,
            'Size': '{Width=3454, Height=2296}',
            'Title': 'maxi party cake_overall_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:15:11',
            'Categories': [],
            'Created': '07/24/2017 13:15:11',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 929,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-929.png',
            'Order': 197,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overallr_ijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:20',
            'Categories': [],
            'Created': '07/24/2017 13:15:53',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1069,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1069.png',
            'Order': 337,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geslaagd',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:40:32',
            'Categories': [],
            'Created': '07/24/2017 14:29:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1120,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1120.png',
            'Order': 388,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:10:27',
            'Categories': [],
            'Created': '07/24/2017 15:10:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1147,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1147.png',
            'Order': 415,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:24:02',
            'Categories': [],
            'Created': '07/24/2017 15:24:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1148,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1148.png',
            'Order': 416,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:24:15',
            'Categories': [],
            'Created': '07/24/2017 15:24:15',
            'ProductTypes': []
          }
        ],
        'Fonts': [],
        'Stickers': []
      },
      {
        'CategoryId': 13,
        'Name': '10 Liefde & Huwelijk',
        'Order': 9,
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 945,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-945.png',
            'Order': 213,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:27:08',
            'Categories': [],
            'Created': '07/24/2017 13:27:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 958,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-958.png',
            'Order': 226,
            'Size': '{Width=534, Height=457}',
            'Title': 'mini tompouce_overall_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:31:32',
            'Categories': [],
            'Created': '07/24/2017 13:31:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 960,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-960.png',
            'Order': 228,
            'Size': '{Width=1119, Height=457}',
            'Title': 'tompouce_kader_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:32:09',
            'Categories': [],
            'Created': '07/24/2017 13:32:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 962,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-962.png',
            'Order': 230,
            'Size': '{Width=1120, Height=457}',
            'Title': 'tompouce_overall_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:32:35',
            'Categories': [],
            'Created': '07/24/2017 13:32:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 966,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-966.png',
            'Order': 234,
            'Size': '{Width=2584, Height=1723}',
            'Title': 'party cake_kader_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:33:04',
            'Categories': [],
            'Created': '07/24/2017 13:33:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 968,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-968.png',
            'Order': 236,
            'Size': '{Width=2584, Height=1723}',
            'Title': 'party cake_overall_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:33:33',
            'Categories': [],
            'Created': '07/24/2017 13:33:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 971,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-971.png',
            'Order': 239,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:34:04',
            'Categories': [],
            'Created': '07/24/2017 13:34:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 974,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-974.png',
            'Order': 242,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:40:49',
            'Categories': [],
            'Created': '07/24/2017 13:34:33',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 977,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-977.png',
            'Order': 245,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:33',
            'Categories': [],
            'Created': '07/24/2017 13:35:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 982,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-982.png',
            'Order': 250,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:39:46',
            'Categories': [],
            'Created': '07/24/2017 13:36:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 985,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-985.png',
            'Order': 253,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:53:37',
            'Categories': [],
            'Created': '07/24/2017 13:36:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 989,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-989.png',
            'Order': 257,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:54:21',
            'Categories': [],
            'Created': '07/24/2017 13:36:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 992,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-992.png',
            'Order': 260,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:55:41',
            'Categories': [],
            'Created': '07/24/2017 13:37:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 994,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-994.png',
            'Order': 262,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:57:39',
            'Categories': [],
            'Created': '07/24/2017 13:38:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1045,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1045.png',
            'Order': 313,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:19:47',
            'Categories': [],
            'Created': '07/24/2017 14:12:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1047,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1047.png',
            'Order': 315,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:14:03',
            'Categories': [],
            'Created': '07/24/2017 14:14:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1058,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1058.png',
            'Order': 326,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:21:35',
            'Categories': [],
            'Created': '07/24/2017 14:21:35',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1060,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1060.png',
            'Order': 328,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:29',
            'Categories': [],
            'Created': '07/24/2017 14:22:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1061,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1061.png',
            'Order': 329,
            'Size': '{Width=1134, Height=638}',
            'Title': 'mini tompouce_kader_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:24:34',
            'Categories': [],
            'Created': '07/24/2017 14:24:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1063,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1063.png',
            'Order': 331,
            'Size': '{Width=1134, Height=638}',
            'Title': 'mini tompouce_overall_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:26:04',
            'Categories': [],
            'Created': '07/24/2017 14:26:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1067,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1067.png',
            'Order': 335,
            'Size': '{Width=2094, Height=643}',
            'Title': 'tompouce_kader_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:28:41',
            'Categories': [],
            'Created': '07/24/2017 14:28:41',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1070,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1070.png',
            'Order': 338,
            'Size': '{Width=2094, Height=643}',
            'Title': 'tompouce_overall_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:30:33',
            'Categories': [],
            'Created': '07/24/2017 14:30:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1073,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1073.png',
            'Order': 341,
            'Size': '{Width=3843, Height=2747}',
            'Title': 'party cake_kader_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:32:23',
            'Categories': [],
            'Created': '07/24/2017 14:32:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1075,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1075.png',
            'Order': 343,
            'Size': '{Width=3843, Height=2747}',
            'Title': 'party cake_overall_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:33:46',
            'Categories': [],
            'Created': '07/24/2017 14:33:46',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1077,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1077.png',
            'Order': 345,
            'Size': '{Width=5124, Height=3663}',
            'Title': 'maxi party cake_kader_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:35:05',
            'Categories': [],
            'Created': '07/24/2017 14:35:05',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1078,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1078.png',
            'Order': 346,
            'Size': '{Width=5124, Height=3663}',
            'Title': 'maxi party cake_overall_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:36:22',
            'Categories': [],
            'Created': '07/24/2017 14:36:22',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1079,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1079.png',
            'Order': 347,
            'Size': '{Width=5124, Height=3706}',
            'Title': 'taart3d_overall_confetti',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:43',
            'Categories': [],
            'Created': '07/24/2017 14:37:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1082,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1082.png',
            'Order': 350,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:41:10',
            'Categories': [],
            'Created': '07/24/2017 14:41:10',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1083,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1083.png',
            'Order': 351,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'taart3d_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:55',
            'Categories': [],
            'Created': '07/24/2017 14:41:36',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1084,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1084.png',
            'Order': 352,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:42:27',
            'Categories': [],
            'Created': '07/24/2017 14:42:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1087,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1087.png',
            'Order': 355,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:43:37',
            'Categories': [],
            'Created': '07/24/2017 14:43:37',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1088,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1088.png',
            'Order': 356,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'taart3d_overall_valentijnwit',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:44:35',
            'Categories': [],
            'Created': '07/24/2017 14:44:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1089,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1089.png',
            'Order': 357,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:45:01',
            'Categories': [],
            'Created': '07/24/2017 14:45:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1090,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1090.png',
            'Order': 358,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:46:27',
            'Categories': [],
            'Created': '07/24/2017 14:46:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1091,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1091.png',
            'Order': 359,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:47:42',
            'Categories': [],
            'Created': '07/24/2017 14:47:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1092,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1092.png',
            'Order': 360,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:49:04',
            'Categories': [],
            'Created': '07/24/2017 14:49:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1094,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1094.png',
            'Order': 362,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:50:32',
            'Categories': [],
            'Created': '07/24/2017 14:50:32',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1096,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1096.png',
            'Order': 364,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:44:44',
            'Categories': [],
            'Created': '07/24/2017 14:52:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1157,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1157.png',
            'Order': 425,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_hartje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:35:03',
            'Categories': [],
            'Created': '07/24/2017 15:29:47',
            'ProductTypes': []
          }
        ],
        'Fonts': [],
        'Stickers': []
      },
      {
        'CategoryId': 14,
        'Name': '11 Momenten',
        'Order': 10,
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 824,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-824.png',
            'Order': 92,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:56:55',
            'Categories': [],
            'Created': '07/24/2017 11:56:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 827,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-827.png',
            'Order': 95,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:59:04',
            'Categories': [],
            'Created': '07/24/2017 11:59:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 943,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-943.png',
            'Order': 211,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:26:02',
            'Categories': [],
            'Created': '07/24/2017 13:26:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 944,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-944.png',
            'Order': 212,
            'Size': '{Width=3543, Height=3682}',
            'Title': 'tompouce_overall_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:26:59',
            'Categories': [],
            'Created': '07/24/2017 13:26:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 946,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-946.png',
            'Order': 214,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:27:36',
            'Categories': [],
            'Created': '07/24/2017 13:27:36',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 948,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-948.png',
            'Order': 216,
            'Size': '{Width=3543, Height=3682}',
            'Title': 'party cake_overall_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:28:06',
            'Categories': [],
            'Created': '07/24/2017 13:28:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 950,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-950.png',
            'Order': 218,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:28:48',
            'Categories': [],
            'Created': '07/24/2017 13:28:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 952,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-952.png',
            'Order': 220,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'maxi party cake_overall',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:30:53',
            'Categories': [],
            'Created': '07/24/2017 13:29:39',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 954,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-954.png',
            'Order': 222,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:13',
            'Categories': [],
            'Created': '07/24/2017 13:29:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 964,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-964.png',
            'Order': 232,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:32:44',
            'Categories': [],
            'Created': '07/24/2017 13:32:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 967,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-967.png',
            'Order': 235,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:33:16',
            'Categories': [],
            'Created': '07/24/2017 13:33:16',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 969,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-969.png',
            'Order': 237,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:33:38',
            'Categories': [],
            'Created': '07/24/2017 13:33:38',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 972,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-972.png',
            'Order': 240,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:34:14',
            'Categories': [],
            'Created': '07/24/2017 13:34:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 975,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-975.png',
            'Order': 243,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:34:42',
            'Categories': [],
            'Created': '07/24/2017 13:34:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 976,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-976.png',
            'Order': 244,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:34:51',
            'Categories': [],
            'Created': '07/24/2017 13:34:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 978,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-978.png',
            'Order': 246,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'tompouce_overall_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:35:24',
            'Categories': [],
            'Created': '07/24/2017 13:35:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 980,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-980.png',
            'Order': 248,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:35:53',
            'Categories': [],
            'Created': '07/24/2017 13:35:53',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 984,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-984.png',
            'Order': 252,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:36:25',
            'Categories': [],
            'Created': '07/24/2017 13:36:25',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 987,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-987.png',
            'Order': 255,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:44',
            'Categories': [],
            'Created': '07/24/2017 13:36:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1033,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1033.png',
            'Order': 301,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:04:40',
            'Categories': [],
            'Created': '07/24/2017 14:04:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1036,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1036.png',
            'Order': 304,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:06:38',
            'Categories': [],
            'Created': '07/24/2017 14:06:38',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1039,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1039.png',
            'Order': 307,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:08:21',
            'Categories': [],
            'Created': '07/24/2017 14:08:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1040,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1040.png',
            'Order': 308,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:09:36',
            'Categories': [],
            'Created': '07/24/2017 14:09:36',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1071,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1071.png',
            'Order': 339,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_suikerfeest',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:55',
            'Categories': [],
            'Created': '07/24/2017 14:31:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1093,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1093.png',
            'Order': 361,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:50:14',
            'Categories': [],
            'Created': '07/24/2017 14:50:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1095,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1095.png',
            'Order': 363,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:51:53',
            'Categories': [],
            'Created': '07/24/2017 14:51:53',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1097,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1097.png',
            'Order': 365,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:53:49',
            'Categories': [],
            'Created': '07/24/2017 14:53:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1099,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1099.png',
            'Order': 367,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:55:48',
            'Categories': [],
            'Created': '07/24/2017 14:55:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1105,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1105.png',
            'Order': 373,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:02:21',
            'Categories': [],
            'Created': '07/24/2017 15:02:21',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1107,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1107.png',
            'Order': 375,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_herfst',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:44:52',
            'Categories': [],
            'Created': '07/24/2017 15:04:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1114,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1114.png',
            'Order': 382,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:08:23',
            'Categories': [],
            'Created': '07/24/2017 15:08:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1123,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1123.png',
            'Order': 391,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:12:22',
            'Categories': [],
            'Created': '07/24/2017 15:12:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1135,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1135.png',
            'Order': 403,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:17:56',
            'Categories': [],
            'Created': '07/24/2017 15:17:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1139,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1139.png',
            'Order': 407,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:19:42',
            'Categories': [],
            'Created': '07/24/2017 15:19:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1152,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1152.png',
            'Order': 420,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:26:49',
            'Categories': [],
            'Created': '07/24/2017 15:26:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1158,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1158.png',
            'Order': 426,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:30:14',
            'Categories': [],
            'Created': '07/24/2017 15:30:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1161,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1161.png',
            'Order': 429,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:32:44',
            'Categories': [],
            'Created': '07/24/2017 15:32:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1163,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1163.png',
            'Order': 431,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:35:06',
            'Categories': [],
            'Created': '07/24/2017 15:35:06',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1165,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1165.png',
            'Order': 433,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:46:31',
            'Categories': [],
            'Created': '07/24/2017 15:35:41',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1168,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1168.png',
            'Order': 436,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:38:22',
            'Categories': [],
            'Created': '07/24/2017 15:38:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1171,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1171.png',
            'Order': 439,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:38:44',
            'Categories': [],
            'Created': '07/24/2017 15:38:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1175,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1175.png',
            'Order': 443,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:40:19',
            'Categories': [],
            'Created': '07/24/2017 15:40:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1178,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1178.png',
            'Order': 446,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:40:57',
            'Categories': [],
            'Created': '07/24/2017 15:40:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1180,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1180.png',
            'Order': 448,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:41:38',
            'Categories': [],
            'Created': '07/24/2017 15:41:38',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1181,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1181.png',
            'Order': 449,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:42:28',
            'Categories': [],
            'Created': '07/24/2017 15:42:28',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1184,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1184.png',
            'Order': 450,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:42:45',
            'Categories': [],
            'Created': '07/24/2017 15:42:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1186,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1186.png',
            'Order': 453,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:43:52',
            'Categories': [],
            'Created': '07/24/2017 15:43:52',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1187,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1187.png',
            'Order': 454,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_winter',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:45',
            'Categories': [],
            'Created': '07/24/2017 15:44:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1189,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1189.png',
            'Order': 455,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_lente',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:45:20',
            'Categories': [],
            'Created': '07/24/2017 15:45:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1190,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1190.png',
            'Order': 456,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_lente',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:47:16',
            'Categories': [],
            'Created': '07/24/2017 15:47:16',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1193,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1193.png',
            'Order': 458,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_lente',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:48:18',
            'Categories': [],
            'Created': '07/24/2017 15:48:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1194,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1194.png',
            'Order': 459,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_lente',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:49:19',
            'Categories': [],
            'Created': '07/24/2017 15:49:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1197,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1197.png',
            'Order': 462,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_lente_01',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:55:51',
            'Categories': [],
            'Created': '07/24/2017 15:55:51',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1199,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1199.png',
            'Order': 464,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_lente-01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:55',
            'Categories': [],
            'Created': '07/24/2017 15:56:50',
            'ProductTypes': []
          }
        ],
        'Fonts': [],
        'Stickers': []
      }
    ],
    'FontColors': [
      {
        'FontcolorId': 14,
        'Order': 0,
        'HexColor': 'ffff00'
      },
      {
        'FontcolorId': 15,
        'Order': 0,
        'HexColor': '85c9b4'
      },
      {
        'FontcolorId': 16,
        'Order': 0,
        'HexColor': '29a59c'
      },
      {
        'FontcolorId': 17,
        'Order': 0,
        'HexColor': '293162'
      },
      {
        'FontcolorId': 18,
        'Order': 0,
        'HexColor': 'f4abcc'
      },
      {
        'FontcolorId': 19,
        'Order': 0,
        'HexColor': '8abde9'
      },
      {
        'FontcolorId': 20,
        'Order': 0,
        'HexColor': 'eb6995'
      },
      {
        'FontcolorId': 2,
        'Order': 1,
        'HexColor': 'ff9900'
      },
      {
        'FontcolorId': 5,
        'Order': 2,
        'HexColor': '0000ff'
      },
      {
        'FontcolorId': 4,
        'Order': 3,
        'HexColor': '00ff00'
      },
      {
        'FontcolorId': 3,
        'Order': 4,
        'HexColor': 'e81011'
      },
      {
        'FontcolorId': 8,
        'Order': 6,
        'HexColor': '000000'
      },
      {
        'FontcolorId': 9,
        'Order': 7,
        'HexColor': 'ff00ff'
      },
      {
        'FontcolorId': 12,
        'Order': 8,
        'HexColor': 'ffffff'
      },
      {
        'FontcolorId': 13,
        'Order': 9,
        'HexColor': '888888'
      }
    ],
    'ProductTypes': [
      {
        'ProductTypeId': 4,
        'Name': 'party-cake-1128x739',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 755,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-755.png',
            'Order': 23,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:07:29',
            'Categories': [],
            'Created': '07/24/2017 11:07:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 756,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-756.png',
            'Order': 24,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:17:59',
            'Categories': [],
            'Created': '07/24/2017 11:17:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 759,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-759.png',
            'Order': 27,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:19:25',
            'Categories': [],
            'Created': '07/24/2017 11:19:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 760,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-760.png',
            'Order': 28,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:19:45',
            'Categories': [],
            'Created': '07/24/2017 11:19:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 763,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-763.png',
            'Order': 31,
            'Size': '{Width=1120, Height=457}',
            'Title': 'party cake_kader_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:21:54',
            'Categories': [],
            'Created': '07/24/2017 11:21:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 764,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-764.png',
            'Order': 32,
            'Size': '{Width=1119, Height=456}',
            'Title': 'party cake_overall_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:22:34',
            'Categories': [],
            'Created': '07/24/2017 11:22:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 767,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-767.png',
            'Order': 35,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:24:18',
            'Categories': [],
            'Created': '07/24/2017 11:24:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 768,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-768.png',
            'Order': 36,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:24:43',
            'Categories': [],
            'Created': '07/24/2017 11:24:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 775,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-775.png',
            'Order': 43,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:28:59',
            'Categories': [],
            'Created': '07/24/2017 11:28:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 777,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-777.png',
            'Order': 45,
            'Size': '{Width=2584, Height=1723}',
            'Title': 'party cake_overall_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:35:37',
            'Categories': [],
            'Created': '07/24/2017 11:35:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 789,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-789.png',
            'Order': 58,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:42:25',
            'Categories': [],
            'Created': '07/24/2017 11:42:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 790,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-790.png',
            'Order': 59,
            'Size': '{Width=2583, Height=1727}',
            'Title': 'party cake_overall_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:43:28',
            'Categories': [],
            'Created': '07/24/2017 11:43:28',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 791,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-791.png',
            'Order': 60,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:43:39',
            'Categories': [],
            'Created': '07/24/2017 11:43:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 793,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-793.png',
            'Order': 62,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:44:22',
            'Categories': [],
            'Created': '07/24/2017 11:44:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 803,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-803.png',
            'Order': 72,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:47:08',
            'Categories': [],
            'Created': '07/24/2017 11:47:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 804,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-804.png',
            'Order': 73,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:47:27',
            'Categories': [],
            'Created': '07/24/2017 11:47:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 814,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-814.png',
            'Order': 83,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:51:01',
            'Categories': [],
            'Created': '07/24/2017 11:51:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 817,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-817.png',
            'Order': 86,
            'Size': '{Width=2583, Height=1727}',
            'Title': 'party cake_overall_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:52:37',
            'Categories': [],
            'Created': '07/24/2017 11:52:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 819,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-819.png',
            'Order': 88,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:53:10',
            'Categories': [],
            'Created': '07/24/2017 11:53:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 822,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-822.png',
            'Order': 90,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:54:25',
            'Categories': [],
            'Created': '07/24/2017 11:54:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 832,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-832.png',
            'Order': 100,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:07:21',
            'Categories': [],
            'Created': '07/24/2017 12:07:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 833,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-833.png',
            'Order': 101,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:07:45',
            'Categories': [],
            'Created': '07/24/2017 12:07:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 840,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-840.png',
            'Order': 108,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:12:03',
            'Categories': [],
            'Created': '07/24/2017 12:12:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 841,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-841.png',
            'Order': 109,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:12:30',
            'Categories': [],
            'Created': '07/24/2017 12:12:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 849,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-849.png',
            'Order': 117,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:21:13',
            'Categories': [],
            'Created': '07/24/2017 12:21:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 850,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-850.png',
            'Order': 118,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:21:37',
            'Categories': [],
            'Created': '07/24/2017 12:21:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 860,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-860.png',
            'Order': 128,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:43:43',
            'Categories': [],
            'Created': '07/24/2017 12:43:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 862,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-862.png',
            'Order': 130,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:44:10',
            'Categories': [],
            'Created': '07/24/2017 12:44:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 866,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-866.png',
            'Order': 134,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:45:39',
            'Categories': [],
            'Created': '07/24/2017 12:45:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 869,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-869.png',
            'Order': 137,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:46:43',
            'Categories': [],
            'Created': '07/24/2017 12:46:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 878,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-878.png',
            'Order': 146,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:49:51',
            'Categories': [],
            'Created': '07/24/2017 12:49:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 882,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-882.png',
            'Order': 150,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:52:01',
            'Categories': [],
            'Created': '07/24/2017 12:52:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 883,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-883.png',
            'Order': 151,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:52:37',
            'Categories': [],
            'Created': '07/24/2017 12:52:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 890,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-890.png',
            'Order': 158,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:55:50',
            'Categories': [],
            'Created': '07/24/2017 12:55:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 896,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-896.png',
            'Order': 164,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:57:13',
            'Categories': [],
            'Created': '07/24/2017 12:57:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 898,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-898.png',
            'Order': 166,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:58:03',
            'Categories': [],
            'Created': '07/24/2017 12:58:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 906,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-906.png',
            'Order': 174,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:59:57',
            'Categories': [],
            'Created': '07/24/2017 12:59:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 909,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-909.png',
            'Order': 177,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:01:27',
            'Categories': [],
            'Created': '07/24/2017 13:00:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 914,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-914.png',
            'Order': 182,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:02:40',
            'Categories': [],
            'Created': '07/24/2017 13:02:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 915,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-915.png',
            'Order': 183,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:03:10',
            'Categories': [],
            'Created': '07/24/2017 13:03:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 925,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-925.png',
            'Order': 193,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:13:37',
            'Categories': [],
            'Created': '07/24/2017 13:13:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 926,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-926.png',
            'Order': 194,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:14:09',
            'Categories': [],
            'Created': '07/24/2017 13:14:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 932,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-932.png',
            'Order': 200,
            'Size': '{Width=2676, Height=2716}',
            'Title': 'taart_kader_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:17:26',
            'Categories': [],
            'Created': '07/24/2017 13:17:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 934,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-934.png',
            'Order': 202,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_overall_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:19:45',
            'Categories': [],
            'Created': '07/24/2017 13:19:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 941,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-941.png',
            'Order': 209,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:22:43',
            'Categories': [],
            'Created': '07/24/2017 13:22:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 942,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-942.png',
            'Order': 210,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:27:41',
            'Categories': [],
            'Created': '07/24/2017 13:23:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 946,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-946.png',
            'Order': 214,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:27:36',
            'Categories': [],
            'Created': '07/24/2017 13:27:36',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 948,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-948.png',
            'Order': 216,
            'Size': '{Width=3543, Height=3682}',
            'Title': 'party cake_overall_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:28:06',
            'Categories': [],
            'Created': '07/24/2017 13:28:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 956,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-956.png',
            'Order': 224,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:30:29',
            'Categories': [],
            'Created': '07/24/2017 13:30:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 957,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-957.png',
            'Order': 225,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_overall_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:31:01',
            'Categories': [],
            'Created': '07/24/2017 13:31:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 966,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-966.png',
            'Order': 234,
            'Size': '{Width=2584, Height=1723}',
            'Title': 'party cake_kader_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:33:04',
            'Categories': [],
            'Created': '07/24/2017 13:33:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 968,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-968.png',
            'Order': 236,
            'Size': '{Width=2584, Height=1723}',
            'Title': 'party cake_overall_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:33:33',
            'Categories': [],
            'Created': '07/24/2017 13:33:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 975,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-975.png',
            'Order': 243,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:34:42',
            'Categories': [],
            'Created': '07/24/2017 13:34:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 976,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-976.png',
            'Order': 244,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:34:51',
            'Categories': [],
            'Created': '07/24/2017 13:34:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 986,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-986.png',
            'Order': 254,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:36:33',
            'Categories': [],
            'Created': '07/24/2017 13:36:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 990,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-990.png',
            'Order': 258,
            'Size': '{Width=2585, Height=1723}',
            'Title': 'taart_overall_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:37:03',
            'Categories': [],
            'Created': '07/24/2017 13:37:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 994,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-994.png',
            'Order': 262,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:57:39',
            'Categories': [],
            'Created': '07/24/2017 13:38:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1001,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1001.png',
            'Order': 269,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:41:32',
            'Categories': [],
            'Created': '07/24/2017 13:41:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1003,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1003.png',
            'Order': 271,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:42:03',
            'Categories': [],
            'Created': '07/24/2017 13:42:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1008,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1008.png',
            'Order': 276,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:43:15',
            'Categories': [],
            'Created': '07/24/2017 13:43:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1010,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1010.png',
            'Order': 278,
            'Size': '{Width=2585, Height=1723}',
            'Title': 'taart_overall_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:43:52',
            'Categories': [],
            'Created': '07/24/2017 13:43:52',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1020,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1020.png',
            'Order': 288,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:52:07',
            'Categories': [],
            'Created': '07/24/2017 13:52:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1021,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1021.png',
            'Order': 289,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:52:28',
            'Categories': [],
            'Created': '07/24/2017 13:52:28',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1022,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1022.png',
            'Order': 290,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:53:20',
            'Categories': [],
            'Created': '07/24/2017 13:53:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1025,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1025.png',
            'Order': 293,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:56:39',
            'Categories': [],
            'Created': '07/24/2017 13:56:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1027,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1027.png',
            'Order': 295,
            'Size': '{Width=2585, Height=1723}',
            'Title': 'taart_overall_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:58:24',
            'Categories': [],
            'Created': '07/24/2017 13:58:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1045,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1045.png',
            'Order': 313,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:19:47',
            'Categories': [],
            'Created': '07/24/2017 14:12:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1049,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1049.png',
            'Order': 317,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:14:11',
            'Categories': [],
            'Created': '07/24/2017 14:14:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1051,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1051.png',
            'Order': 319,
            'Size': '{Width=2584, Height=1723}',
            'Title': 'taart_overall_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:16:34',
            'Categories': [],
            'Created': '07/24/2017 14:16:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1073,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1073.png',
            'Order': 341,
            'Size': '{Width=3843, Height=2747}',
            'Title': 'party cake_kader_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:32:23',
            'Categories': [],
            'Created': '07/24/2017 14:32:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1075,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1075.png',
            'Order': 343,
            'Size': '{Width=3843, Height=2747}',
            'Title': 'party cake_overall_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:33:46',
            'Categories': [],
            'Created': '07/24/2017 14:33:46',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1090,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1090.png',
            'Order': 358,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:46:27',
            'Categories': [],
            'Created': '07/24/2017 14:46:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1091,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1091.png',
            'Order': 359,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:47:42',
            'Categories': [],
            'Created': '07/24/2017 14:47:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1095,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1095.png',
            'Order': 363,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:51:53',
            'Categories': [],
            'Created': '07/24/2017 14:51:53',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1097,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1097.png',
            'Order': 365,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:53:49',
            'Categories': [],
            'Created': '07/24/2017 14:53:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1104,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1104.png',
            'Order': 372,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:02:15',
            'Categories': [],
            'Created': '07/24/2017 15:02:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1106,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1106.png',
            'Order': 374,
            'Size': '{Width=2585, Height=1725}',
            'Title': 'taart_kader_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:02:21',
            'Categories': [],
            'Created': '07/24/2017 15:02:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1109,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1109.png',
            'Order': 377,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:06:06',
            'Categories': [],
            'Created': '07/24/2017 15:06:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1110,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1110.png',
            'Order': 378,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_overall_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:06:11',
            'Categories': [],
            'Created': '07/24/2017 15:06:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1141,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1141.png',
            'Order': 409,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:21:32',
            'Categories': [],
            'Created': '07/24/2017 15:21:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1142,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1142.png',
            'Order': 410,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:21:40',
            'Categories': [],
            'Created': '07/24/2017 15:21:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1145,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1145.png',
            'Order': 413,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:23:02',
            'Categories': [],
            'Created': '07/24/2017 15:23:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1149,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1149.png',
            'Order': 417,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:24:43',
            'Categories': [],
            'Created': '07/24/2017 15:24:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1152,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1152.png',
            'Order': 420,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:26:49',
            'Categories': [],
            'Created': '07/24/2017 15:26:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1154,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1154.png',
            'Order': 422,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'Taart-L_kader_jipjannke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:28:35',
            'Categories': [],
            'Created': '07/24/2017 15:28:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1158,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1158.png',
            'Order': 426,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:30:14',
            'Categories': [],
            'Created': '07/24/2017 15:30:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1159,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1159.png',
            'Order': 427,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'Taart-L_overal_jipjannke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:31:03',
            'Categories': [],
            'Created': '07/24/2017 15:31:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1176,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1176.png',
            'Order': 444,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'taart_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:40:43',
            'Categories': [],
            'Created': '07/24/2017 15:40:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1180,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1180.png',
            'Order': 448,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_kader_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:41:38',
            'Categories': [],
            'Created': '07/24/2017 15:41:38',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1181,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1181.png',
            'Order': 449,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'party cake_overall_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:42:28',
            'Categories': [],
            'Created': '07/24/2017 15:42:28',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1183,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1183.png',
            'Order': 451,
            'Size': '{Width=2586, Height=1723}',
            'Title': 'taart_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:42:48',
            'Categories': [],
            'Created': '07/24/2017 15:42:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1200,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1200.png',
            'Order': 465,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'Taart_L_kader_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:57:48',
            'Categories': [],
            'Created': '07/24/2017 15:57:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1204,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1204.png',
            'Order': 469,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'Taart_L_overall_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 16:01:08',
            'Categories': [],
            'Created': '07/24/2017 16:01:08',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 17,
            'Title': 'Montserrat',
            'ImagePath': 'fonts/font-17.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 14,
            'Order': 5,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '08/15/2017 12:04:47',
            'LastModifiedBy': 'HEMALOCAL\\emdvorobiova',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 22,
            'Title': 'Bungee',
            'ImagePath': 'fonts/font-22.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 9,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/22/2017 06:29:11',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:25:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 6,
            'Title': '6333610',
            'Created': '05/05/2017 13:27:39',
            'LastModified': '06/04/2020 10:09:00',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 690,
            'OptimalHeight': 500,
            'MinimalWidth': 345,
            'MinimalHeight': 250,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-6.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-6.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': true,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 51,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          },
          {
            'ProductId': 21,
            'Title': '6333600',
            'Created': '07/21/2017 14:18:53',
            'LastModified': '03/25/2022 16:28:33',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 19,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 30,
            'OptimalHeight': 30,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-21.png',
            'BackgroundImagePath': 'products/backgrounds/product-21.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': 'products/logo_overlays/product-21-20220325162832933.png',
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': true,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          },
          {
            'ProductId': 22,
            'Title': '6333604',
            'Created': '07/21/2017 14:20:54',
            'LastModified': '03/07/2018 09:19:50',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-22.png',
            'BackgroundImagePath': 'products/backgrounds/product-22.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          },
          {
            'ProductId': 23,
            'Title': '6333614',
            'Created': '07/21/2017 14:22:13',
            'LastModified': '03/07/2018 09:22:03',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-23.png',
            'BackgroundImagePath': 'products/backgrounds/product-23.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          },
          {
            'ProductId': 39,
            'Title': '10270050',
            'Created': '08/23/2021 16:39:13',
            'LastModified': '01/18/2022 11:12:41',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 0,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 690,
            'OptimalHeight': 500,
            'MinimalWidth': 345,
            'MinimalHeight': 250,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-39.png',
            'BackgroundImagePath': 'products/backgrounds/product-39.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': true,
            'WatermarkImagePath': 'products/logo_overlays/product-39-20210906150925362.png',
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': true,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': null,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          },
          {
            'ProductId': 40,
            'Title': '10270051',
            'Created': '09/01/2021 11:50:32',
            'LastModified': '09/06/2021 15:09:02',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'hema-giftcard',
            'BackgroundWidth': 1128,
            'BackgroundHeight': 739,
            'Bleed': 0,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-40.png',
            'BackgroundImagePath': 'products/backgrounds/product-40.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': true,
            'WatermarkImagePath': 'products/logo_overlays/product-40-20210906150902464.png',
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': true,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': null,
            'LayoutTemplates': [],
            'Backgroundclassname': 'hema-giftcard'
          },
          {
            'ProductId': 41,
            'Title': '6330067',
            'Created': '07/21/2022 10:20:15',
            'LastModified': '07/21/2022 10:20:15',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 690,
            'OptimalHeight': 500,
            'MinimalWidth': 345,
            'MinimalHeight': 250,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-41.png',
            'BackgroundImagePath': 'products/backgrounds/product-41.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': true,
            'WatermarkImagePath': 'products/logo_overlays/product-41-20220721102016324.png',
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': true,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': null,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 2,
            'Active': 1,
            'ImagePath': 'templates/template-2.svg',
            'ShapeId': 2,
            'Created': '02/22/2017 13:53:08',
            'LastModified': '05/18/2017 12:10:03',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 4,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 23.076923}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 53.846154}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 23.076923}}',
            'Title': 'Layout-03'
          },
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 5,
            'Active': 1,
            'ImagePath': 'templates/template-5.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:11:50',
            'LastModified': '05/18/2017 12:10:06',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 5,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 50, h: 50}}',
            'Title': 'Layout-04'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 7,
            'Active': 1,
            'ImagePath': 'templates/template-7.svg',
            'ShapeId': 2,
            'Created': '04/27/2017 08:36:17',
            'LastModified': '05/18/2017 12:10:16',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 6,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 8, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 9, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-05'
          },
          {
            'LayoutTemplateId': 8,
            'Active': 1,
            'ImagePath': 'templates/template-8.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:48:38',
            'LastModified': '05/18/2017 12:10:12',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 7,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-06'
          },
          {
            'LayoutTemplateId': 9,
            'Active': 1,
            'ImagePath': 'templates/template-9.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:49:05',
            'LastModified': '05/18/2017 12:10:20',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 8,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-07'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          },
          {
            'LayoutTemplateId': 12,
            'Active': 1,
            'ImagePath': 'templates/template-12.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:24:43',
            'LastModified': '05/18/2017 12:10:25',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 9,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-08'
          },
          {
            'LayoutTemplateId': 13,
            'Active': 1,
            'ImagePath': 'templates/template-13.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:26:35',
            'LastModified': '06/16/2017 13:30:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Order': 10,
            'PermittedSides': 'center,top,right,bottom',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 50, h: 100}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 100}}',
            'Title': 'Layout-09'
          },
          {
            'LayoutTemplateId': 14,
            'Active': 1,
            'ImagePath': 'templates/template-14.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:27:44',
            'LastModified': '05/18/2017 12:10:33',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 11,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-10'
          },
          {
            'LayoutTemplateId': 15,
            'Active': 1,
            'ImagePath': 'templates/template-15.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:12',
            'LastModified': '05/18/2017 12:10:38',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 12,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-11'
          },
          {
            'LayoutTemplateId': 16,
            'Active': 0,
            'ImagePath': 'templates/template-16.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:35',
            'LastModified': '07/31/2019 15:15:43',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 13,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: \'hidden\', accept: \'\', dimension: {w: 100, h: 33.333333}},\r\n{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-12'
          },
          {
            'LayoutTemplateId': 17,
            'Active': 1,
            'ImagePath': 'templates/template-17.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:16',
            'LastModified': '05/18/2017 12:10:46',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 14,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 66.666666}}',
            'Title': 'Layout-13'
          },
          {
            'LayoutTemplateId': 18,
            'Active': 1,
            'ImagePath': 'templates/template-18.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:41',
            'LastModified': '05/18/2017 12:10:50',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 15,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 50}}',
            'Title': 'Layout-14'
          },
          {
            'LayoutTemplateId': 19,
            'Active': 1,
            'ImagePath': 'templates/template-19.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:30:07',
            'LastModified': '06/07/2017 12:46:48',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'Order': 16,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-15'
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 13,
            'Active': 1,
            'Order': 3,
            'Title': 'Strik',
            'ImagePath': 'stickers/sticker-13.png',
            'Size': '{Width=625, Height=335}',
            'LastModified': '05/09/2017 07:13:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:55',
            'ProductTypes': []
          },
          {
            'StickerId': 14,
            'Active': 1,
            'Order': 4,
            'Title': 'Cirkel',
            'ImagePath': 'stickers/sticker-14.png',
            'Size': '{Width=623, Height=624}',
            'LastModified': '05/09/2017 07:14:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:06',
            'ProductTypes': []
          },
          {
            'StickerId': 15,
            'Active': 1,
            'Order': 5,
            'Title': 'Spreekwolk',
            'ImagePath': 'stickers/sticker-15.png',
            'Size': '{Width=833, Height=736}',
            'LastModified': '05/09/2017 07:14:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:19',
            'ProductTypes': []
          },
          {
            'StickerId': 16,
            'Active': 1,
            'Order': 7,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-16.png',
            'Size': '{Width=662, Height=737}',
            'LastModified': '05/09/2017 07:14:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:27',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 19,
            'Active': 1,
            'Order': 10,
            'Title': 'Bril',
            'ImagePath': 'stickers/sticker-19.png',
            'Size': '{Width=688, Height=229}',
            'LastModified': '05/09/2017 07:15:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:01',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 21,
            'Active': 1,
            'Order': 12,
            'Title': 'Baby',
            'ImagePath': 'stickers/sticker-21.png',
            'Size': '{Width=729, Height=658}',
            'LastModified': '05/09/2017 07:15:47',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:47',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 23,
            'Active': 1,
            'Order': 14,
            'Title': 'Hart blauw',
            'ImagePath': 'stickers/sticker-23.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '05/09/2017 07:16:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:14',
            'ProductTypes': []
          },
          {
            'StickerId': 24,
            'Active': 1,
            'Order': 15,
            'Title': 'Ster blauw',
            'ImagePath': 'stickers/sticker-24.png',
            'Size': '{Width=625, Height=570}',
            'LastModified': '05/09/2017 07:16:24',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:24',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 26,
            'Active': 1,
            'Order': 17,
            'Title': 'Welkom kleintje',
            'ImagePath': 'stickers/sticker-26.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:16:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:56',
            'ProductTypes': []
          },
          {
            'StickerId': 27,
            'Active': 1,
            'Order': 18,
            'Title': 'Welkom kleintjes',
            'ImagePath': 'stickers/sticker-27.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:17:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:13',
            'ProductTypes': []
          },
          {
            'StickerId': 28,
            'Active': 1,
            'Order': 19,
            'Title': 'Sinasappel',
            'ImagePath': 'stickers/sticker-28.png',
            'Size': '{Width=729, Height=729}',
            'LastModified': '05/09/2017 07:17:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:25',
            'ProductTypes': []
          },
          {
            'StickerId': 29,
            'Active': 1,
            'Order': 20,
            'Title': 'Blaadje',
            'ImagePath': 'stickers/sticker-29.png',
            'Size': '{Width=717, Height=238}',
            'LastModified': '05/09/2017 07:17:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:37',
            'ProductTypes': []
          },
          {
            'StickerId': 30,
            'Active': 1,
            'Order': 21,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-30.png',
            'Size': '{Width=359, Height=931}',
            'LastModified': '05/09/2017 07:17:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:48',
            'ProductTypes': []
          },
          {
            'StickerId': 31,
            'Active': 1,
            'Order': 22,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-31.png',
            'Size': '{Width=383, Height=942}',
            'LastModified': '05/09/2017 07:18:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:02',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 33,
            'Active': 1,
            'Order': 24,
            'Title': 'Ananas',
            'ImagePath': 'stickers/sticker-33.png',
            'Size': '{Width=405, Height=738}',
            'LastModified': '05/09/2017 07:18:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:28',
            'ProductTypes': []
          },
          {
            'StickerId': 34,
            'Active': 1,
            'Order': 25,
            'Title': 'Herfst blaadjes',
            'ImagePath': 'stickers/sticker-34.png',
            'Size': '{Width=255, Height=546}',
            'LastModified': '05/09/2017 07:18:46',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:46',
            'ProductTypes': []
          },
          {
            'StickerId': 35,
            'Active': 1,
            'Order': 26,
            'Title': 'Winter',
            'ImagePath': 'stickers/sticker-35.png',
            'Size': '{Width=476, Height=785}',
            'LastModified': '05/09/2017 07:18:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:59',
            'ProductTypes': []
          },
          {
            'StickerId': 36,
            'Active': 1,
            'Order': 27,
            'Title': 'Astronaut',
            'ImagePath': 'stickers/sticker-36.png',
            'Size': '{Width=589, Height=988}',
            'LastModified': '05/09/2017 07:19:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:14',
            'ProductTypes': []
          },
          {
            'StickerId': 37,
            'Active': 1,
            'Order': 28,
            'Title': 'Jarig',
            'ImagePath': 'stickers/sticker-37.png',
            'Size': '{Width=1036, Height=1026}',
            'LastModified': '05/09/2017 07:19:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:26',
            'ProductTypes': []
          },
          {
            'StickerId': 38,
            'Active': 1,
            'Order': 29,
            'Title': 'Kikker',
            'ImagePath': 'stickers/sticker-38.png',
            'Size': '{Width=1042, Height=1040}',
            'LastModified': '05/09/2017 07:19:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:38',
            'ProductTypes': []
          },
          {
            'StickerId': 39,
            'Active': 1,
            'Order': 30,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-39.png',
            'Size': '{Width=1042, Height=651}',
            'LastModified': '05/09/2017 07:19:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:56',
            'ProductTypes': []
          },
          {
            'StickerId': 40,
            'Active': 1,
            'Order': 31,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-40.png',
            'Size': '{Width=988, Height=311}',
            'LastModified': '05/09/2017 07:20:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:13',
            'ProductTypes': []
          },
          {
            'StickerId': 41,
            'Active': 1,
            'Order': 32,
            'Title': 'Piratenmuts',
            'ImagePath': 'stickers/sticker-41.png',
            'Size': '{Width=1042, Height=591}',
            'LastModified': '05/09/2017 07:20:34',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:34',
            'ProductTypes': []
          },
          {
            'StickerId': 42,
            'Active': 1,
            'Order': 33,
            'Title': 'Takkie',
            'ImagePath': 'stickers/sticker-42.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:20:45',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:45',
            'ProductTypes': []
          },
          {
            'StickerId': 43,
            'Active': 1,
            'Order': 34,
            'Title': 'Ballon geel',
            'ImagePath': 'stickers/sticker-43.png',
            'Size': '{Width=377, Height=1024}',
            'LastModified': '05/09/2017 07:20:58',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:58',
            'ProductTypes': []
          },
          {
            'StickerId': 44,
            'Active': 1,
            'Order': 35,
            'Title': 'Getrouwd',
            'ImagePath': 'stickers/sticker-44.png',
            'Size': '{Width=1028, Height=349}',
            'LastModified': '05/09/2017 07:21:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:11',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 46,
            'Active': 1,
            'Order': 37,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-46.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:21:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:57',
            'ProductTypes': []
          },
          {
            'StickerId': 47,
            'Active': 1,
            'Order': 38,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-47.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:22:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:19',
            'ProductTypes': []
          },
          {
            'StickerId': 48,
            'Active': 1,
            'Order': 39,
            'Title': 'Papagaai',
            'ImagePath': 'stickers/sticker-48.png',
            'Size': '{Width=1042, Height=928}',
            'LastModified': '05/09/2017 07:22:30',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:30',
            'ProductTypes': []
          },
          {
            'StickerId': 49,
            'Active': 1,
            'Order': 40,
            'Title': 'Robot',
            'ImagePath': 'stickers/sticker-49.png',
            'Size': '{Width=674, Height=1009}',
            'LastModified': '05/09/2017 07:22:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:43',
            'ProductTypes': []
          },
          {
            'StickerId': 50,
            'Active': 1,
            'Order': 41,
            'Title': 'The king',
            'ImagePath': 'stickers/sticker-50.png',
            'Size': '{Width=1044, Height=197}',
            'LastModified': '05/09/2017 07:22:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:55',
            'ProductTypes': []
          },
          {
            'StickerId': 51,
            'Active': 1,
            'Order': 42,
            'Title': 'Ballonnen groen',
            'ImagePath': 'stickers/sticker-51.png',
            'Size': '{Width=785, Height=1007}',
            'LastModified': '05/09/2017 07:23:10',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:10',
            'ProductTypes': []
          },
          {
            'StickerId': 52,
            'Active': 1,
            'Order': 43,
            'Title': 'Je bent mijn liefste',
            'ImagePath': 'stickers/sticker-52.png',
            'Size': '{Width=487, Height=1042}',
            'LastModified': '05/09/2017 07:23:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:27',
            'ProductTypes': []
          },
          {
            'StickerId': 53,
            'Active': 1,
            'Order': 44,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-53.png',
            'Size': '{Width=1038, Height=948}',
            'LastModified': '05/09/2017 07:23:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:37',
            'ProductTypes': []
          },
          {
            'StickerId': 54,
            'Active': 1,
            'Order': 45,
            'Title': 'Racket',
            'ImagePath': 'stickers/sticker-54.png',
            'Size': '{Width=420, Height=1016}',
            'LastModified': '05/09/2017 07:23:49',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:49',
            'ProductTypes': []
          },
          {
            'StickerId': 55,
            'Active': 1,
            'Order': 46,
            'Title': 'Zwaard',
            'ImagePath': 'stickers/sticker-55.png',
            'Size': '{Width=461, Height=1042}',
            'LastModified': '05/09/2017 07:24:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:01',
            'ProductTypes': []
          },
          {
            'StickerId': 56,
            'Active': 1,
            'Order': 47,
            'Title': 'Hoeravlag',
            'ImagePath': 'stickers/sticker-56.png',
            'Size': '{Width=1045, Height=252}',
            'LastModified': '05/09/2017 07:24:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:13',
            'ProductTypes': []
          },
          {
            'StickerId': 57,
            'Active': 1,
            'Order': 48,
            'Title': 'Rood hartje',
            'ImagePath': 'stickers/sticker-57.png',
            'Size': '{Width=624, Height=1007}',
            'LastModified': '05/09/2017 07:24:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:27',
            'ProductTypes': []
          },
          {
            'StickerId': 58,
            'Active': 1,
            'Order': 49,
            'Title': 'Hoera banner',
            'ImagePath': 'stickers/sticker-58.png',
            'Size': '{Width=1029, Height=530}',
            'LastModified': '05/09/2017 07:24:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:48',
            'ProductTypes': []
          },
          {
            'StickerId': 59,
            'Active': 1,
            'Order': 50,
            'Title': 'Raket',
            'ImagePath': 'stickers/sticker-59.png',
            'Size': '{Width=659, Height=984}',
            'LastModified': '05/09/2017 07:25:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:05',
            'ProductTypes': []
          },
          {
            'StickerId': 60,
            'Active': 1,
            'Order': 51,
            'Title': 'Twee hartjes',
            'ImagePath': 'stickers/sticker-60.png',
            'Size': '{Width=968, Height=754}',
            'LastModified': '05/09/2017 07:25:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:18',
            'ProductTypes': []
          },
          {
            'StickerId': 61,
            'Active': 1,
            'Order': 52,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-61.png',
            'Size': '{Width=995, Height=543}',
            'LastModified': '05/09/2017 07:25:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:31',
            'ProductTypes': []
          },
          {
            'StickerId': 62,
            'Active': 1,
            'Order': 53,
            'Title': 'Lijn hartjes',
            'ImagePath': 'stickers/sticker-62.png',
            'Size': '{Width=982, Height=958}',
            'LastModified': '05/09/2017 07:25:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:43',
            'ProductTypes': []
          },
          {
            'StickerId': 63,
            'Active': 1,
            'Order': 54,
            'Title': 'Roze hartje',
            'ImagePath': 'stickers/sticker-63.png',
            'Size': '{Width=624, Height=1017}',
            'LastModified': '05/09/2017 07:26:23',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:23',
            'ProductTypes': []
          },
          {
            'StickerId': 64,
            'Active': 1,
            'Order': 55,
            'Title': 'Ufo',
            'ImagePath': 'stickers/sticker-64.png',
            'Size': '{Width=914, Height=958}',
            'LastModified': '05/09/2017 07:26:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:32',
            'ProductTypes': []
          },
          {
            'StickerId': 65,
            'Active': 1,
            'Order': 56,
            'Title': 'Kadootje',
            'ImagePath': 'stickers/sticker-65.png',
            'Size': '{Width=706, Height=1012}',
            'LastModified': '05/09/2017 07:26:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:42',
            'ProductTypes': []
          },
          {
            'StickerId': 66,
            'Active': 1,
            'Order': 57,
            'Title': 'Ring',
            'ImagePath': 'stickers/sticker-66.png',
            'Size': '{Width=620, Height=1001}',
            'LastModified': '05/09/2017 07:26:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:51',
            'ProductTypes': []
          },
          {
            'StickerId': 67,
            'Active': 1,
            'Order': 58,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-67.png',
            'Size': '{Width=1020, Height=947}',
            'LastModified': '05/09/2017 07:27:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:01',
            'ProductTypes': []
          },
          {
            'StickerId': 68,
            'Active': 1,
            'Order': 59,
            'Title': 'Bowtie',
            'ImagePath': 'stickers/sticker-68.png',
            'Size': '{Width=1017, Height=514}',
            'LastModified': '05/09/2017 07:27:09',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:09',
            'ProductTypes': []
          },
          {
            'StickerId': 69,
            'Active': 1,
            'Order': 60,
            'Title': 'Confetti',
            'ImagePath': 'stickers/sticker-69.png',
            'Size': '{Width=333, Height=995}',
            'LastModified': '05/09/2017 07:27:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:21',
            'ProductTypes': []
          },
          {
            'StickerId': 70,
            'Active': 1,
            'Order': 61,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-70.png',
            'Size': '{Width=898, Height=1006}',
            'LastModified': '05/09/2017 07:27:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:33',
            'ProductTypes': []
          },
          {
            'StickerId': 71,
            'Active': 1,
            'Order': 62,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-71.png',
            'Size': '{Width=1027, Height=573}',
            'LastModified': '05/09/2017 07:27:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:42',
            'ProductTypes': []
          },
          {
            'StickerId': 72,
            'Active': 1,
            'Order': 63,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-72.png',
            'Size': '{Width=797, Height=985}',
            'LastModified': '05/09/2017 07:27:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:55',
            'ProductTypes': []
          },
          {
            'StickerId': 73,
            'Active': 1,
            'Order': 64,
            'Title': 'Mr',
            'ImagePath': 'stickers/sticker-73.png',
            'Size': '{Width=1038, Height=932}',
            'LastModified': '05/09/2017 07:28:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:07',
            'ProductTypes': []
          },
          {
            'StickerId': 74,
            'Active': 1,
            'Order': 65,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-74.png',
            'Size': '{Width=708, Height=990}',
            'LastModified': '05/09/2017 07:28:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:18',
            'ProductTypes': []
          },
          {
            'StickerId': 75,
            'Active': 1,
            'Order': 66,
            'Title': 'Ms',
            'ImagePath': 'stickers/sticker-75.png',
            'Size': '{Width=1031, Height=971}',
            'LastModified': '05/09/2017 07:28:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:32',
            'ProductTypes': []
          },
          {
            'StickerId': 76,
            'Active': 1,
            'Order': 67,
            'Title': 'Rainbow',
            'ImagePath': 'stickers/sticker-76.png',
            'Size': '{Width=1010, Height=659}',
            'LastModified': '05/09/2017 07:28:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:42',
            'ProductTypes': []
          },
          {
            'StickerId': 77,
            'Active': 1,
            'Order': 68,
            'Title': 'Champagne',
            'ImagePath': 'stickers/sticker-77.png',
            'Size': '{Width=341, Height=1006}',
            'LastModified': '05/09/2017 07:28:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:56',
            'ProductTypes': []
          },
          {
            'StickerId': 78,
            'Active': 1,
            'Order': 69,
            'Title': 'Hartjes',
            'ImagePath': 'stickers/sticker-78.png',
            'Size': '{Width=951, Height=571}',
            'LastModified': '05/09/2017 07:29:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:06',
            'ProductTypes': []
          },
          {
            'StickerId': 79,
            'Active': 1,
            'Order': 70,
            'Title': 'You are just lovely',
            'ImagePath': 'stickers/sticker-79.png',
            'Size': '{Width=987, Height=899}',
            'LastModified': '05/09/2017 07:29:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:26',
            'ProductTypes': []
          },
          {
            'StickerId': 80,
            'Active': 1,
            'Order': 71,
            'Title': 'Medaille',
            'ImagePath': 'stickers/sticker-80.png',
            'Size': '{Width=591, Height=1018}',
            'LastModified': '05/09/2017 07:29:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:40',
            'ProductTypes': []
          },
          {
            'StickerId': 81,
            'Active': 1,
            'Order': 72,
            'Title': 'Pluk de dag',
            'ImagePath': 'stickers/sticker-81.png',
            'Size': '{Width=509, Height=1042}',
            'LastModified': '05/09/2017 07:29:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:51',
            'ProductTypes': []
          },
          {
            'StickerId': 82,
            'Active': 1,
            'Order': 73,
            'Title': 'Zon',
            'ImagePath': 'stickers/sticker-82.png',
            'Size': '{Width=1033, Height=1005}',
            'LastModified': '05/09/2017 07:30:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:01',
            'ProductTypes': []
          },
          {
            'StickerId': 83,
            'Active': 1,
            'Order': 74,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-83.png',
            'Size': '{Width=997, Height=646}',
            'LastModified': '05/09/2017 07:30:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:11',
            'ProductTypes': []
          },
          {
            'StickerId': 84,
            'Active': 1,
            'Order': 75,
            'Title': 'Hartjesdoos mama',
            'ImagePath': 'stickers/sticker-84.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:28',
            'ProductTypes': []
          },
          {
            'StickerId': 85,
            'Active': 1,
            'Order': 76,
            'Title': 'Hartjesdoos',
            'ImagePath': 'stickers/sticker-85.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:41',
            'ProductTypes': []
          },
          {
            'StickerId': 86,
            'Active': 1,
            'Order': 77,
            'Title': 'Wolk rain',
            'ImagePath': 'stickers/sticker-86.png',
            'Size': '{Width=1002, Height=948}',
            'LastModified': '05/09/2017 07:30:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:54',
            'ProductTypes': []
          },
          {
            'StickerId': 87,
            'Active': 1,
            'Order': 78,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-87.png',
            'Size': '{Width=1025, Height=721}',
            'LastModified': '05/09/2017 07:31:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:05',
            'ProductTypes': []
          },
          {
            'StickerId': 88,
            'Active': 1,
            'Order': 79,
            'Title': 'Hartje mama',
            'ImagePath': 'stickers/sticker-88.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:32',
            'ProductTypes': []
          },
          {
            'StickerId': 89,
            'Active': 1,
            'Order': 80,
            'Title': 'Hartje',
            'ImagePath': 'stickers/sticker-89.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:42',
            'ProductTypes': []
          },
          {
            'StickerId': 90,
            'Active': 1,
            'Order': 81,
            'Title': 'Wolk donder',
            'ImagePath': 'stickers/sticker-90.png',
            'Size': '{Width=878, Height=998}',
            'LastModified': '05/09/2017 07:40:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:00',
            'ProductTypes': []
          },
          {
            'StickerId': 91,
            'Active': 1,
            'Order': 82,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-91.png',
            'Size': '{Width=1013, Height=1013}',
            'LastModified': '05/09/2017 07:40:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:14',
            'ProductTypes': []
          },
          {
            'StickerId': 92,
            'Active': 1,
            'Order': 83,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-92.png',
            'Size': '{Width=768, Height=1013}',
            'LastModified': '05/09/2017 07:40:44',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:44',
            'ProductTypes': []
          },
          {
            'StickerId': 93,
            'Active': 1,
            'Order': 84,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-93.png',
            'Size': '{Width=1009, Height=1022}',
            'LastModified': '05/09/2017 07:40:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:54',
            'ProductTypes': []
          },
          {
            'StickerId': 94,
            'Active': 1,
            'Order': 85,
            'Title': 'Zwemband',
            'ImagePath': 'stickers/sticker-94.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:41:04',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:04',
            'ProductTypes': []
          },
          {
            'StickerId': 95,
            'Active': 1,
            'Order': 86,
            'Title': 'Plons',
            'ImagePath': 'stickers/sticker-95.png',
            'Size': '{Width=1033, Height=430}',
            'LastModified': '05/09/2017 07:41:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:17',
            'ProductTypes': []
          },
          {
            'StickerId': 96,
            'Active': 1,
            'Order': 87,
            'Title': 'Zwemdiploma',
            'ImagePath': 'stickers/sticker-96.png',
            'Size': '{Width=1019, Height=121}',
            'LastModified': '05/09/2017 07:41:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:29',
            'ProductTypes': []
          },
          {
            'StickerId': 97,
            'Active': 1,
            'Order': 88,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-97.png',
            'Size': '{Width=719, Height=1044}',
            'LastModified': '05/09/2017 07:41:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:41',
            'ProductTypes': []
          },
          {
            'StickerId': 98,
            'Active': 1,
            'Order': 89,
            'Title': 'New home',
            'ImagePath': 'stickers/sticker-98.png',
            'Size': '{Width=835, Height=1042}',
            'LastModified': '05/09/2017 07:41:52',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:52',
            'ProductTypes': []
          },
          {
            'StickerId': 99,
            'Active': 1,
            'Order': 90,
            'Title': 'Sportheld',
            'ImagePath': 'stickers/sticker-99.png',
            'Size': '{Width=925, Height=1040}',
            'LastModified': '05/09/2017 07:42:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:02',
            'ProductTypes': []
          },
          {
            'StickerId': 100,
            'Active': 1,
            'Order': 91,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-100.png',
            'Size': '{Width=855, Height=1042}',
            'LastModified': '05/09/2017 07:42:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:12',
            'ProductTypes': []
          },
          {
            'StickerId': 101,
            'Active': 1,
            'Order': 92,
            'Title': 'Present',
            'ImagePath': 'stickers/sticker-101.png',
            'Size': '{Width=714, Height=1004}',
            'LastModified': '05/09/2017 07:42:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:21',
            'ProductTypes': []
          },
          {
            'StickerId': 102,
            'Active': 1,
            'Order': 93,
            'Title': 'Bird',
            'ImagePath': 'stickers/sticker-102.png',
            'Size': '{Width=1031, Height=720}',
            'LastModified': '05/09/2017 07:42:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:31',
            'ProductTypes': []
          },
          {
            'StickerId': 103,
            'Active': 1,
            'Order': 94,
            'Title': 'Snowflake',
            'ImagePath': 'stickers/sticker-103.png',
            'Size': '{Width=922, Height=1000}',
            'LastModified': '10/11/2022 14:35:16',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:40',
            'ProductTypes': []
          },
          {
            'StickerId': 104,
            'Active': 1,
            'Order': 95,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-104.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:53',
            'ProductTypes': []
          },
          {
            'StickerId': 105,
            'Active': 1,
            'Order': 96,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-105.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:57',
            'ProductTypes': []
          },
          {
            'StickerId': 106,
            'Active': 1,
            'Order': 97,
            'Title': 'Bat',
            'ImagePath': 'stickers/sticker-106.png',
            'Size': '{Width=1042, Height=315}',
            'LastModified': '10/11/2022 14:35:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:07',
            'ProductTypes': []
          },
          {
            'StickerId': 107,
            'Active': 1,
            'Order': 98,
            'Title': 'Hoera een jongen',
            'ImagePath': 'stickers/sticker-107.png',
            'Size': '{Width=734, Height=1042}',
            'LastModified': '05/09/2017 07:43:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:21',
            'ProductTypes': []
          },
          {
            'StickerId': 108,
            'Active': 1,
            'Order': 99,
            'Title': 'Bedankt',
            'ImagePath': 'stickers/sticker-108.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:43:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:32',
            'ProductTypes': []
          },
          {
            'StickerId': 109,
            'Active': 1,
            'Order': 100,
            'Title': 'Pumpkin',
            'ImagePath': 'stickers/sticker-109.png',
            'Size': '{Width=1042, Height=763}',
            'LastModified': '10/11/2022 14:35:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:47',
            'ProductTypes': []
          },
          {
            'StickerId': 110,
            'Active': 1,
            'Order': 101,
            'Title': 'Stoplicht',
            'ImagePath': 'stickers/sticker-110.png',
            'Size': '{Width=288, Height=1032}',
            'LastModified': '05/09/2017 07:44:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:00',
            'ProductTypes': []
          },
          {
            'StickerId': 111,
            'Active': 1,
            'Order': 102,
            'Title': 'Hoera rijbewijs',
            'ImagePath': 'stickers/sticker-111.png',
            'Size': '{Width=1040, Height=632}',
            'LastModified': '05/09/2017 07:44:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:14',
            'ProductTypes': []
          },
          {
            'StickerId': 112,
            'Active': 1,
            'Order': 103,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-112.png',
            'Size': '{Width=997, Height=997}',
            'LastModified': '05/09/2017 07:44:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:25',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 5,
        'Name': 'maxi-party-cake-1636x1099',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 757,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-757.png',
            'Order': 25,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:18:27',
            'Categories': [],
            'Created': '07/24/2017 11:18:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 758,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-758.png',
            'Order': 26,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:18:51',
            'Categories': [],
            'Created': '07/24/2017 11:18:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 761,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-761.png',
            'Order': 29,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:20:06',
            'Categories': [],
            'Created': '07/24/2017 11:20:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 762,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-762.png',
            'Order': 30,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:20:58',
            'Categories': [],
            'Created': '07/24/2017 11:20:58',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 765,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-765.png',
            'Order': 33,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:23:00',
            'Categories': [],
            'Created': '07/24/2017 11:23:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 766,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-766.png',
            'Order': 34,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_streep',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '08/29/2019 13:30:03',
            'Categories': [],
            'Created': '07/24/2017 11:23:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 769,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-769.png',
            'Order': 37,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:25:03',
            'Categories': [],
            'Created': '07/24/2017 11:25:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 770,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-770.png',
            'Order': 38,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:25:48',
            'Categories': [],
            'Created': '07/24/2017 11:25:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 778,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-778.png',
            'Order': 46,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:36:09',
            'Categories': [],
            'Created': '07/24/2017 11:36:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 779,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-779.png',
            'Order': 47,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:36:36',
            'Categories': [],
            'Created': '07/24/2017 11:36:36',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 792,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-792.png',
            'Order': 61,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:44:06',
            'Categories': [],
            'Created': '07/24/2017 11:44:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 794,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-794.png',
            'Order': 63,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:44:25',
            'Categories': [],
            'Created': '07/24/2017 11:44:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 796,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-796.png',
            'Order': 65,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:45:00',
            'Categories': [],
            'Created': '07/24/2017 11:45:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 798,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-798.png',
            'Order': 67,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:45:28',
            'Categories': [],
            'Created': '07/24/2017 11:45:28',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 805,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-805.png',
            'Order': 74,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:47:51',
            'Categories': [],
            'Created': '07/24/2017 11:47:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 806,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-806.png',
            'Order': 75,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:48:12',
            'Categories': [],
            'Created': '07/24/2017 11:48:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 818,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-818.png',
            'Order': 87,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:52:56',
            'Categories': [],
            'Created': '07/24/2017 11:52:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 820,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-820.png',
            'Order': 89,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:53:13',
            'Categories': [],
            'Created': '07/24/2017 11:53:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 823,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-823.png',
            'Order': 91,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:54:59',
            'Categories': [],
            'Created': '07/24/2017 11:54:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 825,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-825.png',
            'Order': 93,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:57:19',
            'Categories': [],
            'Created': '07/24/2017 11:57:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 834,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-834.png',
            'Order': 102,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:08:10',
            'Categories': [],
            'Created': '07/24/2017 12:08:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 835,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-835.png',
            'Order': 103,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:08:39',
            'Categories': [],
            'Created': '07/24/2017 12:08:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 842,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-842.png',
            'Order': 110,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:13:18',
            'Categories': [],
            'Created': '07/24/2017 12:13:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 843,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-843.png',
            'Order': 111,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:13:42',
            'Categories': [],
            'Created': '07/24/2017 12:13:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 851,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-851.png',
            'Order': 119,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:22:37',
            'Categories': [],
            'Created': '07/24/2017 12:22:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 852,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-852.png',
            'Order': 120,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:23:00',
            'Categories': [],
            'Created': '07/24/2017 12:23:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 863,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-863.png',
            'Order': 131,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:44:37',
            'Categories': [],
            'Created': '07/24/2017 12:44:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 865,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-865.png',
            'Order': 133,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:45:12',
            'Categories': [],
            'Created': '07/24/2017 12:45:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 871,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-871.png',
            'Order': 139,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:47:14',
            'Categories': [],
            'Created': '07/24/2017 12:47:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 874,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-874.png',
            'Order': 142,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:47:56',
            'Categories': [],
            'Created': '07/24/2017 12:47:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 884,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-884.png',
            'Order': 152,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:53:12',
            'Categories': [],
            'Created': '07/24/2017 12:53:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 886,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-886.png',
            'Order': 154,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:53:42',
            'Categories': [],
            'Created': '07/24/2017 12:53:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 892,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-892.png',
            'Order': 160,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:56:17',
            'Categories': [],
            'Created': '07/24/2017 12:56:17',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 895,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-895.png',
            'Order': 163,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:56:48',
            'Categories': [],
            'Created': '07/24/2017 12:56:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 900,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-900.png',
            'Order': 168,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:58:35',
            'Categories': [],
            'Created': '07/24/2017 12:58:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 902,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-902.png',
            'Order': 170,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:58:59',
            'Categories': [],
            'Created': '07/24/2017 12:58:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 911,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-911.png',
            'Order': 179,
            'Size': '{Width=3446, Height=2299}',
            'Title': 'maxi party cake_kader_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:01:55',
            'Categories': [],
            'Created': '07/24/2017 13:01:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 913,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-913.png',
            'Order': 181,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_koverall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:02:33',
            'Categories': [],
            'Created': '07/24/2017 13:02:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 916,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-916.png',
            'Order': 184,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:03:11',
            'Categories': [],
            'Created': '07/24/2017 13:03:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 917,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-917.png',
            'Order': 185,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:04:06',
            'Categories': [],
            'Created': '07/24/2017 13:04:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 920,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-920.png',
            'Order': 188,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:11:45',
            'Categories': [],
            'Created': '07/24/2017 13:11:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 927,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-927.png',
            'Order': 195,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:14:40',
            'Categories': [],
            'Created': '07/24/2017 13:14:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 928,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-928.png',
            'Order': 196,
            'Size': '{Width=3454, Height=2296}',
            'Title': 'maxi party cake_overall_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:15:11',
            'Categories': [],
            'Created': '07/24/2017 13:15:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 936,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-936.png',
            'Order': 204,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:20:20',
            'Categories': [],
            'Created': '07/24/2017 13:20:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 938,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-938.png',
            'Order': 206,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:20:47',
            'Categories': [],
            'Created': '07/24/2017 13:20:47',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 950,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-950.png',
            'Order': 218,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:28:48',
            'Categories': [],
            'Created': '07/24/2017 13:28:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 952,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-952.png',
            'Order': 220,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'maxi party cake_overall',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:30:53',
            'Categories': [],
            'Created': '07/24/2017 13:29:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 959,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-959.png',
            'Order': 227,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:31:39',
            'Categories': [],
            'Created': '07/24/2017 13:31:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 961,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-961.png',
            'Order': 229,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:32:10',
            'Categories': [],
            'Created': '07/24/2017 13:32:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 965,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-965.png',
            'Order': 233,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:34:23',
            'Categories': [],
            'Created': '07/24/2017 13:33:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 971,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-971.png',
            'Order': 239,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:34:04',
            'Categories': [],
            'Created': '07/24/2017 13:34:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 974,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-974.png',
            'Order': 242,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:40:49',
            'Categories': [],
            'Created': '07/24/2017 13:34:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 980,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-980.png',
            'Order': 248,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:35:53',
            'Categories': [],
            'Created': '07/24/2017 13:35:53',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 983,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-983.png',
            'Order': 251,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:36:20',
            'Categories': [],
            'Created': '07/24/2017 13:36:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 984,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-984.png',
            'Order': 252,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:36:25',
            'Categories': [],
            'Created': '07/24/2017 13:36:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 995,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-995.png',
            'Order': 263,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:38:49',
            'Categories': [],
            'Created': '07/24/2017 13:38:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 996,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-996.png',
            'Order': 264,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:39:31',
            'Categories': [],
            'Created': '07/24/2017 13:39:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1005,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1005.png',
            'Order': 273,
            'Size': '{Width=3447, Height=2296}',
            'Title': 'maxi party cake_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:42:26',
            'Categories': [],
            'Created': '07/24/2017 13:42:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1007,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1007.png',
            'Order': 275,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:42:51',
            'Categories': [],
            'Created': '07/24/2017 13:42:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1012,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1012.png',
            'Order': 280,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:44:23',
            'Categories': [],
            'Created': '07/24/2017 13:44:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1014,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1014.png',
            'Order': 282,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:47:31',
            'Categories': [],
            'Created': '07/24/2017 13:47:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1023,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1023.png',
            'Order': 291,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:54:42',
            'Categories': [],
            'Created': '07/24/2017 13:54:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1024,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1024.png',
            'Order': 292,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:56:09',
            'Categories': [],
            'Created': '07/24/2017 13:56:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1028,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1028.png',
            'Order': 296,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:00:29',
            'Categories': [],
            'Created': '07/24/2017 14:00:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1030,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1030.png',
            'Order': 298,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:02:05',
            'Categories': [],
            'Created': '07/24/2017 14:02:05',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1047,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1047.png',
            'Order': 315,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:14:03',
            'Categories': [],
            'Created': '07/24/2017 14:14:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1055,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1055.png',
            'Order': 323,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:19:20',
            'Categories': [],
            'Created': '07/24/2017 14:19:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1058,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1058.png',
            'Order': 326,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:21:35',
            'Categories': [],
            'Created': '07/24/2017 14:21:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1065,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1065.png',
            'Order': 333,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:27:19',
            'Categories': [],
            'Created': '07/24/2017 14:27:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1077,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1077.png',
            'Order': 345,
            'Size': '{Width=5124, Height=3663}',
            'Title': 'maxi party cake_kader_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:35:05',
            'Categories': [],
            'Created': '07/24/2017 14:35:05',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1078,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1078.png',
            'Order': 346,
            'Size': '{Width=5124, Height=3663}',
            'Title': 'maxi party cake_overall_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:36:22',
            'Categories': [],
            'Created': '07/24/2017 14:36:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1092,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1092.png',
            'Order': 360,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:49:04',
            'Categories': [],
            'Created': '07/24/2017 14:49:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1094,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1094.png',
            'Order': 362,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:50:32',
            'Categories': [],
            'Created': '07/24/2017 14:50:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1099,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1099.png',
            'Order': 367,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:55:48',
            'Categories': [],
            'Created': '07/24/2017 14:55:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1105,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1105.png',
            'Order': 373,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:02:21',
            'Categories': [],
            'Created': '07/24/2017 15:02:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1113,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1113.png',
            'Order': 381,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:08:06',
            'Categories': [],
            'Created': '07/24/2017 15:08:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1117,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1117.png',
            'Order': 385,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:09:35',
            'Categories': [],
            'Created': '07/24/2017 15:09:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1119,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1119.png',
            'Order': 387,
            'Size': '{Width=3448, Height=2298}',
            'Title': 'mega taart_kader_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:10:04',
            'Categories': [],
            'Created': '07/24/2017 15:10:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1125,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1125.png',
            'Order': 393,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_overall_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:12:45',
            'Categories': [],
            'Created': '07/24/2017 15:12:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1151,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1151.png',
            'Order': 419,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:26:22',
            'Categories': [],
            'Created': '07/24/2017 15:26:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1153,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1153.png',
            'Order': 421,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:28:01',
            'Categories': [],
            'Created': '07/24/2017 15:28:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1161,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1161.png',
            'Order': 429,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:32:44',
            'Categories': [],
            'Created': '07/24/2017 15:32:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1163,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1163.png',
            'Order': 431,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:35:06',
            'Categories': [],
            'Created': '07/24/2017 15:35:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1164,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1164.png',
            'Order': 432,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'MegaTaart-L_kader_jipjannke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:35:17',
            'Categories': [],
            'Created': '07/24/2017 15:35:17',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1169,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1169.png',
            'Order': 437,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'MegaTaart-L_overall_jipjannke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:38:27',
            'Categories': [],
            'Created': '07/24/2017 15:38:27',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1172,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1172.png',
            'Order': 440,
            'Size': '{Width=3460, Height=2296}',
            'Title': 'mega taart3D_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:46:43',
            'Categories': [],
            'Created': '07/24/2017 15:38:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1184,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1184.png',
            'Order': 450,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_kader_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:42:45',
            'Categories': [],
            'Created': '07/24/2017 15:42:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1185,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1185.png',
            'Order': 452,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'mega taart_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\bressersa',
            'LastModified': '07/24/2017 15:43:10',
            'Categories': [],
            'Created': '07/24/2017 15:43:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1186,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1186.png',
            'Order': 453,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:43:52',
            'Categories': [],
            'Created': '07/24/2017 15:43:52',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1197,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1197.png',
            'Order': 462,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_lente_01',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:55:51',
            'Categories': [],
            'Created': '07/24/2017 15:55:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1207,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1207.png',
            'Order': 471,
            'Size': '{Width=3446, Height=2297}',
            'Title': 'MegaTaart_L_kader_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 16:04:32',
            'Categories': [],
            'Created': '07/24/2017 16:04:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1209,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1209.png',
            'Order': 473,
            'Size': '{Width=4535, Height=3236}',
            'Title': 'MegaTaart_L_overall_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 16:07:43',
            'Categories': [],
            'Created': '07/24/2017 16:07:43',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 17,
            'Title': 'Montserrat',
            'ImagePath': 'fonts/font-17.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 14,
            'Order': 5,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '08/15/2017 12:04:47',
            'LastModifiedBy': 'HEMALOCAL\\emdvorobiova',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 22,
            'Title': 'Bungee',
            'ImagePath': 'fonts/font-22.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 9,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/22/2017 06:29:11',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:25:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 7,
            'Title': '6333602',
            'Created': '05/16/2017 13:31:20',
            'LastModified': '08/19/2019 13:13:37',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Active': 1,
            'ProductTypeId': 5,
            'ShapeId': 2,
            'Width': 1636,
            'Height': 1099,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-maxi-party-cake',
            'BackgroundWidth': 2000,
            'BackgroundHeight': 1440,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-7.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-7.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-maxi-party-cake'
          },
          {
            'ProductId': 24,
            'Title': '6333605',
            'Created': '07/21/2017 14:24:13',
            'LastModified': '04/04/2022 16:22:21',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Active': 1,
            'ProductTypeId': 5,
            'ShapeId': 2,
            'Width': 1636,
            'Height': 1099,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-maxi-party-cake',
            'BackgroundWidth': 2000,
            'BackgroundHeight': 1440,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-24.png',
            'BackgroundImagePath': 'products/backgrounds/product-24.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-maxi-party-cake'
          },
          {
            'ProductId': 25,
            'Title': '6333615',
            'Created': '07/21/2017 14:26:09',
            'LastModified': '08/06/2020 11:53:15',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'Active': 1,
            'ProductTypeId': 5,
            'ShapeId': 2,
            'Width': 1636,
            'Height': 1099,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-maxi-party-cake',
            'BackgroundWidth': 2000,
            'BackgroundHeight': 1440,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-25.png',
            'BackgroundImagePath': 'products/backgrounds/product-25.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': true,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-maxi-party-cake'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 2,
            'Active': 1,
            'ImagePath': 'templates/template-2.svg',
            'ShapeId': 2,
            'Created': '02/22/2017 13:53:08',
            'LastModified': '05/18/2017 12:10:03',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 4,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 23.076923}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 53.846154}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 23.076923}}',
            'Title': 'Layout-03'
          },
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 5,
            'Active': 1,
            'ImagePath': 'templates/template-5.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:11:50',
            'LastModified': '05/18/2017 12:10:06',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 5,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 50, h: 50}}',
            'Title': 'Layout-04'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 7,
            'Active': 1,
            'ImagePath': 'templates/template-7.svg',
            'ShapeId': 2,
            'Created': '04/27/2017 08:36:17',
            'LastModified': '05/18/2017 12:10:16',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 6,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 8, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 9, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-05'
          },
          {
            'LayoutTemplateId': 8,
            'Active': 1,
            'ImagePath': 'templates/template-8.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:48:38',
            'LastModified': '05/18/2017 12:10:12',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 7,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-06'
          },
          {
            'LayoutTemplateId': 9,
            'Active': 1,
            'ImagePath': 'templates/template-9.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:49:05',
            'LastModified': '05/18/2017 12:10:20',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 8,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-07'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          },
          {
            'LayoutTemplateId': 12,
            'Active': 1,
            'ImagePath': 'templates/template-12.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:24:43',
            'LastModified': '05/18/2017 12:10:25',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 9,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-08'
          },
          {
            'LayoutTemplateId': 13,
            'Active': 1,
            'ImagePath': 'templates/template-13.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:26:35',
            'LastModified': '06/16/2017 13:30:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Order': 10,
            'PermittedSides': 'center,top,right,bottom',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 50, h: 100}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 100}}',
            'Title': 'Layout-09'
          },
          {
            'LayoutTemplateId': 14,
            'Active': 1,
            'ImagePath': 'templates/template-14.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:27:44',
            'LastModified': '05/18/2017 12:10:33',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 11,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-10'
          },
          {
            'LayoutTemplateId': 15,
            'Active': 1,
            'ImagePath': 'templates/template-15.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:12',
            'LastModified': '05/18/2017 12:10:38',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 12,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-11'
          },
          {
            'LayoutTemplateId': 16,
            'Active': 0,
            'ImagePath': 'templates/template-16.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:35',
            'LastModified': '07/31/2019 15:15:43',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 13,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: \'hidden\', accept: \'\', dimension: {w: 100, h: 33.333333}},\r\n{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-12'
          },
          {
            'LayoutTemplateId': 17,
            'Active': 1,
            'ImagePath': 'templates/template-17.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:16',
            'LastModified': '05/18/2017 12:10:46',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 14,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 66.666666}}',
            'Title': 'Layout-13'
          },
          {
            'LayoutTemplateId': 18,
            'Active': 1,
            'ImagePath': 'templates/template-18.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:41',
            'LastModified': '05/18/2017 12:10:50',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 15,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 50}}',
            'Title': 'Layout-14'
          },
          {
            'LayoutTemplateId': 19,
            'Active': 1,
            'ImagePath': 'templates/template-19.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:30:07',
            'LastModified': '06/07/2017 12:46:48',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'Order': 16,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-15'
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 13,
            'Active': 1,
            'Order': 3,
            'Title': 'Strik',
            'ImagePath': 'stickers/sticker-13.png',
            'Size': '{Width=625, Height=335}',
            'LastModified': '05/09/2017 07:13:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:55',
            'ProductTypes': []
          },
          {
            'StickerId': 14,
            'Active': 1,
            'Order': 4,
            'Title': 'Cirkel',
            'ImagePath': 'stickers/sticker-14.png',
            'Size': '{Width=623, Height=624}',
            'LastModified': '05/09/2017 07:14:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:06',
            'ProductTypes': []
          },
          {
            'StickerId': 15,
            'Active': 1,
            'Order': 5,
            'Title': 'Spreekwolk',
            'ImagePath': 'stickers/sticker-15.png',
            'Size': '{Width=833, Height=736}',
            'LastModified': '05/09/2017 07:14:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:19',
            'ProductTypes': []
          },
          {
            'StickerId': 16,
            'Active': 1,
            'Order': 7,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-16.png',
            'Size': '{Width=662, Height=737}',
            'LastModified': '05/09/2017 07:14:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:27',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 19,
            'Active': 1,
            'Order': 10,
            'Title': 'Bril',
            'ImagePath': 'stickers/sticker-19.png',
            'Size': '{Width=688, Height=229}',
            'LastModified': '05/09/2017 07:15:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:01',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 21,
            'Active': 1,
            'Order': 12,
            'Title': 'Baby',
            'ImagePath': 'stickers/sticker-21.png',
            'Size': '{Width=729, Height=658}',
            'LastModified': '05/09/2017 07:15:47',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:47',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 23,
            'Active': 1,
            'Order': 14,
            'Title': 'Hart blauw',
            'ImagePath': 'stickers/sticker-23.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '05/09/2017 07:16:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:14',
            'ProductTypes': []
          },
          {
            'StickerId': 24,
            'Active': 1,
            'Order': 15,
            'Title': 'Ster blauw',
            'ImagePath': 'stickers/sticker-24.png',
            'Size': '{Width=625, Height=570}',
            'LastModified': '05/09/2017 07:16:24',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:24',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 26,
            'Active': 1,
            'Order': 17,
            'Title': 'Welkom kleintje',
            'ImagePath': 'stickers/sticker-26.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:16:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:56',
            'ProductTypes': []
          },
          {
            'StickerId': 27,
            'Active': 1,
            'Order': 18,
            'Title': 'Welkom kleintjes',
            'ImagePath': 'stickers/sticker-27.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:17:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:13',
            'ProductTypes': []
          },
          {
            'StickerId': 28,
            'Active': 1,
            'Order': 19,
            'Title': 'Sinasappel',
            'ImagePath': 'stickers/sticker-28.png',
            'Size': '{Width=729, Height=729}',
            'LastModified': '05/09/2017 07:17:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:25',
            'ProductTypes': []
          },
          {
            'StickerId': 29,
            'Active': 1,
            'Order': 20,
            'Title': 'Blaadje',
            'ImagePath': 'stickers/sticker-29.png',
            'Size': '{Width=717, Height=238}',
            'LastModified': '05/09/2017 07:17:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:37',
            'ProductTypes': []
          },
          {
            'StickerId': 30,
            'Active': 1,
            'Order': 21,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-30.png',
            'Size': '{Width=359, Height=931}',
            'LastModified': '05/09/2017 07:17:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:48',
            'ProductTypes': []
          },
          {
            'StickerId': 31,
            'Active': 1,
            'Order': 22,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-31.png',
            'Size': '{Width=383, Height=942}',
            'LastModified': '05/09/2017 07:18:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:02',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 33,
            'Active': 1,
            'Order': 24,
            'Title': 'Ananas',
            'ImagePath': 'stickers/sticker-33.png',
            'Size': '{Width=405, Height=738}',
            'LastModified': '05/09/2017 07:18:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:28',
            'ProductTypes': []
          },
          {
            'StickerId': 34,
            'Active': 1,
            'Order': 25,
            'Title': 'Herfst blaadjes',
            'ImagePath': 'stickers/sticker-34.png',
            'Size': '{Width=255, Height=546}',
            'LastModified': '05/09/2017 07:18:46',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:46',
            'ProductTypes': []
          },
          {
            'StickerId': 35,
            'Active': 1,
            'Order': 26,
            'Title': 'Winter',
            'ImagePath': 'stickers/sticker-35.png',
            'Size': '{Width=476, Height=785}',
            'LastModified': '05/09/2017 07:18:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:59',
            'ProductTypes': []
          },
          {
            'StickerId': 36,
            'Active': 1,
            'Order': 27,
            'Title': 'Astronaut',
            'ImagePath': 'stickers/sticker-36.png',
            'Size': '{Width=589, Height=988}',
            'LastModified': '05/09/2017 07:19:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:14',
            'ProductTypes': []
          },
          {
            'StickerId': 37,
            'Active': 1,
            'Order': 28,
            'Title': 'Jarig',
            'ImagePath': 'stickers/sticker-37.png',
            'Size': '{Width=1036, Height=1026}',
            'LastModified': '05/09/2017 07:19:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:26',
            'ProductTypes': []
          },
          {
            'StickerId': 38,
            'Active': 1,
            'Order': 29,
            'Title': 'Kikker',
            'ImagePath': 'stickers/sticker-38.png',
            'Size': '{Width=1042, Height=1040}',
            'LastModified': '05/09/2017 07:19:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:38',
            'ProductTypes': []
          },
          {
            'StickerId': 39,
            'Active': 1,
            'Order': 30,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-39.png',
            'Size': '{Width=1042, Height=651}',
            'LastModified': '05/09/2017 07:19:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:56',
            'ProductTypes': []
          },
          {
            'StickerId': 40,
            'Active': 1,
            'Order': 31,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-40.png',
            'Size': '{Width=988, Height=311}',
            'LastModified': '05/09/2017 07:20:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:13',
            'ProductTypes': []
          },
          {
            'StickerId': 41,
            'Active': 1,
            'Order': 32,
            'Title': 'Piratenmuts',
            'ImagePath': 'stickers/sticker-41.png',
            'Size': '{Width=1042, Height=591}',
            'LastModified': '05/09/2017 07:20:34',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:34',
            'ProductTypes': []
          },
          {
            'StickerId': 42,
            'Active': 1,
            'Order': 33,
            'Title': 'Takkie',
            'ImagePath': 'stickers/sticker-42.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:20:45',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:45',
            'ProductTypes': []
          },
          {
            'StickerId': 43,
            'Active': 1,
            'Order': 34,
            'Title': 'Ballon geel',
            'ImagePath': 'stickers/sticker-43.png',
            'Size': '{Width=377, Height=1024}',
            'LastModified': '05/09/2017 07:20:58',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:58',
            'ProductTypes': []
          },
          {
            'StickerId': 44,
            'Active': 1,
            'Order': 35,
            'Title': 'Getrouwd',
            'ImagePath': 'stickers/sticker-44.png',
            'Size': '{Width=1028, Height=349}',
            'LastModified': '05/09/2017 07:21:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:11',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 46,
            'Active': 1,
            'Order': 37,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-46.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:21:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:57',
            'ProductTypes': []
          },
          {
            'StickerId': 47,
            'Active': 1,
            'Order': 38,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-47.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:22:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:19',
            'ProductTypes': []
          },
          {
            'StickerId': 48,
            'Active': 1,
            'Order': 39,
            'Title': 'Papagaai',
            'ImagePath': 'stickers/sticker-48.png',
            'Size': '{Width=1042, Height=928}',
            'LastModified': '05/09/2017 07:22:30',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:30',
            'ProductTypes': []
          },
          {
            'StickerId': 49,
            'Active': 1,
            'Order': 40,
            'Title': 'Robot',
            'ImagePath': 'stickers/sticker-49.png',
            'Size': '{Width=674, Height=1009}',
            'LastModified': '05/09/2017 07:22:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:43',
            'ProductTypes': []
          },
          {
            'StickerId': 50,
            'Active': 1,
            'Order': 41,
            'Title': 'The king',
            'ImagePath': 'stickers/sticker-50.png',
            'Size': '{Width=1044, Height=197}',
            'LastModified': '05/09/2017 07:22:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:55',
            'ProductTypes': []
          },
          {
            'StickerId': 51,
            'Active': 1,
            'Order': 42,
            'Title': 'Ballonnen groen',
            'ImagePath': 'stickers/sticker-51.png',
            'Size': '{Width=785, Height=1007}',
            'LastModified': '05/09/2017 07:23:10',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:10',
            'ProductTypes': []
          },
          {
            'StickerId': 52,
            'Active': 1,
            'Order': 43,
            'Title': 'Je bent mijn liefste',
            'ImagePath': 'stickers/sticker-52.png',
            'Size': '{Width=487, Height=1042}',
            'LastModified': '05/09/2017 07:23:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:27',
            'ProductTypes': []
          },
          {
            'StickerId': 53,
            'Active': 1,
            'Order': 44,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-53.png',
            'Size': '{Width=1038, Height=948}',
            'LastModified': '05/09/2017 07:23:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:37',
            'ProductTypes': []
          },
          {
            'StickerId': 54,
            'Active': 1,
            'Order': 45,
            'Title': 'Racket',
            'ImagePath': 'stickers/sticker-54.png',
            'Size': '{Width=420, Height=1016}',
            'LastModified': '05/09/2017 07:23:49',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:49',
            'ProductTypes': []
          },
          {
            'StickerId': 55,
            'Active': 1,
            'Order': 46,
            'Title': 'Zwaard',
            'ImagePath': 'stickers/sticker-55.png',
            'Size': '{Width=461, Height=1042}',
            'LastModified': '05/09/2017 07:24:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:01',
            'ProductTypes': []
          },
          {
            'StickerId': 56,
            'Active': 1,
            'Order': 47,
            'Title': 'Hoeravlag',
            'ImagePath': 'stickers/sticker-56.png',
            'Size': '{Width=1045, Height=252}',
            'LastModified': '05/09/2017 07:24:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:13',
            'ProductTypes': []
          },
          {
            'StickerId': 57,
            'Active': 1,
            'Order': 48,
            'Title': 'Rood hartje',
            'ImagePath': 'stickers/sticker-57.png',
            'Size': '{Width=624, Height=1007}',
            'LastModified': '05/09/2017 07:24:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:27',
            'ProductTypes': []
          },
          {
            'StickerId': 58,
            'Active': 1,
            'Order': 49,
            'Title': 'Hoera banner',
            'ImagePath': 'stickers/sticker-58.png',
            'Size': '{Width=1029, Height=530}',
            'LastModified': '05/09/2017 07:24:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:48',
            'ProductTypes': []
          },
          {
            'StickerId': 59,
            'Active': 1,
            'Order': 50,
            'Title': 'Raket',
            'ImagePath': 'stickers/sticker-59.png',
            'Size': '{Width=659, Height=984}',
            'LastModified': '05/09/2017 07:25:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:05',
            'ProductTypes': []
          },
          {
            'StickerId': 60,
            'Active': 1,
            'Order': 51,
            'Title': 'Twee hartjes',
            'ImagePath': 'stickers/sticker-60.png',
            'Size': '{Width=968, Height=754}',
            'LastModified': '05/09/2017 07:25:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:18',
            'ProductTypes': []
          },
          {
            'StickerId': 61,
            'Active': 1,
            'Order': 52,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-61.png',
            'Size': '{Width=995, Height=543}',
            'LastModified': '05/09/2017 07:25:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:31',
            'ProductTypes': []
          },
          {
            'StickerId': 62,
            'Active': 1,
            'Order': 53,
            'Title': 'Lijn hartjes',
            'ImagePath': 'stickers/sticker-62.png',
            'Size': '{Width=982, Height=958}',
            'LastModified': '05/09/2017 07:25:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:43',
            'ProductTypes': []
          },
          {
            'StickerId': 63,
            'Active': 1,
            'Order': 54,
            'Title': 'Roze hartje',
            'ImagePath': 'stickers/sticker-63.png',
            'Size': '{Width=624, Height=1017}',
            'LastModified': '05/09/2017 07:26:23',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:23',
            'ProductTypes': []
          },
          {
            'StickerId': 64,
            'Active': 1,
            'Order': 55,
            'Title': 'Ufo',
            'ImagePath': 'stickers/sticker-64.png',
            'Size': '{Width=914, Height=958}',
            'LastModified': '05/09/2017 07:26:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:32',
            'ProductTypes': []
          },
          {
            'StickerId': 65,
            'Active': 1,
            'Order': 56,
            'Title': 'Kadootje',
            'ImagePath': 'stickers/sticker-65.png',
            'Size': '{Width=706, Height=1012}',
            'LastModified': '05/09/2017 07:26:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:42',
            'ProductTypes': []
          },
          {
            'StickerId': 66,
            'Active': 1,
            'Order': 57,
            'Title': 'Ring',
            'ImagePath': 'stickers/sticker-66.png',
            'Size': '{Width=620, Height=1001}',
            'LastModified': '05/09/2017 07:26:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:51',
            'ProductTypes': []
          },
          {
            'StickerId': 67,
            'Active': 1,
            'Order': 58,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-67.png',
            'Size': '{Width=1020, Height=947}',
            'LastModified': '05/09/2017 07:27:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:01',
            'ProductTypes': []
          },
          {
            'StickerId': 68,
            'Active': 1,
            'Order': 59,
            'Title': 'Bowtie',
            'ImagePath': 'stickers/sticker-68.png',
            'Size': '{Width=1017, Height=514}',
            'LastModified': '05/09/2017 07:27:09',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:09',
            'ProductTypes': []
          },
          {
            'StickerId': 69,
            'Active': 1,
            'Order': 60,
            'Title': 'Confetti',
            'ImagePath': 'stickers/sticker-69.png',
            'Size': '{Width=333, Height=995}',
            'LastModified': '05/09/2017 07:27:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:21',
            'ProductTypes': []
          },
          {
            'StickerId': 70,
            'Active': 1,
            'Order': 61,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-70.png',
            'Size': '{Width=898, Height=1006}',
            'LastModified': '05/09/2017 07:27:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:33',
            'ProductTypes': []
          },
          {
            'StickerId': 71,
            'Active': 1,
            'Order': 62,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-71.png',
            'Size': '{Width=1027, Height=573}',
            'LastModified': '05/09/2017 07:27:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:42',
            'ProductTypes': []
          },
          {
            'StickerId': 72,
            'Active': 1,
            'Order': 63,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-72.png',
            'Size': '{Width=797, Height=985}',
            'LastModified': '05/09/2017 07:27:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:55',
            'ProductTypes': []
          },
          {
            'StickerId': 73,
            'Active': 1,
            'Order': 64,
            'Title': 'Mr',
            'ImagePath': 'stickers/sticker-73.png',
            'Size': '{Width=1038, Height=932}',
            'LastModified': '05/09/2017 07:28:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:07',
            'ProductTypes': []
          },
          {
            'StickerId': 74,
            'Active': 1,
            'Order': 65,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-74.png',
            'Size': '{Width=708, Height=990}',
            'LastModified': '05/09/2017 07:28:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:18',
            'ProductTypes': []
          },
          {
            'StickerId': 75,
            'Active': 1,
            'Order': 66,
            'Title': 'Ms',
            'ImagePath': 'stickers/sticker-75.png',
            'Size': '{Width=1031, Height=971}',
            'LastModified': '05/09/2017 07:28:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:32',
            'ProductTypes': []
          },
          {
            'StickerId': 76,
            'Active': 1,
            'Order': 67,
            'Title': 'Rainbow',
            'ImagePath': 'stickers/sticker-76.png',
            'Size': '{Width=1010, Height=659}',
            'LastModified': '05/09/2017 07:28:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:42',
            'ProductTypes': []
          },
          {
            'StickerId': 77,
            'Active': 1,
            'Order': 68,
            'Title': 'Champagne',
            'ImagePath': 'stickers/sticker-77.png',
            'Size': '{Width=341, Height=1006}',
            'LastModified': '05/09/2017 07:28:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:56',
            'ProductTypes': []
          },
          {
            'StickerId': 78,
            'Active': 1,
            'Order': 69,
            'Title': 'Hartjes',
            'ImagePath': 'stickers/sticker-78.png',
            'Size': '{Width=951, Height=571}',
            'LastModified': '05/09/2017 07:29:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:06',
            'ProductTypes': []
          },
          {
            'StickerId': 79,
            'Active': 1,
            'Order': 70,
            'Title': 'You are just lovely',
            'ImagePath': 'stickers/sticker-79.png',
            'Size': '{Width=987, Height=899}',
            'LastModified': '05/09/2017 07:29:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:26',
            'ProductTypes': []
          },
          {
            'StickerId': 80,
            'Active': 1,
            'Order': 71,
            'Title': 'Medaille',
            'ImagePath': 'stickers/sticker-80.png',
            'Size': '{Width=591, Height=1018}',
            'LastModified': '05/09/2017 07:29:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:40',
            'ProductTypes': []
          },
          {
            'StickerId': 81,
            'Active': 1,
            'Order': 72,
            'Title': 'Pluk de dag',
            'ImagePath': 'stickers/sticker-81.png',
            'Size': '{Width=509, Height=1042}',
            'LastModified': '05/09/2017 07:29:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:51',
            'ProductTypes': []
          },
          {
            'StickerId': 82,
            'Active': 1,
            'Order': 73,
            'Title': 'Zon',
            'ImagePath': 'stickers/sticker-82.png',
            'Size': '{Width=1033, Height=1005}',
            'LastModified': '05/09/2017 07:30:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:01',
            'ProductTypes': []
          },
          {
            'StickerId': 83,
            'Active': 1,
            'Order': 74,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-83.png',
            'Size': '{Width=997, Height=646}',
            'LastModified': '05/09/2017 07:30:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:11',
            'ProductTypes': []
          },
          {
            'StickerId': 84,
            'Active': 1,
            'Order': 75,
            'Title': 'Hartjesdoos mama',
            'ImagePath': 'stickers/sticker-84.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:28',
            'ProductTypes': []
          },
          {
            'StickerId': 85,
            'Active': 1,
            'Order': 76,
            'Title': 'Hartjesdoos',
            'ImagePath': 'stickers/sticker-85.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:41',
            'ProductTypes': []
          },
          {
            'StickerId': 86,
            'Active': 1,
            'Order': 77,
            'Title': 'Wolk rain',
            'ImagePath': 'stickers/sticker-86.png',
            'Size': '{Width=1002, Height=948}',
            'LastModified': '05/09/2017 07:30:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:54',
            'ProductTypes': []
          },
          {
            'StickerId': 87,
            'Active': 1,
            'Order': 78,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-87.png',
            'Size': '{Width=1025, Height=721}',
            'LastModified': '05/09/2017 07:31:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:05',
            'ProductTypes': []
          },
          {
            'StickerId': 88,
            'Active': 1,
            'Order': 79,
            'Title': 'Hartje mama',
            'ImagePath': 'stickers/sticker-88.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:32',
            'ProductTypes': []
          },
          {
            'StickerId': 89,
            'Active': 1,
            'Order': 80,
            'Title': 'Hartje',
            'ImagePath': 'stickers/sticker-89.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:42',
            'ProductTypes': []
          },
          {
            'StickerId': 90,
            'Active': 1,
            'Order': 81,
            'Title': 'Wolk donder',
            'ImagePath': 'stickers/sticker-90.png',
            'Size': '{Width=878, Height=998}',
            'LastModified': '05/09/2017 07:40:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:00',
            'ProductTypes': []
          },
          {
            'StickerId': 91,
            'Active': 1,
            'Order': 82,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-91.png',
            'Size': '{Width=1013, Height=1013}',
            'LastModified': '05/09/2017 07:40:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:14',
            'ProductTypes': []
          },
          {
            'StickerId': 92,
            'Active': 1,
            'Order': 83,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-92.png',
            'Size': '{Width=768, Height=1013}',
            'LastModified': '05/09/2017 07:40:44',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:44',
            'ProductTypes': []
          },
          {
            'StickerId': 93,
            'Active': 1,
            'Order': 84,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-93.png',
            'Size': '{Width=1009, Height=1022}',
            'LastModified': '05/09/2017 07:40:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:54',
            'ProductTypes': []
          },
          {
            'StickerId': 94,
            'Active': 1,
            'Order': 85,
            'Title': 'Zwemband',
            'ImagePath': 'stickers/sticker-94.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:41:04',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:04',
            'ProductTypes': []
          },
          {
            'StickerId': 95,
            'Active': 1,
            'Order': 86,
            'Title': 'Plons',
            'ImagePath': 'stickers/sticker-95.png',
            'Size': '{Width=1033, Height=430}',
            'LastModified': '05/09/2017 07:41:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:17',
            'ProductTypes': []
          },
          {
            'StickerId': 96,
            'Active': 1,
            'Order': 87,
            'Title': 'Zwemdiploma',
            'ImagePath': 'stickers/sticker-96.png',
            'Size': '{Width=1019, Height=121}',
            'LastModified': '05/09/2017 07:41:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:29',
            'ProductTypes': []
          },
          {
            'StickerId': 97,
            'Active': 1,
            'Order': 88,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-97.png',
            'Size': '{Width=719, Height=1044}',
            'LastModified': '05/09/2017 07:41:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:41',
            'ProductTypes': []
          },
          {
            'StickerId': 98,
            'Active': 1,
            'Order': 89,
            'Title': 'New home',
            'ImagePath': 'stickers/sticker-98.png',
            'Size': '{Width=835, Height=1042}',
            'LastModified': '05/09/2017 07:41:52',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:52',
            'ProductTypes': []
          },
          {
            'StickerId': 99,
            'Active': 1,
            'Order': 90,
            'Title': 'Sportheld',
            'ImagePath': 'stickers/sticker-99.png',
            'Size': '{Width=925, Height=1040}',
            'LastModified': '05/09/2017 07:42:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:02',
            'ProductTypes': []
          },
          {
            'StickerId': 100,
            'Active': 1,
            'Order': 91,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-100.png',
            'Size': '{Width=855, Height=1042}',
            'LastModified': '05/09/2017 07:42:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:12',
            'ProductTypes': []
          },
          {
            'StickerId': 101,
            'Active': 1,
            'Order': 92,
            'Title': 'Present',
            'ImagePath': 'stickers/sticker-101.png',
            'Size': '{Width=714, Height=1004}',
            'LastModified': '05/09/2017 07:42:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:21',
            'ProductTypes': []
          },
          {
            'StickerId': 102,
            'Active': 1,
            'Order': 93,
            'Title': 'Bird',
            'ImagePath': 'stickers/sticker-102.png',
            'Size': '{Width=1031, Height=720}',
            'LastModified': '05/09/2017 07:42:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:31',
            'ProductTypes': []
          },
          {
            'StickerId': 103,
            'Active': 1,
            'Order': 94,
            'Title': 'Snowflake',
            'ImagePath': 'stickers/sticker-103.png',
            'Size': '{Width=922, Height=1000}',
            'LastModified': '10/11/2022 14:35:16',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:40',
            'ProductTypes': []
          },
          {
            'StickerId': 104,
            'Active': 1,
            'Order': 95,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-104.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:53',
            'ProductTypes': []
          },
          {
            'StickerId': 105,
            'Active': 1,
            'Order': 96,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-105.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:57',
            'ProductTypes': []
          },
          {
            'StickerId': 106,
            'Active': 1,
            'Order': 97,
            'Title': 'Bat',
            'ImagePath': 'stickers/sticker-106.png',
            'Size': '{Width=1042, Height=315}',
            'LastModified': '10/11/2022 14:35:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:07',
            'ProductTypes': []
          },
          {
            'StickerId': 107,
            'Active': 1,
            'Order': 98,
            'Title': 'Hoera een jongen',
            'ImagePath': 'stickers/sticker-107.png',
            'Size': '{Width=734, Height=1042}',
            'LastModified': '05/09/2017 07:43:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:21',
            'ProductTypes': []
          },
          {
            'StickerId': 108,
            'Active': 1,
            'Order': 99,
            'Title': 'Bedankt',
            'ImagePath': 'stickers/sticker-108.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:43:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:32',
            'ProductTypes': []
          },
          {
            'StickerId': 109,
            'Active': 1,
            'Order': 100,
            'Title': 'Pumpkin',
            'ImagePath': 'stickers/sticker-109.png',
            'Size': '{Width=1042, Height=763}',
            'LastModified': '10/11/2022 14:35:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:47',
            'ProductTypes': []
          },
          {
            'StickerId': 110,
            'Active': 1,
            'Order': 101,
            'Title': 'Stoplicht',
            'ImagePath': 'stickers/sticker-110.png',
            'Size': '{Width=288, Height=1032}',
            'LastModified': '05/09/2017 07:44:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:00',
            'ProductTypes': []
          },
          {
            'StickerId': 111,
            'Active': 1,
            'Order': 102,
            'Title': 'Hoera rijbewijs',
            'ImagePath': 'stickers/sticker-111.png',
            'Size': '{Width=1040, Height=632}',
            'LastModified': '05/09/2017 07:44:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:14',
            'ProductTypes': []
          },
          {
            'StickerId': 112,
            'Active': 1,
            'Order': 103,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-112.png',
            'Size': '{Width=997, Height=997}',
            'LastModified': '05/09/2017 07:44:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:25',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 6,
        'Name': 'heart-cake-1033x1010',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1111,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1111.jpg',
            'Order': 379,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'hart_taart_blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 15:07:29',
            'Categories': [],
            'Created': '07/24/2017 15:07:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1112,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1112.jpg',
            'Order': 380,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'hart_taart_groen',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 15:07:57',
            'Categories': [],
            'Created': '07/24/2017 15:07:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1116,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1116.jpg',
            'Order': 384,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'hart_taart_geel',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 15:09:12',
            'Categories': [],
            'Created': '07/24/2017 15:09:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1118,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1118.jpg',
            'Order': 386,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'hart_taart_rozerood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 15:10:03',
            'Categories': [],
            'Created': '07/24/2017 15:10:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1121,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1121.jpg',
            'Order': 389,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'hart_taart_fuchsia',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 15:11:05',
            'Categories': [],
            'Created': '07/24/2017 15:11:05',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 17,
            'Title': 'Montserrat',
            'ImagePath': 'fonts/font-17.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 14,
            'Order': 5,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '08/15/2017 12:04:47',
            'LastModifiedBy': 'HEMALOCAL\\emdvorobiova',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 22,
            'Title': 'Bungee',
            'ImagePath': 'fonts/font-22.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 9,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/22/2017 06:29:11',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:25:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 37,
            'Title': '6333635',
            'Created': '06/07/2019 14:20:51',
            'LastModified': '08/28/2023 11:48:00',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Active': 1,
            'ProductTypeId': 6,
            'ShapeId': 2,
            'Width': 1033,
            'Height': 1010,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-heart-cake',
            'BackgroundWidth': 1080,
            'BackgroundHeight': 1060,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 540,
            'OptimalHeight': 530,
            'MinimalWidth': 270,
            'MinimalHeight': 265,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': true,
            'CakeMaskPathDefinition': 'M2.9,307.7L2.9,307.7c0.1,0,0.2,0.1,0.2,0.2c44.3,298.1,230.8,559,498.6,697.6l0.2,0.1c9.1,4.7,20,4.8,29.1,0.2  c0-0.1,0-0.2,0.1-0.2C798.9,867,985.3,606.2,1029.8,308c0,0,0-0.1,0.1-0.1l0.2-0.2c15-100.9-29.6-203.3-113.7-260.9  c-84-57.6-195.6-62.4-284.1-12.2c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.2c-35.1,19.9-75,30.5-115.4,30.5l0,0  c-40.4,0-80.3-10.6-115.4-30.5h-0.1l0,0c-88.7-50.3-200.2-45.6-284.5,12S-12.1,206.7,2.9,307.7z',
            'BleedMaskPathDefinition': 'M516.5,946.6C272.2,815.2,102.6,574.6,61.6,300c-0.2-1.6-0.5-3.3-0.9-4.9c-10-77.5,24.8-155.5,89.4-199.6  c34.9-23.8,76-36.4,118.8-36.4c36.4,0,72.1,9.3,103.3,27l13.5,7.7h1c40.4,20,85,30.5,130,30.5c50.5,0,100.5-13.2,144.5-38.2l7-4  l0.1-0.1C697.8,67,730.8,59,764.4,59c42.9,0,83.9,12.6,118.7,36.4c64.3,44.1,99.1,121.7,89.3,199c-0.4,1.8-0.8,3.7-1,5.6  C930.1,574.6,760.6,815.3,516.5,946.6z',
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-8.png',
            'BackgroundImagePath': 'products/backgrounds/product-8.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': null,
            'WatermarkOffsetTop': null,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 50,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-heart-cake'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 2,
            'Active': 1,
            'ImagePath': 'templates/template-2.svg',
            'ShapeId': 2,
            'Created': '02/22/2017 13:53:08',
            'LastModified': '05/18/2017 12:10:03',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 4,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 23.076923}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 53.846154}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 23.076923}}',
            'Title': 'Layout-03'
          },
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 5,
            'Active': 1,
            'ImagePath': 'templates/template-5.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:11:50',
            'LastModified': '05/18/2017 12:10:06',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 5,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 50, h: 50}}',
            'Title': 'Layout-04'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 7,
            'Active': 1,
            'ImagePath': 'templates/template-7.svg',
            'ShapeId': 2,
            'Created': '04/27/2017 08:36:17',
            'LastModified': '05/18/2017 12:10:16',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 6,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 8, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 9, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-05'
          },
          {
            'LayoutTemplateId': 8,
            'Active': 1,
            'ImagePath': 'templates/template-8.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:48:38',
            'LastModified': '05/18/2017 12:10:12',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 7,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-06'
          },
          {
            'LayoutTemplateId': 9,
            'Active': 1,
            'ImagePath': 'templates/template-9.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:49:05',
            'LastModified': '05/18/2017 12:10:20',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 8,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-07'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          },
          {
            'LayoutTemplateId': 12,
            'Active': 1,
            'ImagePath': 'templates/template-12.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:24:43',
            'LastModified': '05/18/2017 12:10:25',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 9,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-08'
          },
          {
            'LayoutTemplateId': 13,
            'Active': 1,
            'ImagePath': 'templates/template-13.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:26:35',
            'LastModified': '06/16/2017 13:30:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Order': 10,
            'PermittedSides': 'center,top,right,bottom',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 50, h: 100}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 100}}',
            'Title': 'Layout-09'
          },
          {
            'LayoutTemplateId': 14,
            'Active': 1,
            'ImagePath': 'templates/template-14.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:27:44',
            'LastModified': '05/18/2017 12:10:33',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 11,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-10'
          },
          {
            'LayoutTemplateId': 15,
            'Active': 1,
            'ImagePath': 'templates/template-15.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:12',
            'LastModified': '05/18/2017 12:10:38',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 12,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-11'
          },
          {
            'LayoutTemplateId': 16,
            'Active': 0,
            'ImagePath': 'templates/template-16.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:35',
            'LastModified': '07/31/2019 15:15:43',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 13,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: \'hidden\', accept: \'\', dimension: {w: 100, h: 33.333333}},\r\n{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-12'
          },
          {
            'LayoutTemplateId': 17,
            'Active': 1,
            'ImagePath': 'templates/template-17.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:16',
            'LastModified': '05/18/2017 12:10:46',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 14,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 66.666666}}',
            'Title': 'Layout-13'
          },
          {
            'LayoutTemplateId': 18,
            'Active': 1,
            'ImagePath': 'templates/template-18.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:41',
            'LastModified': '05/18/2017 12:10:50',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 15,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 50}}',
            'Title': 'Layout-14'
          },
          {
            'LayoutTemplateId': 19,
            'Active': 1,
            'ImagePath': 'templates/template-19.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:30:07',
            'LastModified': '06/07/2017 12:46:48',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'Order': 16,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-15'
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 13,
            'Active': 1,
            'Order': 3,
            'Title': 'Strik',
            'ImagePath': 'stickers/sticker-13.png',
            'Size': '{Width=625, Height=335}',
            'LastModified': '05/09/2017 07:13:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:55',
            'ProductTypes': []
          },
          {
            'StickerId': 14,
            'Active': 1,
            'Order': 4,
            'Title': 'Cirkel',
            'ImagePath': 'stickers/sticker-14.png',
            'Size': '{Width=623, Height=624}',
            'LastModified': '05/09/2017 07:14:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:06',
            'ProductTypes': []
          },
          {
            'StickerId': 15,
            'Active': 1,
            'Order': 5,
            'Title': 'Spreekwolk',
            'ImagePath': 'stickers/sticker-15.png',
            'Size': '{Width=833, Height=736}',
            'LastModified': '05/09/2017 07:14:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:19',
            'ProductTypes': []
          },
          {
            'StickerId': 16,
            'Active': 1,
            'Order': 7,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-16.png',
            'Size': '{Width=662, Height=737}',
            'LastModified': '05/09/2017 07:14:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:27',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 19,
            'Active': 1,
            'Order': 10,
            'Title': 'Bril',
            'ImagePath': 'stickers/sticker-19.png',
            'Size': '{Width=688, Height=229}',
            'LastModified': '05/09/2017 07:15:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:01',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 21,
            'Active': 1,
            'Order': 12,
            'Title': 'Baby',
            'ImagePath': 'stickers/sticker-21.png',
            'Size': '{Width=729, Height=658}',
            'LastModified': '05/09/2017 07:15:47',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:47',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 23,
            'Active': 1,
            'Order': 14,
            'Title': 'Hart blauw',
            'ImagePath': 'stickers/sticker-23.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '05/09/2017 07:16:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:14',
            'ProductTypes': []
          },
          {
            'StickerId': 24,
            'Active': 1,
            'Order': 15,
            'Title': 'Ster blauw',
            'ImagePath': 'stickers/sticker-24.png',
            'Size': '{Width=625, Height=570}',
            'LastModified': '05/09/2017 07:16:24',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:24',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 26,
            'Active': 1,
            'Order': 17,
            'Title': 'Welkom kleintje',
            'ImagePath': 'stickers/sticker-26.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:16:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:56',
            'ProductTypes': []
          },
          {
            'StickerId': 27,
            'Active': 1,
            'Order': 18,
            'Title': 'Welkom kleintjes',
            'ImagePath': 'stickers/sticker-27.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:17:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:13',
            'ProductTypes': []
          },
          {
            'StickerId': 28,
            'Active': 1,
            'Order': 19,
            'Title': 'Sinasappel',
            'ImagePath': 'stickers/sticker-28.png',
            'Size': '{Width=729, Height=729}',
            'LastModified': '05/09/2017 07:17:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:25',
            'ProductTypes': []
          },
          {
            'StickerId': 29,
            'Active': 1,
            'Order': 20,
            'Title': 'Blaadje',
            'ImagePath': 'stickers/sticker-29.png',
            'Size': '{Width=717, Height=238}',
            'LastModified': '05/09/2017 07:17:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:37',
            'ProductTypes': []
          },
          {
            'StickerId': 30,
            'Active': 1,
            'Order': 21,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-30.png',
            'Size': '{Width=359, Height=931}',
            'LastModified': '05/09/2017 07:17:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:48',
            'ProductTypes': []
          },
          {
            'StickerId': 31,
            'Active': 1,
            'Order': 22,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-31.png',
            'Size': '{Width=383, Height=942}',
            'LastModified': '05/09/2017 07:18:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:02',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 33,
            'Active': 1,
            'Order': 24,
            'Title': 'Ananas',
            'ImagePath': 'stickers/sticker-33.png',
            'Size': '{Width=405, Height=738}',
            'LastModified': '05/09/2017 07:18:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:28',
            'ProductTypes': []
          },
          {
            'StickerId': 34,
            'Active': 1,
            'Order': 25,
            'Title': 'Herfst blaadjes',
            'ImagePath': 'stickers/sticker-34.png',
            'Size': '{Width=255, Height=546}',
            'LastModified': '05/09/2017 07:18:46',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:46',
            'ProductTypes': []
          },
          {
            'StickerId': 35,
            'Active': 1,
            'Order': 26,
            'Title': 'Winter',
            'ImagePath': 'stickers/sticker-35.png',
            'Size': '{Width=476, Height=785}',
            'LastModified': '05/09/2017 07:18:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:59',
            'ProductTypes': []
          },
          {
            'StickerId': 36,
            'Active': 1,
            'Order': 27,
            'Title': 'Astronaut',
            'ImagePath': 'stickers/sticker-36.png',
            'Size': '{Width=589, Height=988}',
            'LastModified': '05/09/2017 07:19:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:14',
            'ProductTypes': []
          },
          {
            'StickerId': 37,
            'Active': 1,
            'Order': 28,
            'Title': 'Jarig',
            'ImagePath': 'stickers/sticker-37.png',
            'Size': '{Width=1036, Height=1026}',
            'LastModified': '05/09/2017 07:19:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:26',
            'ProductTypes': []
          },
          {
            'StickerId': 38,
            'Active': 1,
            'Order': 29,
            'Title': 'Kikker',
            'ImagePath': 'stickers/sticker-38.png',
            'Size': '{Width=1042, Height=1040}',
            'LastModified': '05/09/2017 07:19:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:38',
            'ProductTypes': []
          },
          {
            'StickerId': 39,
            'Active': 1,
            'Order': 30,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-39.png',
            'Size': '{Width=1042, Height=651}',
            'LastModified': '05/09/2017 07:19:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:56',
            'ProductTypes': []
          },
          {
            'StickerId': 40,
            'Active': 1,
            'Order': 31,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-40.png',
            'Size': '{Width=988, Height=311}',
            'LastModified': '05/09/2017 07:20:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:13',
            'ProductTypes': []
          },
          {
            'StickerId': 41,
            'Active': 1,
            'Order': 32,
            'Title': 'Piratenmuts',
            'ImagePath': 'stickers/sticker-41.png',
            'Size': '{Width=1042, Height=591}',
            'LastModified': '05/09/2017 07:20:34',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:34',
            'ProductTypes': []
          },
          {
            'StickerId': 42,
            'Active': 1,
            'Order': 33,
            'Title': 'Takkie',
            'ImagePath': 'stickers/sticker-42.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:20:45',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:45',
            'ProductTypes': []
          },
          {
            'StickerId': 43,
            'Active': 1,
            'Order': 34,
            'Title': 'Ballon geel',
            'ImagePath': 'stickers/sticker-43.png',
            'Size': '{Width=377, Height=1024}',
            'LastModified': '05/09/2017 07:20:58',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:58',
            'ProductTypes': []
          },
          {
            'StickerId': 44,
            'Active': 1,
            'Order': 35,
            'Title': 'Getrouwd',
            'ImagePath': 'stickers/sticker-44.png',
            'Size': '{Width=1028, Height=349}',
            'LastModified': '05/09/2017 07:21:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:11',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 46,
            'Active': 1,
            'Order': 37,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-46.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:21:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:57',
            'ProductTypes': []
          },
          {
            'StickerId': 47,
            'Active': 1,
            'Order': 38,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-47.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:22:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:19',
            'ProductTypes': []
          },
          {
            'StickerId': 48,
            'Active': 1,
            'Order': 39,
            'Title': 'Papagaai',
            'ImagePath': 'stickers/sticker-48.png',
            'Size': '{Width=1042, Height=928}',
            'LastModified': '05/09/2017 07:22:30',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:30',
            'ProductTypes': []
          },
          {
            'StickerId': 49,
            'Active': 1,
            'Order': 40,
            'Title': 'Robot',
            'ImagePath': 'stickers/sticker-49.png',
            'Size': '{Width=674, Height=1009}',
            'LastModified': '05/09/2017 07:22:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:43',
            'ProductTypes': []
          },
          {
            'StickerId': 50,
            'Active': 1,
            'Order': 41,
            'Title': 'The king',
            'ImagePath': 'stickers/sticker-50.png',
            'Size': '{Width=1044, Height=197}',
            'LastModified': '05/09/2017 07:22:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:55',
            'ProductTypes': []
          },
          {
            'StickerId': 51,
            'Active': 1,
            'Order': 42,
            'Title': 'Ballonnen groen',
            'ImagePath': 'stickers/sticker-51.png',
            'Size': '{Width=785, Height=1007}',
            'LastModified': '05/09/2017 07:23:10',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:10',
            'ProductTypes': []
          },
          {
            'StickerId': 52,
            'Active': 1,
            'Order': 43,
            'Title': 'Je bent mijn liefste',
            'ImagePath': 'stickers/sticker-52.png',
            'Size': '{Width=487, Height=1042}',
            'LastModified': '05/09/2017 07:23:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:27',
            'ProductTypes': []
          },
          {
            'StickerId': 53,
            'Active': 1,
            'Order': 44,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-53.png',
            'Size': '{Width=1038, Height=948}',
            'LastModified': '05/09/2017 07:23:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:37',
            'ProductTypes': []
          },
          {
            'StickerId': 54,
            'Active': 1,
            'Order': 45,
            'Title': 'Racket',
            'ImagePath': 'stickers/sticker-54.png',
            'Size': '{Width=420, Height=1016}',
            'LastModified': '05/09/2017 07:23:49',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:49',
            'ProductTypes': []
          },
          {
            'StickerId': 55,
            'Active': 1,
            'Order': 46,
            'Title': 'Zwaard',
            'ImagePath': 'stickers/sticker-55.png',
            'Size': '{Width=461, Height=1042}',
            'LastModified': '05/09/2017 07:24:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:01',
            'ProductTypes': []
          },
          {
            'StickerId': 56,
            'Active': 1,
            'Order': 47,
            'Title': 'Hoeravlag',
            'ImagePath': 'stickers/sticker-56.png',
            'Size': '{Width=1045, Height=252}',
            'LastModified': '05/09/2017 07:24:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:13',
            'ProductTypes': []
          },
          {
            'StickerId': 57,
            'Active': 1,
            'Order': 48,
            'Title': 'Rood hartje',
            'ImagePath': 'stickers/sticker-57.png',
            'Size': '{Width=624, Height=1007}',
            'LastModified': '05/09/2017 07:24:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:27',
            'ProductTypes': []
          },
          {
            'StickerId': 58,
            'Active': 1,
            'Order': 49,
            'Title': 'Hoera banner',
            'ImagePath': 'stickers/sticker-58.png',
            'Size': '{Width=1029, Height=530}',
            'LastModified': '05/09/2017 07:24:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:48',
            'ProductTypes': []
          },
          {
            'StickerId': 59,
            'Active': 1,
            'Order': 50,
            'Title': 'Raket',
            'ImagePath': 'stickers/sticker-59.png',
            'Size': '{Width=659, Height=984}',
            'LastModified': '05/09/2017 07:25:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:05',
            'ProductTypes': []
          },
          {
            'StickerId': 60,
            'Active': 1,
            'Order': 51,
            'Title': 'Twee hartjes',
            'ImagePath': 'stickers/sticker-60.png',
            'Size': '{Width=968, Height=754}',
            'LastModified': '05/09/2017 07:25:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:18',
            'ProductTypes': []
          },
          {
            'StickerId': 61,
            'Active': 1,
            'Order': 52,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-61.png',
            'Size': '{Width=995, Height=543}',
            'LastModified': '05/09/2017 07:25:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:31',
            'ProductTypes': []
          },
          {
            'StickerId': 62,
            'Active': 1,
            'Order': 53,
            'Title': 'Lijn hartjes',
            'ImagePath': 'stickers/sticker-62.png',
            'Size': '{Width=982, Height=958}',
            'LastModified': '05/09/2017 07:25:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:43',
            'ProductTypes': []
          },
          {
            'StickerId': 63,
            'Active': 1,
            'Order': 54,
            'Title': 'Roze hartje',
            'ImagePath': 'stickers/sticker-63.png',
            'Size': '{Width=624, Height=1017}',
            'LastModified': '05/09/2017 07:26:23',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:23',
            'ProductTypes': []
          },
          {
            'StickerId': 64,
            'Active': 1,
            'Order': 55,
            'Title': 'Ufo',
            'ImagePath': 'stickers/sticker-64.png',
            'Size': '{Width=914, Height=958}',
            'LastModified': '05/09/2017 07:26:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:32',
            'ProductTypes': []
          },
          {
            'StickerId': 65,
            'Active': 1,
            'Order': 56,
            'Title': 'Kadootje',
            'ImagePath': 'stickers/sticker-65.png',
            'Size': '{Width=706, Height=1012}',
            'LastModified': '05/09/2017 07:26:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:42',
            'ProductTypes': []
          },
          {
            'StickerId': 66,
            'Active': 1,
            'Order': 57,
            'Title': 'Ring',
            'ImagePath': 'stickers/sticker-66.png',
            'Size': '{Width=620, Height=1001}',
            'LastModified': '05/09/2017 07:26:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:51',
            'ProductTypes': []
          },
          {
            'StickerId': 67,
            'Active': 1,
            'Order': 58,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-67.png',
            'Size': '{Width=1020, Height=947}',
            'LastModified': '05/09/2017 07:27:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:01',
            'ProductTypes': []
          },
          {
            'StickerId': 68,
            'Active': 1,
            'Order': 59,
            'Title': 'Bowtie',
            'ImagePath': 'stickers/sticker-68.png',
            'Size': '{Width=1017, Height=514}',
            'LastModified': '05/09/2017 07:27:09',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:09',
            'ProductTypes': []
          },
          {
            'StickerId': 69,
            'Active': 1,
            'Order': 60,
            'Title': 'Confetti',
            'ImagePath': 'stickers/sticker-69.png',
            'Size': '{Width=333, Height=995}',
            'LastModified': '05/09/2017 07:27:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:21',
            'ProductTypes': []
          },
          {
            'StickerId': 70,
            'Active': 1,
            'Order': 61,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-70.png',
            'Size': '{Width=898, Height=1006}',
            'LastModified': '05/09/2017 07:27:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:33',
            'ProductTypes': []
          },
          {
            'StickerId': 71,
            'Active': 1,
            'Order': 62,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-71.png',
            'Size': '{Width=1027, Height=573}',
            'LastModified': '05/09/2017 07:27:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:42',
            'ProductTypes': []
          },
          {
            'StickerId': 72,
            'Active': 1,
            'Order': 63,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-72.png',
            'Size': '{Width=797, Height=985}',
            'LastModified': '05/09/2017 07:27:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:55',
            'ProductTypes': []
          },
          {
            'StickerId': 73,
            'Active': 1,
            'Order': 64,
            'Title': 'Mr',
            'ImagePath': 'stickers/sticker-73.png',
            'Size': '{Width=1038, Height=932}',
            'LastModified': '05/09/2017 07:28:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:07',
            'ProductTypes': []
          },
          {
            'StickerId': 74,
            'Active': 1,
            'Order': 65,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-74.png',
            'Size': '{Width=708, Height=990}',
            'LastModified': '05/09/2017 07:28:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:18',
            'ProductTypes': []
          },
          {
            'StickerId': 75,
            'Active': 1,
            'Order': 66,
            'Title': 'Ms',
            'ImagePath': 'stickers/sticker-75.png',
            'Size': '{Width=1031, Height=971}',
            'LastModified': '05/09/2017 07:28:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:32',
            'ProductTypes': []
          },
          {
            'StickerId': 76,
            'Active': 1,
            'Order': 67,
            'Title': 'Rainbow',
            'ImagePath': 'stickers/sticker-76.png',
            'Size': '{Width=1010, Height=659}',
            'LastModified': '05/09/2017 07:28:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:42',
            'ProductTypes': []
          },
          {
            'StickerId': 77,
            'Active': 1,
            'Order': 68,
            'Title': 'Champagne',
            'ImagePath': 'stickers/sticker-77.png',
            'Size': '{Width=341, Height=1006}',
            'LastModified': '05/09/2017 07:28:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:56',
            'ProductTypes': []
          },
          {
            'StickerId': 78,
            'Active': 1,
            'Order': 69,
            'Title': 'Hartjes',
            'ImagePath': 'stickers/sticker-78.png',
            'Size': '{Width=951, Height=571}',
            'LastModified': '05/09/2017 07:29:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:06',
            'ProductTypes': []
          },
          {
            'StickerId': 79,
            'Active': 1,
            'Order': 70,
            'Title': 'You are just lovely',
            'ImagePath': 'stickers/sticker-79.png',
            'Size': '{Width=987, Height=899}',
            'LastModified': '05/09/2017 07:29:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:26',
            'ProductTypes': []
          },
          {
            'StickerId': 80,
            'Active': 1,
            'Order': 71,
            'Title': 'Medaille',
            'ImagePath': 'stickers/sticker-80.png',
            'Size': '{Width=591, Height=1018}',
            'LastModified': '05/09/2017 07:29:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:40',
            'ProductTypes': []
          },
          {
            'StickerId': 81,
            'Active': 1,
            'Order': 72,
            'Title': 'Pluk de dag',
            'ImagePath': 'stickers/sticker-81.png',
            'Size': '{Width=509, Height=1042}',
            'LastModified': '05/09/2017 07:29:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:51',
            'ProductTypes': []
          },
          {
            'StickerId': 82,
            'Active': 1,
            'Order': 73,
            'Title': 'Zon',
            'ImagePath': 'stickers/sticker-82.png',
            'Size': '{Width=1033, Height=1005}',
            'LastModified': '05/09/2017 07:30:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:01',
            'ProductTypes': []
          },
          {
            'StickerId': 83,
            'Active': 1,
            'Order': 74,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-83.png',
            'Size': '{Width=997, Height=646}',
            'LastModified': '05/09/2017 07:30:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:11',
            'ProductTypes': []
          },
          {
            'StickerId': 84,
            'Active': 1,
            'Order': 75,
            'Title': 'Hartjesdoos mama',
            'ImagePath': 'stickers/sticker-84.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:28',
            'ProductTypes': []
          },
          {
            'StickerId': 85,
            'Active': 1,
            'Order': 76,
            'Title': 'Hartjesdoos',
            'ImagePath': 'stickers/sticker-85.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:41',
            'ProductTypes': []
          },
          {
            'StickerId': 86,
            'Active': 1,
            'Order': 77,
            'Title': 'Wolk rain',
            'ImagePath': 'stickers/sticker-86.png',
            'Size': '{Width=1002, Height=948}',
            'LastModified': '05/09/2017 07:30:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:54',
            'ProductTypes': []
          },
          {
            'StickerId': 87,
            'Active': 1,
            'Order': 78,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-87.png',
            'Size': '{Width=1025, Height=721}',
            'LastModified': '05/09/2017 07:31:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:05',
            'ProductTypes': []
          },
          {
            'StickerId': 88,
            'Active': 1,
            'Order': 79,
            'Title': 'Hartje mama',
            'ImagePath': 'stickers/sticker-88.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:32',
            'ProductTypes': []
          },
          {
            'StickerId': 89,
            'Active': 1,
            'Order': 80,
            'Title': 'Hartje',
            'ImagePath': 'stickers/sticker-89.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:42',
            'ProductTypes': []
          },
          {
            'StickerId': 90,
            'Active': 1,
            'Order': 81,
            'Title': 'Wolk donder',
            'ImagePath': 'stickers/sticker-90.png',
            'Size': '{Width=878, Height=998}',
            'LastModified': '05/09/2017 07:40:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:00',
            'ProductTypes': []
          },
          {
            'StickerId': 91,
            'Active': 1,
            'Order': 82,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-91.png',
            'Size': '{Width=1013, Height=1013}',
            'LastModified': '05/09/2017 07:40:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:14',
            'ProductTypes': []
          },
          {
            'StickerId': 92,
            'Active': 1,
            'Order': 83,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-92.png',
            'Size': '{Width=768, Height=1013}',
            'LastModified': '05/09/2017 07:40:44',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:44',
            'ProductTypes': []
          },
          {
            'StickerId': 93,
            'Active': 1,
            'Order': 84,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-93.png',
            'Size': '{Width=1009, Height=1022}',
            'LastModified': '05/09/2017 07:40:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:54',
            'ProductTypes': []
          },
          {
            'StickerId': 94,
            'Active': 1,
            'Order': 85,
            'Title': 'Zwemband',
            'ImagePath': 'stickers/sticker-94.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:41:04',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:04',
            'ProductTypes': []
          },
          {
            'StickerId': 95,
            'Active': 1,
            'Order': 86,
            'Title': 'Plons',
            'ImagePath': 'stickers/sticker-95.png',
            'Size': '{Width=1033, Height=430}',
            'LastModified': '05/09/2017 07:41:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:17',
            'ProductTypes': []
          },
          {
            'StickerId': 96,
            'Active': 1,
            'Order': 87,
            'Title': 'Zwemdiploma',
            'ImagePath': 'stickers/sticker-96.png',
            'Size': '{Width=1019, Height=121}',
            'LastModified': '05/09/2017 07:41:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:29',
            'ProductTypes': []
          },
          {
            'StickerId': 97,
            'Active': 1,
            'Order': 88,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-97.png',
            'Size': '{Width=719, Height=1044}',
            'LastModified': '05/09/2017 07:41:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:41',
            'ProductTypes': []
          },
          {
            'StickerId': 98,
            'Active': 1,
            'Order': 89,
            'Title': 'New home',
            'ImagePath': 'stickers/sticker-98.png',
            'Size': '{Width=835, Height=1042}',
            'LastModified': '05/09/2017 07:41:52',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:52',
            'ProductTypes': []
          },
          {
            'StickerId': 99,
            'Active': 1,
            'Order': 90,
            'Title': 'Sportheld',
            'ImagePath': 'stickers/sticker-99.png',
            'Size': '{Width=925, Height=1040}',
            'LastModified': '05/09/2017 07:42:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:02',
            'ProductTypes': []
          },
          {
            'StickerId': 100,
            'Active': 1,
            'Order': 91,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-100.png',
            'Size': '{Width=855, Height=1042}',
            'LastModified': '05/09/2017 07:42:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:12',
            'ProductTypes': []
          },
          {
            'StickerId': 101,
            'Active': 1,
            'Order': 92,
            'Title': 'Present',
            'ImagePath': 'stickers/sticker-101.png',
            'Size': '{Width=714, Height=1004}',
            'LastModified': '05/09/2017 07:42:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:21',
            'ProductTypes': []
          },
          {
            'StickerId': 102,
            'Active': 1,
            'Order': 93,
            'Title': 'Bird',
            'ImagePath': 'stickers/sticker-102.png',
            'Size': '{Width=1031, Height=720}',
            'LastModified': '05/09/2017 07:42:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:31',
            'ProductTypes': []
          },
          {
            'StickerId': 103,
            'Active': 1,
            'Order': 94,
            'Title': 'Snowflake',
            'ImagePath': 'stickers/sticker-103.png',
            'Size': '{Width=922, Height=1000}',
            'LastModified': '10/11/2022 14:35:16',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:40',
            'ProductTypes': []
          },
          {
            'StickerId': 104,
            'Active': 1,
            'Order': 95,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-104.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:53',
            'ProductTypes': []
          },
          {
            'StickerId': 105,
            'Active': 1,
            'Order': 96,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-105.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:57',
            'ProductTypes': []
          },
          {
            'StickerId': 106,
            'Active': 1,
            'Order': 97,
            'Title': 'Bat',
            'ImagePath': 'stickers/sticker-106.png',
            'Size': '{Width=1042, Height=315}',
            'LastModified': '10/11/2022 14:35:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:07',
            'ProductTypes': []
          },
          {
            'StickerId': 107,
            'Active': 1,
            'Order': 98,
            'Title': 'Hoera een jongen',
            'ImagePath': 'stickers/sticker-107.png',
            'Size': '{Width=734, Height=1042}',
            'LastModified': '05/09/2017 07:43:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:21',
            'ProductTypes': []
          },
          {
            'StickerId': 108,
            'Active': 1,
            'Order': 99,
            'Title': 'Bedankt',
            'ImagePath': 'stickers/sticker-108.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:43:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:32',
            'ProductTypes': []
          },
          {
            'StickerId': 109,
            'Active': 1,
            'Order': 100,
            'Title': 'Pumpkin',
            'ImagePath': 'stickers/sticker-109.png',
            'Size': '{Width=1042, Height=763}',
            'LastModified': '10/11/2022 14:35:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:47',
            'ProductTypes': []
          },
          {
            'StickerId': 110,
            'Active': 1,
            'Order': 101,
            'Title': 'Stoplicht',
            'ImagePath': 'stickers/sticker-110.png',
            'Size': '{Width=288, Height=1032}',
            'LastModified': '05/09/2017 07:44:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:00',
            'ProductTypes': []
          },
          {
            'StickerId': 111,
            'Active': 1,
            'Order': 102,
            'Title': 'Hoera rijbewijs',
            'ImagePath': 'stickers/sticker-111.png',
            'Size': '{Width=1040, Height=632}',
            'LastModified': '05/09/2017 07:44:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:14',
            'ProductTypes': []
          },
          {
            'StickerId': 112,
            'Active': 1,
            'Order': 103,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-112.png',
            'Size': '{Width=997, Height=997}',
            'LastModified': '05/09/2017 07:44:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:25',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 7,
        'Name': 'mini-tompouce-cake-245x207',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 734,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-734.png',
            'Order': 5,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_stip',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'LastModified': '03/09/2022 11:47:53',
            'Categories': [],
            'Created': '07/24/2017 10:13:52',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 736,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-736.png',
            'Order': 6,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:32:37',
            'Categories': [],
            'Created': '07/24/2017 10:15:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 740,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-740.png',
            'Order': 10,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:31:48',
            'Categories': [],
            'Created': '07/24/2017 10:31:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 741,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-741.png',
            'Order': 11,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:33:04',
            'Categories': [],
            'Created': '07/24/2017 10:33:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 745,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-745.png',
            'Order': 14,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:35:32',
            'Categories': [],
            'Created': '07/24/2017 10:35:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 746,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-746.png',
            'Order': 15,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:35:58',
            'Categories': [],
            'Created': '07/24/2017 10:35:58',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 750,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-750.png',
            'Order': 18,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:37:54',
            'Categories': [],
            'Created': '07/24/2017 10:37:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 751,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-751.png',
            'Order': 19,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:38:25',
            'Categories': [],
            'Created': '07/24/2017 10:38:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 771,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-771.png',
            'Order': 39,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:26:59',
            'Categories': [],
            'Created': '07/24/2017 11:26:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 772,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-772.png',
            'Order': 40,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:27:26',
            'Categories': [],
            'Created': '07/24/2017 11:27:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 776,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-776.png',
            'Order': 44,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:37:04',
            'Categories': [],
            'Created': '07/24/2017 11:35:36',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 781,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-781.png',
            'Order': 49,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:38:37',
            'Categories': [],
            'Created': '07/24/2017 11:38:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 784,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-784.png',
            'Order': 52,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:40:09',
            'Categories': [],
            'Created': '07/24/2017 11:40:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 785,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-785.png',
            'Order': 53,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:40:29',
            'Categories': [],
            'Created': '07/24/2017 11:40:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 797,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-797.png',
            'Order': 66,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:45:22',
            'Categories': [],
            'Created': '07/24/2017 11:45:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 799,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-799.png',
            'Order': 68,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:45:45',
            'Categories': [],
            'Created': '07/24/2017 11:45:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 808,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-808.png',
            'Order': 77,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:49:45',
            'Categories': [],
            'Created': '07/24/2017 11:49:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 809,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-809.png',
            'Order': 78,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:50:03',
            'Categories': [],
            'Created': '07/24/2017 11:50:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 811,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-811.png',
            'Order': 80,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:50:23',
            'Categories': [],
            'Created': '07/24/2017 11:50:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 813,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-813.png',
            'Order': 82,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:50:56',
            'Categories': [],
            'Created': '07/24/2017 11:50:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 824,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-824.png',
            'Order': 92,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:56:55',
            'Categories': [],
            'Created': '07/24/2017 11:56:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 827,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-827.png',
            'Order': 95,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:59:04',
            'Categories': [],
            'Created': '07/24/2017 11:59:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 828,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-828.png',
            'Order': 96,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:00:35',
            'Categories': [],
            'Created': '07/24/2017 11:59:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 829,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-829.png',
            'Order': 97,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:01:06',
            'Categories': [],
            'Created': '07/24/2017 11:59:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 837,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-837.png',
            'Order': 105,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:10:05',
            'Categories': [],
            'Created': '07/24/2017 12:10:05',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 838,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-838.png',
            'Order': 106,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:10:29',
            'Categories': [],
            'Created': '07/24/2017 12:10:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 845,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-845.png',
            'Order': 113,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:15:11',
            'Categories': [],
            'Created': '07/24/2017 12:14:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 846,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-846.png',
            'Order': 114,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:15:40',
            'Categories': [],
            'Created': '07/24/2017 12:15:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 854,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-854.png',
            'Order': 122,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_stipblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:35:01',
            'Categories': [],
            'Created': '07/24/2017 12:35:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 855,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-855.png',
            'Order': 123,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:40:02',
            'Categories': [],
            'Created': '07/24/2017 12:40:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 856,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-856.png',
            'Order': 124,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:42:07',
            'Categories': [],
            'Created': '07/24/2017 12:42:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 858,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-858.png',
            'Order': 126,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:42:56',
            'Categories': [],
            'Created': '07/24/2017 12:42:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 870,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-870.png',
            'Order': 138,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:46:56',
            'Categories': [],
            'Created': '07/24/2017 12:46:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 872,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-872.png',
            'Order': 140,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:47:24',
            'Categories': [],
            'Created': '07/24/2017 12:47:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 873,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-873.png',
            'Order': 141,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:47:30',
            'Categories': [],
            'Created': '07/24/2017 12:47:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 879,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-879.png',
            'Order': 147,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:50:21',
            'Categories': [],
            'Created': '07/24/2017 12:50:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 880,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-880.png',
            'Order': 148,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:51:03',
            'Categories': [],
            'Created': '07/24/2017 12:51:03',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 885,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-885.png',
            'Order': 153,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_space',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:53:32',
            'Categories': [],
            'Created': '07/24/2017 12:53:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 888,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-888.png',
            'Order': 156,
            'Size': '{Width=1552, Height=1575}',
            'Title': 'mini tompouce_overall_space',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:54:14',
            'Categories': [],
            'Created': '07/24/2017 12:54:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 889,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-889.png',
            'Order': 157,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:55:25',
            'Categories': [],
            'Created': '07/24/2017 12:55:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 891,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-891.png',
            'Order': 159,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:55:52',
            'Categories': [],
            'Created': '07/24/2017 12:55:52',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 899,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-899.png',
            'Order': 167,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:58:11',
            'Categories': [],
            'Created': '07/24/2017 12:58:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 901,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-901.png',
            'Order': 169,
            'Size': '{Width=533, Height=457}',
            'Title': 'mini tompouce_overall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:58:42',
            'Categories': [],
            'Created': '07/24/2017 12:58:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 905,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-905.png',
            'Order': 173,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:59:33',
            'Categories': [],
            'Created': '07/24/2017 12:59:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 907,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-907.png',
            'Order': 175,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:59:57',
            'Categories': [],
            'Created': '07/24/2017 12:59:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 908,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-908.png',
            'Order': 176,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:00:20',
            'Categories': [],
            'Created': '07/24/2017 13:00:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 919,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-919.png',
            'Order': 187,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:11:07',
            'Categories': [],
            'Created': '07/24/2017 13:11:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 921,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-921.png',
            'Order': 189,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:11:49',
            'Categories': [],
            'Created': '07/24/2017 13:11:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 933,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-933.png',
            'Order': 201,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:18:39',
            'Categories': [],
            'Created': '07/24/2017 13:18:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 935,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-935.png',
            'Order': 203,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:20:10',
            'Categories': [],
            'Created': '07/24/2017 13:20:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 945,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-945.png',
            'Order': 213,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:27:08',
            'Categories': [],
            'Created': '07/24/2017 13:27:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 947,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-947.png',
            'Order': 215,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:27:40',
            'Categories': [],
            'Created': '07/24/2017 13:27:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 949,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-949.png',
            'Order': 217,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:28:13',
            'Categories': [],
            'Created': '07/24/2017 13:28:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 958,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-958.png',
            'Order': 226,
            'Size': '{Width=534, Height=457}',
            'Title': 'mini tompouce_overall_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:31:32',
            'Categories': [],
            'Created': '07/24/2017 13:31:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 964,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-964.png',
            'Order': 232,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:32:44',
            'Categories': [],
            'Created': '07/24/2017 13:32:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 967,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-967.png',
            'Order': 235,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:33:16',
            'Categories': [],
            'Created': '07/24/2017 13:33:16',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 970,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-970.png',
            'Order': 238,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:33:44',
            'Categories': [],
            'Created': '07/24/2017 13:33:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 973,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-973.png',
            'Order': 241,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:34:16',
            'Categories': [],
            'Created': '07/24/2017 13:34:16',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 982,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-982.png',
            'Order': 250,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:39:46',
            'Categories': [],
            'Created': '07/24/2017 13:36:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 985,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-985.png',
            'Order': 253,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:53:37',
            'Categories': [],
            'Created': '07/24/2017 13:36:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 991,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-991.png',
            'Order': 259,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:37:18',
            'Categories': [],
            'Created': '07/24/2017 13:37:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 993,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-993.png',
            'Order': 261,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:38:07',
            'Categories': [],
            'Created': '07/24/2017 13:38:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1000,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1000.png',
            'Order': 268,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:41:09',
            'Categories': [],
            'Created': '07/24/2017 13:41:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1002,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1002.png',
            'Order': 270,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:41:41',
            'Categories': [],
            'Created': '07/24/2017 13:41:41',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1011,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1011.png',
            'Order': 279,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:44:02',
            'Categories': [],
            'Created': '07/24/2017 13:44:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1013,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1013.png',
            'Order': 281,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_gras',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:44:32',
            'Categories': [],
            'Created': '07/24/2017 13:44:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1016,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1016.png',
            'Order': 284,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:48:45',
            'Categories': [],
            'Created': '07/24/2017 13:48:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1017,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1017.png',
            'Order': 285,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:49:15',
            'Categories': [],
            'Created': '07/24/2017 13:49:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1033,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1033.png',
            'Order': 301,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:04:40',
            'Categories': [],
            'Created': '07/24/2017 14:04:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1035,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1035.png',
            'Order': 303,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:06:34',
            'Categories': [],
            'Created': '07/24/2017 14:06:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1036,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1036.png',
            'Order': 304,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:06:38',
            'Categories': [],
            'Created': '07/24/2017 14:06:38',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1037,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1037.png',
            'Order': 305,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:08:05',
            'Categories': [],
            'Created': '07/24/2017 14:08:05',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1061,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1061.png',
            'Order': 329,
            'Size': '{Width=1134, Height=638}',
            'Title': 'mini tompouce_kader_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:24:34',
            'Categories': [],
            'Created': '07/24/2017 14:24:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1063,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1063.png',
            'Order': 331,
            'Size': '{Width=1134, Height=638}',
            'Title': 'mini tompouce_overall_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:26:04',
            'Categories': [],
            'Created': '07/24/2017 14:26:04',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1072,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1072.png',
            'Order': 340,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:31:32',
            'Categories': [],
            'Created': '07/24/2017 14:31:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1076,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1076.png',
            'Order': 344,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:34:08',
            'Categories': [],
            'Created': '07/24/2017 14:34:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1082,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1082.png',
            'Order': 350,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:41:10',
            'Categories': [],
            'Created': '07/24/2017 14:41:10',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1084,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1084.png',
            'Order': 352,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:42:27',
            'Categories': [],
            'Created': '07/24/2017 14:42:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1098,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1098.png',
            'Order': 366,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:55:15',
            'Categories': [],
            'Created': '07/24/2017 14:55:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1100,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1100.png',
            'Order': 368,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:58:45',
            'Categories': [],
            'Created': '07/24/2017 14:58:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1114,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1114.png',
            'Order': 382,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:08:23',
            'Categories': [],
            'Created': '07/24/2017 15:08:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1120,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1120.png',
            'Order': 388,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:10:27',
            'Categories': [],
            'Created': '07/24/2017 15:10:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1122,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1122.png',
            'Order': 390,
            'Size': '{Width=533, Height=456}',
            'Title': 'Minitompouce_kader_jipjannneke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:12:16',
            'Categories': [],
            'Created': '07/24/2017 15:12:16',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1123,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1123.png',
            'Order': 391,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:12:22',
            'Categories': [],
            'Created': '07/24/2017 15:12:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1126,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1126.png',
            'Order': 394,
            'Size': '{Width=533, Height=456}',
            'Title': 'Minitompouce_overall_jipjanneke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:13:25',
            'Categories': [],
            'Created': '07/24/2017 15:13:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1128,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1128.png',
            'Order': 396,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:14:43',
            'Categories': [],
            'Created': '07/24/2017 15:14:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1132,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1132.png',
            'Order': 400,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:16:02',
            'Categories': [],
            'Created': '07/24/2017 15:16:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1160,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1160.png',
            'Order': 428,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:32:11',
            'Categories': [],
            'Created': '07/24/2017 15:32:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1162,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1162.png',
            'Order': 430,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:34:54',
            'Categories': [],
            'Created': '07/24/2017 15:34:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1168,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1168.png',
            'Order': 436,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:38:22',
            'Categories': [],
            'Created': '07/24/2017 15:38:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1171,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1171.png',
            'Order': 439,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:38:44',
            'Categories': [],
            'Created': '07/24/2017 15:38:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1189,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1189.png',
            'Order': 455,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_kader_lente',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:45:20',
            'Categories': [],
            'Created': '07/24/2017 15:45:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1190,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1190.png',
            'Order': 456,
            'Size': '{Width=533, Height=456}',
            'Title': 'mini tompouce_overall_lente',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:47:16',
            'Categories': [],
            'Created': '07/24/2017 15:47:16',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1192,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1192.png',
            'Order': 458,
            'Size': '{Width=533, Height=456}',
            'Title': 'Minitompouce_L_kader_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:47:54',
            'Categories': [],
            'Created': '07/24/2017 15:47:54',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 17,
            'Title': 'Montserrat',
            'ImagePath': 'fonts/font-17.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 14,
            'Order': 5,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '08/15/2017 12:04:47',
            'LastModifiedBy': 'HEMALOCAL\\emdvorobiova',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 22,
            'Title': 'Bungee',
            'ImagePath': 'fonts/font-22.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 9,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/22/2017 06:29:11',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:25:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 9,
            'Title': '6311019',
            'Created': '05/16/2017 14:17:12',
            'LastModified': '05/15/2020 15:30:34',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 7,
            'ShapeId': 2,
            'Width': 245,
            'Height': 206,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-mini-tompouce',
            'BackgroundWidth': 275,
            'BackgroundHeight': 236,
            'Bleed': 0,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': 726,
            'MultiCloneWidth': 1124,
            'IsMultiClone': true,
            'OptimalWidth': 137,
            'OptimalHeight': 118,
            'MinimalWidth': 69,
            'MinimalHeight': 59,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-9.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-9.png',
            'OverlayImagePath': 'products/overlays/product-9.png',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 30,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-mini-tompouce'
          },
          {
            'ProductId': 20,
            'Title': '6311027',
            'Created': '07/21/2017 14:15:20',
            'LastModified': '10/25/2017 10:59:50',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Active': 1,
            'ProductTypeId': 7,
            'ShapeId': 2,
            'Width': 245,
            'Height': 206,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-mini-tompouce',
            'BackgroundWidth': 275,
            'BackgroundHeight': 236,
            'Bleed': 0,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': 726,
            'MultiCloneWidth': 1124,
            'IsMultiClone': true,
            'OptimalWidth': 137,
            'OptimalHeight': 118,
            'MinimalWidth': 69,
            'MinimalHeight': 59,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': true,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-20.PNG',
            'BackgroundImagePath': 'products/backgrounds/product-20.png',
            'OverlayImagePath': 'products/overlays/product-20.png',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-mini-tompouce'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 2,
            'Active': 1,
            'ImagePath': 'templates/template-2.svg',
            'ShapeId': 2,
            'Created': '02/22/2017 13:53:08',
            'LastModified': '05/18/2017 12:10:03',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 4,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 23.076923}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 53.846154}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 23.076923}}',
            'Title': 'Layout-03'
          },
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 5,
            'Active': 1,
            'ImagePath': 'templates/template-5.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:11:50',
            'LastModified': '05/18/2017 12:10:06',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 5,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 50, h: 50}}',
            'Title': 'Layout-04'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 7,
            'Active': 1,
            'ImagePath': 'templates/template-7.svg',
            'ShapeId': 2,
            'Created': '04/27/2017 08:36:17',
            'LastModified': '05/18/2017 12:10:16',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 6,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 8, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 9, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-05'
          },
          {
            'LayoutTemplateId': 8,
            'Active': 1,
            'ImagePath': 'templates/template-8.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:48:38',
            'LastModified': '05/18/2017 12:10:12',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 7,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-06'
          },
          {
            'LayoutTemplateId': 9,
            'Active': 1,
            'ImagePath': 'templates/template-9.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:49:05',
            'LastModified': '05/18/2017 12:10:20',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 8,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-07'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          },
          {
            'LayoutTemplateId': 12,
            'Active': 1,
            'ImagePath': 'templates/template-12.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:24:43',
            'LastModified': '05/18/2017 12:10:25',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 9,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-08'
          },
          {
            'LayoutTemplateId': 13,
            'Active': 1,
            'ImagePath': 'templates/template-13.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:26:35',
            'LastModified': '06/16/2017 13:30:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Order': 10,
            'PermittedSides': 'center,top,right,bottom',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 50, h: 100}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 100}}',
            'Title': 'Layout-09'
          },
          {
            'LayoutTemplateId': 14,
            'Active': 1,
            'ImagePath': 'templates/template-14.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:27:44',
            'LastModified': '05/18/2017 12:10:33',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 11,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-10'
          },
          {
            'LayoutTemplateId': 15,
            'Active': 1,
            'ImagePath': 'templates/template-15.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:12',
            'LastModified': '05/18/2017 12:10:38',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 12,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-11'
          },
          {
            'LayoutTemplateId': 16,
            'Active': 0,
            'ImagePath': 'templates/template-16.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:35',
            'LastModified': '07/31/2019 15:15:43',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 13,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: \'hidden\', accept: \'\', dimension: {w: 100, h: 33.333333}},\r\n{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-12'
          },
          {
            'LayoutTemplateId': 17,
            'Active': 1,
            'ImagePath': 'templates/template-17.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:16',
            'LastModified': '05/18/2017 12:10:46',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 14,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 66.666666}}',
            'Title': 'Layout-13'
          },
          {
            'LayoutTemplateId': 18,
            'Active': 1,
            'ImagePath': 'templates/template-18.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:41',
            'LastModified': '05/18/2017 12:10:50',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 15,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 50}}',
            'Title': 'Layout-14'
          },
          {
            'LayoutTemplateId': 19,
            'Active': 1,
            'ImagePath': 'templates/template-19.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:30:07',
            'LastModified': '06/07/2017 12:46:48',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'Order': 16,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-15'
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 13,
            'Active': 1,
            'Order': 3,
            'Title': 'Strik',
            'ImagePath': 'stickers/sticker-13.png',
            'Size': '{Width=625, Height=335}',
            'LastModified': '05/09/2017 07:13:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:55',
            'ProductTypes': []
          },
          {
            'StickerId': 14,
            'Active': 1,
            'Order': 4,
            'Title': 'Cirkel',
            'ImagePath': 'stickers/sticker-14.png',
            'Size': '{Width=623, Height=624}',
            'LastModified': '05/09/2017 07:14:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:06',
            'ProductTypes': []
          },
          {
            'StickerId': 15,
            'Active': 1,
            'Order': 5,
            'Title': 'Spreekwolk',
            'ImagePath': 'stickers/sticker-15.png',
            'Size': '{Width=833, Height=736}',
            'LastModified': '05/09/2017 07:14:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:19',
            'ProductTypes': []
          },
          {
            'StickerId': 16,
            'Active': 1,
            'Order': 7,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-16.png',
            'Size': '{Width=662, Height=737}',
            'LastModified': '05/09/2017 07:14:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:27',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 19,
            'Active': 1,
            'Order': 10,
            'Title': 'Bril',
            'ImagePath': 'stickers/sticker-19.png',
            'Size': '{Width=688, Height=229}',
            'LastModified': '05/09/2017 07:15:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:01',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 21,
            'Active': 1,
            'Order': 12,
            'Title': 'Baby',
            'ImagePath': 'stickers/sticker-21.png',
            'Size': '{Width=729, Height=658}',
            'LastModified': '05/09/2017 07:15:47',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:47',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 23,
            'Active': 1,
            'Order': 14,
            'Title': 'Hart blauw',
            'ImagePath': 'stickers/sticker-23.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '05/09/2017 07:16:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:14',
            'ProductTypes': []
          },
          {
            'StickerId': 24,
            'Active': 1,
            'Order': 15,
            'Title': 'Ster blauw',
            'ImagePath': 'stickers/sticker-24.png',
            'Size': '{Width=625, Height=570}',
            'LastModified': '05/09/2017 07:16:24',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:24',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 26,
            'Active': 1,
            'Order': 17,
            'Title': 'Welkom kleintje',
            'ImagePath': 'stickers/sticker-26.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:16:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:56',
            'ProductTypes': []
          },
          {
            'StickerId': 27,
            'Active': 1,
            'Order': 18,
            'Title': 'Welkom kleintjes',
            'ImagePath': 'stickers/sticker-27.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:17:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:13',
            'ProductTypes': []
          },
          {
            'StickerId': 28,
            'Active': 1,
            'Order': 19,
            'Title': 'Sinasappel',
            'ImagePath': 'stickers/sticker-28.png',
            'Size': '{Width=729, Height=729}',
            'LastModified': '05/09/2017 07:17:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:25',
            'ProductTypes': []
          },
          {
            'StickerId': 29,
            'Active': 1,
            'Order': 20,
            'Title': 'Blaadje',
            'ImagePath': 'stickers/sticker-29.png',
            'Size': '{Width=717, Height=238}',
            'LastModified': '05/09/2017 07:17:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:37',
            'ProductTypes': []
          },
          {
            'StickerId': 30,
            'Active': 1,
            'Order': 21,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-30.png',
            'Size': '{Width=359, Height=931}',
            'LastModified': '05/09/2017 07:17:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:48',
            'ProductTypes': []
          },
          {
            'StickerId': 31,
            'Active': 1,
            'Order': 22,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-31.png',
            'Size': '{Width=383, Height=942}',
            'LastModified': '05/09/2017 07:18:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:02',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 33,
            'Active': 1,
            'Order': 24,
            'Title': 'Ananas',
            'ImagePath': 'stickers/sticker-33.png',
            'Size': '{Width=405, Height=738}',
            'LastModified': '05/09/2017 07:18:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:28',
            'ProductTypes': []
          },
          {
            'StickerId': 34,
            'Active': 1,
            'Order': 25,
            'Title': 'Herfst blaadjes',
            'ImagePath': 'stickers/sticker-34.png',
            'Size': '{Width=255, Height=546}',
            'LastModified': '05/09/2017 07:18:46',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:46',
            'ProductTypes': []
          },
          {
            'StickerId': 35,
            'Active': 1,
            'Order': 26,
            'Title': 'Winter',
            'ImagePath': 'stickers/sticker-35.png',
            'Size': '{Width=476, Height=785}',
            'LastModified': '05/09/2017 07:18:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:59',
            'ProductTypes': []
          },
          {
            'StickerId': 36,
            'Active': 1,
            'Order': 27,
            'Title': 'Astronaut',
            'ImagePath': 'stickers/sticker-36.png',
            'Size': '{Width=589, Height=988}',
            'LastModified': '05/09/2017 07:19:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:14',
            'ProductTypes': []
          },
          {
            'StickerId': 37,
            'Active': 1,
            'Order': 28,
            'Title': 'Jarig',
            'ImagePath': 'stickers/sticker-37.png',
            'Size': '{Width=1036, Height=1026}',
            'LastModified': '05/09/2017 07:19:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:26',
            'ProductTypes': []
          },
          {
            'StickerId': 38,
            'Active': 1,
            'Order': 29,
            'Title': 'Kikker',
            'ImagePath': 'stickers/sticker-38.png',
            'Size': '{Width=1042, Height=1040}',
            'LastModified': '05/09/2017 07:19:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:38',
            'ProductTypes': []
          },
          {
            'StickerId': 39,
            'Active': 1,
            'Order': 30,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-39.png',
            'Size': '{Width=1042, Height=651}',
            'LastModified': '05/09/2017 07:19:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:56',
            'ProductTypes': []
          },
          {
            'StickerId': 40,
            'Active': 1,
            'Order': 31,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-40.png',
            'Size': '{Width=988, Height=311}',
            'LastModified': '05/09/2017 07:20:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:13',
            'ProductTypes': []
          },
          {
            'StickerId': 41,
            'Active': 1,
            'Order': 32,
            'Title': 'Piratenmuts',
            'ImagePath': 'stickers/sticker-41.png',
            'Size': '{Width=1042, Height=591}',
            'LastModified': '05/09/2017 07:20:34',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:34',
            'ProductTypes': []
          },
          {
            'StickerId': 42,
            'Active': 1,
            'Order': 33,
            'Title': 'Takkie',
            'ImagePath': 'stickers/sticker-42.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:20:45',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:45',
            'ProductTypes': []
          },
          {
            'StickerId': 43,
            'Active': 1,
            'Order': 34,
            'Title': 'Ballon geel',
            'ImagePath': 'stickers/sticker-43.png',
            'Size': '{Width=377, Height=1024}',
            'LastModified': '05/09/2017 07:20:58',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:58',
            'ProductTypes': []
          },
          {
            'StickerId': 44,
            'Active': 1,
            'Order': 35,
            'Title': 'Getrouwd',
            'ImagePath': 'stickers/sticker-44.png',
            'Size': '{Width=1028, Height=349}',
            'LastModified': '05/09/2017 07:21:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:11',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 46,
            'Active': 1,
            'Order': 37,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-46.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:21:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:57',
            'ProductTypes': []
          },
          {
            'StickerId': 47,
            'Active': 1,
            'Order': 38,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-47.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:22:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:19',
            'ProductTypes': []
          },
          {
            'StickerId': 48,
            'Active': 1,
            'Order': 39,
            'Title': 'Papagaai',
            'ImagePath': 'stickers/sticker-48.png',
            'Size': '{Width=1042, Height=928}',
            'LastModified': '05/09/2017 07:22:30',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:30',
            'ProductTypes': []
          },
          {
            'StickerId': 49,
            'Active': 1,
            'Order': 40,
            'Title': 'Robot',
            'ImagePath': 'stickers/sticker-49.png',
            'Size': '{Width=674, Height=1009}',
            'LastModified': '05/09/2017 07:22:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:43',
            'ProductTypes': []
          },
          {
            'StickerId': 50,
            'Active': 1,
            'Order': 41,
            'Title': 'The king',
            'ImagePath': 'stickers/sticker-50.png',
            'Size': '{Width=1044, Height=197}',
            'LastModified': '05/09/2017 07:22:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:55',
            'ProductTypes': []
          },
          {
            'StickerId': 51,
            'Active': 1,
            'Order': 42,
            'Title': 'Ballonnen groen',
            'ImagePath': 'stickers/sticker-51.png',
            'Size': '{Width=785, Height=1007}',
            'LastModified': '05/09/2017 07:23:10',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:10',
            'ProductTypes': []
          },
          {
            'StickerId': 52,
            'Active': 1,
            'Order': 43,
            'Title': 'Je bent mijn liefste',
            'ImagePath': 'stickers/sticker-52.png',
            'Size': '{Width=487, Height=1042}',
            'LastModified': '05/09/2017 07:23:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:27',
            'ProductTypes': []
          },
          {
            'StickerId': 53,
            'Active': 1,
            'Order': 44,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-53.png',
            'Size': '{Width=1038, Height=948}',
            'LastModified': '05/09/2017 07:23:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:37',
            'ProductTypes': []
          },
          {
            'StickerId': 54,
            'Active': 1,
            'Order': 45,
            'Title': 'Racket',
            'ImagePath': 'stickers/sticker-54.png',
            'Size': '{Width=420, Height=1016}',
            'LastModified': '05/09/2017 07:23:49',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:49',
            'ProductTypes': []
          },
          {
            'StickerId': 55,
            'Active': 1,
            'Order': 46,
            'Title': 'Zwaard',
            'ImagePath': 'stickers/sticker-55.png',
            'Size': '{Width=461, Height=1042}',
            'LastModified': '05/09/2017 07:24:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:01',
            'ProductTypes': []
          },
          {
            'StickerId': 56,
            'Active': 1,
            'Order': 47,
            'Title': 'Hoeravlag',
            'ImagePath': 'stickers/sticker-56.png',
            'Size': '{Width=1045, Height=252}',
            'LastModified': '05/09/2017 07:24:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:13',
            'ProductTypes': []
          },
          {
            'StickerId': 57,
            'Active': 1,
            'Order': 48,
            'Title': 'Rood hartje',
            'ImagePath': 'stickers/sticker-57.png',
            'Size': '{Width=624, Height=1007}',
            'LastModified': '05/09/2017 07:24:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:27',
            'ProductTypes': []
          },
          {
            'StickerId': 58,
            'Active': 1,
            'Order': 49,
            'Title': 'Hoera banner',
            'ImagePath': 'stickers/sticker-58.png',
            'Size': '{Width=1029, Height=530}',
            'LastModified': '05/09/2017 07:24:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:48',
            'ProductTypes': []
          },
          {
            'StickerId': 59,
            'Active': 1,
            'Order': 50,
            'Title': 'Raket',
            'ImagePath': 'stickers/sticker-59.png',
            'Size': '{Width=659, Height=984}',
            'LastModified': '05/09/2017 07:25:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:05',
            'ProductTypes': []
          },
          {
            'StickerId': 60,
            'Active': 1,
            'Order': 51,
            'Title': 'Twee hartjes',
            'ImagePath': 'stickers/sticker-60.png',
            'Size': '{Width=968, Height=754}',
            'LastModified': '05/09/2017 07:25:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:18',
            'ProductTypes': []
          },
          {
            'StickerId': 61,
            'Active': 1,
            'Order': 52,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-61.png',
            'Size': '{Width=995, Height=543}',
            'LastModified': '05/09/2017 07:25:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:31',
            'ProductTypes': []
          },
          {
            'StickerId': 62,
            'Active': 1,
            'Order': 53,
            'Title': 'Lijn hartjes',
            'ImagePath': 'stickers/sticker-62.png',
            'Size': '{Width=982, Height=958}',
            'LastModified': '05/09/2017 07:25:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:43',
            'ProductTypes': []
          },
          {
            'StickerId': 63,
            'Active': 1,
            'Order': 54,
            'Title': 'Roze hartje',
            'ImagePath': 'stickers/sticker-63.png',
            'Size': '{Width=624, Height=1017}',
            'LastModified': '05/09/2017 07:26:23',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:23',
            'ProductTypes': []
          },
          {
            'StickerId': 64,
            'Active': 1,
            'Order': 55,
            'Title': 'Ufo',
            'ImagePath': 'stickers/sticker-64.png',
            'Size': '{Width=914, Height=958}',
            'LastModified': '05/09/2017 07:26:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:32',
            'ProductTypes': []
          },
          {
            'StickerId': 65,
            'Active': 1,
            'Order': 56,
            'Title': 'Kadootje',
            'ImagePath': 'stickers/sticker-65.png',
            'Size': '{Width=706, Height=1012}',
            'LastModified': '05/09/2017 07:26:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:42',
            'ProductTypes': []
          },
          {
            'StickerId': 66,
            'Active': 1,
            'Order': 57,
            'Title': 'Ring',
            'ImagePath': 'stickers/sticker-66.png',
            'Size': '{Width=620, Height=1001}',
            'LastModified': '05/09/2017 07:26:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:51',
            'ProductTypes': []
          },
          {
            'StickerId': 67,
            'Active': 1,
            'Order': 58,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-67.png',
            'Size': '{Width=1020, Height=947}',
            'LastModified': '05/09/2017 07:27:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:01',
            'ProductTypes': []
          },
          {
            'StickerId': 68,
            'Active': 1,
            'Order': 59,
            'Title': 'Bowtie',
            'ImagePath': 'stickers/sticker-68.png',
            'Size': '{Width=1017, Height=514}',
            'LastModified': '05/09/2017 07:27:09',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:09',
            'ProductTypes': []
          },
          {
            'StickerId': 69,
            'Active': 1,
            'Order': 60,
            'Title': 'Confetti',
            'ImagePath': 'stickers/sticker-69.png',
            'Size': '{Width=333, Height=995}',
            'LastModified': '05/09/2017 07:27:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:21',
            'ProductTypes': []
          },
          {
            'StickerId': 70,
            'Active': 1,
            'Order': 61,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-70.png',
            'Size': '{Width=898, Height=1006}',
            'LastModified': '05/09/2017 07:27:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:33',
            'ProductTypes': []
          },
          {
            'StickerId': 71,
            'Active': 1,
            'Order': 62,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-71.png',
            'Size': '{Width=1027, Height=573}',
            'LastModified': '05/09/2017 07:27:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:42',
            'ProductTypes': []
          },
          {
            'StickerId': 72,
            'Active': 1,
            'Order': 63,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-72.png',
            'Size': '{Width=797, Height=985}',
            'LastModified': '05/09/2017 07:27:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:55',
            'ProductTypes': []
          },
          {
            'StickerId': 73,
            'Active': 1,
            'Order': 64,
            'Title': 'Mr',
            'ImagePath': 'stickers/sticker-73.png',
            'Size': '{Width=1038, Height=932}',
            'LastModified': '05/09/2017 07:28:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:07',
            'ProductTypes': []
          },
          {
            'StickerId': 74,
            'Active': 1,
            'Order': 65,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-74.png',
            'Size': '{Width=708, Height=990}',
            'LastModified': '05/09/2017 07:28:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:18',
            'ProductTypes': []
          },
          {
            'StickerId': 75,
            'Active': 1,
            'Order': 66,
            'Title': 'Ms',
            'ImagePath': 'stickers/sticker-75.png',
            'Size': '{Width=1031, Height=971}',
            'LastModified': '05/09/2017 07:28:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:32',
            'ProductTypes': []
          },
          {
            'StickerId': 76,
            'Active': 1,
            'Order': 67,
            'Title': 'Rainbow',
            'ImagePath': 'stickers/sticker-76.png',
            'Size': '{Width=1010, Height=659}',
            'LastModified': '05/09/2017 07:28:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:42',
            'ProductTypes': []
          },
          {
            'StickerId': 77,
            'Active': 1,
            'Order': 68,
            'Title': 'Champagne',
            'ImagePath': 'stickers/sticker-77.png',
            'Size': '{Width=341, Height=1006}',
            'LastModified': '05/09/2017 07:28:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:56',
            'ProductTypes': []
          },
          {
            'StickerId': 78,
            'Active': 1,
            'Order': 69,
            'Title': 'Hartjes',
            'ImagePath': 'stickers/sticker-78.png',
            'Size': '{Width=951, Height=571}',
            'LastModified': '05/09/2017 07:29:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:06',
            'ProductTypes': []
          },
          {
            'StickerId': 79,
            'Active': 1,
            'Order': 70,
            'Title': 'You are just lovely',
            'ImagePath': 'stickers/sticker-79.png',
            'Size': '{Width=987, Height=899}',
            'LastModified': '05/09/2017 07:29:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:26',
            'ProductTypes': []
          },
          {
            'StickerId': 80,
            'Active': 1,
            'Order': 71,
            'Title': 'Medaille',
            'ImagePath': 'stickers/sticker-80.png',
            'Size': '{Width=591, Height=1018}',
            'LastModified': '05/09/2017 07:29:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:40',
            'ProductTypes': []
          },
          {
            'StickerId': 81,
            'Active': 1,
            'Order': 72,
            'Title': 'Pluk de dag',
            'ImagePath': 'stickers/sticker-81.png',
            'Size': '{Width=509, Height=1042}',
            'LastModified': '05/09/2017 07:29:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:51',
            'ProductTypes': []
          },
          {
            'StickerId': 82,
            'Active': 1,
            'Order': 73,
            'Title': 'Zon',
            'ImagePath': 'stickers/sticker-82.png',
            'Size': '{Width=1033, Height=1005}',
            'LastModified': '05/09/2017 07:30:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:01',
            'ProductTypes': []
          },
          {
            'StickerId': 83,
            'Active': 1,
            'Order': 74,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-83.png',
            'Size': '{Width=997, Height=646}',
            'LastModified': '05/09/2017 07:30:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:11',
            'ProductTypes': []
          },
          {
            'StickerId': 84,
            'Active': 1,
            'Order': 75,
            'Title': 'Hartjesdoos mama',
            'ImagePath': 'stickers/sticker-84.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:28',
            'ProductTypes': []
          },
          {
            'StickerId': 85,
            'Active': 1,
            'Order': 76,
            'Title': 'Hartjesdoos',
            'ImagePath': 'stickers/sticker-85.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:41',
            'ProductTypes': []
          },
          {
            'StickerId': 86,
            'Active': 1,
            'Order': 77,
            'Title': 'Wolk rain',
            'ImagePath': 'stickers/sticker-86.png',
            'Size': '{Width=1002, Height=948}',
            'LastModified': '05/09/2017 07:30:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:54',
            'ProductTypes': []
          },
          {
            'StickerId': 87,
            'Active': 1,
            'Order': 78,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-87.png',
            'Size': '{Width=1025, Height=721}',
            'LastModified': '05/09/2017 07:31:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:05',
            'ProductTypes': []
          },
          {
            'StickerId': 88,
            'Active': 1,
            'Order': 79,
            'Title': 'Hartje mama',
            'ImagePath': 'stickers/sticker-88.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:32',
            'ProductTypes': []
          },
          {
            'StickerId': 89,
            'Active': 1,
            'Order': 80,
            'Title': 'Hartje',
            'ImagePath': 'stickers/sticker-89.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:42',
            'ProductTypes': []
          },
          {
            'StickerId': 90,
            'Active': 1,
            'Order': 81,
            'Title': 'Wolk donder',
            'ImagePath': 'stickers/sticker-90.png',
            'Size': '{Width=878, Height=998}',
            'LastModified': '05/09/2017 07:40:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:00',
            'ProductTypes': []
          },
          {
            'StickerId': 91,
            'Active': 1,
            'Order': 82,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-91.png',
            'Size': '{Width=1013, Height=1013}',
            'LastModified': '05/09/2017 07:40:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:14',
            'ProductTypes': []
          },
          {
            'StickerId': 92,
            'Active': 1,
            'Order': 83,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-92.png',
            'Size': '{Width=768, Height=1013}',
            'LastModified': '05/09/2017 07:40:44',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:44',
            'ProductTypes': []
          },
          {
            'StickerId': 93,
            'Active': 1,
            'Order': 84,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-93.png',
            'Size': '{Width=1009, Height=1022}',
            'LastModified': '05/09/2017 07:40:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:54',
            'ProductTypes': []
          },
          {
            'StickerId': 94,
            'Active': 1,
            'Order': 85,
            'Title': 'Zwemband',
            'ImagePath': 'stickers/sticker-94.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:41:04',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:04',
            'ProductTypes': []
          },
          {
            'StickerId': 95,
            'Active': 1,
            'Order': 86,
            'Title': 'Plons',
            'ImagePath': 'stickers/sticker-95.png',
            'Size': '{Width=1033, Height=430}',
            'LastModified': '05/09/2017 07:41:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:17',
            'ProductTypes': []
          },
          {
            'StickerId': 96,
            'Active': 1,
            'Order': 87,
            'Title': 'Zwemdiploma',
            'ImagePath': 'stickers/sticker-96.png',
            'Size': '{Width=1019, Height=121}',
            'LastModified': '05/09/2017 07:41:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:29',
            'ProductTypes': []
          },
          {
            'StickerId': 97,
            'Active': 1,
            'Order': 88,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-97.png',
            'Size': '{Width=719, Height=1044}',
            'LastModified': '05/09/2017 07:41:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:41',
            'ProductTypes': []
          },
          {
            'StickerId': 98,
            'Active': 1,
            'Order': 89,
            'Title': 'New home',
            'ImagePath': 'stickers/sticker-98.png',
            'Size': '{Width=835, Height=1042}',
            'LastModified': '05/09/2017 07:41:52',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:52',
            'ProductTypes': []
          },
          {
            'StickerId': 99,
            'Active': 1,
            'Order': 90,
            'Title': 'Sportheld',
            'ImagePath': 'stickers/sticker-99.png',
            'Size': '{Width=925, Height=1040}',
            'LastModified': '05/09/2017 07:42:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:02',
            'ProductTypes': []
          },
          {
            'StickerId': 100,
            'Active': 1,
            'Order': 91,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-100.png',
            'Size': '{Width=855, Height=1042}',
            'LastModified': '05/09/2017 07:42:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:12',
            'ProductTypes': []
          },
          {
            'StickerId': 101,
            'Active': 1,
            'Order': 92,
            'Title': 'Present',
            'ImagePath': 'stickers/sticker-101.png',
            'Size': '{Width=714, Height=1004}',
            'LastModified': '05/09/2017 07:42:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:21',
            'ProductTypes': []
          },
          {
            'StickerId': 102,
            'Active': 1,
            'Order': 93,
            'Title': 'Bird',
            'ImagePath': 'stickers/sticker-102.png',
            'Size': '{Width=1031, Height=720}',
            'LastModified': '05/09/2017 07:42:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:31',
            'ProductTypes': []
          },
          {
            'StickerId': 103,
            'Active': 1,
            'Order': 94,
            'Title': 'Snowflake',
            'ImagePath': 'stickers/sticker-103.png',
            'Size': '{Width=922, Height=1000}',
            'LastModified': '10/11/2022 14:35:16',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:40',
            'ProductTypes': []
          },
          {
            'StickerId': 104,
            'Active': 1,
            'Order': 95,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-104.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:53',
            'ProductTypes': []
          },
          {
            'StickerId': 105,
            'Active': 1,
            'Order': 96,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-105.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:57',
            'ProductTypes': []
          },
          {
            'StickerId': 106,
            'Active': 1,
            'Order': 97,
            'Title': 'Bat',
            'ImagePath': 'stickers/sticker-106.png',
            'Size': '{Width=1042, Height=315}',
            'LastModified': '10/11/2022 14:35:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:07',
            'ProductTypes': []
          },
          {
            'StickerId': 107,
            'Active': 1,
            'Order': 98,
            'Title': 'Hoera een jongen',
            'ImagePath': 'stickers/sticker-107.png',
            'Size': '{Width=734, Height=1042}',
            'LastModified': '05/09/2017 07:43:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:21',
            'ProductTypes': []
          },
          {
            'StickerId': 108,
            'Active': 1,
            'Order': 99,
            'Title': 'Bedankt',
            'ImagePath': 'stickers/sticker-108.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:43:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:32',
            'ProductTypes': []
          },
          {
            'StickerId': 109,
            'Active': 1,
            'Order': 100,
            'Title': 'Pumpkin',
            'ImagePath': 'stickers/sticker-109.png',
            'Size': '{Width=1042, Height=763}',
            'LastModified': '10/11/2022 14:35:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:47',
            'ProductTypes': []
          },
          {
            'StickerId': 110,
            'Active': 1,
            'Order': 101,
            'Title': 'Stoplicht',
            'ImagePath': 'stickers/sticker-110.png',
            'Size': '{Width=288, Height=1032}',
            'LastModified': '05/09/2017 07:44:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:00',
            'ProductTypes': []
          },
          {
            'StickerId': 111,
            'Active': 1,
            'Order': 102,
            'Title': 'Hoera rijbewijs',
            'ImagePath': 'stickers/sticker-111.png',
            'Size': '{Width=1040, Height=632}',
            'LastModified': '05/09/2017 07:44:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:14',
            'ProductTypes': []
          },
          {
            'StickerId': 112,
            'Active': 1,
            'Order': 103,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-112.png',
            'Size': '{Width=997, Height=997}',
            'LastModified': '05/09/2017 07:44:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:25',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 8,
        'Name': 'tompouce-cake-526x207',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 737,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-737.png',
            'Order': 7,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:39:42',
            'Categories': [],
            'Created': '07/24/2017 10:27:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 738,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-738.png',
            'Order': 8,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:28:37',
            'Categories': [],
            'Created': '07/24/2017 10:28:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 743,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-743.png',
            'Order': 12,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:39:56',
            'Categories': [],
            'Created': '07/24/2017 10:34:16',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 744,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-744.png',
            'Order': 13,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_ster',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:40:04',
            'Categories': [],
            'Created': '07/24/2017 10:34:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 747,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-747.png',
            'Order': 16,
            'Size': '{Width=1120, Height=457}',
            'Title': 'tompouce_kader_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:36:22',
            'Categories': [],
            'Created': '07/24/2017 10:36:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 748,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-748.png',
            'Order': 17,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_streep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:36:45',
            'Categories': [],
            'Created': '07/24/2017 10:36:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 752,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-752.png',
            'Order': 20,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:38:54',
            'Categories': [],
            'Created': '07/24/2017 10:38:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 753,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-753.png',
            'Order': 21,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 10:40:25',
            'Categories': [],
            'Created': '07/24/2017 10:39:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 773,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-773.png',
            'Order': 41,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:27:44',
            'Categories': [],
            'Created': '07/24/2017 11:27:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 774,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-774.png',
            'Order': 42,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:28:02',
            'Categories': [],
            'Created': '07/24/2017 11:28:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 782,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-782.png',
            'Order': 50,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:39:27',
            'Categories': [],
            'Created': '07/24/2017 11:39:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 783,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-783.png',
            'Order': 51,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:39:58',
            'Categories': [],
            'Created': '07/24/2017 11:39:58',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 786,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-786.png',
            'Order': 54,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:40:47',
            'Categories': [],
            'Created': '07/24/2017 11:40:47',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 788,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-788.png',
            'Order': 57,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:41:13',
            'Categories': [],
            'Created': '07/24/2017 11:41:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 801,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-801.png',
            'Order': 70,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:46:21',
            'Categories': [],
            'Created': '07/24/2017 11:46:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 802,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-802.png',
            'Order': 71,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:46:42',
            'Categories': [],
            'Created': '07/24/2017 11:46:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 810,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-810.png',
            'Order': 79,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_blaadje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 11:50:20',
            'Categories': [],
            'Created': '07/24/2017 11:50:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 815,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-815.png',
            'Order': 84,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:51:26',
            'Categories': [],
            'Created': '07/24/2017 11:51:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 816,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-816.png',
            'Order': 85,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 11:52:21',
            'Categories': [],
            'Created': '07/24/2017 11:52:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 830,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-830.png',
            'Order': 98,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:06:15',
            'Categories': [],
            'Created': '07/24/2017 12:06:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 831,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-831.png',
            'Order': 99,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:06:45',
            'Categories': [],
            'Created': '07/24/2017 12:06:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 839,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-839.png',
            'Order': 107,
            'Size': '{Width=456, Height=1119}',
            'Title': 'tompouce_kader_oranje',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:19:04',
            'Categories': [],
            'Created': '07/24/2017 12:11:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 847,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-847.png',
            'Order': 115,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:17:19',
            'Categories': [],
            'Created': '07/24/2017 12:16:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 848,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-848.png',
            'Order': 116,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:20:20',
            'Categories': [],
            'Created': '07/24/2017 12:20:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 857,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-857.png',
            'Order': 125,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:42:37',
            'Categories': [],
            'Created': '07/24/2017 12:42:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 859,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-859.png',
            'Order': 127,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:43:07',
            'Categories': [],
            'Created': '07/24/2017 12:43:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 861,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-861.png',
            'Order': 129,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:44:08',
            'Categories': [],
            'Created': '07/24/2017 12:44:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 864,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-864.png',
            'Order': 132,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_beertje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:44:43',
            'Categories': [],
            'Created': '07/24/2017 12:44:43',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 875,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-875.png',
            'Order': 143,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:48:11',
            'Categories': [],
            'Created': '07/24/2017 12:48:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 876,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-876.png',
            'Order': 144,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:49:11',
            'Categories': [],
            'Created': '07/24/2017 12:49:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 881,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-881.png',
            'Order': 149,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:51:33',
            'Categories': [],
            'Created': '07/24/2017 12:51:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 893,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-893.png',
            'Order': 161,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:56:18',
            'Categories': [],
            'Created': '07/24/2017 12:56:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 894,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-894.png',
            'Order': 162,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 12:56:42',
            'Categories': [],
            'Created': '07/24/2017 12:56:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 903,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-903.png',
            'Order': 171,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 12:59:09',
            'Categories': [],
            'Created': '07/24/2017 12:59:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 910,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-910.png',
            'Order': 178,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:01:31',
            'Categories': [],
            'Created': '07/24/2017 13:01:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 912,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-912.png',
            'Order': 180,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:02:11',
            'Categories': [],
            'Created': '07/24/2017 13:02:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 923,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-923.png',
            'Order': 191,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:12:19',
            'Categories': [],
            'Created': '07/24/2017 13:12:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 924,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-924.png',
            'Order': 192,
            'Size': '{Width=1119, Height=457}',
            'Title': 'tompouce_overall_rijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:12:48',
            'Categories': [],
            'Created': '07/24/2017 13:12:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 930,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-930.png',
            'Order': 198,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:16:01',
            'Categories': [],
            'Created': '07/24/2017 13:16:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 931,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-931.png',
            'Order': 199,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_space',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:16:33',
            'Categories': [],
            'Created': '07/24/2017 13:16:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 937,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-937.png',
            'Order': 205,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:20:40',
            'Categories': [],
            'Created': '07/24/2017 13:20:40',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 939,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-939.png',
            'Order': 207,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 13:21:51',
            'Categories': [],
            'Created': '07/24/2017 13:21:06',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 943,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-943.png',
            'Order': 211,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:26:02',
            'Categories': [],
            'Created': '07/24/2017 13:26:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 944,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-944.png',
            'Order': 212,
            'Size': '{Width=3543, Height=3682}',
            'Title': 'tompouce_overall_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:26:59',
            'Categories': [],
            'Created': '07/24/2017 13:26:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 951,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-951.png',
            'Order': 219,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:29:21',
            'Categories': [],
            'Created': '07/24/2017 13:29:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 955,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-955.png',
            'Order': 223,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_BFF',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:29:58',
            'Categories': [],
            'Created': '07/24/2017 13:29:58',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 960,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-960.png',
            'Order': 228,
            'Size': '{Width=1119, Height=457}',
            'Title': 'tompouce_kader_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:32:09',
            'Categories': [],
            'Created': '07/24/2017 13:32:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 962,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-962.png',
            'Order': 230,
            'Size': '{Width=1120, Height=457}',
            'Title': 'tompouce_overall_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:32:35',
            'Categories': [],
            'Created': '07/24/2017 13:32:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 969,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-969.png',
            'Order': 237,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:33:38',
            'Categories': [],
            'Created': '07/24/2017 13:33:38',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 972,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-972.png',
            'Order': 240,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:34:14',
            'Categories': [],
            'Created': '07/24/2017 13:34:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 978,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-978.png',
            'Order': 246,
            'Size': '{Width=2583, Height=1723}',
            'Title': 'tompouce_overall_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:35:24',
            'Categories': [],
            'Created': '07/24/2017 13:35:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 979,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-979.png',
            'Order': 247,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:35:26',
            'Categories': [],
            'Created': '07/24/2017 13:35:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 981,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-981.png',
            'Order': 249,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:36:00',
            'Categories': [],
            'Created': '07/24/2017 13:36:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 989,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-989.png',
            'Order': 257,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:54:21',
            'Categories': [],
            'Created': '07/24/2017 13:36:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 992,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-992.png',
            'Order': 260,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 13:55:41',
            'Categories': [],
            'Created': '07/24/2017 13:37:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 998,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-998.png',
            'Order': 266,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:40:18',
            'Categories': [],
            'Created': '07/24/2017 13:40:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 999,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-999.png',
            'Order': 267,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/24/2017 13:40:59',
            'Categories': [],
            'Created': '07/24/2017 13:40:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1004,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1004.png',
            'Order': 272,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:42:14',
            'Categories': [],
            'Created': '07/24/2017 13:42:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1006,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1006.png',
            'Order': 274,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:42:44',
            'Categories': [],
            'Created': '07/24/2017 13:42:44',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1018,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1018.png',
            'Order': 286,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:49:50',
            'Categories': [],
            'Created': '07/24/2017 13:49:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1019,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1019.png',
            'Order': 287,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_monsters',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 13:50:24',
            'Categories': [],
            'Created': '07/24/2017 13:50:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1039,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1039.png',
            'Order': 307,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:08:21',
            'Categories': [],
            'Created': '07/24/2017 14:08:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1040,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1040.png',
            'Order': 308,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:09:36',
            'Categories': [],
            'Created': '07/24/2017 14:09:36',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1041,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1041.png',
            'Order': 309,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:09:41',
            'Categories': [],
            'Created': '07/24/2017 14:09:41',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1044,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1044.png',
            'Order': 312,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_piraat',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:12:09',
            'Categories': [],
            'Created': '07/24/2017 14:12:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1067,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1067.png',
            'Order': 335,
            'Size': '{Width=2094, Height=643}',
            'Title': 'tompouce_kader_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:28:41',
            'Categories': [],
            'Created': '07/24/2017 14:28:41',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1070,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1070.png',
            'Order': 338,
            'Size': '{Width=2094, Height=643}',
            'Title': 'tompouce_overall_confetti',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:30:33',
            'Categories': [],
            'Created': '07/24/2017 14:30:33',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1086,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1086.png',
            'Order': 354,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:43:26',
            'Categories': [],
            'Created': '07/24/2017 14:43:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1087,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1087.png',
            'Order': 355,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:43:37',
            'Categories': [],
            'Created': '07/24/2017 14:43:37',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1089,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1089.png',
            'Order': 357,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:45:01',
            'Categories': [],
            'Created': '07/24/2017 14:45:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1093,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1093.png',
            'Order': 361,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_herfst',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 14:50:14',
            'Categories': [],
            'Created': '07/24/2017 14:50:14',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1101,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1101.png',
            'Order': 369,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_princes',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 14:58:52',
            'Categories': [],
            'Created': '07/24/2017 14:58:52',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1102,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1102.png',
            'Order': 370,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 14:59:51',
            'Categories': [],
            'Created': '07/24/2017 14:59:51',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1103,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1103.png',
            'Order': 371,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_kado',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:00:59',
            'Categories': [],
            'Created': '07/24/2017 15:00:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1133,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1133.png',
            'Order': 401,
            'Size': '{Width=1119, Height=456}',
            'Title': 'Tompouce_kader_jipjaneke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:17:25',
            'Categories': [],
            'Created': '07/24/2017 15:17:25',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1135,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1135.png',
            'Order': 403,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:17:56',
            'Categories': [],
            'Created': '07/24/2017 15:17:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1137,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1137.png',
            'Order': 405,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kado_kaderwit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:18:34',
            'Categories': [],
            'Created': '07/24/2017 15:18:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1138,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1138.png',
            'Order': 406,
            'Size': '{Width=2652, Height=3103}',
            'Title': 'Tompouce_overall_jipjaneke',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:19:20',
            'Categories': [],
            'Created': '07/24/2017 15:19:20',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1139,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1139.png',
            'Order': 407,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:19:42',
            'Categories': [],
            'Created': '07/24/2017 15:19:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1140,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1140.png',
            'Order': 408,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\brokaarl',
            'LastModified': '07/24/2017 15:20:26',
            'Categories': [],
            'Created': '07/24/2017 15:20:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1170,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1170.png',
            'Order': 438,
            'Size': '{Width=1119, Height=459}',
            'Title': 'tompouce_kader_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:38:32',
            'Categories': [],
            'Created': '07/24/2017 15:38:32',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1174,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1174.png',
            'Order': 442,
            'Size': '{Width=1120, Height=456}',
            'Title': 'tompouce_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\lye',
            'LastModified': '07/24/2017 15:40:17',
            'Categories': [],
            'Created': '07/24/2017 15:40:17',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1175,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1175.png',
            'Order': 443,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:40:19',
            'Categories': [],
            'Created': '07/24/2017 15:40:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1178,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1178.png',
            'Order': 446,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_winter',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:40:57',
            'Categories': [],
            'Created': '07/24/2017 15:40:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1193,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1193.png',
            'Order': 458,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_kader_lente',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:48:18',
            'Categories': [],
            'Created': '07/24/2017 15:48:18',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1194,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1194.png',
            'Order': 459,
            'Size': '{Width=1119, Height=456}',
            'Title': 'tompouce_overall_lente',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'LastModified': '07/24/2017 15:49:19',
            'Categories': [],
            'Created': '07/24/2017 15:49:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1195,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1195.png',
            'Order': 460,
            'Size': '{Width=1131, Height=469}',
            'Title': 'Tompouce_L_kader_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\vermeulenm',
            'LastModified': '07/24/2017 15:54:12',
            'Categories': [],
            'Created': '07/24/2017 15:54:12',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 17,
            'Title': 'Montserrat',
            'ImagePath': 'fonts/font-17.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 14,
            'Order': 5,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '08/15/2017 12:04:47',
            'LastModifiedBy': 'HEMALOCAL\\emdvorobiova',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 22,
            'Title': 'Bungee',
            'ImagePath': 'fonts/font-22.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 9,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/22/2017 06:29:11',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:25:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 10,
            'Title': '6311018',
            'Created': '05/16/2017 14:18:24',
            'LastModified': '03/24/2020 11:36:36',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 8,
            'ShapeId': 2,
            'Width': 525,
            'Height': 206,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-tompouce',
            'BackgroundWidth': 566,
            'BackgroundHeight': 254,
            'Bleed': 0,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': 726,
            'MultiCloneWidth': 1122,
            'IsMultiClone': true,
            'OptimalWidth': 283,
            'OptimalHeight': 127,
            'MinimalWidth': 142,
            'MinimalHeight': 64,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': true,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-10.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-10.png',
            'OverlayImagePath': 'products/overlays/product-10.png',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-tompouce'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 2,
            'Active': 1,
            'ImagePath': 'templates/template-2.svg',
            'ShapeId': 2,
            'Created': '02/22/2017 13:53:08',
            'LastModified': '05/18/2017 12:10:03',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 4,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 23.076923}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 53.846154}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 23.076923}}',
            'Title': 'Layout-03'
          },
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 5,
            'Active': 1,
            'ImagePath': 'templates/template-5.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:11:50',
            'LastModified': '05/18/2017 12:10:06',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 5,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 50, h: 50}}',
            'Title': 'Layout-04'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 7,
            'Active': 1,
            'ImagePath': 'templates/template-7.svg',
            'ShapeId': 2,
            'Created': '04/27/2017 08:36:17',
            'LastModified': '05/18/2017 12:10:16',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 6,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 8, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 9, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-05'
          },
          {
            'LayoutTemplateId': 8,
            'Active': 1,
            'ImagePath': 'templates/template-8.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:48:38',
            'LastModified': '05/18/2017 12:10:12',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 7,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-06'
          },
          {
            'LayoutTemplateId': 9,
            'Active': 1,
            'ImagePath': 'templates/template-9.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:49:05',
            'LastModified': '05/18/2017 12:10:20',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 8,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-07'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          },
          {
            'LayoutTemplateId': 12,
            'Active': 1,
            'ImagePath': 'templates/template-12.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:24:43',
            'LastModified': '05/18/2017 12:10:25',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 9,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-08'
          },
          {
            'LayoutTemplateId': 13,
            'Active': 1,
            'ImagePath': 'templates/template-13.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:26:35',
            'LastModified': '06/16/2017 13:30:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Order': 10,
            'PermittedSides': 'center,top,right,bottom',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 50, h: 100}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 100}}',
            'Title': 'Layout-09'
          },
          {
            'LayoutTemplateId': 14,
            'Active': 1,
            'ImagePath': 'templates/template-14.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:27:44',
            'LastModified': '05/18/2017 12:10:33',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 11,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-10'
          },
          {
            'LayoutTemplateId': 15,
            'Active': 1,
            'ImagePath': 'templates/template-15.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:12',
            'LastModified': '05/18/2017 12:10:38',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 12,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-11'
          },
          {
            'LayoutTemplateId': 16,
            'Active': 0,
            'ImagePath': 'templates/template-16.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:35',
            'LastModified': '07/31/2019 15:15:43',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 13,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: \'hidden\', accept: \'\', dimension: {w: 100, h: 33.333333}},\r\n{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-12'
          },
          {
            'LayoutTemplateId': 17,
            'Active': 1,
            'ImagePath': 'templates/template-17.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:16',
            'LastModified': '05/18/2017 12:10:46',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 14,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 66.666666}}',
            'Title': 'Layout-13'
          },
          {
            'LayoutTemplateId': 18,
            'Active': 1,
            'ImagePath': 'templates/template-18.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:41',
            'LastModified': '05/18/2017 12:10:50',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 15,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 50}}',
            'Title': 'Layout-14'
          },
          {
            'LayoutTemplateId': 19,
            'Active': 1,
            'ImagePath': 'templates/template-19.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:30:07',
            'LastModified': '06/07/2017 12:46:48',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'Order': 16,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-15'
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 13,
            'Active': 1,
            'Order': 3,
            'Title': 'Strik',
            'ImagePath': 'stickers/sticker-13.png',
            'Size': '{Width=625, Height=335}',
            'LastModified': '05/09/2017 07:13:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:55',
            'ProductTypes': []
          },
          {
            'StickerId': 14,
            'Active': 1,
            'Order': 4,
            'Title': 'Cirkel',
            'ImagePath': 'stickers/sticker-14.png',
            'Size': '{Width=623, Height=624}',
            'LastModified': '05/09/2017 07:14:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:06',
            'ProductTypes': []
          },
          {
            'StickerId': 15,
            'Active': 1,
            'Order': 5,
            'Title': 'Spreekwolk',
            'ImagePath': 'stickers/sticker-15.png',
            'Size': '{Width=833, Height=736}',
            'LastModified': '05/09/2017 07:14:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:19',
            'ProductTypes': []
          },
          {
            'StickerId': 16,
            'Active': 1,
            'Order': 7,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-16.png',
            'Size': '{Width=662, Height=737}',
            'LastModified': '05/09/2017 07:14:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:27',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 19,
            'Active': 1,
            'Order': 10,
            'Title': 'Bril',
            'ImagePath': 'stickers/sticker-19.png',
            'Size': '{Width=688, Height=229}',
            'LastModified': '05/09/2017 07:15:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:01',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 21,
            'Active': 1,
            'Order': 12,
            'Title': 'Baby',
            'ImagePath': 'stickers/sticker-21.png',
            'Size': '{Width=729, Height=658}',
            'LastModified': '05/09/2017 07:15:47',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:47',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 23,
            'Active': 1,
            'Order': 14,
            'Title': 'Hart blauw',
            'ImagePath': 'stickers/sticker-23.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '05/09/2017 07:16:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:14',
            'ProductTypes': []
          },
          {
            'StickerId': 24,
            'Active': 1,
            'Order': 15,
            'Title': 'Ster blauw',
            'ImagePath': 'stickers/sticker-24.png',
            'Size': '{Width=625, Height=570}',
            'LastModified': '05/09/2017 07:16:24',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:24',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 26,
            'Active': 1,
            'Order': 17,
            'Title': 'Welkom kleintje',
            'ImagePath': 'stickers/sticker-26.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:16:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:56',
            'ProductTypes': []
          },
          {
            'StickerId': 27,
            'Active': 1,
            'Order': 18,
            'Title': 'Welkom kleintjes',
            'ImagePath': 'stickers/sticker-27.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:17:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:13',
            'ProductTypes': []
          },
          {
            'StickerId': 28,
            'Active': 1,
            'Order': 19,
            'Title': 'Sinasappel',
            'ImagePath': 'stickers/sticker-28.png',
            'Size': '{Width=729, Height=729}',
            'LastModified': '05/09/2017 07:17:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:25',
            'ProductTypes': []
          },
          {
            'StickerId': 29,
            'Active': 1,
            'Order': 20,
            'Title': 'Blaadje',
            'ImagePath': 'stickers/sticker-29.png',
            'Size': '{Width=717, Height=238}',
            'LastModified': '05/09/2017 07:17:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:37',
            'ProductTypes': []
          },
          {
            'StickerId': 30,
            'Active': 1,
            'Order': 21,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-30.png',
            'Size': '{Width=359, Height=931}',
            'LastModified': '05/09/2017 07:17:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:48',
            'ProductTypes': []
          },
          {
            'StickerId': 31,
            'Active': 1,
            'Order': 22,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-31.png',
            'Size': '{Width=383, Height=942}',
            'LastModified': '05/09/2017 07:18:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:02',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 33,
            'Active': 1,
            'Order': 24,
            'Title': 'Ananas',
            'ImagePath': 'stickers/sticker-33.png',
            'Size': '{Width=405, Height=738}',
            'LastModified': '05/09/2017 07:18:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:28',
            'ProductTypes': []
          },
          {
            'StickerId': 34,
            'Active': 1,
            'Order': 25,
            'Title': 'Herfst blaadjes',
            'ImagePath': 'stickers/sticker-34.png',
            'Size': '{Width=255, Height=546}',
            'LastModified': '05/09/2017 07:18:46',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:46',
            'ProductTypes': []
          },
          {
            'StickerId': 35,
            'Active': 1,
            'Order': 26,
            'Title': 'Winter',
            'ImagePath': 'stickers/sticker-35.png',
            'Size': '{Width=476, Height=785}',
            'LastModified': '05/09/2017 07:18:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:59',
            'ProductTypes': []
          },
          {
            'StickerId': 36,
            'Active': 1,
            'Order': 27,
            'Title': 'Astronaut',
            'ImagePath': 'stickers/sticker-36.png',
            'Size': '{Width=589, Height=988}',
            'LastModified': '05/09/2017 07:19:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:14',
            'ProductTypes': []
          },
          {
            'StickerId': 37,
            'Active': 1,
            'Order': 28,
            'Title': 'Jarig',
            'ImagePath': 'stickers/sticker-37.png',
            'Size': '{Width=1036, Height=1026}',
            'LastModified': '05/09/2017 07:19:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:26',
            'ProductTypes': []
          },
          {
            'StickerId': 38,
            'Active': 1,
            'Order': 29,
            'Title': 'Kikker',
            'ImagePath': 'stickers/sticker-38.png',
            'Size': '{Width=1042, Height=1040}',
            'LastModified': '05/09/2017 07:19:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:38',
            'ProductTypes': []
          },
          {
            'StickerId': 39,
            'Active': 1,
            'Order': 30,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-39.png',
            'Size': '{Width=1042, Height=651}',
            'LastModified': '05/09/2017 07:19:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:56',
            'ProductTypes': []
          },
          {
            'StickerId': 40,
            'Active': 1,
            'Order': 31,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-40.png',
            'Size': '{Width=988, Height=311}',
            'LastModified': '05/09/2017 07:20:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:13',
            'ProductTypes': []
          },
          {
            'StickerId': 41,
            'Active': 1,
            'Order': 32,
            'Title': 'Piratenmuts',
            'ImagePath': 'stickers/sticker-41.png',
            'Size': '{Width=1042, Height=591}',
            'LastModified': '05/09/2017 07:20:34',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:34',
            'ProductTypes': []
          },
          {
            'StickerId': 42,
            'Active': 1,
            'Order': 33,
            'Title': 'Takkie',
            'ImagePath': 'stickers/sticker-42.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:20:45',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:45',
            'ProductTypes': []
          },
          {
            'StickerId': 43,
            'Active': 1,
            'Order': 34,
            'Title': 'Ballon geel',
            'ImagePath': 'stickers/sticker-43.png',
            'Size': '{Width=377, Height=1024}',
            'LastModified': '05/09/2017 07:20:58',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:58',
            'ProductTypes': []
          },
          {
            'StickerId': 44,
            'Active': 1,
            'Order': 35,
            'Title': 'Getrouwd',
            'ImagePath': 'stickers/sticker-44.png',
            'Size': '{Width=1028, Height=349}',
            'LastModified': '05/09/2017 07:21:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:11',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 46,
            'Active': 1,
            'Order': 37,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-46.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:21:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:57',
            'ProductTypes': []
          },
          {
            'StickerId': 47,
            'Active': 1,
            'Order': 38,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-47.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:22:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:19',
            'ProductTypes': []
          },
          {
            'StickerId': 48,
            'Active': 1,
            'Order': 39,
            'Title': 'Papagaai',
            'ImagePath': 'stickers/sticker-48.png',
            'Size': '{Width=1042, Height=928}',
            'LastModified': '05/09/2017 07:22:30',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:30',
            'ProductTypes': []
          },
          {
            'StickerId': 49,
            'Active': 1,
            'Order': 40,
            'Title': 'Robot',
            'ImagePath': 'stickers/sticker-49.png',
            'Size': '{Width=674, Height=1009}',
            'LastModified': '05/09/2017 07:22:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:43',
            'ProductTypes': []
          },
          {
            'StickerId': 50,
            'Active': 1,
            'Order': 41,
            'Title': 'The king',
            'ImagePath': 'stickers/sticker-50.png',
            'Size': '{Width=1044, Height=197}',
            'LastModified': '05/09/2017 07:22:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:55',
            'ProductTypes': []
          },
          {
            'StickerId': 51,
            'Active': 1,
            'Order': 42,
            'Title': 'Ballonnen groen',
            'ImagePath': 'stickers/sticker-51.png',
            'Size': '{Width=785, Height=1007}',
            'LastModified': '05/09/2017 07:23:10',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:10',
            'ProductTypes': []
          },
          {
            'StickerId': 52,
            'Active': 1,
            'Order': 43,
            'Title': 'Je bent mijn liefste',
            'ImagePath': 'stickers/sticker-52.png',
            'Size': '{Width=487, Height=1042}',
            'LastModified': '05/09/2017 07:23:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:27',
            'ProductTypes': []
          },
          {
            'StickerId': 53,
            'Active': 1,
            'Order': 44,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-53.png',
            'Size': '{Width=1038, Height=948}',
            'LastModified': '05/09/2017 07:23:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:37',
            'ProductTypes': []
          },
          {
            'StickerId': 54,
            'Active': 1,
            'Order': 45,
            'Title': 'Racket',
            'ImagePath': 'stickers/sticker-54.png',
            'Size': '{Width=420, Height=1016}',
            'LastModified': '05/09/2017 07:23:49',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:49',
            'ProductTypes': []
          },
          {
            'StickerId': 55,
            'Active': 1,
            'Order': 46,
            'Title': 'Zwaard',
            'ImagePath': 'stickers/sticker-55.png',
            'Size': '{Width=461, Height=1042}',
            'LastModified': '05/09/2017 07:24:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:01',
            'ProductTypes': []
          },
          {
            'StickerId': 56,
            'Active': 1,
            'Order': 47,
            'Title': 'Hoeravlag',
            'ImagePath': 'stickers/sticker-56.png',
            'Size': '{Width=1045, Height=252}',
            'LastModified': '05/09/2017 07:24:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:13',
            'ProductTypes': []
          },
          {
            'StickerId': 57,
            'Active': 1,
            'Order': 48,
            'Title': 'Rood hartje',
            'ImagePath': 'stickers/sticker-57.png',
            'Size': '{Width=624, Height=1007}',
            'LastModified': '05/09/2017 07:24:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:27',
            'ProductTypes': []
          },
          {
            'StickerId': 58,
            'Active': 1,
            'Order': 49,
            'Title': 'Hoera banner',
            'ImagePath': 'stickers/sticker-58.png',
            'Size': '{Width=1029, Height=530}',
            'LastModified': '05/09/2017 07:24:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:48',
            'ProductTypes': []
          },
          {
            'StickerId': 59,
            'Active': 1,
            'Order': 50,
            'Title': 'Raket',
            'ImagePath': 'stickers/sticker-59.png',
            'Size': '{Width=659, Height=984}',
            'LastModified': '05/09/2017 07:25:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:05',
            'ProductTypes': []
          },
          {
            'StickerId': 60,
            'Active': 1,
            'Order': 51,
            'Title': 'Twee hartjes',
            'ImagePath': 'stickers/sticker-60.png',
            'Size': '{Width=968, Height=754}',
            'LastModified': '05/09/2017 07:25:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:18',
            'ProductTypes': []
          },
          {
            'StickerId': 61,
            'Active': 1,
            'Order': 52,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-61.png',
            'Size': '{Width=995, Height=543}',
            'LastModified': '05/09/2017 07:25:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:31',
            'ProductTypes': []
          },
          {
            'StickerId': 62,
            'Active': 1,
            'Order': 53,
            'Title': 'Lijn hartjes',
            'ImagePath': 'stickers/sticker-62.png',
            'Size': '{Width=982, Height=958}',
            'LastModified': '05/09/2017 07:25:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:43',
            'ProductTypes': []
          },
          {
            'StickerId': 63,
            'Active': 1,
            'Order': 54,
            'Title': 'Roze hartje',
            'ImagePath': 'stickers/sticker-63.png',
            'Size': '{Width=624, Height=1017}',
            'LastModified': '05/09/2017 07:26:23',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:23',
            'ProductTypes': []
          },
          {
            'StickerId': 64,
            'Active': 1,
            'Order': 55,
            'Title': 'Ufo',
            'ImagePath': 'stickers/sticker-64.png',
            'Size': '{Width=914, Height=958}',
            'LastModified': '05/09/2017 07:26:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:32',
            'ProductTypes': []
          },
          {
            'StickerId': 65,
            'Active': 1,
            'Order': 56,
            'Title': 'Kadootje',
            'ImagePath': 'stickers/sticker-65.png',
            'Size': '{Width=706, Height=1012}',
            'LastModified': '05/09/2017 07:26:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:42',
            'ProductTypes': []
          },
          {
            'StickerId': 66,
            'Active': 1,
            'Order': 57,
            'Title': 'Ring',
            'ImagePath': 'stickers/sticker-66.png',
            'Size': '{Width=620, Height=1001}',
            'LastModified': '05/09/2017 07:26:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:51',
            'ProductTypes': []
          },
          {
            'StickerId': 67,
            'Active': 1,
            'Order': 58,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-67.png',
            'Size': '{Width=1020, Height=947}',
            'LastModified': '05/09/2017 07:27:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:01',
            'ProductTypes': []
          },
          {
            'StickerId': 68,
            'Active': 1,
            'Order': 59,
            'Title': 'Bowtie',
            'ImagePath': 'stickers/sticker-68.png',
            'Size': '{Width=1017, Height=514}',
            'LastModified': '05/09/2017 07:27:09',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:09',
            'ProductTypes': []
          },
          {
            'StickerId': 69,
            'Active': 1,
            'Order': 60,
            'Title': 'Confetti',
            'ImagePath': 'stickers/sticker-69.png',
            'Size': '{Width=333, Height=995}',
            'LastModified': '05/09/2017 07:27:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:21',
            'ProductTypes': []
          },
          {
            'StickerId': 70,
            'Active': 1,
            'Order': 61,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-70.png',
            'Size': '{Width=898, Height=1006}',
            'LastModified': '05/09/2017 07:27:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:33',
            'ProductTypes': []
          },
          {
            'StickerId': 71,
            'Active': 1,
            'Order': 62,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-71.png',
            'Size': '{Width=1027, Height=573}',
            'LastModified': '05/09/2017 07:27:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:42',
            'ProductTypes': []
          },
          {
            'StickerId': 72,
            'Active': 1,
            'Order': 63,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-72.png',
            'Size': '{Width=797, Height=985}',
            'LastModified': '05/09/2017 07:27:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:55',
            'ProductTypes': []
          },
          {
            'StickerId': 73,
            'Active': 1,
            'Order': 64,
            'Title': 'Mr',
            'ImagePath': 'stickers/sticker-73.png',
            'Size': '{Width=1038, Height=932}',
            'LastModified': '05/09/2017 07:28:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:07',
            'ProductTypes': []
          },
          {
            'StickerId': 74,
            'Active': 1,
            'Order': 65,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-74.png',
            'Size': '{Width=708, Height=990}',
            'LastModified': '05/09/2017 07:28:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:18',
            'ProductTypes': []
          },
          {
            'StickerId': 75,
            'Active': 1,
            'Order': 66,
            'Title': 'Ms',
            'ImagePath': 'stickers/sticker-75.png',
            'Size': '{Width=1031, Height=971}',
            'LastModified': '05/09/2017 07:28:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:32',
            'ProductTypes': []
          },
          {
            'StickerId': 76,
            'Active': 1,
            'Order': 67,
            'Title': 'Rainbow',
            'ImagePath': 'stickers/sticker-76.png',
            'Size': '{Width=1010, Height=659}',
            'LastModified': '05/09/2017 07:28:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:42',
            'ProductTypes': []
          },
          {
            'StickerId': 77,
            'Active': 1,
            'Order': 68,
            'Title': 'Champagne',
            'ImagePath': 'stickers/sticker-77.png',
            'Size': '{Width=341, Height=1006}',
            'LastModified': '05/09/2017 07:28:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:56',
            'ProductTypes': []
          },
          {
            'StickerId': 78,
            'Active': 1,
            'Order': 69,
            'Title': 'Hartjes',
            'ImagePath': 'stickers/sticker-78.png',
            'Size': '{Width=951, Height=571}',
            'LastModified': '05/09/2017 07:29:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:06',
            'ProductTypes': []
          },
          {
            'StickerId': 79,
            'Active': 1,
            'Order': 70,
            'Title': 'You are just lovely',
            'ImagePath': 'stickers/sticker-79.png',
            'Size': '{Width=987, Height=899}',
            'LastModified': '05/09/2017 07:29:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:26',
            'ProductTypes': []
          },
          {
            'StickerId': 80,
            'Active': 1,
            'Order': 71,
            'Title': 'Medaille',
            'ImagePath': 'stickers/sticker-80.png',
            'Size': '{Width=591, Height=1018}',
            'LastModified': '05/09/2017 07:29:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:40',
            'ProductTypes': []
          },
          {
            'StickerId': 81,
            'Active': 1,
            'Order': 72,
            'Title': 'Pluk de dag',
            'ImagePath': 'stickers/sticker-81.png',
            'Size': '{Width=509, Height=1042}',
            'LastModified': '05/09/2017 07:29:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:51',
            'ProductTypes': []
          },
          {
            'StickerId': 82,
            'Active': 1,
            'Order': 73,
            'Title': 'Zon',
            'ImagePath': 'stickers/sticker-82.png',
            'Size': '{Width=1033, Height=1005}',
            'LastModified': '05/09/2017 07:30:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:01',
            'ProductTypes': []
          },
          {
            'StickerId': 83,
            'Active': 1,
            'Order': 74,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-83.png',
            'Size': '{Width=997, Height=646}',
            'LastModified': '05/09/2017 07:30:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:11',
            'ProductTypes': []
          },
          {
            'StickerId': 84,
            'Active': 1,
            'Order': 75,
            'Title': 'Hartjesdoos mama',
            'ImagePath': 'stickers/sticker-84.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:28',
            'ProductTypes': []
          },
          {
            'StickerId': 85,
            'Active': 1,
            'Order': 76,
            'Title': 'Hartjesdoos',
            'ImagePath': 'stickers/sticker-85.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:41',
            'ProductTypes': []
          },
          {
            'StickerId': 86,
            'Active': 1,
            'Order': 77,
            'Title': 'Wolk rain',
            'ImagePath': 'stickers/sticker-86.png',
            'Size': '{Width=1002, Height=948}',
            'LastModified': '05/09/2017 07:30:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:54',
            'ProductTypes': []
          },
          {
            'StickerId': 87,
            'Active': 1,
            'Order': 78,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-87.png',
            'Size': '{Width=1025, Height=721}',
            'LastModified': '05/09/2017 07:31:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:05',
            'ProductTypes': []
          },
          {
            'StickerId': 88,
            'Active': 1,
            'Order': 79,
            'Title': 'Hartje mama',
            'ImagePath': 'stickers/sticker-88.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:32',
            'ProductTypes': []
          },
          {
            'StickerId': 89,
            'Active': 1,
            'Order': 80,
            'Title': 'Hartje',
            'ImagePath': 'stickers/sticker-89.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:42',
            'ProductTypes': []
          },
          {
            'StickerId': 90,
            'Active': 1,
            'Order': 81,
            'Title': 'Wolk donder',
            'ImagePath': 'stickers/sticker-90.png',
            'Size': '{Width=878, Height=998}',
            'LastModified': '05/09/2017 07:40:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:00',
            'ProductTypes': []
          },
          {
            'StickerId': 91,
            'Active': 1,
            'Order': 82,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-91.png',
            'Size': '{Width=1013, Height=1013}',
            'LastModified': '05/09/2017 07:40:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:14',
            'ProductTypes': []
          },
          {
            'StickerId': 92,
            'Active': 1,
            'Order': 83,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-92.png',
            'Size': '{Width=768, Height=1013}',
            'LastModified': '05/09/2017 07:40:44',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:44',
            'ProductTypes': []
          },
          {
            'StickerId': 93,
            'Active': 1,
            'Order': 84,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-93.png',
            'Size': '{Width=1009, Height=1022}',
            'LastModified': '05/09/2017 07:40:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:54',
            'ProductTypes': []
          },
          {
            'StickerId': 94,
            'Active': 1,
            'Order': 85,
            'Title': 'Zwemband',
            'ImagePath': 'stickers/sticker-94.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:41:04',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:04',
            'ProductTypes': []
          },
          {
            'StickerId': 95,
            'Active': 1,
            'Order': 86,
            'Title': 'Plons',
            'ImagePath': 'stickers/sticker-95.png',
            'Size': '{Width=1033, Height=430}',
            'LastModified': '05/09/2017 07:41:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:17',
            'ProductTypes': []
          },
          {
            'StickerId': 96,
            'Active': 1,
            'Order': 87,
            'Title': 'Zwemdiploma',
            'ImagePath': 'stickers/sticker-96.png',
            'Size': '{Width=1019, Height=121}',
            'LastModified': '05/09/2017 07:41:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:29',
            'ProductTypes': []
          },
          {
            'StickerId': 97,
            'Active': 1,
            'Order': 88,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-97.png',
            'Size': '{Width=719, Height=1044}',
            'LastModified': '05/09/2017 07:41:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:41',
            'ProductTypes': []
          },
          {
            'StickerId': 98,
            'Active': 1,
            'Order': 89,
            'Title': 'New home',
            'ImagePath': 'stickers/sticker-98.png',
            'Size': '{Width=835, Height=1042}',
            'LastModified': '05/09/2017 07:41:52',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:52',
            'ProductTypes': []
          },
          {
            'StickerId': 99,
            'Active': 1,
            'Order': 90,
            'Title': 'Sportheld',
            'ImagePath': 'stickers/sticker-99.png',
            'Size': '{Width=925, Height=1040}',
            'LastModified': '05/09/2017 07:42:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:02',
            'ProductTypes': []
          },
          {
            'StickerId': 100,
            'Active': 1,
            'Order': 91,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-100.png',
            'Size': '{Width=855, Height=1042}',
            'LastModified': '05/09/2017 07:42:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:12',
            'ProductTypes': []
          },
          {
            'StickerId': 101,
            'Active': 1,
            'Order': 92,
            'Title': 'Present',
            'ImagePath': 'stickers/sticker-101.png',
            'Size': '{Width=714, Height=1004}',
            'LastModified': '05/09/2017 07:42:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:21',
            'ProductTypes': []
          },
          {
            'StickerId': 102,
            'Active': 1,
            'Order': 93,
            'Title': 'Bird',
            'ImagePath': 'stickers/sticker-102.png',
            'Size': '{Width=1031, Height=720}',
            'LastModified': '05/09/2017 07:42:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:31',
            'ProductTypes': []
          },
          {
            'StickerId': 103,
            'Active': 1,
            'Order': 94,
            'Title': 'Snowflake',
            'ImagePath': 'stickers/sticker-103.png',
            'Size': '{Width=922, Height=1000}',
            'LastModified': '10/11/2022 14:35:16',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:40',
            'ProductTypes': []
          },
          {
            'StickerId': 104,
            'Active': 1,
            'Order': 95,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-104.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:53',
            'ProductTypes': []
          },
          {
            'StickerId': 105,
            'Active': 1,
            'Order': 96,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-105.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:57',
            'ProductTypes': []
          },
          {
            'StickerId': 106,
            'Active': 1,
            'Order': 97,
            'Title': 'Bat',
            'ImagePath': 'stickers/sticker-106.png',
            'Size': '{Width=1042, Height=315}',
            'LastModified': '10/11/2022 14:35:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:07',
            'ProductTypes': []
          },
          {
            'StickerId': 107,
            'Active': 1,
            'Order': 98,
            'Title': 'Hoera een jongen',
            'ImagePath': 'stickers/sticker-107.png',
            'Size': '{Width=734, Height=1042}',
            'LastModified': '05/09/2017 07:43:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:21',
            'ProductTypes': []
          },
          {
            'StickerId': 108,
            'Active': 1,
            'Order': 99,
            'Title': 'Bedankt',
            'ImagePath': 'stickers/sticker-108.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:43:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:32',
            'ProductTypes': []
          },
          {
            'StickerId': 109,
            'Active': 1,
            'Order': 100,
            'Title': 'Pumpkin',
            'ImagePath': 'stickers/sticker-109.png',
            'Size': '{Width=1042, Height=763}',
            'LastModified': '10/11/2022 14:35:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:47',
            'ProductTypes': []
          },
          {
            'StickerId': 110,
            'Active': 1,
            'Order': 101,
            'Title': 'Stoplicht',
            'ImagePath': 'stickers/sticker-110.png',
            'Size': '{Width=288, Height=1032}',
            'LastModified': '05/09/2017 07:44:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:00',
            'ProductTypes': []
          },
          {
            'StickerId': 111,
            'Active': 1,
            'Order': 102,
            'Title': 'Hoera rijbewijs',
            'ImagePath': 'stickers/sticker-111.png',
            'Size': '{Width=1040, Height=632}',
            'LastModified': '05/09/2017 07:44:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:14',
            'ProductTypes': []
          },
          {
            'StickerId': 112,
            'Active': 1,
            'Order': 103,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-112.png',
            'Size': '{Width=997, Height=997}',
            'LastModified': '05/09/2017 07:44:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:25',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 9,
        'Name': 'choco-ipad-cake-957x662',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1029,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1029.jpg',
            'Order': 297,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_blauw',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:29',
            'Categories': [],
            'Created': '07/24/2017 14:01:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1031,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1031.jpg',
            'Order': 299,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_groen',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:46',
            'Categories': [],
            'Created': '07/24/2017 14:03:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1034,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1034.jpg',
            'Order': 302,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geel',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:13',
            'Categories': [],
            'Created': '07/24/2017 14:05:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1038,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1038.jpg',
            'Order': 306,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_roodstreep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:32:19',
            'Categories': [],
            'Created': '07/24/2017 14:08:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1042,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1042.jpg',
            'Order': 310,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_rozerood',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:40:53',
            'Categories': [],
            'Created': '07/24/2017 14:09:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1043,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1043.jpg',
            'Order': 311,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_roze',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:34:29',
            'Categories': [],
            'Created': '07/24/2017 14:10:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1046,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1046.jpg',
            'Order': 314,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_fuchsia',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:37:57',
            'Categories': [],
            'Created': '07/24/2017 14:13:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1048,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1048.jpg',
            'Order': 316,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_boom',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:39:05',
            'Categories': [],
            'Created': '07/24/2017 14:14:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1050,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1050.jpg',
            'Order': 318,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_bloem',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:40:17',
            'Categories': [],
            'Created': '07/24/2017 14:15:38',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1052,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1052.jpg',
            'Order': 320,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:40:51',
            'Categories': [],
            'Created': '07/24/2017 14:16:46',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1053,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1053.jpg',
            'Order': 321,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:02:19',
            'Categories': [],
            'Created': '07/24/2017 14:17:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1054,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1054.jpg',
            'Order': 322,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:02:51',
            'Categories': [],
            'Created': '07/24/2017 14:18:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1056,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1056.jpg',
            'Order': 324,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruitrood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:03:06',
            'Categories': [],
            'Created': '07/24/2017 14:19:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1057,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1057.jpg',
            'Order': 325,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_stip rood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:05:08',
            'Categories': [],
            'Created': '07/24/2017 14:21:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1059,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1059.png',
            'Order': 327,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_moederdag',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:06:55',
            'Categories': [],
            'Created': '07/24/2017 14:22:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1062,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1062.png',
            'Order': 330,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:06:37',
            'Categories': [],
            'Created': '07/24/2017 14:24:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1064,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1064.png',
            'Order': 332,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_verkeer',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:10',
            'Categories': [],
            'Created': '07/24/2017 14:26:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1066,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1066.png',
            'Order': 334,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geboorte meisje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:25',
            'Categories': [],
            'Created': '07/24/2017 14:28:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1071,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1071.png',
            'Order': 339,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_suikerfeest',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:55',
            'Categories': [],
            'Created': '07/24/2017 14:31:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1074,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1074.png',
            'Order': 342,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:35:27',
            'Categories': [],
            'Created': '07/24/2017 14:32:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1115,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1115.png',
            'Order': 383,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_moederdag',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:08:31',
            'Categories': [],
            'Created': '07/24/2017 15:08:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1127,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1127.png',
            'Order': 395,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_ jongensstropdas',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:14:26',
            'Categories': [],
            'Created': '07/24/2017 15:14:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1131,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1131.png',
            'Order': 399,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_stropdasjongens',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:15:48',
            'Categories': [],
            'Created': '07/24/2017 15:15:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1134,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1134.jpg',
            'Order': 402,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_verkeerjongens',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:17:56',
            'Categories': [],
            'Created': '07/24/2017 15:17:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1143,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1143.jpg',
            'Order': 411,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_geboortemeisje',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:22:27',
            'Categories': [],
            'Created': '07/24/2017 15:22:27',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1147,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1147.png',
            'Order': 415,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:24:02',
            'Categories': [],
            'Created': '07/24/2017 15:24:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1148,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1148.png',
            'Order': 416,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:24:15',
            'Categories': [],
            'Created': '07/24/2017 15:24:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1150,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1150.png',
            'Order': 418,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_suikerfeest',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:26:21',
            'Categories': [],
            'Created': '07/24/2017 15:26:21',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1157,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1157.png',
            'Order': 425,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_hartje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:35:03',
            'Categories': [],
            'Created': '07/24/2017 15:29:47',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1167,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1167.jpg',
            'Order': 435,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_blauw',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:37:07',
            'Categories': [],
            'Created': '07/24/2017 15:37:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1173,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1173.jpg',
            'Order': 441,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_groen',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:39:13',
            'Categories': [],
            'Created': '07/24/2017 15:39:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1177,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1177.jpg',
            'Order': 445,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_geel',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:40:57',
            'Categories': [],
            'Created': '07/24/2017 15:40:57',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1182,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1182.jpg',
            'Order': 450,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_roodstreep',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:42:49',
            'Categories': [],
            'Created': '07/24/2017 15:42:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1188,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1188.jpg',
            'Order': 455,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_fuchsia',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:45:13',
            'Categories': [],
            'Created': '07/24/2017 15:45:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1191,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1191.jpg',
            'Order': 457,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_roze',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:47:42',
            'Categories': [],
            'Created': '07/24/2017 15:47:42',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1196,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1196.jpg',
            'Order': 461,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_hardroze',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:54:24',
            'Categories': [],
            'Created': '07/24/2017 15:54:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1201,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1201.jpg',
            'Order': 466,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_bloem',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:58:23',
            'Categories': [],
            'Created': '07/24/2017 15:58:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1205,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1205.jpg',
            'Order': 470,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_rozeruit',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 16:01:45',
            'Categories': [],
            'Created': '07/24/2017 16:01:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1206,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1206.jpg',
            'Order': 471,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_blauwruit',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 16:04:34',
            'Categories': [],
            'Created': '07/24/2017 16:04:34',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1210,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1210.jpg',
            'Order': 474,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_roodstip',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 16:09:27',
            'Categories': [],
            'Created': '07/24/2017 16:09:27',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 17,
            'Title': 'Montserrat',
            'ImagePath': 'fonts/font-17.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 14,
            'Order': 5,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '08/15/2017 12:04:47',
            'LastModifiedBy': 'HEMALOCAL\\emdvorobiova',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 22,
            'Title': 'Bungee',
            'ImagePath': 'fonts/font-22.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 9,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/22/2017 06:29:11',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:25:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 11,
            'Title': '6380005',
            'Created': '05/16/2017 14:20:22',
            'LastModified': '03/07/2018 09:31:22',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 9,
            'ShapeId': 2,
            'Width': 957,
            'Height': 662,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-choco-ipad',
            'BackgroundWidth': 1106,
            'BackgroundHeight': 814,
            'Bleed': 14,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 1,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-11.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-11.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-choco-ipad'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 2,
            'Active': 1,
            'ImagePath': 'templates/template-2.svg',
            'ShapeId': 2,
            'Created': '02/22/2017 13:53:08',
            'LastModified': '05/18/2017 12:10:03',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 4,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 23.076923}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 53.846154}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 23.076923}}',
            'Title': 'Layout-03'
          },
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 5,
            'Active': 1,
            'ImagePath': 'templates/template-5.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:11:50',
            'LastModified': '05/18/2017 12:10:06',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 5,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 50, h: 50}}',
            'Title': 'Layout-04'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 7,
            'Active': 1,
            'ImagePath': 'templates/template-7.svg',
            'ShapeId': 2,
            'Created': '04/27/2017 08:36:17',
            'LastModified': '05/18/2017 12:10:16',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 6,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 8, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 9, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-05'
          },
          {
            'LayoutTemplateId': 8,
            'Active': 1,
            'ImagePath': 'templates/template-8.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:48:38',
            'LastModified': '05/18/2017 12:10:12',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 7,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-06'
          },
          {
            'LayoutTemplateId': 9,
            'Active': 1,
            'ImagePath': 'templates/template-9.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:49:05',
            'LastModified': '05/18/2017 12:10:20',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 8,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-07'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          },
          {
            'LayoutTemplateId': 12,
            'Active': 1,
            'ImagePath': 'templates/template-12.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:24:43',
            'LastModified': '05/18/2017 12:10:25',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 9,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-08'
          },
          {
            'LayoutTemplateId': 13,
            'Active': 1,
            'ImagePath': 'templates/template-13.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:26:35',
            'LastModified': '06/16/2017 13:30:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Order': 10,
            'PermittedSides': 'center,top,right,bottom',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 50, h: 100}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 100}}',
            'Title': 'Layout-09'
          },
          {
            'LayoutTemplateId': 14,
            'Active': 1,
            'ImagePath': 'templates/template-14.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:27:44',
            'LastModified': '05/18/2017 12:10:33',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 11,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-10'
          },
          {
            'LayoutTemplateId': 15,
            'Active': 1,
            'ImagePath': 'templates/template-15.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:12',
            'LastModified': '05/18/2017 12:10:38',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 12,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-11'
          },
          {
            'LayoutTemplateId': 16,
            'Active': 0,
            'ImagePath': 'templates/template-16.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:35',
            'LastModified': '07/31/2019 15:15:43',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 13,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: \'hidden\', accept: \'\', dimension: {w: 100, h: 33.333333}},\r\n{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-12'
          },
          {
            'LayoutTemplateId': 17,
            'Active': 1,
            'ImagePath': 'templates/template-17.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:16',
            'LastModified': '05/18/2017 12:10:46',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 14,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 66.666666}}',
            'Title': 'Layout-13'
          },
          {
            'LayoutTemplateId': 18,
            'Active': 1,
            'ImagePath': 'templates/template-18.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:41',
            'LastModified': '05/18/2017 12:10:50',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 15,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 50}}',
            'Title': 'Layout-14'
          },
          {
            'LayoutTemplateId': 19,
            'Active': 1,
            'ImagePath': 'templates/template-19.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:30:07',
            'LastModified': '06/07/2017 12:46:48',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'Order': 16,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-15'
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 13,
            'Active': 1,
            'Order': 3,
            'Title': 'Strik',
            'ImagePath': 'stickers/sticker-13.png',
            'Size': '{Width=625, Height=335}',
            'LastModified': '05/09/2017 07:13:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:55',
            'ProductTypes': []
          },
          {
            'StickerId': 14,
            'Active': 1,
            'Order': 4,
            'Title': 'Cirkel',
            'ImagePath': 'stickers/sticker-14.png',
            'Size': '{Width=623, Height=624}',
            'LastModified': '05/09/2017 07:14:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:06',
            'ProductTypes': []
          },
          {
            'StickerId': 15,
            'Active': 1,
            'Order': 5,
            'Title': 'Spreekwolk',
            'ImagePath': 'stickers/sticker-15.png',
            'Size': '{Width=833, Height=736}',
            'LastModified': '05/09/2017 07:14:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:19',
            'ProductTypes': []
          },
          {
            'StickerId': 16,
            'Active': 1,
            'Order': 7,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-16.png',
            'Size': '{Width=662, Height=737}',
            'LastModified': '05/09/2017 07:14:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:27',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 19,
            'Active': 1,
            'Order': 10,
            'Title': 'Bril',
            'ImagePath': 'stickers/sticker-19.png',
            'Size': '{Width=688, Height=229}',
            'LastModified': '05/09/2017 07:15:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:01',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 21,
            'Active': 1,
            'Order': 12,
            'Title': 'Baby',
            'ImagePath': 'stickers/sticker-21.png',
            'Size': '{Width=729, Height=658}',
            'LastModified': '05/09/2017 07:15:47',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:47',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 23,
            'Active': 1,
            'Order': 14,
            'Title': 'Hart blauw',
            'ImagePath': 'stickers/sticker-23.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '05/09/2017 07:16:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:14',
            'ProductTypes': []
          },
          {
            'StickerId': 24,
            'Active': 1,
            'Order': 15,
            'Title': 'Ster blauw',
            'ImagePath': 'stickers/sticker-24.png',
            'Size': '{Width=625, Height=570}',
            'LastModified': '05/09/2017 07:16:24',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:24',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 26,
            'Active': 1,
            'Order': 17,
            'Title': 'Welkom kleintje',
            'ImagePath': 'stickers/sticker-26.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:16:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:56',
            'ProductTypes': []
          },
          {
            'StickerId': 27,
            'Active': 1,
            'Order': 18,
            'Title': 'Welkom kleintjes',
            'ImagePath': 'stickers/sticker-27.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:17:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:13',
            'ProductTypes': []
          },
          {
            'StickerId': 28,
            'Active': 1,
            'Order': 19,
            'Title': 'Sinasappel',
            'ImagePath': 'stickers/sticker-28.png',
            'Size': '{Width=729, Height=729}',
            'LastModified': '05/09/2017 07:17:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:25',
            'ProductTypes': []
          },
          {
            'StickerId': 29,
            'Active': 1,
            'Order': 20,
            'Title': 'Blaadje',
            'ImagePath': 'stickers/sticker-29.png',
            'Size': '{Width=717, Height=238}',
            'LastModified': '05/09/2017 07:17:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:37',
            'ProductTypes': []
          },
          {
            'StickerId': 30,
            'Active': 1,
            'Order': 21,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-30.png',
            'Size': '{Width=359, Height=931}',
            'LastModified': '05/09/2017 07:17:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:48',
            'ProductTypes': []
          },
          {
            'StickerId': 31,
            'Active': 1,
            'Order': 22,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-31.png',
            'Size': '{Width=383, Height=942}',
            'LastModified': '05/09/2017 07:18:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:02',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 33,
            'Active': 1,
            'Order': 24,
            'Title': 'Ananas',
            'ImagePath': 'stickers/sticker-33.png',
            'Size': '{Width=405, Height=738}',
            'LastModified': '05/09/2017 07:18:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:28',
            'ProductTypes': []
          },
          {
            'StickerId': 34,
            'Active': 1,
            'Order': 25,
            'Title': 'Herfst blaadjes',
            'ImagePath': 'stickers/sticker-34.png',
            'Size': '{Width=255, Height=546}',
            'LastModified': '05/09/2017 07:18:46',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:46',
            'ProductTypes': []
          },
          {
            'StickerId': 35,
            'Active': 1,
            'Order': 26,
            'Title': 'Winter',
            'ImagePath': 'stickers/sticker-35.png',
            'Size': '{Width=476, Height=785}',
            'LastModified': '05/09/2017 07:18:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:59',
            'ProductTypes': []
          },
          {
            'StickerId': 36,
            'Active': 1,
            'Order': 27,
            'Title': 'Astronaut',
            'ImagePath': 'stickers/sticker-36.png',
            'Size': '{Width=589, Height=988}',
            'LastModified': '05/09/2017 07:19:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:14',
            'ProductTypes': []
          },
          {
            'StickerId': 37,
            'Active': 1,
            'Order': 28,
            'Title': 'Jarig',
            'ImagePath': 'stickers/sticker-37.png',
            'Size': '{Width=1036, Height=1026}',
            'LastModified': '05/09/2017 07:19:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:26',
            'ProductTypes': []
          },
          {
            'StickerId': 38,
            'Active': 1,
            'Order': 29,
            'Title': 'Kikker',
            'ImagePath': 'stickers/sticker-38.png',
            'Size': '{Width=1042, Height=1040}',
            'LastModified': '05/09/2017 07:19:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:38',
            'ProductTypes': []
          },
          {
            'StickerId': 39,
            'Active': 1,
            'Order': 30,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-39.png',
            'Size': '{Width=1042, Height=651}',
            'LastModified': '05/09/2017 07:19:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:56',
            'ProductTypes': []
          },
          {
            'StickerId': 40,
            'Active': 1,
            'Order': 31,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-40.png',
            'Size': '{Width=988, Height=311}',
            'LastModified': '05/09/2017 07:20:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:13',
            'ProductTypes': []
          },
          {
            'StickerId': 41,
            'Active': 1,
            'Order': 32,
            'Title': 'Piratenmuts',
            'ImagePath': 'stickers/sticker-41.png',
            'Size': '{Width=1042, Height=591}',
            'LastModified': '05/09/2017 07:20:34',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:34',
            'ProductTypes': []
          },
          {
            'StickerId': 42,
            'Active': 1,
            'Order': 33,
            'Title': 'Takkie',
            'ImagePath': 'stickers/sticker-42.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:20:45',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:45',
            'ProductTypes': []
          },
          {
            'StickerId': 43,
            'Active': 1,
            'Order': 34,
            'Title': 'Ballon geel',
            'ImagePath': 'stickers/sticker-43.png',
            'Size': '{Width=377, Height=1024}',
            'LastModified': '05/09/2017 07:20:58',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:58',
            'ProductTypes': []
          },
          {
            'StickerId': 44,
            'Active': 1,
            'Order': 35,
            'Title': 'Getrouwd',
            'ImagePath': 'stickers/sticker-44.png',
            'Size': '{Width=1028, Height=349}',
            'LastModified': '05/09/2017 07:21:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:11',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 46,
            'Active': 1,
            'Order': 37,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-46.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:21:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:57',
            'ProductTypes': []
          },
          {
            'StickerId': 47,
            'Active': 1,
            'Order': 38,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-47.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:22:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:19',
            'ProductTypes': []
          },
          {
            'StickerId': 48,
            'Active': 1,
            'Order': 39,
            'Title': 'Papagaai',
            'ImagePath': 'stickers/sticker-48.png',
            'Size': '{Width=1042, Height=928}',
            'LastModified': '05/09/2017 07:22:30',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:30',
            'ProductTypes': []
          },
          {
            'StickerId': 49,
            'Active': 1,
            'Order': 40,
            'Title': 'Robot',
            'ImagePath': 'stickers/sticker-49.png',
            'Size': '{Width=674, Height=1009}',
            'LastModified': '05/09/2017 07:22:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:43',
            'ProductTypes': []
          },
          {
            'StickerId': 50,
            'Active': 1,
            'Order': 41,
            'Title': 'The king',
            'ImagePath': 'stickers/sticker-50.png',
            'Size': '{Width=1044, Height=197}',
            'LastModified': '05/09/2017 07:22:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:55',
            'ProductTypes': []
          },
          {
            'StickerId': 51,
            'Active': 1,
            'Order': 42,
            'Title': 'Ballonnen groen',
            'ImagePath': 'stickers/sticker-51.png',
            'Size': '{Width=785, Height=1007}',
            'LastModified': '05/09/2017 07:23:10',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:10',
            'ProductTypes': []
          },
          {
            'StickerId': 52,
            'Active': 1,
            'Order': 43,
            'Title': 'Je bent mijn liefste',
            'ImagePath': 'stickers/sticker-52.png',
            'Size': '{Width=487, Height=1042}',
            'LastModified': '05/09/2017 07:23:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:27',
            'ProductTypes': []
          },
          {
            'StickerId': 53,
            'Active': 1,
            'Order': 44,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-53.png',
            'Size': '{Width=1038, Height=948}',
            'LastModified': '05/09/2017 07:23:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:37',
            'ProductTypes': []
          },
          {
            'StickerId': 54,
            'Active': 1,
            'Order': 45,
            'Title': 'Racket',
            'ImagePath': 'stickers/sticker-54.png',
            'Size': '{Width=420, Height=1016}',
            'LastModified': '05/09/2017 07:23:49',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:49',
            'ProductTypes': []
          },
          {
            'StickerId': 55,
            'Active': 1,
            'Order': 46,
            'Title': 'Zwaard',
            'ImagePath': 'stickers/sticker-55.png',
            'Size': '{Width=461, Height=1042}',
            'LastModified': '05/09/2017 07:24:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:01',
            'ProductTypes': []
          },
          {
            'StickerId': 56,
            'Active': 1,
            'Order': 47,
            'Title': 'Hoeravlag',
            'ImagePath': 'stickers/sticker-56.png',
            'Size': '{Width=1045, Height=252}',
            'LastModified': '05/09/2017 07:24:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:13',
            'ProductTypes': []
          },
          {
            'StickerId': 57,
            'Active': 1,
            'Order': 48,
            'Title': 'Rood hartje',
            'ImagePath': 'stickers/sticker-57.png',
            'Size': '{Width=624, Height=1007}',
            'LastModified': '05/09/2017 07:24:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:27',
            'ProductTypes': []
          },
          {
            'StickerId': 58,
            'Active': 1,
            'Order': 49,
            'Title': 'Hoera banner',
            'ImagePath': 'stickers/sticker-58.png',
            'Size': '{Width=1029, Height=530}',
            'LastModified': '05/09/2017 07:24:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:48',
            'ProductTypes': []
          },
          {
            'StickerId': 59,
            'Active': 1,
            'Order': 50,
            'Title': 'Raket',
            'ImagePath': 'stickers/sticker-59.png',
            'Size': '{Width=659, Height=984}',
            'LastModified': '05/09/2017 07:25:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:05',
            'ProductTypes': []
          },
          {
            'StickerId': 60,
            'Active': 1,
            'Order': 51,
            'Title': 'Twee hartjes',
            'ImagePath': 'stickers/sticker-60.png',
            'Size': '{Width=968, Height=754}',
            'LastModified': '05/09/2017 07:25:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:18',
            'ProductTypes': []
          },
          {
            'StickerId': 61,
            'Active': 1,
            'Order': 52,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-61.png',
            'Size': '{Width=995, Height=543}',
            'LastModified': '05/09/2017 07:25:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:31',
            'ProductTypes': []
          },
          {
            'StickerId': 62,
            'Active': 1,
            'Order': 53,
            'Title': 'Lijn hartjes',
            'ImagePath': 'stickers/sticker-62.png',
            'Size': '{Width=982, Height=958}',
            'LastModified': '05/09/2017 07:25:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:43',
            'ProductTypes': []
          },
          {
            'StickerId': 63,
            'Active': 1,
            'Order': 54,
            'Title': 'Roze hartje',
            'ImagePath': 'stickers/sticker-63.png',
            'Size': '{Width=624, Height=1017}',
            'LastModified': '05/09/2017 07:26:23',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:23',
            'ProductTypes': []
          },
          {
            'StickerId': 64,
            'Active': 1,
            'Order': 55,
            'Title': 'Ufo',
            'ImagePath': 'stickers/sticker-64.png',
            'Size': '{Width=914, Height=958}',
            'LastModified': '05/09/2017 07:26:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:32',
            'ProductTypes': []
          },
          {
            'StickerId': 65,
            'Active': 1,
            'Order': 56,
            'Title': 'Kadootje',
            'ImagePath': 'stickers/sticker-65.png',
            'Size': '{Width=706, Height=1012}',
            'LastModified': '05/09/2017 07:26:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:42',
            'ProductTypes': []
          },
          {
            'StickerId': 66,
            'Active': 1,
            'Order': 57,
            'Title': 'Ring',
            'ImagePath': 'stickers/sticker-66.png',
            'Size': '{Width=620, Height=1001}',
            'LastModified': '05/09/2017 07:26:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:51',
            'ProductTypes': []
          },
          {
            'StickerId': 67,
            'Active': 1,
            'Order': 58,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-67.png',
            'Size': '{Width=1020, Height=947}',
            'LastModified': '05/09/2017 07:27:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:01',
            'ProductTypes': []
          },
          {
            'StickerId': 68,
            'Active': 1,
            'Order': 59,
            'Title': 'Bowtie',
            'ImagePath': 'stickers/sticker-68.png',
            'Size': '{Width=1017, Height=514}',
            'LastModified': '05/09/2017 07:27:09',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:09',
            'ProductTypes': []
          },
          {
            'StickerId': 69,
            'Active': 1,
            'Order': 60,
            'Title': 'Confetti',
            'ImagePath': 'stickers/sticker-69.png',
            'Size': '{Width=333, Height=995}',
            'LastModified': '05/09/2017 07:27:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:21',
            'ProductTypes': []
          },
          {
            'StickerId': 70,
            'Active': 1,
            'Order': 61,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-70.png',
            'Size': '{Width=898, Height=1006}',
            'LastModified': '05/09/2017 07:27:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:33',
            'ProductTypes': []
          },
          {
            'StickerId': 71,
            'Active': 1,
            'Order': 62,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-71.png',
            'Size': '{Width=1027, Height=573}',
            'LastModified': '05/09/2017 07:27:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:42',
            'ProductTypes': []
          },
          {
            'StickerId': 72,
            'Active': 1,
            'Order': 63,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-72.png',
            'Size': '{Width=797, Height=985}',
            'LastModified': '05/09/2017 07:27:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:55',
            'ProductTypes': []
          },
          {
            'StickerId': 73,
            'Active': 1,
            'Order': 64,
            'Title': 'Mr',
            'ImagePath': 'stickers/sticker-73.png',
            'Size': '{Width=1038, Height=932}',
            'LastModified': '05/09/2017 07:28:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:07',
            'ProductTypes': []
          },
          {
            'StickerId': 74,
            'Active': 1,
            'Order': 65,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-74.png',
            'Size': '{Width=708, Height=990}',
            'LastModified': '05/09/2017 07:28:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:18',
            'ProductTypes': []
          },
          {
            'StickerId': 75,
            'Active': 1,
            'Order': 66,
            'Title': 'Ms',
            'ImagePath': 'stickers/sticker-75.png',
            'Size': '{Width=1031, Height=971}',
            'LastModified': '05/09/2017 07:28:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:32',
            'ProductTypes': []
          },
          {
            'StickerId': 76,
            'Active': 1,
            'Order': 67,
            'Title': 'Rainbow',
            'ImagePath': 'stickers/sticker-76.png',
            'Size': '{Width=1010, Height=659}',
            'LastModified': '05/09/2017 07:28:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:42',
            'ProductTypes': []
          },
          {
            'StickerId': 77,
            'Active': 1,
            'Order': 68,
            'Title': 'Champagne',
            'ImagePath': 'stickers/sticker-77.png',
            'Size': '{Width=341, Height=1006}',
            'LastModified': '05/09/2017 07:28:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:56',
            'ProductTypes': []
          },
          {
            'StickerId': 78,
            'Active': 1,
            'Order': 69,
            'Title': 'Hartjes',
            'ImagePath': 'stickers/sticker-78.png',
            'Size': '{Width=951, Height=571}',
            'LastModified': '05/09/2017 07:29:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:06',
            'ProductTypes': []
          },
          {
            'StickerId': 79,
            'Active': 1,
            'Order': 70,
            'Title': 'You are just lovely',
            'ImagePath': 'stickers/sticker-79.png',
            'Size': '{Width=987, Height=899}',
            'LastModified': '05/09/2017 07:29:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:26',
            'ProductTypes': []
          },
          {
            'StickerId': 80,
            'Active': 1,
            'Order': 71,
            'Title': 'Medaille',
            'ImagePath': 'stickers/sticker-80.png',
            'Size': '{Width=591, Height=1018}',
            'LastModified': '05/09/2017 07:29:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:40',
            'ProductTypes': []
          },
          {
            'StickerId': 81,
            'Active': 1,
            'Order': 72,
            'Title': 'Pluk de dag',
            'ImagePath': 'stickers/sticker-81.png',
            'Size': '{Width=509, Height=1042}',
            'LastModified': '05/09/2017 07:29:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:51',
            'ProductTypes': []
          },
          {
            'StickerId': 82,
            'Active': 1,
            'Order': 73,
            'Title': 'Zon',
            'ImagePath': 'stickers/sticker-82.png',
            'Size': '{Width=1033, Height=1005}',
            'LastModified': '05/09/2017 07:30:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:01',
            'ProductTypes': []
          },
          {
            'StickerId': 83,
            'Active': 1,
            'Order': 74,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-83.png',
            'Size': '{Width=997, Height=646}',
            'LastModified': '05/09/2017 07:30:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:11',
            'ProductTypes': []
          },
          {
            'StickerId': 84,
            'Active': 1,
            'Order': 75,
            'Title': 'Hartjesdoos mama',
            'ImagePath': 'stickers/sticker-84.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:28',
            'ProductTypes': []
          },
          {
            'StickerId': 85,
            'Active': 1,
            'Order': 76,
            'Title': 'Hartjesdoos',
            'ImagePath': 'stickers/sticker-85.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:41',
            'ProductTypes': []
          },
          {
            'StickerId': 86,
            'Active': 1,
            'Order': 77,
            'Title': 'Wolk rain',
            'ImagePath': 'stickers/sticker-86.png',
            'Size': '{Width=1002, Height=948}',
            'LastModified': '05/09/2017 07:30:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:54',
            'ProductTypes': []
          },
          {
            'StickerId': 87,
            'Active': 1,
            'Order': 78,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-87.png',
            'Size': '{Width=1025, Height=721}',
            'LastModified': '05/09/2017 07:31:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:05',
            'ProductTypes': []
          },
          {
            'StickerId': 88,
            'Active': 1,
            'Order': 79,
            'Title': 'Hartje mama',
            'ImagePath': 'stickers/sticker-88.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:32',
            'ProductTypes': []
          },
          {
            'StickerId': 89,
            'Active': 1,
            'Order': 80,
            'Title': 'Hartje',
            'ImagePath': 'stickers/sticker-89.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:42',
            'ProductTypes': []
          },
          {
            'StickerId': 90,
            'Active': 1,
            'Order': 81,
            'Title': 'Wolk donder',
            'ImagePath': 'stickers/sticker-90.png',
            'Size': '{Width=878, Height=998}',
            'LastModified': '05/09/2017 07:40:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:00',
            'ProductTypes': []
          },
          {
            'StickerId': 91,
            'Active': 1,
            'Order': 82,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-91.png',
            'Size': '{Width=1013, Height=1013}',
            'LastModified': '05/09/2017 07:40:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:14',
            'ProductTypes': []
          },
          {
            'StickerId': 92,
            'Active': 1,
            'Order': 83,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-92.png',
            'Size': '{Width=768, Height=1013}',
            'LastModified': '05/09/2017 07:40:44',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:44',
            'ProductTypes': []
          },
          {
            'StickerId': 93,
            'Active': 1,
            'Order': 84,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-93.png',
            'Size': '{Width=1009, Height=1022}',
            'LastModified': '05/09/2017 07:40:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:54',
            'ProductTypes': []
          },
          {
            'StickerId': 94,
            'Active': 1,
            'Order': 85,
            'Title': 'Zwemband',
            'ImagePath': 'stickers/sticker-94.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:41:04',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:04',
            'ProductTypes': []
          },
          {
            'StickerId': 95,
            'Active': 1,
            'Order': 86,
            'Title': 'Plons',
            'ImagePath': 'stickers/sticker-95.png',
            'Size': '{Width=1033, Height=430}',
            'LastModified': '05/09/2017 07:41:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:17',
            'ProductTypes': []
          },
          {
            'StickerId': 96,
            'Active': 1,
            'Order': 87,
            'Title': 'Zwemdiploma',
            'ImagePath': 'stickers/sticker-96.png',
            'Size': '{Width=1019, Height=121}',
            'LastModified': '05/09/2017 07:41:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:29',
            'ProductTypes': []
          },
          {
            'StickerId': 97,
            'Active': 1,
            'Order': 88,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-97.png',
            'Size': '{Width=719, Height=1044}',
            'LastModified': '05/09/2017 07:41:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:41',
            'ProductTypes': []
          },
          {
            'StickerId': 98,
            'Active': 1,
            'Order': 89,
            'Title': 'New home',
            'ImagePath': 'stickers/sticker-98.png',
            'Size': '{Width=835, Height=1042}',
            'LastModified': '05/09/2017 07:41:52',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:52',
            'ProductTypes': []
          },
          {
            'StickerId': 99,
            'Active': 1,
            'Order': 90,
            'Title': 'Sportheld',
            'ImagePath': 'stickers/sticker-99.png',
            'Size': '{Width=925, Height=1040}',
            'LastModified': '05/09/2017 07:42:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:02',
            'ProductTypes': []
          },
          {
            'StickerId': 100,
            'Active': 1,
            'Order': 91,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-100.png',
            'Size': '{Width=855, Height=1042}',
            'LastModified': '05/09/2017 07:42:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:12',
            'ProductTypes': []
          },
          {
            'StickerId': 101,
            'Active': 1,
            'Order': 92,
            'Title': 'Present',
            'ImagePath': 'stickers/sticker-101.png',
            'Size': '{Width=714, Height=1004}',
            'LastModified': '05/09/2017 07:42:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:21',
            'ProductTypes': []
          },
          {
            'StickerId': 102,
            'Active': 1,
            'Order': 93,
            'Title': 'Bird',
            'ImagePath': 'stickers/sticker-102.png',
            'Size': '{Width=1031, Height=720}',
            'LastModified': '05/09/2017 07:42:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:31',
            'ProductTypes': []
          },
          {
            'StickerId': 103,
            'Active': 1,
            'Order': 94,
            'Title': 'Snowflake',
            'ImagePath': 'stickers/sticker-103.png',
            'Size': '{Width=922, Height=1000}',
            'LastModified': '10/11/2022 14:35:16',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:40',
            'ProductTypes': []
          },
          {
            'StickerId': 104,
            'Active': 1,
            'Order': 95,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-104.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:53',
            'ProductTypes': []
          },
          {
            'StickerId': 105,
            'Active': 1,
            'Order': 96,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-105.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:57',
            'ProductTypes': []
          },
          {
            'StickerId': 106,
            'Active': 1,
            'Order': 97,
            'Title': 'Bat',
            'ImagePath': 'stickers/sticker-106.png',
            'Size': '{Width=1042, Height=315}',
            'LastModified': '10/11/2022 14:35:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:07',
            'ProductTypes': []
          },
          {
            'StickerId': 107,
            'Active': 1,
            'Order': 98,
            'Title': 'Hoera een jongen',
            'ImagePath': 'stickers/sticker-107.png',
            'Size': '{Width=734, Height=1042}',
            'LastModified': '05/09/2017 07:43:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:21',
            'ProductTypes': []
          },
          {
            'StickerId': 108,
            'Active': 1,
            'Order': 99,
            'Title': 'Bedankt',
            'ImagePath': 'stickers/sticker-108.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:43:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:32',
            'ProductTypes': []
          },
          {
            'StickerId': 109,
            'Active': 1,
            'Order': 100,
            'Title': 'Pumpkin',
            'ImagePath': 'stickers/sticker-109.png',
            'Size': '{Width=1042, Height=763}',
            'LastModified': '10/11/2022 14:35:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:47',
            'ProductTypes': []
          },
          {
            'StickerId': 110,
            'Active': 1,
            'Order': 101,
            'Title': 'Stoplicht',
            'ImagePath': 'stickers/sticker-110.png',
            'Size': '{Width=288, Height=1032}',
            'LastModified': '05/09/2017 07:44:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:00',
            'ProductTypes': []
          },
          {
            'StickerId': 111,
            'Active': 1,
            'Order': 102,
            'Title': 'Hoera rijbewijs',
            'ImagePath': 'stickers/sticker-111.png',
            'Size': '{Width=1040, Height=632}',
            'LastModified': '05/09/2017 07:44:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:14',
            'ProductTypes': []
          },
          {
            'StickerId': 112,
            'Active': 1,
            'Order': 103,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-112.png',
            'Size': '{Width=997, Height=997}',
            'LastModified': '05/09/2017 07:44:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:25',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 10,
        'Name': 'choco-iphone-cake-308x544',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1198,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1198.jpg',
            'Order': 463,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_bruinzwart',
            'LastModifiedBy': 'HEMALOCAL\\Satinkt',
            'LastModified': '07/24/2017 15:56:13',
            'Categories': [],
            'Created': '07/24/2017 15:56:13',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1212,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1212.jpg',
            'Order': 476,
            'Size': '{Width=301, Height=537}',
            'Title': 'choco iphone_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:18:31',
            'Categories': [],
            'Created': '07/26/2017 08:18:31',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 17,
            'Title': 'Montserrat',
            'ImagePath': 'fonts/font-17.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 14,
            'Order': 5,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '08/15/2017 12:04:47',
            'LastModifiedBy': 'HEMALOCAL\\emdvorobiova',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 22,
            'Title': 'Bungee',
            'ImagePath': 'fonts/font-22.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 9,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/22/2017 06:29:11',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:25:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 12,
            'Title': '6380004',
            'Created': '05/16/2017 14:21:37',
            'LastModified': '03/07/2018 09:33:54',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 10,
            'ShapeId': 2,
            'Width': 308,
            'Height': 544,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-choco-iphone',
            'BackgroundWidth': 332,
            'BackgroundHeight': 686,
            'Bleed': 10,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': true,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-12.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-12.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-choco-iphone'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 2,
            'Active': 1,
            'ImagePath': 'templates/template-2.svg',
            'ShapeId': 2,
            'Created': '02/22/2017 13:53:08',
            'LastModified': '05/18/2017 12:10:03',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 4,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 23.076923}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 53.846154}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 23.076923}}',
            'Title': 'Layout-03'
          },
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 5,
            'Active': 1,
            'ImagePath': 'templates/template-5.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:11:50',
            'LastModified': '05/18/2017 12:10:06',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 5,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 50, h: 50}}',
            'Title': 'Layout-04'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 7,
            'Active': 1,
            'ImagePath': 'templates/template-7.svg',
            'ShapeId': 2,
            'Created': '04/27/2017 08:36:17',
            'LastModified': '05/18/2017 12:10:16',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 6,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 8, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 9, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-05'
          },
          {
            'LayoutTemplateId': 8,
            'Active': 1,
            'ImagePath': 'templates/template-8.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:48:38',
            'LastModified': '05/18/2017 12:10:12',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 7,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-06'
          },
          {
            'LayoutTemplateId': 9,
            'Active': 1,
            'ImagePath': 'templates/template-9.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:49:05',
            'LastModified': '05/18/2017 12:10:20',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 8,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-07'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          },
          {
            'LayoutTemplateId': 12,
            'Active': 1,
            'ImagePath': 'templates/template-12.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:24:43',
            'LastModified': '05/18/2017 12:10:25',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 9,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-08'
          },
          {
            'LayoutTemplateId': 13,
            'Active': 1,
            'ImagePath': 'templates/template-13.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:26:35',
            'LastModified': '06/16/2017 13:30:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Order': 10,
            'PermittedSides': 'center,top,right,bottom',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 50, h: 100}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 100}}',
            'Title': 'Layout-09'
          },
          {
            'LayoutTemplateId': 14,
            'Active': 1,
            'ImagePath': 'templates/template-14.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:27:44',
            'LastModified': '05/18/2017 12:10:33',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 11,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-10'
          },
          {
            'LayoutTemplateId': 15,
            'Active': 1,
            'ImagePath': 'templates/template-15.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:12',
            'LastModified': '05/18/2017 12:10:38',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 12,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-11'
          },
          {
            'LayoutTemplateId': 16,
            'Active': 0,
            'ImagePath': 'templates/template-16.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:35',
            'LastModified': '07/31/2019 15:15:43',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 13,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: \'hidden\', accept: \'\', dimension: {w: 100, h: 33.333333}},\r\n{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-12'
          },
          {
            'LayoutTemplateId': 17,
            'Active': 1,
            'ImagePath': 'templates/template-17.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:16',
            'LastModified': '05/18/2017 12:10:46',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 14,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 66.666666}}',
            'Title': 'Layout-13'
          },
          {
            'LayoutTemplateId': 18,
            'Active': 1,
            'ImagePath': 'templates/template-18.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:41',
            'LastModified': '05/18/2017 12:10:50',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 15,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 50}}',
            'Title': 'Layout-14'
          },
          {
            'LayoutTemplateId': 19,
            'Active': 1,
            'ImagePath': 'templates/template-19.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:30:07',
            'LastModified': '06/07/2017 12:46:48',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'Order': 16,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-15'
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 13,
            'Active': 1,
            'Order': 3,
            'Title': 'Strik',
            'ImagePath': 'stickers/sticker-13.png',
            'Size': '{Width=625, Height=335}',
            'LastModified': '05/09/2017 07:13:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:55',
            'ProductTypes': []
          },
          {
            'StickerId': 14,
            'Active': 1,
            'Order': 4,
            'Title': 'Cirkel',
            'ImagePath': 'stickers/sticker-14.png',
            'Size': '{Width=623, Height=624}',
            'LastModified': '05/09/2017 07:14:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:06',
            'ProductTypes': []
          },
          {
            'StickerId': 15,
            'Active': 1,
            'Order': 5,
            'Title': 'Spreekwolk',
            'ImagePath': 'stickers/sticker-15.png',
            'Size': '{Width=833, Height=736}',
            'LastModified': '05/09/2017 07:14:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:19',
            'ProductTypes': []
          },
          {
            'StickerId': 16,
            'Active': 1,
            'Order': 7,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-16.png',
            'Size': '{Width=662, Height=737}',
            'LastModified': '05/09/2017 07:14:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:27',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 19,
            'Active': 1,
            'Order': 10,
            'Title': 'Bril',
            'ImagePath': 'stickers/sticker-19.png',
            'Size': '{Width=688, Height=229}',
            'LastModified': '05/09/2017 07:15:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:01',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 21,
            'Active': 1,
            'Order': 12,
            'Title': 'Baby',
            'ImagePath': 'stickers/sticker-21.png',
            'Size': '{Width=729, Height=658}',
            'LastModified': '05/09/2017 07:15:47',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:47',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 23,
            'Active': 1,
            'Order': 14,
            'Title': 'Hart blauw',
            'ImagePath': 'stickers/sticker-23.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '05/09/2017 07:16:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:14',
            'ProductTypes': []
          },
          {
            'StickerId': 24,
            'Active': 1,
            'Order': 15,
            'Title': 'Ster blauw',
            'ImagePath': 'stickers/sticker-24.png',
            'Size': '{Width=625, Height=570}',
            'LastModified': '05/09/2017 07:16:24',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:24',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 26,
            'Active': 1,
            'Order': 17,
            'Title': 'Welkom kleintje',
            'ImagePath': 'stickers/sticker-26.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:16:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:56',
            'ProductTypes': []
          },
          {
            'StickerId': 27,
            'Active': 1,
            'Order': 18,
            'Title': 'Welkom kleintjes',
            'ImagePath': 'stickers/sticker-27.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:17:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:13',
            'ProductTypes': []
          },
          {
            'StickerId': 28,
            'Active': 1,
            'Order': 19,
            'Title': 'Sinasappel',
            'ImagePath': 'stickers/sticker-28.png',
            'Size': '{Width=729, Height=729}',
            'LastModified': '05/09/2017 07:17:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:25',
            'ProductTypes': []
          },
          {
            'StickerId': 29,
            'Active': 1,
            'Order': 20,
            'Title': 'Blaadje',
            'ImagePath': 'stickers/sticker-29.png',
            'Size': '{Width=717, Height=238}',
            'LastModified': '05/09/2017 07:17:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:37',
            'ProductTypes': []
          },
          {
            'StickerId': 30,
            'Active': 1,
            'Order': 21,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-30.png',
            'Size': '{Width=359, Height=931}',
            'LastModified': '05/09/2017 07:17:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:48',
            'ProductTypes': []
          },
          {
            'StickerId': 31,
            'Active': 1,
            'Order': 22,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-31.png',
            'Size': '{Width=383, Height=942}',
            'LastModified': '05/09/2017 07:18:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:02',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 33,
            'Active': 1,
            'Order': 24,
            'Title': 'Ananas',
            'ImagePath': 'stickers/sticker-33.png',
            'Size': '{Width=405, Height=738}',
            'LastModified': '05/09/2017 07:18:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:28',
            'ProductTypes': []
          },
          {
            'StickerId': 34,
            'Active': 1,
            'Order': 25,
            'Title': 'Herfst blaadjes',
            'ImagePath': 'stickers/sticker-34.png',
            'Size': '{Width=255, Height=546}',
            'LastModified': '05/09/2017 07:18:46',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:46',
            'ProductTypes': []
          },
          {
            'StickerId': 35,
            'Active': 1,
            'Order': 26,
            'Title': 'Winter',
            'ImagePath': 'stickers/sticker-35.png',
            'Size': '{Width=476, Height=785}',
            'LastModified': '05/09/2017 07:18:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:59',
            'ProductTypes': []
          },
          {
            'StickerId': 36,
            'Active': 1,
            'Order': 27,
            'Title': 'Astronaut',
            'ImagePath': 'stickers/sticker-36.png',
            'Size': '{Width=589, Height=988}',
            'LastModified': '05/09/2017 07:19:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:14',
            'ProductTypes': []
          },
          {
            'StickerId': 37,
            'Active': 1,
            'Order': 28,
            'Title': 'Jarig',
            'ImagePath': 'stickers/sticker-37.png',
            'Size': '{Width=1036, Height=1026}',
            'LastModified': '05/09/2017 07:19:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:26',
            'ProductTypes': []
          },
          {
            'StickerId': 38,
            'Active': 1,
            'Order': 29,
            'Title': 'Kikker',
            'ImagePath': 'stickers/sticker-38.png',
            'Size': '{Width=1042, Height=1040}',
            'LastModified': '05/09/2017 07:19:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:38',
            'ProductTypes': []
          },
          {
            'StickerId': 39,
            'Active': 1,
            'Order': 30,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-39.png',
            'Size': '{Width=1042, Height=651}',
            'LastModified': '05/09/2017 07:19:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:56',
            'ProductTypes': []
          },
          {
            'StickerId': 40,
            'Active': 1,
            'Order': 31,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-40.png',
            'Size': '{Width=988, Height=311}',
            'LastModified': '05/09/2017 07:20:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:13',
            'ProductTypes': []
          },
          {
            'StickerId': 41,
            'Active': 1,
            'Order': 32,
            'Title': 'Piratenmuts',
            'ImagePath': 'stickers/sticker-41.png',
            'Size': '{Width=1042, Height=591}',
            'LastModified': '05/09/2017 07:20:34',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:34',
            'ProductTypes': []
          },
          {
            'StickerId': 42,
            'Active': 1,
            'Order': 33,
            'Title': 'Takkie',
            'ImagePath': 'stickers/sticker-42.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:20:45',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:45',
            'ProductTypes': []
          },
          {
            'StickerId': 43,
            'Active': 1,
            'Order': 34,
            'Title': 'Ballon geel',
            'ImagePath': 'stickers/sticker-43.png',
            'Size': '{Width=377, Height=1024}',
            'LastModified': '05/09/2017 07:20:58',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:58',
            'ProductTypes': []
          },
          {
            'StickerId': 44,
            'Active': 1,
            'Order': 35,
            'Title': 'Getrouwd',
            'ImagePath': 'stickers/sticker-44.png',
            'Size': '{Width=1028, Height=349}',
            'LastModified': '05/09/2017 07:21:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:11',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 46,
            'Active': 1,
            'Order': 37,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-46.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:21:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:57',
            'ProductTypes': []
          },
          {
            'StickerId': 47,
            'Active': 1,
            'Order': 38,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-47.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:22:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:19',
            'ProductTypes': []
          },
          {
            'StickerId': 48,
            'Active': 1,
            'Order': 39,
            'Title': 'Papagaai',
            'ImagePath': 'stickers/sticker-48.png',
            'Size': '{Width=1042, Height=928}',
            'LastModified': '05/09/2017 07:22:30',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:30',
            'ProductTypes': []
          },
          {
            'StickerId': 49,
            'Active': 1,
            'Order': 40,
            'Title': 'Robot',
            'ImagePath': 'stickers/sticker-49.png',
            'Size': '{Width=674, Height=1009}',
            'LastModified': '05/09/2017 07:22:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:43',
            'ProductTypes': []
          },
          {
            'StickerId': 50,
            'Active': 1,
            'Order': 41,
            'Title': 'The king',
            'ImagePath': 'stickers/sticker-50.png',
            'Size': '{Width=1044, Height=197}',
            'LastModified': '05/09/2017 07:22:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:55',
            'ProductTypes': []
          },
          {
            'StickerId': 51,
            'Active': 1,
            'Order': 42,
            'Title': 'Ballonnen groen',
            'ImagePath': 'stickers/sticker-51.png',
            'Size': '{Width=785, Height=1007}',
            'LastModified': '05/09/2017 07:23:10',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:10',
            'ProductTypes': []
          },
          {
            'StickerId': 52,
            'Active': 1,
            'Order': 43,
            'Title': 'Je bent mijn liefste',
            'ImagePath': 'stickers/sticker-52.png',
            'Size': '{Width=487, Height=1042}',
            'LastModified': '05/09/2017 07:23:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:27',
            'ProductTypes': []
          },
          {
            'StickerId': 53,
            'Active': 1,
            'Order': 44,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-53.png',
            'Size': '{Width=1038, Height=948}',
            'LastModified': '05/09/2017 07:23:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:37',
            'ProductTypes': []
          },
          {
            'StickerId': 54,
            'Active': 1,
            'Order': 45,
            'Title': 'Racket',
            'ImagePath': 'stickers/sticker-54.png',
            'Size': '{Width=420, Height=1016}',
            'LastModified': '05/09/2017 07:23:49',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:49',
            'ProductTypes': []
          },
          {
            'StickerId': 55,
            'Active': 1,
            'Order': 46,
            'Title': 'Zwaard',
            'ImagePath': 'stickers/sticker-55.png',
            'Size': '{Width=461, Height=1042}',
            'LastModified': '05/09/2017 07:24:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:01',
            'ProductTypes': []
          },
          {
            'StickerId': 56,
            'Active': 1,
            'Order': 47,
            'Title': 'Hoeravlag',
            'ImagePath': 'stickers/sticker-56.png',
            'Size': '{Width=1045, Height=252}',
            'LastModified': '05/09/2017 07:24:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:13',
            'ProductTypes': []
          },
          {
            'StickerId': 57,
            'Active': 1,
            'Order': 48,
            'Title': 'Rood hartje',
            'ImagePath': 'stickers/sticker-57.png',
            'Size': '{Width=624, Height=1007}',
            'LastModified': '05/09/2017 07:24:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:27',
            'ProductTypes': []
          },
          {
            'StickerId': 58,
            'Active': 1,
            'Order': 49,
            'Title': 'Hoera banner',
            'ImagePath': 'stickers/sticker-58.png',
            'Size': '{Width=1029, Height=530}',
            'LastModified': '05/09/2017 07:24:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:48',
            'ProductTypes': []
          },
          {
            'StickerId': 59,
            'Active': 1,
            'Order': 50,
            'Title': 'Raket',
            'ImagePath': 'stickers/sticker-59.png',
            'Size': '{Width=659, Height=984}',
            'LastModified': '05/09/2017 07:25:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:05',
            'ProductTypes': []
          },
          {
            'StickerId': 60,
            'Active': 1,
            'Order': 51,
            'Title': 'Twee hartjes',
            'ImagePath': 'stickers/sticker-60.png',
            'Size': '{Width=968, Height=754}',
            'LastModified': '05/09/2017 07:25:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:18',
            'ProductTypes': []
          },
          {
            'StickerId': 61,
            'Active': 1,
            'Order': 52,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-61.png',
            'Size': '{Width=995, Height=543}',
            'LastModified': '05/09/2017 07:25:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:31',
            'ProductTypes': []
          },
          {
            'StickerId': 62,
            'Active': 1,
            'Order': 53,
            'Title': 'Lijn hartjes',
            'ImagePath': 'stickers/sticker-62.png',
            'Size': '{Width=982, Height=958}',
            'LastModified': '05/09/2017 07:25:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:43',
            'ProductTypes': []
          },
          {
            'StickerId': 63,
            'Active': 1,
            'Order': 54,
            'Title': 'Roze hartje',
            'ImagePath': 'stickers/sticker-63.png',
            'Size': '{Width=624, Height=1017}',
            'LastModified': '05/09/2017 07:26:23',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:23',
            'ProductTypes': []
          },
          {
            'StickerId': 64,
            'Active': 1,
            'Order': 55,
            'Title': 'Ufo',
            'ImagePath': 'stickers/sticker-64.png',
            'Size': '{Width=914, Height=958}',
            'LastModified': '05/09/2017 07:26:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:32',
            'ProductTypes': []
          },
          {
            'StickerId': 65,
            'Active': 1,
            'Order': 56,
            'Title': 'Kadootje',
            'ImagePath': 'stickers/sticker-65.png',
            'Size': '{Width=706, Height=1012}',
            'LastModified': '05/09/2017 07:26:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:42',
            'ProductTypes': []
          },
          {
            'StickerId': 66,
            'Active': 1,
            'Order': 57,
            'Title': 'Ring',
            'ImagePath': 'stickers/sticker-66.png',
            'Size': '{Width=620, Height=1001}',
            'LastModified': '05/09/2017 07:26:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:51',
            'ProductTypes': []
          },
          {
            'StickerId': 67,
            'Active': 1,
            'Order': 58,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-67.png',
            'Size': '{Width=1020, Height=947}',
            'LastModified': '05/09/2017 07:27:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:01',
            'ProductTypes': []
          },
          {
            'StickerId': 68,
            'Active': 1,
            'Order': 59,
            'Title': 'Bowtie',
            'ImagePath': 'stickers/sticker-68.png',
            'Size': '{Width=1017, Height=514}',
            'LastModified': '05/09/2017 07:27:09',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:09',
            'ProductTypes': []
          },
          {
            'StickerId': 69,
            'Active': 1,
            'Order': 60,
            'Title': 'Confetti',
            'ImagePath': 'stickers/sticker-69.png',
            'Size': '{Width=333, Height=995}',
            'LastModified': '05/09/2017 07:27:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:21',
            'ProductTypes': []
          },
          {
            'StickerId': 70,
            'Active': 1,
            'Order': 61,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-70.png',
            'Size': '{Width=898, Height=1006}',
            'LastModified': '05/09/2017 07:27:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:33',
            'ProductTypes': []
          },
          {
            'StickerId': 71,
            'Active': 1,
            'Order': 62,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-71.png',
            'Size': '{Width=1027, Height=573}',
            'LastModified': '05/09/2017 07:27:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:42',
            'ProductTypes': []
          },
          {
            'StickerId': 72,
            'Active': 1,
            'Order': 63,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-72.png',
            'Size': '{Width=797, Height=985}',
            'LastModified': '05/09/2017 07:27:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:55',
            'ProductTypes': []
          },
          {
            'StickerId': 73,
            'Active': 1,
            'Order': 64,
            'Title': 'Mr',
            'ImagePath': 'stickers/sticker-73.png',
            'Size': '{Width=1038, Height=932}',
            'LastModified': '05/09/2017 07:28:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:07',
            'ProductTypes': []
          },
          {
            'StickerId': 74,
            'Active': 1,
            'Order': 65,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-74.png',
            'Size': '{Width=708, Height=990}',
            'LastModified': '05/09/2017 07:28:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:18',
            'ProductTypes': []
          },
          {
            'StickerId': 75,
            'Active': 1,
            'Order': 66,
            'Title': 'Ms',
            'ImagePath': 'stickers/sticker-75.png',
            'Size': '{Width=1031, Height=971}',
            'LastModified': '05/09/2017 07:28:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:32',
            'ProductTypes': []
          },
          {
            'StickerId': 76,
            'Active': 1,
            'Order': 67,
            'Title': 'Rainbow',
            'ImagePath': 'stickers/sticker-76.png',
            'Size': '{Width=1010, Height=659}',
            'LastModified': '05/09/2017 07:28:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:42',
            'ProductTypes': []
          },
          {
            'StickerId': 77,
            'Active': 1,
            'Order': 68,
            'Title': 'Champagne',
            'ImagePath': 'stickers/sticker-77.png',
            'Size': '{Width=341, Height=1006}',
            'LastModified': '05/09/2017 07:28:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:56',
            'ProductTypes': []
          },
          {
            'StickerId': 78,
            'Active': 1,
            'Order': 69,
            'Title': 'Hartjes',
            'ImagePath': 'stickers/sticker-78.png',
            'Size': '{Width=951, Height=571}',
            'LastModified': '05/09/2017 07:29:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:06',
            'ProductTypes': []
          },
          {
            'StickerId': 79,
            'Active': 1,
            'Order': 70,
            'Title': 'You are just lovely',
            'ImagePath': 'stickers/sticker-79.png',
            'Size': '{Width=987, Height=899}',
            'LastModified': '05/09/2017 07:29:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:26',
            'ProductTypes': []
          },
          {
            'StickerId': 80,
            'Active': 1,
            'Order': 71,
            'Title': 'Medaille',
            'ImagePath': 'stickers/sticker-80.png',
            'Size': '{Width=591, Height=1018}',
            'LastModified': '05/09/2017 07:29:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:40',
            'ProductTypes': []
          },
          {
            'StickerId': 81,
            'Active': 1,
            'Order': 72,
            'Title': 'Pluk de dag',
            'ImagePath': 'stickers/sticker-81.png',
            'Size': '{Width=509, Height=1042}',
            'LastModified': '05/09/2017 07:29:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:51',
            'ProductTypes': []
          },
          {
            'StickerId': 82,
            'Active': 1,
            'Order': 73,
            'Title': 'Zon',
            'ImagePath': 'stickers/sticker-82.png',
            'Size': '{Width=1033, Height=1005}',
            'LastModified': '05/09/2017 07:30:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:01',
            'ProductTypes': []
          },
          {
            'StickerId': 83,
            'Active': 1,
            'Order': 74,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-83.png',
            'Size': '{Width=997, Height=646}',
            'LastModified': '05/09/2017 07:30:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:11',
            'ProductTypes': []
          },
          {
            'StickerId': 84,
            'Active': 1,
            'Order': 75,
            'Title': 'Hartjesdoos mama',
            'ImagePath': 'stickers/sticker-84.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:28',
            'ProductTypes': []
          },
          {
            'StickerId': 85,
            'Active': 1,
            'Order': 76,
            'Title': 'Hartjesdoos',
            'ImagePath': 'stickers/sticker-85.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:41',
            'ProductTypes': []
          },
          {
            'StickerId': 86,
            'Active': 1,
            'Order': 77,
            'Title': 'Wolk rain',
            'ImagePath': 'stickers/sticker-86.png',
            'Size': '{Width=1002, Height=948}',
            'LastModified': '05/09/2017 07:30:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:54',
            'ProductTypes': []
          },
          {
            'StickerId': 87,
            'Active': 1,
            'Order': 78,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-87.png',
            'Size': '{Width=1025, Height=721}',
            'LastModified': '05/09/2017 07:31:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:05',
            'ProductTypes': []
          },
          {
            'StickerId': 88,
            'Active': 1,
            'Order': 79,
            'Title': 'Hartje mama',
            'ImagePath': 'stickers/sticker-88.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:32',
            'ProductTypes': []
          },
          {
            'StickerId': 89,
            'Active': 1,
            'Order': 80,
            'Title': 'Hartje',
            'ImagePath': 'stickers/sticker-89.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:42',
            'ProductTypes': []
          },
          {
            'StickerId': 90,
            'Active': 1,
            'Order': 81,
            'Title': 'Wolk donder',
            'ImagePath': 'stickers/sticker-90.png',
            'Size': '{Width=878, Height=998}',
            'LastModified': '05/09/2017 07:40:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:00',
            'ProductTypes': []
          },
          {
            'StickerId': 91,
            'Active': 1,
            'Order': 82,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-91.png',
            'Size': '{Width=1013, Height=1013}',
            'LastModified': '05/09/2017 07:40:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:14',
            'ProductTypes': []
          },
          {
            'StickerId': 92,
            'Active': 1,
            'Order': 83,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-92.png',
            'Size': '{Width=768, Height=1013}',
            'LastModified': '05/09/2017 07:40:44',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:44',
            'ProductTypes': []
          },
          {
            'StickerId': 93,
            'Active': 1,
            'Order': 84,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-93.png',
            'Size': '{Width=1009, Height=1022}',
            'LastModified': '05/09/2017 07:40:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:54',
            'ProductTypes': []
          },
          {
            'StickerId': 94,
            'Active': 1,
            'Order': 85,
            'Title': 'Zwemband',
            'ImagePath': 'stickers/sticker-94.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:41:04',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:04',
            'ProductTypes': []
          },
          {
            'StickerId': 95,
            'Active': 1,
            'Order': 86,
            'Title': 'Plons',
            'ImagePath': 'stickers/sticker-95.png',
            'Size': '{Width=1033, Height=430}',
            'LastModified': '05/09/2017 07:41:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:17',
            'ProductTypes': []
          },
          {
            'StickerId': 96,
            'Active': 1,
            'Order': 87,
            'Title': 'Zwemdiploma',
            'ImagePath': 'stickers/sticker-96.png',
            'Size': '{Width=1019, Height=121}',
            'LastModified': '05/09/2017 07:41:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:29',
            'ProductTypes': []
          },
          {
            'StickerId': 97,
            'Active': 1,
            'Order': 88,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-97.png',
            'Size': '{Width=719, Height=1044}',
            'LastModified': '05/09/2017 07:41:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:41',
            'ProductTypes': []
          },
          {
            'StickerId': 98,
            'Active': 1,
            'Order': 89,
            'Title': 'New home',
            'ImagePath': 'stickers/sticker-98.png',
            'Size': '{Width=835, Height=1042}',
            'LastModified': '05/09/2017 07:41:52',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:52',
            'ProductTypes': []
          },
          {
            'StickerId': 99,
            'Active': 1,
            'Order': 90,
            'Title': 'Sportheld',
            'ImagePath': 'stickers/sticker-99.png',
            'Size': '{Width=925, Height=1040}',
            'LastModified': '05/09/2017 07:42:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:02',
            'ProductTypes': []
          },
          {
            'StickerId': 100,
            'Active': 1,
            'Order': 91,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-100.png',
            'Size': '{Width=855, Height=1042}',
            'LastModified': '05/09/2017 07:42:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:12',
            'ProductTypes': []
          },
          {
            'StickerId': 101,
            'Active': 1,
            'Order': 92,
            'Title': 'Present',
            'ImagePath': 'stickers/sticker-101.png',
            'Size': '{Width=714, Height=1004}',
            'LastModified': '05/09/2017 07:42:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:21',
            'ProductTypes': []
          },
          {
            'StickerId': 102,
            'Active': 1,
            'Order': 93,
            'Title': 'Bird',
            'ImagePath': 'stickers/sticker-102.png',
            'Size': '{Width=1031, Height=720}',
            'LastModified': '05/09/2017 07:42:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:31',
            'ProductTypes': []
          },
          {
            'StickerId': 103,
            'Active': 1,
            'Order': 94,
            'Title': 'Snowflake',
            'ImagePath': 'stickers/sticker-103.png',
            'Size': '{Width=922, Height=1000}',
            'LastModified': '10/11/2022 14:35:16',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:40',
            'ProductTypes': []
          },
          {
            'StickerId': 104,
            'Active': 1,
            'Order': 95,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-104.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:53',
            'ProductTypes': []
          },
          {
            'StickerId': 105,
            'Active': 1,
            'Order': 96,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-105.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:57',
            'ProductTypes': []
          },
          {
            'StickerId': 106,
            'Active': 1,
            'Order': 97,
            'Title': 'Bat',
            'ImagePath': 'stickers/sticker-106.png',
            'Size': '{Width=1042, Height=315}',
            'LastModified': '10/11/2022 14:35:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:07',
            'ProductTypes': []
          },
          {
            'StickerId': 107,
            'Active': 1,
            'Order': 98,
            'Title': 'Hoera een jongen',
            'ImagePath': 'stickers/sticker-107.png',
            'Size': '{Width=734, Height=1042}',
            'LastModified': '05/09/2017 07:43:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:21',
            'ProductTypes': []
          },
          {
            'StickerId': 108,
            'Active': 1,
            'Order': 99,
            'Title': 'Bedankt',
            'ImagePath': 'stickers/sticker-108.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:43:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:32',
            'ProductTypes': []
          },
          {
            'StickerId': 109,
            'Active': 1,
            'Order': 100,
            'Title': 'Pumpkin',
            'ImagePath': 'stickers/sticker-109.png',
            'Size': '{Width=1042, Height=763}',
            'LastModified': '10/11/2022 14:35:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:47',
            'ProductTypes': []
          },
          {
            'StickerId': 110,
            'Active': 1,
            'Order': 101,
            'Title': 'Stoplicht',
            'ImagePath': 'stickers/sticker-110.png',
            'Size': '{Width=288, Height=1032}',
            'LastModified': '05/09/2017 07:44:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:00',
            'ProductTypes': []
          },
          {
            'StickerId': 111,
            'Active': 1,
            'Order': 102,
            'Title': 'Hoera rijbewijs',
            'ImagePath': 'stickers/sticker-111.png',
            'Size': '{Width=1040, Height=632}',
            'LastModified': '05/09/2017 07:44:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:14',
            'ProductTypes': []
          },
          {
            'StickerId': 112,
            'Active': 1,
            'Order': 103,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-112.png',
            'Size': '{Width=997, Height=997}',
            'LastModified': '05/09/2017 07:44:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:25',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 11,
        'Name': 'choco-heart-cake-993x762',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1029,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1029.jpg',
            'Order': 297,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_blauw',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:29',
            'Categories': [],
            'Created': '07/24/2017 14:01:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1031,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1031.jpg',
            'Order': 299,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_groen',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:46',
            'Categories': [],
            'Created': '07/24/2017 14:03:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1034,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1034.jpg',
            'Order': 302,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geel',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:13',
            'Categories': [],
            'Created': '07/24/2017 14:05:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1038,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1038.jpg',
            'Order': 306,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_roodstreep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:32:19',
            'Categories': [],
            'Created': '07/24/2017 14:08:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1042,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1042.jpg',
            'Order': 310,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_rozerood',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:40:53',
            'Categories': [],
            'Created': '07/24/2017 14:09:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1043,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1043.jpg',
            'Order': 311,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_roze',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:34:29',
            'Categories': [],
            'Created': '07/24/2017 14:10:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1046,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1046.jpg',
            'Order': 314,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_fuchsia',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:37:57',
            'Categories': [],
            'Created': '07/24/2017 14:13:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1048,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1048.jpg',
            'Order': 316,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_boom',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:39:05',
            'Categories': [],
            'Created': '07/24/2017 14:14:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1050,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1050.jpg',
            'Order': 318,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_bloem',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:40:17',
            'Categories': [],
            'Created': '07/24/2017 14:15:38',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1052,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1052.jpg',
            'Order': 320,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:40:51',
            'Categories': [],
            'Created': '07/24/2017 14:16:46',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1053,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1053.jpg',
            'Order': 321,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:02:19',
            'Categories': [],
            'Created': '07/24/2017 14:17:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1054,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1054.jpg',
            'Order': 322,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:02:51',
            'Categories': [],
            'Created': '07/24/2017 14:18:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1056,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1056.jpg',
            'Order': 324,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruitrood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:03:06',
            'Categories': [],
            'Created': '07/24/2017 14:19:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1057,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1057.jpg',
            'Order': 325,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_stip rood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:05:08',
            'Categories': [],
            'Created': '07/24/2017 14:21:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1059,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1059.png',
            'Order': 327,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_moederdag',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:06:55',
            'Categories': [],
            'Created': '07/24/2017 14:22:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1062,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1062.png',
            'Order': 330,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:06:37',
            'Categories': [],
            'Created': '07/24/2017 14:24:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1064,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1064.png',
            'Order': 332,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_verkeer',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:10',
            'Categories': [],
            'Created': '07/24/2017 14:26:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1066,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1066.png',
            'Order': 334,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geboorte meisje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:25',
            'Categories': [],
            'Created': '07/24/2017 14:28:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1071,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1071.png',
            'Order': 339,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_suikerfeest',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:55',
            'Categories': [],
            'Created': '07/24/2017 14:31:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1074,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1074.png',
            'Order': 342,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:35:27',
            'Categories': [],
            'Created': '07/24/2017 14:32:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1157,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1157.png',
            'Order': 425,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_hartje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:35:03',
            'Categories': [],
            'Created': '07/24/2017 15:29:47',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 17,
            'Title': 'Montserrat',
            'ImagePath': 'fonts/font-17.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 14,
            'Order': 5,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '08/15/2017 12:04:47',
            'LastModifiedBy': 'HEMALOCAL\\emdvorobiova',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 22,
            'Title': 'Bungee',
            'ImagePath': 'fonts/font-22.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 9,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/22/2017 06:29:11',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:25:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 14,
            'Title': '6333601',
            'Created': '05/16/2017 14:23:57',
            'LastModified': '08/19/2019 13:13:50',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Active': 1,
            'ProductTypeId': 11,
            'ShapeId': 2,
            'Width': 993,
            'Height': 762,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-choco-heart',
            'BackgroundWidth': 1108,
            'BackgroundHeight': 822,
            'Bleed': 14,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 1,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': true,
            'CakeMaskPathDefinition': 'M 992.6,182 992.6,180.4 992.5,179 992.2,175 991.3,169.1 991.1,167.6 990.5,164.4 989.9,160.9 988,153.5 988,153.5    986.8,148.8 986.6,148.1 986,146.1 983.3,139 980.6,131.6 980.3,131 979.9,129.7 977.2,123.8 974.5,118 974.1,117.3 973.7,116.4    972.4,114 971.4,112.1 970.6,110.9 969.8,109.4 965.6,101.9 961.3,94.9 957.5,89.4 953.6,84 951.3,81.2 948.6,77.7 943.9,72.3    939.3,67.2 935.8,64.1 929.2,57.8 921.9,51.2 916.5,47.3 913,44.5 912.7,44.3 911.5,43.4 906.1,39.4 900.3,35.9 900.3,35.9    899.1,35.2 898.7,34.9 894.9,32.4 889.1,29.3 880.6,24.6 871.7,20.3 867.3,18.6 866.7,18.4 858.5,14.8 850,12.1 847.2,11.2    844.2,10.2 841.9,9.5 841.5,9.4 840.7,9.2 834.6,7.4 825.3,5.5 823.4,5.1 823.4,5.1 823.4,5.1 815.7,3.5 808.8,2.7 804.4,2    799.4,1.5 796.3,1.2 786.3,0.4 785.1,0.4 775.5,0 766.2,0 761.6,0.2 756.5,0.4 756.1,0.4 748,0.8 739.1,1.6 730.3,2.7 721.8,4.3    720.5,4.6 717.9,5.1 708.6,7.4 704.6,8.6 703.2,9 702.1,9.3 699.4,10.2 689.7,13.3 688.3,13.8 683.9,15.2 676.6,18.3 671.5,20.3    669.3,21.3 665,23 662.6,24.2 653.8,28.5 644.9,33.2 636.4,38.3 632.9,40.6 632.9,40.6 628.3,43.7 619.4,50 610.5,56.2 602.4,63.3    602.3,63.4 598.1,66.8 589.1,75.6 586.5,78.1 578.8,85.9 571.8,94.1 564.9,102.3 558.3,110.9 552.1,119.9 550.9,122 549,124.6    539.4,141 530.9,158.2 524.3,173 522.5,177.6 521.2,180.4 519.7,184.4 518.1,188.3 512.3,203.5 506.5,218.7 505.3,222.5    503.8,226.5 496.5,250 489.2,226.5 487.7,222.4 486.5,218.7 480.7,203.5 474.9,188.3 473.3,184.4 471.8,180.4 470.5,177.6    468.7,173 462.1,158.2 453.6,141 444,124.6 442.1,122 440.9,119.9 434.7,110.9 428.1,102.3 421.2,94.1 414.2,85.9 408.4,80.1    408.4,80.1 408.4,80.1 406.5,78.1 403.9,75.6 394.9,66.8 390.7,63.4 390.6,63.3 382.5,56.2 373.6,50 364.7,43.7 360.1,40.6    360.1,40.6 356.6,38.3 348.1,33.2 339.2,28.5 330.4,24.2 330.4,24.2 328,23 323.7,21.3 321.5,20.3 316.4,18.3 309.1,15.2    304.7,13.8 303.3,13.3 293.6,10.2 290.9,9.4 289.8,9 288.4,8.6 284.4,7.4 275.1,5.1 272.5,4.6 271.2,4.3 262.7,2.7 253.9,1.6    245,0.8 236.9,0.4 236.5,0.4 231.4,0.2 226.8,0 217.5,0 207.9,0.4 206.7,0.4 196.7,1.2 193.6,1.5 188.6,2 184.2,2.7 177.3,3.5    167.7,5.5 158.4,7.4 152.3,9.2 151.5,9.4 151.1,9.5 148.8,10.2 145.8,11.2 143,12.1 134.5,14.8 126.3,18.4 125.7,18.6 121.3,20.3    112.4,24.6 103.9,29.3 98.1,32.4 94.3,34.9 93.9,35.2 92.7,35.9 92.7,35.9 86.9,39.4 81.5,43.4 80.3,44.3 80,44.5 76.5,47.3    71.1,51.2 63.8,57.8 57.2,64.1 53.7,67.2 49.1,72.3 44.4,77.7 41.7,81.2 39.4,84 35.5,89.4 31.7,94.9 27.4,101.9 23.2,109.4    22.4,110.9 21.6,112.1 20.6,114 19.3,116.4 18.9,117.3 18.5,118 15.8,123.8 13.1,129.7 12.7,131 12.4,131.6 9.7,139 7,146.1    6.4,148.1 6.2,148.8 5,153.5 5,153.5 3.1,160.9 2.5,164.4 1.9,167.6 1.7,169.1 0.8,175 0.5,179 0.4,180.4 0.4,182 0,189.4 0,193.3    0,196.8 0,200 0.4,207 0.8,217.2 1.1,220.2 1.2,221.1 1.9,229.7 3.1,238.2 4.6,246.4 7,256.2 9.3,266 11.2,272.6 11.6,274.2    12,275.4 12,275.4 15.1,285.1 17.6,291.5 17.8,292.1 20.9,301.1 24,308.2 24.3,308.9 24.3,308.9 24.3,308.9 27.4,315.2 28.6,317.2    30.1,320.7 35.2,329.6 39.4,337.1 42.2,341.9 47.9,351.9 56,365.6 64.5,379.2 73,392.5 81.9,405.4 86.7,412 92,419.5 100.2,430.3    105.1,437 111.6,445 112.1,445.6 112.7,446.4 117.5,452.3 130.2,467.5 134.6,472.5 144.5,483.9 155.7,496.4 167.3,508.5 181.6,523    195.9,537.4 195.9,537.4 197.8,539.4 212.1,553 226.4,566.3 241.1,579.6 255.8,592.9 270.5,605.8 285.5,618.3 300.6,630.8    316.1,643.3 323.8,649.3 328.4,653 347,667.5 362.8,679.2 368.2,683.1 372.5,686.2 373.9,687.2 379,690.9 395.3,701.9 396.3,702.5    398.7,704.2 411.1,712.4 415.7,715.1 416.9,715.9 426.9,721.9 437,728 450.1,735.8 456.4,739.5 462.1,742.9 470.6,747.9    479.1,752.6 480.2,753.2 482.6,754.6 491.7,759.4 496.5,762 501.3,759.4 510.4,754.6 512.8,753.2 513.9,752.6 522.4,747.9    530.9,742.9 536.6,739.5 542.9,735.8 556,728 566.1,721.9 576.1,715.9 577.3,715.1 581.9,712.4 594.3,704.2 596.7,702.5    597.7,701.9 614,690.9 619.1,687.2 620.5,686.2 624.8,683.1 630.2,679.2 646,667.5 664.6,653 669.2,649.3 676.9,643.3 692.4,630.8    707.5,618.3 722.5,605.8 737.2,592.9 751.9,579.6 766.6,566.3 780.9,553 795.2,539.4 797.1,537.4 797.1,537.4 811.4,523    825.7,508.5 837.3,496.4 848.5,483.9 858.4,472.5 862.8,467.5 875.5,452.3 880.3,446.4 880.9,445.6 881.4,445 887.9,437    892.8,430.3 901,419.5 906.3,412 911.1,405.4 920,392.5 928.5,379.2 937,365.6 945.1,351.9 950.8,341.9 953.6,337.1 957.8,329.6    962.9,320.7 964.4,317.2 965.6,315.2 968.7,308.9 968.7,308.9 968.7,308.9 969,308.2 972.1,301.1 975.2,292.1 975.4,291.5    977.9,285.1 981,275.4 981,275.4 981.4,274.2 981.8,272.6 983.7,266 986,256.2 988.4,246.4 989.9,238.2 991.1,229.7 991.8,221.1    991.9,220.2 992.2,217.2 992.6,207 993,200 993,196.8 993,193.3 993,189.4  Z',
            'BleedMaskPathDefinition': 'M 494.2,733.6 491.8,732.2 490.5,731.5 482.6,727.1 468.4,718.7 462.3,715.1 449.4,707.5 439.2,701.2 429.6,695.5   428.3,694.7 423.9,692.1 412.2,684.3 409.6,682.5 408.5,681.8 392.8,671.2 387.7,667.6 386.4,666.7 382.3,663.6 377,659.8   361.5,648.4 343.3,634.2 338.6,630.4 331,624.5 315.8,612.2 286,587.5 271.8,575 242.6,548.6 228.6,535.6 214.7,522.3 184.5,491.8   173.3,480.1 162.5,468 152.6,456.5 148.4,451.9 136,437 131.2,431.1 130.7,430.5 130.4,430.1 124.1,422.4 119.3,415.9 111.4,405.4   106.3,398 101.5,391.5 93,379.2 84.8,366.4 76.5,353.1 68.7,339.9 63,329.9 60.2,325 56,317.8 51.5,309.8 50,306.4 48.7,304.1   45.7,298 43.2,292.4 40.4,284 40,283.1 37.7,277.2 34.8,267.8 34.6,267.4 34.3,266.3 32.5,259.9 28.1,241.5 26.8,234.4 25.8,227   25.1,219.4 25.1,218.3 24.7,215.3 24.4,205.9 24,199.3 24,190.1 24.4,182.6 24.4,181.8 24.5,181.1 24.7,177.6 25.5,172.5   25.7,171.2 26.2,168.6 26.6,165.9 28.4,159 28.4,158.9 29.2,155.7 29.4,155.1 29.8,153.4 32.1,147.5 34.6,140.6 34.9,140   35.3,138.9 40.1,128.6 40.4,128 40.7,127.3 41.8,125.2 42.6,123.8 43.2,122.7 44.1,121.1 48.1,114.1 51.8,108.1 58.4,98.6   60.4,96.3 63.1,92.9 67.1,88.1 70.6,84.3 73.4,81.7 80.1,75.4 86.2,69.8 90.9,66.4 94.1,63.9 94.4,63.8 95.9,62.6 100.2,59.5   105.7,56.2 106.6,55.5 106.8,55.4 110.4,53.1 115.5,50.3 123.5,45.9 130.8,42.4 135,40.8 136.1,40.3 142.9,37.3 153.5,33.9 156,33   158,32.5 158.2,32.4 158.8,32.3 164.2,30.7 172.5,29 181.2,27.2 187.7,26.4 191.5,25.8 196,25.4 199,25.1 207.6,24.4 208.4,24.4   218,24 226.3,24 230.4,24.2 235,24.4 235.4,24.4 243.4,24.7 251.2,25.4 259,26.4 266.4,27.8 267.5,28.1 269.9,28.5 278,30.6   281.8,31.7 282.9,32 283.8,32.3 286.6,33.1 295.4,35.9 296.8,36.5 300.7,37.7 307.3,40.5 312.2,42.5 314.4,43.4 318.1,44.9   319.7,45.7 328.4,49.9 336.4,54.1 343.8,58.5 351.1,63.5 367.7,75.2 374.7,81.2 375,81.5 378.8,84.6 387.3,92.9 389.6,95.2   396.5,102.2 409.4,117.4 415.2,125 420.8,133 422.1,135.1 423.7,137.5 432.5,152.4 440.4,168.4 446.6,182.4 448.4,186.9   449.6,189.5 451,193.2 452.5,197 463.8,226.7 465,230.3 466.4,234.3 496.5,330.2 526.6,234.3 528,230.3 529.2,226.7 540.5,197   542,193.2 543.4,189.5 544.6,186.9 546.4,182.4 552.6,168.4 560.5,152.4 569.3,137.5 570.9,135.1 572.2,133 577.8,125 583.6,117.4   596.5,102.1 603.4,95.2 605.9,92.8 614.2,84.6 618,81.5 618.3,81.2 625.3,75.2 641.9,63.5 649.2,58.5 656.6,54.1 664.6,49.9   673.3,45.7 674.9,44.9 678.6,43.4 680.8,42.5 685.7,40.5 692.3,37.8 696.2,36.5 697.6,35.9 706.4,33.1 709.2,32.3 710.1,32   711.2,31.7 715,30.6 723.1,28.5 725.5,28.1 726.6,27.8 734,26.4 741.8,25.4 749.6,24.7 757.6,24.4 758,24.4 762.5,24.2 766.7,24   775,24 784.6,24.4 785.4,24.4 794,25.1 797,25.4 801.5,25.8 805.3,26.4 811.8,27.2 820.5,29 828.8,30.7 834.4,32.3 834.8,32.4   835,32.5 837,33 839.5,33.9 850.1,37.3 856.9,40.3 858,40.8 862.2,42.4 869.5,45.9 877.7,50.4 882.6,53.1 886.2,55.4 886.4,55.5   887.3,56.2 892.8,59.5 897.1,62.6 898.7,63.8 898.9,63.9 902,66.4 906.8,69.9 912.9,75.4 919.6,81.7 922.4,84.3 925.9,88.1   929.9,92.9 932.6,96.3 934.6,98.6 941.2,108.1 944.9,114.1 948.9,121.1 949.8,122.7 950.4,123.8 951.4,125.6 952.3,127.3 952.6,128   952.9,128.6 957.7,138.9 958.1,140 958.4,140.6 960.9,147.7 963.2,153.4 963.6,155.1 963.8,155.7 964.8,159.5 966.4,165.9   966.8,168.6 967.3,171.2 967.5,172.5 968.3,177.6 968.5,181.1 968.6,181.8 968.6,182.6 969,190.1 969,199.3 968.6,205.9   968.3,215.3 967.9,218.3 967.9,219.4 967.2,227 966.2,234.4 964.9,241.5 960.5,259.9 958.7,266.3 958.4,267.4 958.1,268.1   955.3,277.2 953,283.1 952.5,284.3 949.8,292.4 947.3,298 944.3,304.1 943,306.4 941.5,309.8 937,317.8 932.8,325 929.9,330.1   924.3,339.9 916.5,353.1 908.2,366.4 900,379.2 891.5,391.5 886.7,398 881.6,405.4 873.5,416.2 868.9,422.4 862.6,430.1   862.3,430.5 861.7,431.2 857,437 844.6,451.9 840.3,456.7 830.5,468 819.7,480.1 808.5,491.8 778.3,522.3 764.4,535.6 750.4,548.6   721.3,575 707,587.5 677.2,612.2 662,624.5 654.2,630.6 649.7,634.2 631.5,648.4 616,659.8 610.6,663.8 606.6,666.7 605.3,667.6   600.2,671.2 584.5,681.8 583.4,682.5 580.8,684.3 569.1,692.1 564.7,694.7 563.4,695.5 553.5,701.4 543.6,707.5 530.7,715.1   524.3,718.9 510.4,727.1 502.5,731.5 501.2,732.2 498.8,733.6 496.5,734.8 Z',
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-14.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-14.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': true,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-choco-heart'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 2,
            'Active': 1,
            'ImagePath': 'templates/template-2.svg',
            'ShapeId': 2,
            'Created': '02/22/2017 13:53:08',
            'LastModified': '05/18/2017 12:10:03',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 4,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 23.076923}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 53.846154}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 23.076923}}',
            'Title': 'Layout-03'
          },
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 5,
            'Active': 1,
            'ImagePath': 'templates/template-5.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:11:50',
            'LastModified': '05/18/2017 12:10:06',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 5,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 50, h: 50}}',
            'Title': 'Layout-04'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 7,
            'Active': 1,
            'ImagePath': 'templates/template-7.svg',
            'ShapeId': 2,
            'Created': '04/27/2017 08:36:17',
            'LastModified': '05/18/2017 12:10:16',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 6,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 8, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 9, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-05'
          },
          {
            'LayoutTemplateId': 8,
            'Active': 1,
            'ImagePath': 'templates/template-8.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:48:38',
            'LastModified': '05/18/2017 12:10:12',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 7,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-06'
          },
          {
            'LayoutTemplateId': 9,
            'Active': 1,
            'ImagePath': 'templates/template-9.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:49:05',
            'LastModified': '05/18/2017 12:10:20',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 8,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-07'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          },
          {
            'LayoutTemplateId': 12,
            'Active': 1,
            'ImagePath': 'templates/template-12.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:24:43',
            'LastModified': '05/18/2017 12:10:25',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 9,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-08'
          },
          {
            'LayoutTemplateId': 13,
            'Active': 1,
            'ImagePath': 'templates/template-13.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:26:35',
            'LastModified': '06/16/2017 13:30:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Order': 10,
            'PermittedSides': 'center,top,right,bottom',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 50, h: 100}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 100}}',
            'Title': 'Layout-09'
          },
          {
            'LayoutTemplateId': 14,
            'Active': 1,
            'ImagePath': 'templates/template-14.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:27:44',
            'LastModified': '05/18/2017 12:10:33',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 11,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-10'
          },
          {
            'LayoutTemplateId': 15,
            'Active': 1,
            'ImagePath': 'templates/template-15.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:12',
            'LastModified': '05/18/2017 12:10:38',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 12,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-11'
          },
          {
            'LayoutTemplateId': 16,
            'Active': 0,
            'ImagePath': 'templates/template-16.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:35',
            'LastModified': '07/31/2019 15:15:43',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 13,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: \'hidden\', accept: \'\', dimension: {w: 100, h: 33.333333}},\r\n{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-12'
          },
          {
            'LayoutTemplateId': 17,
            'Active': 1,
            'ImagePath': 'templates/template-17.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:16',
            'LastModified': '05/18/2017 12:10:46',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 14,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 66.666666}}',
            'Title': 'Layout-13'
          },
          {
            'LayoutTemplateId': 18,
            'Active': 1,
            'ImagePath': 'templates/template-18.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:41',
            'LastModified': '05/18/2017 12:10:50',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 15,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 50}}',
            'Title': 'Layout-14'
          },
          {
            'LayoutTemplateId': 19,
            'Active': 1,
            'ImagePath': 'templates/template-19.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:30:07',
            'LastModified': '06/07/2017 12:46:48',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'Order': 16,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-15'
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 13,
            'Active': 1,
            'Order': 3,
            'Title': 'Strik',
            'ImagePath': 'stickers/sticker-13.png',
            'Size': '{Width=625, Height=335}',
            'LastModified': '05/09/2017 07:13:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:55',
            'ProductTypes': []
          },
          {
            'StickerId': 14,
            'Active': 1,
            'Order': 4,
            'Title': 'Cirkel',
            'ImagePath': 'stickers/sticker-14.png',
            'Size': '{Width=623, Height=624}',
            'LastModified': '05/09/2017 07:14:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:06',
            'ProductTypes': []
          },
          {
            'StickerId': 15,
            'Active': 1,
            'Order': 5,
            'Title': 'Spreekwolk',
            'ImagePath': 'stickers/sticker-15.png',
            'Size': '{Width=833, Height=736}',
            'LastModified': '05/09/2017 07:14:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:19',
            'ProductTypes': []
          },
          {
            'StickerId': 16,
            'Active': 1,
            'Order': 7,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-16.png',
            'Size': '{Width=662, Height=737}',
            'LastModified': '05/09/2017 07:14:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:27',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 19,
            'Active': 1,
            'Order': 10,
            'Title': 'Bril',
            'ImagePath': 'stickers/sticker-19.png',
            'Size': '{Width=688, Height=229}',
            'LastModified': '05/09/2017 07:15:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:01',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 21,
            'Active': 1,
            'Order': 12,
            'Title': 'Baby',
            'ImagePath': 'stickers/sticker-21.png',
            'Size': '{Width=729, Height=658}',
            'LastModified': '05/09/2017 07:15:47',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:47',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 23,
            'Active': 1,
            'Order': 14,
            'Title': 'Hart blauw',
            'ImagePath': 'stickers/sticker-23.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '05/09/2017 07:16:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:14',
            'ProductTypes': []
          },
          {
            'StickerId': 24,
            'Active': 1,
            'Order': 15,
            'Title': 'Ster blauw',
            'ImagePath': 'stickers/sticker-24.png',
            'Size': '{Width=625, Height=570}',
            'LastModified': '05/09/2017 07:16:24',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:24',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 26,
            'Active': 1,
            'Order': 17,
            'Title': 'Welkom kleintje',
            'ImagePath': 'stickers/sticker-26.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:16:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:56',
            'ProductTypes': []
          },
          {
            'StickerId': 27,
            'Active': 1,
            'Order': 18,
            'Title': 'Welkom kleintjes',
            'ImagePath': 'stickers/sticker-27.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:17:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:13',
            'ProductTypes': []
          },
          {
            'StickerId': 28,
            'Active': 1,
            'Order': 19,
            'Title': 'Sinasappel',
            'ImagePath': 'stickers/sticker-28.png',
            'Size': '{Width=729, Height=729}',
            'LastModified': '05/09/2017 07:17:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:25',
            'ProductTypes': []
          },
          {
            'StickerId': 29,
            'Active': 1,
            'Order': 20,
            'Title': 'Blaadje',
            'ImagePath': 'stickers/sticker-29.png',
            'Size': '{Width=717, Height=238}',
            'LastModified': '05/09/2017 07:17:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:37',
            'ProductTypes': []
          },
          {
            'StickerId': 30,
            'Active': 1,
            'Order': 21,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-30.png',
            'Size': '{Width=359, Height=931}',
            'LastModified': '05/09/2017 07:17:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:48',
            'ProductTypes': []
          },
          {
            'StickerId': 31,
            'Active': 1,
            'Order': 22,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-31.png',
            'Size': '{Width=383, Height=942}',
            'LastModified': '05/09/2017 07:18:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:02',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 33,
            'Active': 1,
            'Order': 24,
            'Title': 'Ananas',
            'ImagePath': 'stickers/sticker-33.png',
            'Size': '{Width=405, Height=738}',
            'LastModified': '05/09/2017 07:18:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:28',
            'ProductTypes': []
          },
          {
            'StickerId': 34,
            'Active': 1,
            'Order': 25,
            'Title': 'Herfst blaadjes',
            'ImagePath': 'stickers/sticker-34.png',
            'Size': '{Width=255, Height=546}',
            'LastModified': '05/09/2017 07:18:46',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:46',
            'ProductTypes': []
          },
          {
            'StickerId': 35,
            'Active': 1,
            'Order': 26,
            'Title': 'Winter',
            'ImagePath': 'stickers/sticker-35.png',
            'Size': '{Width=476, Height=785}',
            'LastModified': '05/09/2017 07:18:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:59',
            'ProductTypes': []
          },
          {
            'StickerId': 36,
            'Active': 1,
            'Order': 27,
            'Title': 'Astronaut',
            'ImagePath': 'stickers/sticker-36.png',
            'Size': '{Width=589, Height=988}',
            'LastModified': '05/09/2017 07:19:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:14',
            'ProductTypes': []
          },
          {
            'StickerId': 37,
            'Active': 1,
            'Order': 28,
            'Title': 'Jarig',
            'ImagePath': 'stickers/sticker-37.png',
            'Size': '{Width=1036, Height=1026}',
            'LastModified': '05/09/2017 07:19:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:26',
            'ProductTypes': []
          },
          {
            'StickerId': 38,
            'Active': 1,
            'Order': 29,
            'Title': 'Kikker',
            'ImagePath': 'stickers/sticker-38.png',
            'Size': '{Width=1042, Height=1040}',
            'LastModified': '05/09/2017 07:19:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:38',
            'ProductTypes': []
          },
          {
            'StickerId': 39,
            'Active': 1,
            'Order': 30,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-39.png',
            'Size': '{Width=1042, Height=651}',
            'LastModified': '05/09/2017 07:19:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:56',
            'ProductTypes': []
          },
          {
            'StickerId': 40,
            'Active': 1,
            'Order': 31,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-40.png',
            'Size': '{Width=988, Height=311}',
            'LastModified': '05/09/2017 07:20:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:13',
            'ProductTypes': []
          },
          {
            'StickerId': 41,
            'Active': 1,
            'Order': 32,
            'Title': 'Piratenmuts',
            'ImagePath': 'stickers/sticker-41.png',
            'Size': '{Width=1042, Height=591}',
            'LastModified': '05/09/2017 07:20:34',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:34',
            'ProductTypes': []
          },
          {
            'StickerId': 42,
            'Active': 1,
            'Order': 33,
            'Title': 'Takkie',
            'ImagePath': 'stickers/sticker-42.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:20:45',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:45',
            'ProductTypes': []
          },
          {
            'StickerId': 43,
            'Active': 1,
            'Order': 34,
            'Title': 'Ballon geel',
            'ImagePath': 'stickers/sticker-43.png',
            'Size': '{Width=377, Height=1024}',
            'LastModified': '05/09/2017 07:20:58',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:58',
            'ProductTypes': []
          },
          {
            'StickerId': 44,
            'Active': 1,
            'Order': 35,
            'Title': 'Getrouwd',
            'ImagePath': 'stickers/sticker-44.png',
            'Size': '{Width=1028, Height=349}',
            'LastModified': '05/09/2017 07:21:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:11',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 46,
            'Active': 1,
            'Order': 37,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-46.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:21:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:57',
            'ProductTypes': []
          },
          {
            'StickerId': 47,
            'Active': 1,
            'Order': 38,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-47.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:22:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:19',
            'ProductTypes': []
          },
          {
            'StickerId': 48,
            'Active': 1,
            'Order': 39,
            'Title': 'Papagaai',
            'ImagePath': 'stickers/sticker-48.png',
            'Size': '{Width=1042, Height=928}',
            'LastModified': '05/09/2017 07:22:30',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:30',
            'ProductTypes': []
          },
          {
            'StickerId': 49,
            'Active': 1,
            'Order': 40,
            'Title': 'Robot',
            'ImagePath': 'stickers/sticker-49.png',
            'Size': '{Width=674, Height=1009}',
            'LastModified': '05/09/2017 07:22:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:43',
            'ProductTypes': []
          },
          {
            'StickerId': 50,
            'Active': 1,
            'Order': 41,
            'Title': 'The king',
            'ImagePath': 'stickers/sticker-50.png',
            'Size': '{Width=1044, Height=197}',
            'LastModified': '05/09/2017 07:22:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:55',
            'ProductTypes': []
          },
          {
            'StickerId': 51,
            'Active': 1,
            'Order': 42,
            'Title': 'Ballonnen groen',
            'ImagePath': 'stickers/sticker-51.png',
            'Size': '{Width=785, Height=1007}',
            'LastModified': '05/09/2017 07:23:10',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:10',
            'ProductTypes': []
          },
          {
            'StickerId': 52,
            'Active': 1,
            'Order': 43,
            'Title': 'Je bent mijn liefste',
            'ImagePath': 'stickers/sticker-52.png',
            'Size': '{Width=487, Height=1042}',
            'LastModified': '05/09/2017 07:23:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:27',
            'ProductTypes': []
          },
          {
            'StickerId': 53,
            'Active': 1,
            'Order': 44,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-53.png',
            'Size': '{Width=1038, Height=948}',
            'LastModified': '05/09/2017 07:23:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:37',
            'ProductTypes': []
          },
          {
            'StickerId': 54,
            'Active': 1,
            'Order': 45,
            'Title': 'Racket',
            'ImagePath': 'stickers/sticker-54.png',
            'Size': '{Width=420, Height=1016}',
            'LastModified': '05/09/2017 07:23:49',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:49',
            'ProductTypes': []
          },
          {
            'StickerId': 55,
            'Active': 1,
            'Order': 46,
            'Title': 'Zwaard',
            'ImagePath': 'stickers/sticker-55.png',
            'Size': '{Width=461, Height=1042}',
            'LastModified': '05/09/2017 07:24:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:01',
            'ProductTypes': []
          },
          {
            'StickerId': 56,
            'Active': 1,
            'Order': 47,
            'Title': 'Hoeravlag',
            'ImagePath': 'stickers/sticker-56.png',
            'Size': '{Width=1045, Height=252}',
            'LastModified': '05/09/2017 07:24:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:13',
            'ProductTypes': []
          },
          {
            'StickerId': 57,
            'Active': 1,
            'Order': 48,
            'Title': 'Rood hartje',
            'ImagePath': 'stickers/sticker-57.png',
            'Size': '{Width=624, Height=1007}',
            'LastModified': '05/09/2017 07:24:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:27',
            'ProductTypes': []
          },
          {
            'StickerId': 58,
            'Active': 1,
            'Order': 49,
            'Title': 'Hoera banner',
            'ImagePath': 'stickers/sticker-58.png',
            'Size': '{Width=1029, Height=530}',
            'LastModified': '05/09/2017 07:24:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:48',
            'ProductTypes': []
          },
          {
            'StickerId': 59,
            'Active': 1,
            'Order': 50,
            'Title': 'Raket',
            'ImagePath': 'stickers/sticker-59.png',
            'Size': '{Width=659, Height=984}',
            'LastModified': '05/09/2017 07:25:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:05',
            'ProductTypes': []
          },
          {
            'StickerId': 60,
            'Active': 1,
            'Order': 51,
            'Title': 'Twee hartjes',
            'ImagePath': 'stickers/sticker-60.png',
            'Size': '{Width=968, Height=754}',
            'LastModified': '05/09/2017 07:25:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:18',
            'ProductTypes': []
          },
          {
            'StickerId': 61,
            'Active': 1,
            'Order': 52,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-61.png',
            'Size': '{Width=995, Height=543}',
            'LastModified': '05/09/2017 07:25:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:31',
            'ProductTypes': []
          },
          {
            'StickerId': 62,
            'Active': 1,
            'Order': 53,
            'Title': 'Lijn hartjes',
            'ImagePath': 'stickers/sticker-62.png',
            'Size': '{Width=982, Height=958}',
            'LastModified': '05/09/2017 07:25:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:43',
            'ProductTypes': []
          },
          {
            'StickerId': 63,
            'Active': 1,
            'Order': 54,
            'Title': 'Roze hartje',
            'ImagePath': 'stickers/sticker-63.png',
            'Size': '{Width=624, Height=1017}',
            'LastModified': '05/09/2017 07:26:23',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:23',
            'ProductTypes': []
          },
          {
            'StickerId': 64,
            'Active': 1,
            'Order': 55,
            'Title': 'Ufo',
            'ImagePath': 'stickers/sticker-64.png',
            'Size': '{Width=914, Height=958}',
            'LastModified': '05/09/2017 07:26:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:32',
            'ProductTypes': []
          },
          {
            'StickerId': 65,
            'Active': 1,
            'Order': 56,
            'Title': 'Kadootje',
            'ImagePath': 'stickers/sticker-65.png',
            'Size': '{Width=706, Height=1012}',
            'LastModified': '05/09/2017 07:26:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:42',
            'ProductTypes': []
          },
          {
            'StickerId': 66,
            'Active': 1,
            'Order': 57,
            'Title': 'Ring',
            'ImagePath': 'stickers/sticker-66.png',
            'Size': '{Width=620, Height=1001}',
            'LastModified': '05/09/2017 07:26:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:51',
            'ProductTypes': []
          },
          {
            'StickerId': 67,
            'Active': 1,
            'Order': 58,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-67.png',
            'Size': '{Width=1020, Height=947}',
            'LastModified': '05/09/2017 07:27:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:01',
            'ProductTypes': []
          },
          {
            'StickerId': 68,
            'Active': 1,
            'Order': 59,
            'Title': 'Bowtie',
            'ImagePath': 'stickers/sticker-68.png',
            'Size': '{Width=1017, Height=514}',
            'LastModified': '05/09/2017 07:27:09',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:09',
            'ProductTypes': []
          },
          {
            'StickerId': 69,
            'Active': 1,
            'Order': 60,
            'Title': 'Confetti',
            'ImagePath': 'stickers/sticker-69.png',
            'Size': '{Width=333, Height=995}',
            'LastModified': '05/09/2017 07:27:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:21',
            'ProductTypes': []
          },
          {
            'StickerId': 70,
            'Active': 1,
            'Order': 61,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-70.png',
            'Size': '{Width=898, Height=1006}',
            'LastModified': '05/09/2017 07:27:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:33',
            'ProductTypes': []
          },
          {
            'StickerId': 71,
            'Active': 1,
            'Order': 62,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-71.png',
            'Size': '{Width=1027, Height=573}',
            'LastModified': '05/09/2017 07:27:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:42',
            'ProductTypes': []
          },
          {
            'StickerId': 72,
            'Active': 1,
            'Order': 63,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-72.png',
            'Size': '{Width=797, Height=985}',
            'LastModified': '05/09/2017 07:27:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:55',
            'ProductTypes': []
          },
          {
            'StickerId': 73,
            'Active': 1,
            'Order': 64,
            'Title': 'Mr',
            'ImagePath': 'stickers/sticker-73.png',
            'Size': '{Width=1038, Height=932}',
            'LastModified': '05/09/2017 07:28:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:07',
            'ProductTypes': []
          },
          {
            'StickerId': 74,
            'Active': 1,
            'Order': 65,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-74.png',
            'Size': '{Width=708, Height=990}',
            'LastModified': '05/09/2017 07:28:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:18',
            'ProductTypes': []
          },
          {
            'StickerId': 75,
            'Active': 1,
            'Order': 66,
            'Title': 'Ms',
            'ImagePath': 'stickers/sticker-75.png',
            'Size': '{Width=1031, Height=971}',
            'LastModified': '05/09/2017 07:28:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:32',
            'ProductTypes': []
          },
          {
            'StickerId': 76,
            'Active': 1,
            'Order': 67,
            'Title': 'Rainbow',
            'ImagePath': 'stickers/sticker-76.png',
            'Size': '{Width=1010, Height=659}',
            'LastModified': '05/09/2017 07:28:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:42',
            'ProductTypes': []
          },
          {
            'StickerId': 77,
            'Active': 1,
            'Order': 68,
            'Title': 'Champagne',
            'ImagePath': 'stickers/sticker-77.png',
            'Size': '{Width=341, Height=1006}',
            'LastModified': '05/09/2017 07:28:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:56',
            'ProductTypes': []
          },
          {
            'StickerId': 78,
            'Active': 1,
            'Order': 69,
            'Title': 'Hartjes',
            'ImagePath': 'stickers/sticker-78.png',
            'Size': '{Width=951, Height=571}',
            'LastModified': '05/09/2017 07:29:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:06',
            'ProductTypes': []
          },
          {
            'StickerId': 79,
            'Active': 1,
            'Order': 70,
            'Title': 'You are just lovely',
            'ImagePath': 'stickers/sticker-79.png',
            'Size': '{Width=987, Height=899}',
            'LastModified': '05/09/2017 07:29:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:26',
            'ProductTypes': []
          },
          {
            'StickerId': 80,
            'Active': 1,
            'Order': 71,
            'Title': 'Medaille',
            'ImagePath': 'stickers/sticker-80.png',
            'Size': '{Width=591, Height=1018}',
            'LastModified': '05/09/2017 07:29:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:40',
            'ProductTypes': []
          },
          {
            'StickerId': 81,
            'Active': 1,
            'Order': 72,
            'Title': 'Pluk de dag',
            'ImagePath': 'stickers/sticker-81.png',
            'Size': '{Width=509, Height=1042}',
            'LastModified': '05/09/2017 07:29:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:51',
            'ProductTypes': []
          },
          {
            'StickerId': 82,
            'Active': 1,
            'Order': 73,
            'Title': 'Zon',
            'ImagePath': 'stickers/sticker-82.png',
            'Size': '{Width=1033, Height=1005}',
            'LastModified': '05/09/2017 07:30:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:01',
            'ProductTypes': []
          },
          {
            'StickerId': 83,
            'Active': 1,
            'Order': 74,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-83.png',
            'Size': '{Width=997, Height=646}',
            'LastModified': '05/09/2017 07:30:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:11',
            'ProductTypes': []
          },
          {
            'StickerId': 84,
            'Active': 1,
            'Order': 75,
            'Title': 'Hartjesdoos mama',
            'ImagePath': 'stickers/sticker-84.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:28',
            'ProductTypes': []
          },
          {
            'StickerId': 85,
            'Active': 1,
            'Order': 76,
            'Title': 'Hartjesdoos',
            'ImagePath': 'stickers/sticker-85.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:41',
            'ProductTypes': []
          },
          {
            'StickerId': 86,
            'Active': 1,
            'Order': 77,
            'Title': 'Wolk rain',
            'ImagePath': 'stickers/sticker-86.png',
            'Size': '{Width=1002, Height=948}',
            'LastModified': '05/09/2017 07:30:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:54',
            'ProductTypes': []
          },
          {
            'StickerId': 87,
            'Active': 1,
            'Order': 78,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-87.png',
            'Size': '{Width=1025, Height=721}',
            'LastModified': '05/09/2017 07:31:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:05',
            'ProductTypes': []
          },
          {
            'StickerId': 88,
            'Active': 1,
            'Order': 79,
            'Title': 'Hartje mama',
            'ImagePath': 'stickers/sticker-88.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:32',
            'ProductTypes': []
          },
          {
            'StickerId': 89,
            'Active': 1,
            'Order': 80,
            'Title': 'Hartje',
            'ImagePath': 'stickers/sticker-89.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:42',
            'ProductTypes': []
          },
          {
            'StickerId': 90,
            'Active': 1,
            'Order': 81,
            'Title': 'Wolk donder',
            'ImagePath': 'stickers/sticker-90.png',
            'Size': '{Width=878, Height=998}',
            'LastModified': '05/09/2017 07:40:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:00',
            'ProductTypes': []
          },
          {
            'StickerId': 91,
            'Active': 1,
            'Order': 82,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-91.png',
            'Size': '{Width=1013, Height=1013}',
            'LastModified': '05/09/2017 07:40:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:14',
            'ProductTypes': []
          },
          {
            'StickerId': 92,
            'Active': 1,
            'Order': 83,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-92.png',
            'Size': '{Width=768, Height=1013}',
            'LastModified': '05/09/2017 07:40:44',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:44',
            'ProductTypes': []
          },
          {
            'StickerId': 93,
            'Active': 1,
            'Order': 84,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-93.png',
            'Size': '{Width=1009, Height=1022}',
            'LastModified': '05/09/2017 07:40:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:54',
            'ProductTypes': []
          },
          {
            'StickerId': 94,
            'Active': 1,
            'Order': 85,
            'Title': 'Zwemband',
            'ImagePath': 'stickers/sticker-94.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:41:04',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:04',
            'ProductTypes': []
          },
          {
            'StickerId': 95,
            'Active': 1,
            'Order': 86,
            'Title': 'Plons',
            'ImagePath': 'stickers/sticker-95.png',
            'Size': '{Width=1033, Height=430}',
            'LastModified': '05/09/2017 07:41:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:17',
            'ProductTypes': []
          },
          {
            'StickerId': 96,
            'Active': 1,
            'Order': 87,
            'Title': 'Zwemdiploma',
            'ImagePath': 'stickers/sticker-96.png',
            'Size': '{Width=1019, Height=121}',
            'LastModified': '05/09/2017 07:41:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:29',
            'ProductTypes': []
          },
          {
            'StickerId': 97,
            'Active': 1,
            'Order': 88,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-97.png',
            'Size': '{Width=719, Height=1044}',
            'LastModified': '05/09/2017 07:41:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:41',
            'ProductTypes': []
          },
          {
            'StickerId': 98,
            'Active': 1,
            'Order': 89,
            'Title': 'New home',
            'ImagePath': 'stickers/sticker-98.png',
            'Size': '{Width=835, Height=1042}',
            'LastModified': '05/09/2017 07:41:52',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:52',
            'ProductTypes': []
          },
          {
            'StickerId': 99,
            'Active': 1,
            'Order': 90,
            'Title': 'Sportheld',
            'ImagePath': 'stickers/sticker-99.png',
            'Size': '{Width=925, Height=1040}',
            'LastModified': '05/09/2017 07:42:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:02',
            'ProductTypes': []
          },
          {
            'StickerId': 100,
            'Active': 1,
            'Order': 91,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-100.png',
            'Size': '{Width=855, Height=1042}',
            'LastModified': '05/09/2017 07:42:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:12',
            'ProductTypes': []
          },
          {
            'StickerId': 101,
            'Active': 1,
            'Order': 92,
            'Title': 'Present',
            'ImagePath': 'stickers/sticker-101.png',
            'Size': '{Width=714, Height=1004}',
            'LastModified': '05/09/2017 07:42:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:21',
            'ProductTypes': []
          },
          {
            'StickerId': 102,
            'Active': 1,
            'Order': 93,
            'Title': 'Bird',
            'ImagePath': 'stickers/sticker-102.png',
            'Size': '{Width=1031, Height=720}',
            'LastModified': '05/09/2017 07:42:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:31',
            'ProductTypes': []
          },
          {
            'StickerId': 103,
            'Active': 1,
            'Order': 94,
            'Title': 'Snowflake',
            'ImagePath': 'stickers/sticker-103.png',
            'Size': '{Width=922, Height=1000}',
            'LastModified': '10/11/2022 14:35:16',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:40',
            'ProductTypes': []
          },
          {
            'StickerId': 104,
            'Active': 1,
            'Order': 95,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-104.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:53',
            'ProductTypes': []
          },
          {
            'StickerId': 105,
            'Active': 1,
            'Order': 96,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-105.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:57',
            'ProductTypes': []
          },
          {
            'StickerId': 106,
            'Active': 1,
            'Order': 97,
            'Title': 'Bat',
            'ImagePath': 'stickers/sticker-106.png',
            'Size': '{Width=1042, Height=315}',
            'LastModified': '10/11/2022 14:35:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:07',
            'ProductTypes': []
          },
          {
            'StickerId': 107,
            'Active': 1,
            'Order': 98,
            'Title': 'Hoera een jongen',
            'ImagePath': 'stickers/sticker-107.png',
            'Size': '{Width=734, Height=1042}',
            'LastModified': '05/09/2017 07:43:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:21',
            'ProductTypes': []
          },
          {
            'StickerId': 108,
            'Active': 1,
            'Order': 99,
            'Title': 'Bedankt',
            'ImagePath': 'stickers/sticker-108.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:43:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:32',
            'ProductTypes': []
          },
          {
            'StickerId': 109,
            'Active': 1,
            'Order': 100,
            'Title': 'Pumpkin',
            'ImagePath': 'stickers/sticker-109.png',
            'Size': '{Width=1042, Height=763}',
            'LastModified': '10/11/2022 14:35:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:47',
            'ProductTypes': []
          },
          {
            'StickerId': 110,
            'Active': 1,
            'Order': 101,
            'Title': 'Stoplicht',
            'ImagePath': 'stickers/sticker-110.png',
            'Size': '{Width=288, Height=1032}',
            'LastModified': '05/09/2017 07:44:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:00',
            'ProductTypes': []
          },
          {
            'StickerId': 111,
            'Active': 1,
            'Order': 102,
            'Title': 'Hoera rijbewijs',
            'ImagePath': 'stickers/sticker-111.png',
            'Size': '{Width=1040, Height=632}',
            'LastModified': '05/09/2017 07:44:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:14',
            'ProductTypes': []
          },
          {
            'StickerId': 112,
            'Active': 1,
            'Order': 103,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-112.png',
            'Size': '{Width=997, Height=997}',
            'LastModified': '05/09/2017 07:44:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:25',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 12,
        'Name': 'lolly-s-cake-331x33x',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1029,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1029.jpg',
            'Order': 297,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_blauw',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:29',
            'Categories': [],
            'Created': '07/24/2017 14:01:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1031,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1031.jpg',
            'Order': 299,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_groen',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:46',
            'Categories': [],
            'Created': '07/24/2017 14:03:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1034,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1034.jpg',
            'Order': 302,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geel',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:13',
            'Categories': [],
            'Created': '07/24/2017 14:05:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1038,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1038.jpg',
            'Order': 306,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_roodstreep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:32:19',
            'Categories': [],
            'Created': '07/24/2017 14:08:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1042,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1042.jpg',
            'Order': 310,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_rozerood',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:40:53',
            'Categories': [],
            'Created': '07/24/2017 14:09:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1043,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1043.jpg',
            'Order': 311,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_roze',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:34:29',
            'Categories': [],
            'Created': '07/24/2017 14:10:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1046,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1046.jpg',
            'Order': 314,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_fuchsia',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:37:57',
            'Categories': [],
            'Created': '07/24/2017 14:13:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1048,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1048.jpg',
            'Order': 316,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_boom',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:39:05',
            'Categories': [],
            'Created': '07/24/2017 14:14:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1050,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1050.jpg',
            'Order': 318,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_bloem',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:40:17',
            'Categories': [],
            'Created': '07/24/2017 14:15:38',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1052,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1052.jpg',
            'Order': 320,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:40:51',
            'Categories': [],
            'Created': '07/24/2017 14:16:46',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1053,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1053.jpg',
            'Order': 321,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:02:19',
            'Categories': [],
            'Created': '07/24/2017 14:17:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1054,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1054.jpg',
            'Order': 322,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:02:51',
            'Categories': [],
            'Created': '07/24/2017 14:18:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1056,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1056.jpg',
            'Order': 324,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruitrood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:03:06',
            'Categories': [],
            'Created': '07/24/2017 14:19:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1057,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1057.jpg',
            'Order': 325,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_stip rood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:05:08',
            'Categories': [],
            'Created': '07/24/2017 14:21:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1059,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1059.png',
            'Order': 327,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_moederdag',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:06:55',
            'Categories': [],
            'Created': '07/24/2017 14:22:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1062,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1062.png',
            'Order': 330,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:06:37',
            'Categories': [],
            'Created': '07/24/2017 14:24:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1064,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1064.png',
            'Order': 332,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_verkeer',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:10',
            'Categories': [],
            'Created': '07/24/2017 14:26:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1066,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1066.png',
            'Order': 334,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geboorte meisje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:25',
            'Categories': [],
            'Created': '07/24/2017 14:28:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1071,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1071.png',
            'Order': 339,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_suikerfeest',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:55',
            'Categories': [],
            'Created': '07/24/2017 14:31:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1074,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1074.png',
            'Order': 342,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:35:27',
            'Categories': [],
            'Created': '07/24/2017 14:32:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1155,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1155.jpg',
            'Order': 423,
            'Size': '{Width=331, Height=331}',
            'Title': 'Choco_lolly_blauw',
            'LastModifiedBy': 'HEMALOCAL\\schroderr',
            'LastModified': '07/24/2017 15:28:58',
            'Categories': [],
            'Created': '07/24/2017 15:28:58',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1157,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1157.png',
            'Order': 425,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_hartje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:35:03',
            'Categories': [],
            'Created': '07/24/2017 15:29:47',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 17,
            'Title': 'Montserrat',
            'ImagePath': 'fonts/font-17.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 14,
            'Order': 5,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '08/15/2017 12:04:47',
            'LastModifiedBy': 'HEMALOCAL\\emdvorobiova',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 22,
            'Title': 'Bungee',
            'ImagePath': 'fonts/font-22.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 9,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/22/2017 06:29:11',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:25:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 15,
            'Title': '6380002',
            'Created': '05/16/2017 14:25:19',
            'LastModified': '07/17/2019 10:29:39',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 12,
            'ShapeId': 2,
            'Width': 331,
            'Height': 331,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-choco-lolly',
            'BackgroundWidth': 396,
            'BackgroundHeight': 396,
            'Bleed': 12,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': 1034,
            'MultiCloneWidth': 739,
            'IsMultiClone': true,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': '{\'Cloning\':{\'Items\':[{\'Left\':0,\'Top\':142,\'Rotation\':-75},{\'Left\':408,\'Top\':0,\'Rotation\':105},{\'Left\':0,\'Top\':703,\'Rotation\':-75},{\'Left\':408,\'Top\':561,\'Rotation\':105}]},\'Masking\':{\'PredefinedShape\':1},\'IsLollyCake\':true}',
            'ImagePath': 'products/product-15.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-15.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': true,
            'CornerRadius': 165,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-choco-lolly'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 2,
            'Active': 1,
            'ImagePath': 'templates/template-2.svg',
            'ShapeId': 2,
            'Created': '02/22/2017 13:53:08',
            'LastModified': '05/18/2017 12:10:03',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 4,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 23.076923}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 53.846154}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 23.076923}}',
            'Title': 'Layout-03'
          },
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 5,
            'Active': 1,
            'ImagePath': 'templates/template-5.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:11:50',
            'LastModified': '05/18/2017 12:10:06',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 5,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 50, h: 50}}',
            'Title': 'Layout-04'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 7,
            'Active': 1,
            'ImagePath': 'templates/template-7.svg',
            'ShapeId': 2,
            'Created': '04/27/2017 08:36:17',
            'LastModified': '05/18/2017 12:10:16',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 6,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 8, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 9, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-05'
          },
          {
            'LayoutTemplateId': 8,
            'Active': 1,
            'ImagePath': 'templates/template-8.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:48:38',
            'LastModified': '05/18/2017 12:10:12',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 7,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-06'
          },
          {
            'LayoutTemplateId': 9,
            'Active': 1,
            'ImagePath': 'templates/template-9.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:49:05',
            'LastModified': '05/18/2017 12:10:20',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 8,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-07'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          },
          {
            'LayoutTemplateId': 12,
            'Active': 1,
            'ImagePath': 'templates/template-12.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:24:43',
            'LastModified': '05/18/2017 12:10:25',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 9,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-08'
          },
          {
            'LayoutTemplateId': 13,
            'Active': 1,
            'ImagePath': 'templates/template-13.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:26:35',
            'LastModified': '06/16/2017 13:30:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Order': 10,
            'PermittedSides': 'center,top,right,bottom',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 50, h: 100}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 100}}',
            'Title': 'Layout-09'
          },
          {
            'LayoutTemplateId': 14,
            'Active': 1,
            'ImagePath': 'templates/template-14.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:27:44',
            'LastModified': '05/18/2017 12:10:33',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 11,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-10'
          },
          {
            'LayoutTemplateId': 15,
            'Active': 1,
            'ImagePath': 'templates/template-15.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:12',
            'LastModified': '05/18/2017 12:10:38',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 12,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-11'
          },
          {
            'LayoutTemplateId': 16,
            'Active': 0,
            'ImagePath': 'templates/template-16.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:35',
            'LastModified': '07/31/2019 15:15:43',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 13,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: \'hidden\', accept: \'\', dimension: {w: 100, h: 33.333333}},\r\n{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-12'
          },
          {
            'LayoutTemplateId': 17,
            'Active': 1,
            'ImagePath': 'templates/template-17.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:16',
            'LastModified': '05/18/2017 12:10:46',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 14,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 66.666666}}',
            'Title': 'Layout-13'
          },
          {
            'LayoutTemplateId': 18,
            'Active': 1,
            'ImagePath': 'templates/template-18.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:41',
            'LastModified': '05/18/2017 12:10:50',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 15,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 50}}',
            'Title': 'Layout-14'
          },
          {
            'LayoutTemplateId': 19,
            'Active': 1,
            'ImagePath': 'templates/template-19.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:30:07',
            'LastModified': '06/07/2017 12:46:48',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'Order': 16,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-15'
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 13,
            'Active': 1,
            'Order': 3,
            'Title': 'Strik',
            'ImagePath': 'stickers/sticker-13.png',
            'Size': '{Width=625, Height=335}',
            'LastModified': '05/09/2017 07:13:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:55',
            'ProductTypes': []
          },
          {
            'StickerId': 14,
            'Active': 1,
            'Order': 4,
            'Title': 'Cirkel',
            'ImagePath': 'stickers/sticker-14.png',
            'Size': '{Width=623, Height=624}',
            'LastModified': '05/09/2017 07:14:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:06',
            'ProductTypes': []
          },
          {
            'StickerId': 15,
            'Active': 1,
            'Order': 5,
            'Title': 'Spreekwolk',
            'ImagePath': 'stickers/sticker-15.png',
            'Size': '{Width=833, Height=736}',
            'LastModified': '05/09/2017 07:14:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:19',
            'ProductTypes': []
          },
          {
            'StickerId': 16,
            'Active': 1,
            'Order': 7,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-16.png',
            'Size': '{Width=662, Height=737}',
            'LastModified': '05/09/2017 07:14:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:27',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 19,
            'Active': 1,
            'Order': 10,
            'Title': 'Bril',
            'ImagePath': 'stickers/sticker-19.png',
            'Size': '{Width=688, Height=229}',
            'LastModified': '05/09/2017 07:15:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:01',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 21,
            'Active': 1,
            'Order': 12,
            'Title': 'Baby',
            'ImagePath': 'stickers/sticker-21.png',
            'Size': '{Width=729, Height=658}',
            'LastModified': '05/09/2017 07:15:47',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:47',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 23,
            'Active': 1,
            'Order': 14,
            'Title': 'Hart blauw',
            'ImagePath': 'stickers/sticker-23.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '05/09/2017 07:16:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:14',
            'ProductTypes': []
          },
          {
            'StickerId': 24,
            'Active': 1,
            'Order': 15,
            'Title': 'Ster blauw',
            'ImagePath': 'stickers/sticker-24.png',
            'Size': '{Width=625, Height=570}',
            'LastModified': '05/09/2017 07:16:24',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:24',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 26,
            'Active': 1,
            'Order': 17,
            'Title': 'Welkom kleintje',
            'ImagePath': 'stickers/sticker-26.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:16:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:56',
            'ProductTypes': []
          },
          {
            'StickerId': 27,
            'Active': 1,
            'Order': 18,
            'Title': 'Welkom kleintjes',
            'ImagePath': 'stickers/sticker-27.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:17:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:13',
            'ProductTypes': []
          },
          {
            'StickerId': 28,
            'Active': 1,
            'Order': 19,
            'Title': 'Sinasappel',
            'ImagePath': 'stickers/sticker-28.png',
            'Size': '{Width=729, Height=729}',
            'LastModified': '05/09/2017 07:17:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:25',
            'ProductTypes': []
          },
          {
            'StickerId': 29,
            'Active': 1,
            'Order': 20,
            'Title': 'Blaadje',
            'ImagePath': 'stickers/sticker-29.png',
            'Size': '{Width=717, Height=238}',
            'LastModified': '05/09/2017 07:17:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:37',
            'ProductTypes': []
          },
          {
            'StickerId': 30,
            'Active': 1,
            'Order': 21,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-30.png',
            'Size': '{Width=359, Height=931}',
            'LastModified': '05/09/2017 07:17:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:48',
            'ProductTypes': []
          },
          {
            'StickerId': 31,
            'Active': 1,
            'Order': 22,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-31.png',
            'Size': '{Width=383, Height=942}',
            'LastModified': '05/09/2017 07:18:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:02',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 33,
            'Active': 1,
            'Order': 24,
            'Title': 'Ananas',
            'ImagePath': 'stickers/sticker-33.png',
            'Size': '{Width=405, Height=738}',
            'LastModified': '05/09/2017 07:18:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:28',
            'ProductTypes': []
          },
          {
            'StickerId': 34,
            'Active': 1,
            'Order': 25,
            'Title': 'Herfst blaadjes',
            'ImagePath': 'stickers/sticker-34.png',
            'Size': '{Width=255, Height=546}',
            'LastModified': '05/09/2017 07:18:46',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:46',
            'ProductTypes': []
          },
          {
            'StickerId': 35,
            'Active': 1,
            'Order': 26,
            'Title': 'Winter',
            'ImagePath': 'stickers/sticker-35.png',
            'Size': '{Width=476, Height=785}',
            'LastModified': '05/09/2017 07:18:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:59',
            'ProductTypes': []
          },
          {
            'StickerId': 36,
            'Active': 1,
            'Order': 27,
            'Title': 'Astronaut',
            'ImagePath': 'stickers/sticker-36.png',
            'Size': '{Width=589, Height=988}',
            'LastModified': '05/09/2017 07:19:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:14',
            'ProductTypes': []
          },
          {
            'StickerId': 37,
            'Active': 1,
            'Order': 28,
            'Title': 'Jarig',
            'ImagePath': 'stickers/sticker-37.png',
            'Size': '{Width=1036, Height=1026}',
            'LastModified': '05/09/2017 07:19:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:26',
            'ProductTypes': []
          },
          {
            'StickerId': 38,
            'Active': 1,
            'Order': 29,
            'Title': 'Kikker',
            'ImagePath': 'stickers/sticker-38.png',
            'Size': '{Width=1042, Height=1040}',
            'LastModified': '05/09/2017 07:19:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:38',
            'ProductTypes': []
          },
          {
            'StickerId': 39,
            'Active': 1,
            'Order': 30,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-39.png',
            'Size': '{Width=1042, Height=651}',
            'LastModified': '05/09/2017 07:19:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:56',
            'ProductTypes': []
          },
          {
            'StickerId': 40,
            'Active': 1,
            'Order': 31,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-40.png',
            'Size': '{Width=988, Height=311}',
            'LastModified': '05/09/2017 07:20:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:13',
            'ProductTypes': []
          },
          {
            'StickerId': 41,
            'Active': 1,
            'Order': 32,
            'Title': 'Piratenmuts',
            'ImagePath': 'stickers/sticker-41.png',
            'Size': '{Width=1042, Height=591}',
            'LastModified': '05/09/2017 07:20:34',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:34',
            'ProductTypes': []
          },
          {
            'StickerId': 42,
            'Active': 1,
            'Order': 33,
            'Title': 'Takkie',
            'ImagePath': 'stickers/sticker-42.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:20:45',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:45',
            'ProductTypes': []
          },
          {
            'StickerId': 43,
            'Active': 1,
            'Order': 34,
            'Title': 'Ballon geel',
            'ImagePath': 'stickers/sticker-43.png',
            'Size': '{Width=377, Height=1024}',
            'LastModified': '05/09/2017 07:20:58',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:58',
            'ProductTypes': []
          },
          {
            'StickerId': 44,
            'Active': 1,
            'Order': 35,
            'Title': 'Getrouwd',
            'ImagePath': 'stickers/sticker-44.png',
            'Size': '{Width=1028, Height=349}',
            'LastModified': '05/09/2017 07:21:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:11',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 46,
            'Active': 1,
            'Order': 37,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-46.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:21:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:57',
            'ProductTypes': []
          },
          {
            'StickerId': 47,
            'Active': 1,
            'Order': 38,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-47.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:22:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:19',
            'ProductTypes': []
          },
          {
            'StickerId': 48,
            'Active': 1,
            'Order': 39,
            'Title': 'Papagaai',
            'ImagePath': 'stickers/sticker-48.png',
            'Size': '{Width=1042, Height=928}',
            'LastModified': '05/09/2017 07:22:30',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:30',
            'ProductTypes': []
          },
          {
            'StickerId': 49,
            'Active': 1,
            'Order': 40,
            'Title': 'Robot',
            'ImagePath': 'stickers/sticker-49.png',
            'Size': '{Width=674, Height=1009}',
            'LastModified': '05/09/2017 07:22:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:43',
            'ProductTypes': []
          },
          {
            'StickerId': 50,
            'Active': 1,
            'Order': 41,
            'Title': 'The king',
            'ImagePath': 'stickers/sticker-50.png',
            'Size': '{Width=1044, Height=197}',
            'LastModified': '05/09/2017 07:22:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:55',
            'ProductTypes': []
          },
          {
            'StickerId': 51,
            'Active': 1,
            'Order': 42,
            'Title': 'Ballonnen groen',
            'ImagePath': 'stickers/sticker-51.png',
            'Size': '{Width=785, Height=1007}',
            'LastModified': '05/09/2017 07:23:10',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:10',
            'ProductTypes': []
          },
          {
            'StickerId': 52,
            'Active': 1,
            'Order': 43,
            'Title': 'Je bent mijn liefste',
            'ImagePath': 'stickers/sticker-52.png',
            'Size': '{Width=487, Height=1042}',
            'LastModified': '05/09/2017 07:23:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:27',
            'ProductTypes': []
          },
          {
            'StickerId': 53,
            'Active': 1,
            'Order': 44,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-53.png',
            'Size': '{Width=1038, Height=948}',
            'LastModified': '05/09/2017 07:23:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:37',
            'ProductTypes': []
          },
          {
            'StickerId': 54,
            'Active': 1,
            'Order': 45,
            'Title': 'Racket',
            'ImagePath': 'stickers/sticker-54.png',
            'Size': '{Width=420, Height=1016}',
            'LastModified': '05/09/2017 07:23:49',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:49',
            'ProductTypes': []
          },
          {
            'StickerId': 55,
            'Active': 1,
            'Order': 46,
            'Title': 'Zwaard',
            'ImagePath': 'stickers/sticker-55.png',
            'Size': '{Width=461, Height=1042}',
            'LastModified': '05/09/2017 07:24:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:01',
            'ProductTypes': []
          },
          {
            'StickerId': 56,
            'Active': 1,
            'Order': 47,
            'Title': 'Hoeravlag',
            'ImagePath': 'stickers/sticker-56.png',
            'Size': '{Width=1045, Height=252}',
            'LastModified': '05/09/2017 07:24:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:13',
            'ProductTypes': []
          },
          {
            'StickerId': 57,
            'Active': 1,
            'Order': 48,
            'Title': 'Rood hartje',
            'ImagePath': 'stickers/sticker-57.png',
            'Size': '{Width=624, Height=1007}',
            'LastModified': '05/09/2017 07:24:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:27',
            'ProductTypes': []
          },
          {
            'StickerId': 58,
            'Active': 1,
            'Order': 49,
            'Title': 'Hoera banner',
            'ImagePath': 'stickers/sticker-58.png',
            'Size': '{Width=1029, Height=530}',
            'LastModified': '05/09/2017 07:24:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:48',
            'ProductTypes': []
          },
          {
            'StickerId': 59,
            'Active': 1,
            'Order': 50,
            'Title': 'Raket',
            'ImagePath': 'stickers/sticker-59.png',
            'Size': '{Width=659, Height=984}',
            'LastModified': '05/09/2017 07:25:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:05',
            'ProductTypes': []
          },
          {
            'StickerId': 60,
            'Active': 1,
            'Order': 51,
            'Title': 'Twee hartjes',
            'ImagePath': 'stickers/sticker-60.png',
            'Size': '{Width=968, Height=754}',
            'LastModified': '05/09/2017 07:25:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:18',
            'ProductTypes': []
          },
          {
            'StickerId': 61,
            'Active': 1,
            'Order': 52,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-61.png',
            'Size': '{Width=995, Height=543}',
            'LastModified': '05/09/2017 07:25:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:31',
            'ProductTypes': []
          },
          {
            'StickerId': 62,
            'Active': 1,
            'Order': 53,
            'Title': 'Lijn hartjes',
            'ImagePath': 'stickers/sticker-62.png',
            'Size': '{Width=982, Height=958}',
            'LastModified': '05/09/2017 07:25:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:43',
            'ProductTypes': []
          },
          {
            'StickerId': 63,
            'Active': 1,
            'Order': 54,
            'Title': 'Roze hartje',
            'ImagePath': 'stickers/sticker-63.png',
            'Size': '{Width=624, Height=1017}',
            'LastModified': '05/09/2017 07:26:23',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:23',
            'ProductTypes': []
          },
          {
            'StickerId': 64,
            'Active': 1,
            'Order': 55,
            'Title': 'Ufo',
            'ImagePath': 'stickers/sticker-64.png',
            'Size': '{Width=914, Height=958}',
            'LastModified': '05/09/2017 07:26:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:32',
            'ProductTypes': []
          },
          {
            'StickerId': 65,
            'Active': 1,
            'Order': 56,
            'Title': 'Kadootje',
            'ImagePath': 'stickers/sticker-65.png',
            'Size': '{Width=706, Height=1012}',
            'LastModified': '05/09/2017 07:26:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:42',
            'ProductTypes': []
          },
          {
            'StickerId': 66,
            'Active': 1,
            'Order': 57,
            'Title': 'Ring',
            'ImagePath': 'stickers/sticker-66.png',
            'Size': '{Width=620, Height=1001}',
            'LastModified': '05/09/2017 07:26:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:51',
            'ProductTypes': []
          },
          {
            'StickerId': 67,
            'Active': 1,
            'Order': 58,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-67.png',
            'Size': '{Width=1020, Height=947}',
            'LastModified': '05/09/2017 07:27:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:01',
            'ProductTypes': []
          },
          {
            'StickerId': 68,
            'Active': 1,
            'Order': 59,
            'Title': 'Bowtie',
            'ImagePath': 'stickers/sticker-68.png',
            'Size': '{Width=1017, Height=514}',
            'LastModified': '05/09/2017 07:27:09',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:09',
            'ProductTypes': []
          },
          {
            'StickerId': 69,
            'Active': 1,
            'Order': 60,
            'Title': 'Confetti',
            'ImagePath': 'stickers/sticker-69.png',
            'Size': '{Width=333, Height=995}',
            'LastModified': '05/09/2017 07:27:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:21',
            'ProductTypes': []
          },
          {
            'StickerId': 70,
            'Active': 1,
            'Order': 61,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-70.png',
            'Size': '{Width=898, Height=1006}',
            'LastModified': '05/09/2017 07:27:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:33',
            'ProductTypes': []
          },
          {
            'StickerId': 71,
            'Active': 1,
            'Order': 62,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-71.png',
            'Size': '{Width=1027, Height=573}',
            'LastModified': '05/09/2017 07:27:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:42',
            'ProductTypes': []
          },
          {
            'StickerId': 72,
            'Active': 1,
            'Order': 63,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-72.png',
            'Size': '{Width=797, Height=985}',
            'LastModified': '05/09/2017 07:27:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:55',
            'ProductTypes': []
          },
          {
            'StickerId': 73,
            'Active': 1,
            'Order': 64,
            'Title': 'Mr',
            'ImagePath': 'stickers/sticker-73.png',
            'Size': '{Width=1038, Height=932}',
            'LastModified': '05/09/2017 07:28:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:07',
            'ProductTypes': []
          },
          {
            'StickerId': 74,
            'Active': 1,
            'Order': 65,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-74.png',
            'Size': '{Width=708, Height=990}',
            'LastModified': '05/09/2017 07:28:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:18',
            'ProductTypes': []
          },
          {
            'StickerId': 75,
            'Active': 1,
            'Order': 66,
            'Title': 'Ms',
            'ImagePath': 'stickers/sticker-75.png',
            'Size': '{Width=1031, Height=971}',
            'LastModified': '05/09/2017 07:28:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:32',
            'ProductTypes': []
          },
          {
            'StickerId': 76,
            'Active': 1,
            'Order': 67,
            'Title': 'Rainbow',
            'ImagePath': 'stickers/sticker-76.png',
            'Size': '{Width=1010, Height=659}',
            'LastModified': '05/09/2017 07:28:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:42',
            'ProductTypes': []
          },
          {
            'StickerId': 77,
            'Active': 1,
            'Order': 68,
            'Title': 'Champagne',
            'ImagePath': 'stickers/sticker-77.png',
            'Size': '{Width=341, Height=1006}',
            'LastModified': '05/09/2017 07:28:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:56',
            'ProductTypes': []
          },
          {
            'StickerId': 78,
            'Active': 1,
            'Order': 69,
            'Title': 'Hartjes',
            'ImagePath': 'stickers/sticker-78.png',
            'Size': '{Width=951, Height=571}',
            'LastModified': '05/09/2017 07:29:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:06',
            'ProductTypes': []
          },
          {
            'StickerId': 79,
            'Active': 1,
            'Order': 70,
            'Title': 'You are just lovely',
            'ImagePath': 'stickers/sticker-79.png',
            'Size': '{Width=987, Height=899}',
            'LastModified': '05/09/2017 07:29:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:26',
            'ProductTypes': []
          },
          {
            'StickerId': 80,
            'Active': 1,
            'Order': 71,
            'Title': 'Medaille',
            'ImagePath': 'stickers/sticker-80.png',
            'Size': '{Width=591, Height=1018}',
            'LastModified': '05/09/2017 07:29:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:40',
            'ProductTypes': []
          },
          {
            'StickerId': 81,
            'Active': 1,
            'Order': 72,
            'Title': 'Pluk de dag',
            'ImagePath': 'stickers/sticker-81.png',
            'Size': '{Width=509, Height=1042}',
            'LastModified': '05/09/2017 07:29:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:51',
            'ProductTypes': []
          },
          {
            'StickerId': 82,
            'Active': 1,
            'Order': 73,
            'Title': 'Zon',
            'ImagePath': 'stickers/sticker-82.png',
            'Size': '{Width=1033, Height=1005}',
            'LastModified': '05/09/2017 07:30:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:01',
            'ProductTypes': []
          },
          {
            'StickerId': 83,
            'Active': 1,
            'Order': 74,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-83.png',
            'Size': '{Width=997, Height=646}',
            'LastModified': '05/09/2017 07:30:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:11',
            'ProductTypes': []
          },
          {
            'StickerId': 84,
            'Active': 1,
            'Order': 75,
            'Title': 'Hartjesdoos mama',
            'ImagePath': 'stickers/sticker-84.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:28',
            'ProductTypes': []
          },
          {
            'StickerId': 85,
            'Active': 1,
            'Order': 76,
            'Title': 'Hartjesdoos',
            'ImagePath': 'stickers/sticker-85.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:41',
            'ProductTypes': []
          },
          {
            'StickerId': 86,
            'Active': 1,
            'Order': 77,
            'Title': 'Wolk rain',
            'ImagePath': 'stickers/sticker-86.png',
            'Size': '{Width=1002, Height=948}',
            'LastModified': '05/09/2017 07:30:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:54',
            'ProductTypes': []
          },
          {
            'StickerId': 87,
            'Active': 1,
            'Order': 78,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-87.png',
            'Size': '{Width=1025, Height=721}',
            'LastModified': '05/09/2017 07:31:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:05',
            'ProductTypes': []
          },
          {
            'StickerId': 88,
            'Active': 1,
            'Order': 79,
            'Title': 'Hartje mama',
            'ImagePath': 'stickers/sticker-88.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:32',
            'ProductTypes': []
          },
          {
            'StickerId': 89,
            'Active': 1,
            'Order': 80,
            'Title': 'Hartje',
            'ImagePath': 'stickers/sticker-89.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:42',
            'ProductTypes': []
          },
          {
            'StickerId': 90,
            'Active': 1,
            'Order': 81,
            'Title': 'Wolk donder',
            'ImagePath': 'stickers/sticker-90.png',
            'Size': '{Width=878, Height=998}',
            'LastModified': '05/09/2017 07:40:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:00',
            'ProductTypes': []
          },
          {
            'StickerId': 91,
            'Active': 1,
            'Order': 82,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-91.png',
            'Size': '{Width=1013, Height=1013}',
            'LastModified': '05/09/2017 07:40:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:14',
            'ProductTypes': []
          },
          {
            'StickerId': 92,
            'Active': 1,
            'Order': 83,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-92.png',
            'Size': '{Width=768, Height=1013}',
            'LastModified': '05/09/2017 07:40:44',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:44',
            'ProductTypes': []
          },
          {
            'StickerId': 93,
            'Active': 1,
            'Order': 84,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-93.png',
            'Size': '{Width=1009, Height=1022}',
            'LastModified': '05/09/2017 07:40:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:54',
            'ProductTypes': []
          },
          {
            'StickerId': 94,
            'Active': 1,
            'Order': 85,
            'Title': 'Zwemband',
            'ImagePath': 'stickers/sticker-94.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:41:04',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:04',
            'ProductTypes': []
          },
          {
            'StickerId': 95,
            'Active': 1,
            'Order': 86,
            'Title': 'Plons',
            'ImagePath': 'stickers/sticker-95.png',
            'Size': '{Width=1033, Height=430}',
            'LastModified': '05/09/2017 07:41:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:17',
            'ProductTypes': []
          },
          {
            'StickerId': 96,
            'Active': 1,
            'Order': 87,
            'Title': 'Zwemdiploma',
            'ImagePath': 'stickers/sticker-96.png',
            'Size': '{Width=1019, Height=121}',
            'LastModified': '05/09/2017 07:41:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:29',
            'ProductTypes': []
          },
          {
            'StickerId': 97,
            'Active': 1,
            'Order': 88,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-97.png',
            'Size': '{Width=719, Height=1044}',
            'LastModified': '05/09/2017 07:41:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:41',
            'ProductTypes': []
          },
          {
            'StickerId': 98,
            'Active': 1,
            'Order': 89,
            'Title': 'New home',
            'ImagePath': 'stickers/sticker-98.png',
            'Size': '{Width=835, Height=1042}',
            'LastModified': '05/09/2017 07:41:52',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:52',
            'ProductTypes': []
          },
          {
            'StickerId': 99,
            'Active': 1,
            'Order': 90,
            'Title': 'Sportheld',
            'ImagePath': 'stickers/sticker-99.png',
            'Size': '{Width=925, Height=1040}',
            'LastModified': '05/09/2017 07:42:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:02',
            'ProductTypes': []
          },
          {
            'StickerId': 100,
            'Active': 1,
            'Order': 91,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-100.png',
            'Size': '{Width=855, Height=1042}',
            'LastModified': '05/09/2017 07:42:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:12',
            'ProductTypes': []
          },
          {
            'StickerId': 101,
            'Active': 1,
            'Order': 92,
            'Title': 'Present',
            'ImagePath': 'stickers/sticker-101.png',
            'Size': '{Width=714, Height=1004}',
            'LastModified': '05/09/2017 07:42:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:21',
            'ProductTypes': []
          },
          {
            'StickerId': 102,
            'Active': 1,
            'Order': 93,
            'Title': 'Bird',
            'ImagePath': 'stickers/sticker-102.png',
            'Size': '{Width=1031, Height=720}',
            'LastModified': '05/09/2017 07:42:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:31',
            'ProductTypes': []
          },
          {
            'StickerId': 103,
            'Active': 1,
            'Order': 94,
            'Title': 'Snowflake',
            'ImagePath': 'stickers/sticker-103.png',
            'Size': '{Width=922, Height=1000}',
            'LastModified': '10/11/2022 14:35:16',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:40',
            'ProductTypes': []
          },
          {
            'StickerId': 104,
            'Active': 1,
            'Order': 95,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-104.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:53',
            'ProductTypes': []
          },
          {
            'StickerId': 105,
            'Active': 1,
            'Order': 96,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-105.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:57',
            'ProductTypes': []
          },
          {
            'StickerId': 106,
            'Active': 1,
            'Order': 97,
            'Title': 'Bat',
            'ImagePath': 'stickers/sticker-106.png',
            'Size': '{Width=1042, Height=315}',
            'LastModified': '10/11/2022 14:35:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:07',
            'ProductTypes': []
          },
          {
            'StickerId': 107,
            'Active': 1,
            'Order': 98,
            'Title': 'Hoera een jongen',
            'ImagePath': 'stickers/sticker-107.png',
            'Size': '{Width=734, Height=1042}',
            'LastModified': '05/09/2017 07:43:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:21',
            'ProductTypes': []
          },
          {
            'StickerId': 108,
            'Active': 1,
            'Order': 99,
            'Title': 'Bedankt',
            'ImagePath': 'stickers/sticker-108.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:43:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:32',
            'ProductTypes': []
          },
          {
            'StickerId': 109,
            'Active': 1,
            'Order': 100,
            'Title': 'Pumpkin',
            'ImagePath': 'stickers/sticker-109.png',
            'Size': '{Width=1042, Height=763}',
            'LastModified': '10/11/2022 14:35:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:47',
            'ProductTypes': []
          },
          {
            'StickerId': 110,
            'Active': 1,
            'Order': 101,
            'Title': 'Stoplicht',
            'ImagePath': 'stickers/sticker-110.png',
            'Size': '{Width=288, Height=1032}',
            'LastModified': '05/09/2017 07:44:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:00',
            'ProductTypes': []
          },
          {
            'StickerId': 111,
            'Active': 1,
            'Order': 102,
            'Title': 'Hoera rijbewijs',
            'ImagePath': 'stickers/sticker-111.png',
            'Size': '{Width=1040, Height=632}',
            'LastModified': '05/09/2017 07:44:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:14',
            'ProductTypes': []
          },
          {
            'StickerId': 112,
            'Active': 1,
            'Order': 103,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-112.png',
            'Size': '{Width=997, Height=997}',
            'LastModified': '05/09/2017 07:44:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:25',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 13,
        'Name': 'choco-fotolist-cake-957x662',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1029,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1029.jpg',
            'Order': 297,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_blauw',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:29',
            'Categories': [],
            'Created': '07/24/2017 14:01:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1031,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1031.jpg',
            'Order': 299,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_groen',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:46',
            'Categories': [],
            'Created': '07/24/2017 14:03:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1034,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1034.jpg',
            'Order': 302,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geel',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:13',
            'Categories': [],
            'Created': '07/24/2017 14:05:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1038,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1038.jpg',
            'Order': 306,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_roodstreep',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:32:19',
            'Categories': [],
            'Created': '07/24/2017 14:08:15',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1042,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1042.jpg',
            'Order': 310,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_rozerood',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:40:53',
            'Categories': [],
            'Created': '07/24/2017 14:09:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1043,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1043.jpg',
            'Order': 311,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_roze',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:34:29',
            'Categories': [],
            'Created': '07/24/2017 14:10:59',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1046,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1046.jpg',
            'Order': 314,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_fuchsia',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:37:57',
            'Categories': [],
            'Created': '07/24/2017 14:13:00',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1048,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1048.jpg',
            'Order': 316,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_boom',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:39:05',
            'Categories': [],
            'Created': '07/24/2017 14:14:09',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1050,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1050.jpg',
            'Order': 318,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_bloem',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:40:17',
            'Categories': [],
            'Created': '07/24/2017 14:15:38',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1052,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1052.jpg',
            'Order': 320,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:40:51',
            'Categories': [],
            'Created': '07/24/2017 14:16:46',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1053,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1053.jpg',
            'Order': 321,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:02:19',
            'Categories': [],
            'Created': '07/24/2017 14:17:49',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1054,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1054.jpg',
            'Order': 322,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruit blauw',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:02:51',
            'Categories': [],
            'Created': '07/24/2017 14:18:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1056,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1056.jpg',
            'Order': 324,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_ruitrood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:03:06',
            'Categories': [],
            'Created': '07/24/2017 14:19:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1057,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1057.jpg',
            'Order': 325,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_stip rood',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:05:08',
            'Categories': [],
            'Created': '07/24/2017 14:21:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1059,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1059.png',
            'Order': 327,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_moederdag',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:06:55',
            'Categories': [],
            'Created': '07/24/2017 14:22:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1062,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1062.png',
            'Order': 330,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:06:37',
            'Categories': [],
            'Created': '07/24/2017 14:24:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1064,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1064.png',
            'Order': 332,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_verkeer',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:10',
            'Categories': [],
            'Created': '07/24/2017 14:26:12',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1066,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1066.png',
            'Order': 334,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geboorte meisje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:25',
            'Categories': [],
            'Created': '07/24/2017 14:28:24',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1071,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1071.png',
            'Order': 339,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_suikerfeest',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 08:07:55',
            'Categories': [],
            'Created': '07/24/2017 14:31:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1074,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1074.png',
            'Order': 342,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:35:27',
            'Categories': [],
            'Created': '07/24/2017 14:32:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1157,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1157.png',
            'Order': 425,
            'Size': '{Width=950, Height=655}',
            'Title': 'choco_ipad_hartje',
            'LastModifiedBy': 'HEMALOCAL\\Eedew',
            'LastModified': '07/26/2017 07:35:03',
            'Categories': [],
            'Created': '07/24/2017 15:29:47',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 17,
            'Title': 'Montserrat',
            'ImagePath': 'fonts/font-17.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 14,
            'Order': 5,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '08/15/2017 12:04:47',
            'LastModifiedBy': 'HEMALOCAL\\emdvorobiova',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:02',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 22,
            'Title': 'Bungee',
            'ImagePath': 'fonts/font-22.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 9,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/22/2017 06:29:11',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:25:26',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 13,
            'Title': '6380003',
            'Created': '05/16/2017 14:22:41',
            'LastModified': '03/07/2018 09:36:35',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 13,
            'ShapeId': 2,
            'Width': 957,
            'Height': 662,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-choco-fotolist',
            'BackgroundWidth': 1098,
            'BackgroundHeight': 808,
            'Bleed': 14,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 1,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-13.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-13.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-choco-fotolist'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 2,
            'Active': 1,
            'ImagePath': 'templates/template-2.svg',
            'ShapeId': 2,
            'Created': '02/22/2017 13:53:08',
            'LastModified': '05/18/2017 12:10:03',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 4,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 23.076923}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 53.846154}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 23.076923}}',
            'Title': 'Layout-03'
          },
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 5,
            'Active': 1,
            'ImagePath': 'templates/template-5.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:11:50',
            'LastModified': '05/18/2017 12:10:06',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 5,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 50, h: 50}}',
            'Title': 'Layout-04'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 7,
            'Active': 1,
            'ImagePath': 'templates/template-7.svg',
            'ShapeId': 2,
            'Created': '04/27/2017 08:36:17',
            'LastModified': '05/18/2017 12:10:16',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 6,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 8, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 9, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-05'
          },
          {
            'LayoutTemplateId': 8,
            'Active': 1,
            'ImagePath': 'templates/template-8.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:48:38',
            'LastModified': '05/18/2017 12:10:12',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 7,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}},\r\n{id: 7, accept: \'photo\', dimension: {w: 33.333333, h: 33.333333}}',
            'Title': 'Layout-06'
          },
          {
            'LayoutTemplateId': 9,
            'Active': 1,
            'ImagePath': 'templates/template-9.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:49:05',
            'LastModified': '05/18/2017 12:10:20',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 8,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 66.666666}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-07'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          },
          {
            'LayoutTemplateId': 12,
            'Active': 1,
            'ImagePath': 'templates/template-12.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:24:43',
            'LastModified': '05/18/2017 12:10:25',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 9,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-08'
          },
          {
            'LayoutTemplateId': 13,
            'Active': 1,
            'ImagePath': 'templates/template-13.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:26:35',
            'LastModified': '06/16/2017 13:30:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Order': 10,
            'PermittedSides': 'center,top,right,bottom',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 50, h: 100}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 100}}',
            'Title': 'Layout-09'
          },
          {
            'LayoutTemplateId': 14,
            'Active': 1,
            'ImagePath': 'templates/template-14.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:27:44',
            'LastModified': '05/18/2017 12:10:33',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 11,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-10'
          },
          {
            'LayoutTemplateId': 15,
            'Active': 1,
            'ImagePath': 'templates/template-15.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:12',
            'LastModified': '05/18/2017 12:10:38',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 12,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 33.333333}},\r\n{id: 3, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-11'
          },
          {
            'LayoutTemplateId': 16,
            'Active': 0,
            'ImagePath': 'templates/template-16.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:35',
            'LastModified': '07/31/2019 15:15:43',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 13,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: \'hidden\', accept: \'\', dimension: {w: 100, h: 33.333333}},\r\n{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-12'
          },
          {
            'LayoutTemplateId': 17,
            'Active': 1,
            'ImagePath': 'templates/template-17.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:16',
            'LastModified': '05/18/2017 12:10:46',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 14,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}},\r\n{id: 2, accept: \'photo\', dimension: {w: 100, h: 66.666666}}',
            'Title': 'Layout-13'
          },
          {
            'LayoutTemplateId': 18,
            'Active': 1,
            'ImagePath': 'templates/template-18.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:29:41',
            'LastModified': '05/18/2017 12:10:50',
            'LastModifiedBy': 'HEMALOCAL\\VriesE',
            'Order': 15,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 5, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 6, accept: \'photo\', dimension: {w: 33.333333, h: 50}}',
            'Title': 'Layout-14'
          },
          {
            'LayoutTemplateId': 19,
            'Active': 1,
            'ImagePath': 'templates/template-19.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:30:07',
            'LastModified': '06/07/2017 12:46:48',
            'LastModifiedBy': 'HEMALOCAL\\emhcakirkan',
            'Order': 16,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 33.333333, h: 50}},\r\n{id: 4, accept: \'text\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-15'
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 13,
            'Active': 1,
            'Order': 3,
            'Title': 'Strik',
            'ImagePath': 'stickers/sticker-13.png',
            'Size': '{Width=625, Height=335}',
            'LastModified': '05/09/2017 07:13:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:55',
            'ProductTypes': []
          },
          {
            'StickerId': 14,
            'Active': 1,
            'Order': 4,
            'Title': 'Cirkel',
            'ImagePath': 'stickers/sticker-14.png',
            'Size': '{Width=623, Height=624}',
            'LastModified': '05/09/2017 07:14:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:06',
            'ProductTypes': []
          },
          {
            'StickerId': 15,
            'Active': 1,
            'Order': 5,
            'Title': 'Spreekwolk',
            'ImagePath': 'stickers/sticker-15.png',
            'Size': '{Width=833, Height=736}',
            'LastModified': '05/09/2017 07:14:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:19',
            'ProductTypes': []
          },
          {
            'StickerId': 16,
            'Active': 1,
            'Order': 7,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-16.png',
            'Size': '{Width=662, Height=737}',
            'LastModified': '05/09/2017 07:14:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:27',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 19,
            'Active': 1,
            'Order': 10,
            'Title': 'Bril',
            'ImagePath': 'stickers/sticker-19.png',
            'Size': '{Width=688, Height=229}',
            'LastModified': '05/09/2017 07:15:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:01',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 21,
            'Active': 1,
            'Order': 12,
            'Title': 'Baby',
            'ImagePath': 'stickers/sticker-21.png',
            'Size': '{Width=729, Height=658}',
            'LastModified': '05/09/2017 07:15:47',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:47',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 23,
            'Active': 1,
            'Order': 14,
            'Title': 'Hart blauw',
            'ImagePath': 'stickers/sticker-23.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '05/09/2017 07:16:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:14',
            'ProductTypes': []
          },
          {
            'StickerId': 24,
            'Active': 1,
            'Order': 15,
            'Title': 'Ster blauw',
            'ImagePath': 'stickers/sticker-24.png',
            'Size': '{Width=625, Height=570}',
            'LastModified': '05/09/2017 07:16:24',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:24',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 26,
            'Active': 1,
            'Order': 17,
            'Title': 'Welkom kleintje',
            'ImagePath': 'stickers/sticker-26.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:16:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:56',
            'ProductTypes': []
          },
          {
            'StickerId': 27,
            'Active': 1,
            'Order': 18,
            'Title': 'Welkom kleintjes',
            'ImagePath': 'stickers/sticker-27.png',
            'Size': '{Width=829, Height=613}',
            'LastModified': '05/09/2017 07:17:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:13',
            'ProductTypes': []
          },
          {
            'StickerId': 28,
            'Active': 1,
            'Order': 19,
            'Title': 'Sinasappel',
            'ImagePath': 'stickers/sticker-28.png',
            'Size': '{Width=729, Height=729}',
            'LastModified': '05/09/2017 07:17:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:25',
            'ProductTypes': []
          },
          {
            'StickerId': 29,
            'Active': 1,
            'Order': 20,
            'Title': 'Blaadje',
            'ImagePath': 'stickers/sticker-29.png',
            'Size': '{Width=717, Height=238}',
            'LastModified': '05/09/2017 07:17:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:37',
            'ProductTypes': []
          },
          {
            'StickerId': 30,
            'Active': 1,
            'Order': 21,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-30.png',
            'Size': '{Width=359, Height=931}',
            'LastModified': '05/09/2017 07:17:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:17:48',
            'ProductTypes': []
          },
          {
            'StickerId': 31,
            'Active': 1,
            'Order': 22,
            'Title': 'Bloem',
            'ImagePath': 'stickers/sticker-31.png',
            'Size': '{Width=383, Height=942}',
            'LastModified': '05/09/2017 07:18:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:02',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 33,
            'Active': 1,
            'Order': 24,
            'Title': 'Ananas',
            'ImagePath': 'stickers/sticker-33.png',
            'Size': '{Width=405, Height=738}',
            'LastModified': '05/09/2017 07:18:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:28',
            'ProductTypes': []
          },
          {
            'StickerId': 34,
            'Active': 1,
            'Order': 25,
            'Title': 'Herfst blaadjes',
            'ImagePath': 'stickers/sticker-34.png',
            'Size': '{Width=255, Height=546}',
            'LastModified': '05/09/2017 07:18:46',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:46',
            'ProductTypes': []
          },
          {
            'StickerId': 35,
            'Active': 1,
            'Order': 26,
            'Title': 'Winter',
            'ImagePath': 'stickers/sticker-35.png',
            'Size': '{Width=476, Height=785}',
            'LastModified': '05/09/2017 07:18:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:59',
            'ProductTypes': []
          },
          {
            'StickerId': 36,
            'Active': 1,
            'Order': 27,
            'Title': 'Astronaut',
            'ImagePath': 'stickers/sticker-36.png',
            'Size': '{Width=589, Height=988}',
            'LastModified': '05/09/2017 07:19:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:14',
            'ProductTypes': []
          },
          {
            'StickerId': 37,
            'Active': 1,
            'Order': 28,
            'Title': 'Jarig',
            'ImagePath': 'stickers/sticker-37.png',
            'Size': '{Width=1036, Height=1026}',
            'LastModified': '05/09/2017 07:19:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:26',
            'ProductTypes': []
          },
          {
            'StickerId': 38,
            'Active': 1,
            'Order': 29,
            'Title': 'Kikker',
            'ImagePath': 'stickers/sticker-38.png',
            'Size': '{Width=1042, Height=1040}',
            'LastModified': '05/09/2017 07:19:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:38',
            'ProductTypes': []
          },
          {
            'StickerId': 39,
            'Active': 1,
            'Order': 30,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-39.png',
            'Size': '{Width=1042, Height=651}',
            'LastModified': '05/09/2017 07:19:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:19:56',
            'ProductTypes': []
          },
          {
            'StickerId': 40,
            'Active': 1,
            'Order': 31,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-40.png',
            'Size': '{Width=988, Height=311}',
            'LastModified': '05/09/2017 07:20:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:13',
            'ProductTypes': []
          },
          {
            'StickerId': 41,
            'Active': 1,
            'Order': 32,
            'Title': 'Piratenmuts',
            'ImagePath': 'stickers/sticker-41.png',
            'Size': '{Width=1042, Height=591}',
            'LastModified': '05/09/2017 07:20:34',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:34',
            'ProductTypes': []
          },
          {
            'StickerId': 42,
            'Active': 1,
            'Order': 33,
            'Title': 'Takkie',
            'ImagePath': 'stickers/sticker-42.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:20:45',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:45',
            'ProductTypes': []
          },
          {
            'StickerId': 43,
            'Active': 1,
            'Order': 34,
            'Title': 'Ballon geel',
            'ImagePath': 'stickers/sticker-43.png',
            'Size': '{Width=377, Height=1024}',
            'LastModified': '05/09/2017 07:20:58',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:20:58',
            'ProductTypes': []
          },
          {
            'StickerId': 44,
            'Active': 1,
            'Order': 35,
            'Title': 'Getrouwd',
            'ImagePath': 'stickers/sticker-44.png',
            'Size': '{Width=1028, Height=349}',
            'LastModified': '05/09/2017 07:21:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:11',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 46,
            'Active': 1,
            'Order': 37,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-46.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:21:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:57',
            'ProductTypes': []
          },
          {
            'StickerId': 47,
            'Active': 1,
            'Order': 38,
            'Title': 'Kroon',
            'ImagePath': 'stickers/sticker-47.png',
            'Size': '{Width=1042, Height=845}',
            'LastModified': '05/09/2017 07:22:19',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:19',
            'ProductTypes': []
          },
          {
            'StickerId': 48,
            'Active': 1,
            'Order': 39,
            'Title': 'Papagaai',
            'ImagePath': 'stickers/sticker-48.png',
            'Size': '{Width=1042, Height=928}',
            'LastModified': '05/09/2017 07:22:30',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:30',
            'ProductTypes': []
          },
          {
            'StickerId': 49,
            'Active': 1,
            'Order': 40,
            'Title': 'Robot',
            'ImagePath': 'stickers/sticker-49.png',
            'Size': '{Width=674, Height=1009}',
            'LastModified': '05/09/2017 07:22:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:43',
            'ProductTypes': []
          },
          {
            'StickerId': 50,
            'Active': 1,
            'Order': 41,
            'Title': 'The king',
            'ImagePath': 'stickers/sticker-50.png',
            'Size': '{Width=1044, Height=197}',
            'LastModified': '05/09/2017 07:22:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:22:55',
            'ProductTypes': []
          },
          {
            'StickerId': 51,
            'Active': 1,
            'Order': 42,
            'Title': 'Ballonnen groen',
            'ImagePath': 'stickers/sticker-51.png',
            'Size': '{Width=785, Height=1007}',
            'LastModified': '05/09/2017 07:23:10',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:10',
            'ProductTypes': []
          },
          {
            'StickerId': 52,
            'Active': 1,
            'Order': 43,
            'Title': 'Je bent mijn liefste',
            'ImagePath': 'stickers/sticker-52.png',
            'Size': '{Width=487, Height=1042}',
            'LastModified': '05/09/2017 07:23:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:27',
            'ProductTypes': []
          },
          {
            'StickerId': 53,
            'Active': 1,
            'Order': 44,
            'Title': 'Love',
            'ImagePath': 'stickers/sticker-53.png',
            'Size': '{Width=1038, Height=948}',
            'LastModified': '05/09/2017 07:23:37',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:37',
            'ProductTypes': []
          },
          {
            'StickerId': 54,
            'Active': 1,
            'Order': 45,
            'Title': 'Racket',
            'ImagePath': 'stickers/sticker-54.png',
            'Size': '{Width=420, Height=1016}',
            'LastModified': '05/09/2017 07:23:49',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:23:49',
            'ProductTypes': []
          },
          {
            'StickerId': 55,
            'Active': 1,
            'Order': 46,
            'Title': 'Zwaard',
            'ImagePath': 'stickers/sticker-55.png',
            'Size': '{Width=461, Height=1042}',
            'LastModified': '05/09/2017 07:24:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:01',
            'ProductTypes': []
          },
          {
            'StickerId': 56,
            'Active': 1,
            'Order': 47,
            'Title': 'Hoeravlag',
            'ImagePath': 'stickers/sticker-56.png',
            'Size': '{Width=1045, Height=252}',
            'LastModified': '05/09/2017 07:24:13',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:13',
            'ProductTypes': []
          },
          {
            'StickerId': 57,
            'Active': 1,
            'Order': 48,
            'Title': 'Rood hartje',
            'ImagePath': 'stickers/sticker-57.png',
            'Size': '{Width=624, Height=1007}',
            'LastModified': '05/09/2017 07:24:27',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:27',
            'ProductTypes': []
          },
          {
            'StickerId': 58,
            'Active': 1,
            'Order': 49,
            'Title': 'Hoera banner',
            'ImagePath': 'stickers/sticker-58.png',
            'Size': '{Width=1029, Height=530}',
            'LastModified': '05/09/2017 07:24:48',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:24:48',
            'ProductTypes': []
          },
          {
            'StickerId': 59,
            'Active': 1,
            'Order': 50,
            'Title': 'Raket',
            'ImagePath': 'stickers/sticker-59.png',
            'Size': '{Width=659, Height=984}',
            'LastModified': '05/09/2017 07:25:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:05',
            'ProductTypes': []
          },
          {
            'StickerId': 60,
            'Active': 1,
            'Order': 51,
            'Title': 'Twee hartjes',
            'ImagePath': 'stickers/sticker-60.png',
            'Size': '{Width=968, Height=754}',
            'LastModified': '05/09/2017 07:25:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:18',
            'ProductTypes': []
          },
          {
            'StickerId': 61,
            'Active': 1,
            'Order': 52,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-61.png',
            'Size': '{Width=995, Height=543}',
            'LastModified': '05/09/2017 07:25:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:31',
            'ProductTypes': []
          },
          {
            'StickerId': 62,
            'Active': 1,
            'Order': 53,
            'Title': 'Lijn hartjes',
            'ImagePath': 'stickers/sticker-62.png',
            'Size': '{Width=982, Height=958}',
            'LastModified': '05/09/2017 07:25:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:25:43',
            'ProductTypes': []
          },
          {
            'StickerId': 63,
            'Active': 1,
            'Order': 54,
            'Title': 'Roze hartje',
            'ImagePath': 'stickers/sticker-63.png',
            'Size': '{Width=624, Height=1017}',
            'LastModified': '05/09/2017 07:26:23',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:23',
            'ProductTypes': []
          },
          {
            'StickerId': 64,
            'Active': 1,
            'Order': 55,
            'Title': 'Ufo',
            'ImagePath': 'stickers/sticker-64.png',
            'Size': '{Width=914, Height=958}',
            'LastModified': '05/09/2017 07:26:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:32',
            'ProductTypes': []
          },
          {
            'StickerId': 65,
            'Active': 1,
            'Order': 56,
            'Title': 'Kadootje',
            'ImagePath': 'stickers/sticker-65.png',
            'Size': '{Width=706, Height=1012}',
            'LastModified': '05/09/2017 07:26:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:42',
            'ProductTypes': []
          },
          {
            'StickerId': 66,
            'Active': 1,
            'Order': 57,
            'Title': 'Ring',
            'ImagePath': 'stickers/sticker-66.png',
            'Size': '{Width=620, Height=1001}',
            'LastModified': '05/09/2017 07:26:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:26:51',
            'ProductTypes': []
          },
          {
            'StickerId': 67,
            'Active': 1,
            'Order': 58,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-67.png',
            'Size': '{Width=1020, Height=947}',
            'LastModified': '05/09/2017 07:27:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:01',
            'ProductTypes': []
          },
          {
            'StickerId': 68,
            'Active': 1,
            'Order': 59,
            'Title': 'Bowtie',
            'ImagePath': 'stickers/sticker-68.png',
            'Size': '{Width=1017, Height=514}',
            'LastModified': '05/09/2017 07:27:09',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:09',
            'ProductTypes': []
          },
          {
            'StickerId': 69,
            'Active': 1,
            'Order': 60,
            'Title': 'Confetti',
            'ImagePath': 'stickers/sticker-69.png',
            'Size': '{Width=333, Height=995}',
            'LastModified': '05/09/2017 07:27:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:21',
            'ProductTypes': []
          },
          {
            'StickerId': 70,
            'Active': 1,
            'Order': 61,
            'Title': 'Unicorn',
            'ImagePath': 'stickers/sticker-70.png',
            'Size': '{Width=898, Height=1006}',
            'LastModified': '05/09/2017 07:27:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:33',
            'ProductTypes': []
          },
          {
            'StickerId': 71,
            'Active': 1,
            'Order': 62,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-71.png',
            'Size': '{Width=1027, Height=573}',
            'LastModified': '05/09/2017 07:27:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:42',
            'ProductTypes': []
          },
          {
            'StickerId': 72,
            'Active': 1,
            'Order': 63,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-72.png',
            'Size': '{Width=797, Height=985}',
            'LastModified': '05/09/2017 07:27:55',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:27:55',
            'ProductTypes': []
          },
          {
            'StickerId': 73,
            'Active': 1,
            'Order': 64,
            'Title': 'Mr',
            'ImagePath': 'stickers/sticker-73.png',
            'Size': '{Width=1038, Height=932}',
            'LastModified': '05/09/2017 07:28:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:07',
            'ProductTypes': []
          },
          {
            'StickerId': 74,
            'Active': 1,
            'Order': 65,
            'Title': 'Kitty',
            'ImagePath': 'stickers/sticker-74.png',
            'Size': '{Width=708, Height=990}',
            'LastModified': '05/09/2017 07:28:18',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:18',
            'ProductTypes': []
          },
          {
            'StickerId': 75,
            'Active': 1,
            'Order': 66,
            'Title': 'Ms',
            'ImagePath': 'stickers/sticker-75.png',
            'Size': '{Width=1031, Height=971}',
            'LastModified': '05/09/2017 07:28:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:32',
            'ProductTypes': []
          },
          {
            'StickerId': 76,
            'Active': 1,
            'Order': 67,
            'Title': 'Rainbow',
            'ImagePath': 'stickers/sticker-76.png',
            'Size': '{Width=1010, Height=659}',
            'LastModified': '05/09/2017 07:28:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:42',
            'ProductTypes': []
          },
          {
            'StickerId': 77,
            'Active': 1,
            'Order': 68,
            'Title': 'Champagne',
            'ImagePath': 'stickers/sticker-77.png',
            'Size': '{Width=341, Height=1006}',
            'LastModified': '05/09/2017 07:28:56',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:28:56',
            'ProductTypes': []
          },
          {
            'StickerId': 78,
            'Active': 1,
            'Order': 69,
            'Title': 'Hartjes',
            'ImagePath': 'stickers/sticker-78.png',
            'Size': '{Width=951, Height=571}',
            'LastModified': '05/09/2017 07:29:06',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:06',
            'ProductTypes': []
          },
          {
            'StickerId': 79,
            'Active': 1,
            'Order': 70,
            'Title': 'You are just lovely',
            'ImagePath': 'stickers/sticker-79.png',
            'Size': '{Width=987, Height=899}',
            'LastModified': '05/09/2017 07:29:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:26',
            'ProductTypes': []
          },
          {
            'StickerId': 80,
            'Active': 1,
            'Order': 71,
            'Title': 'Medaille',
            'ImagePath': 'stickers/sticker-80.png',
            'Size': '{Width=591, Height=1018}',
            'LastModified': '05/09/2017 07:29:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:40',
            'ProductTypes': []
          },
          {
            'StickerId': 81,
            'Active': 1,
            'Order': 72,
            'Title': 'Pluk de dag',
            'ImagePath': 'stickers/sticker-81.png',
            'Size': '{Width=509, Height=1042}',
            'LastModified': '05/09/2017 07:29:51',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:29:51',
            'ProductTypes': []
          },
          {
            'StickerId': 82,
            'Active': 1,
            'Order': 73,
            'Title': 'Zon',
            'ImagePath': 'stickers/sticker-82.png',
            'Size': '{Width=1033, Height=1005}',
            'LastModified': '05/09/2017 07:30:01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:01',
            'ProductTypes': []
          },
          {
            'StickerId': 83,
            'Active': 1,
            'Order': 74,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-83.png',
            'Size': '{Width=997, Height=646}',
            'LastModified': '05/09/2017 07:30:11',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:11',
            'ProductTypes': []
          },
          {
            'StickerId': 84,
            'Active': 1,
            'Order': 75,
            'Title': 'Hartjesdoos mama',
            'ImagePath': 'stickers/sticker-84.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:28',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:28',
            'ProductTypes': []
          },
          {
            'StickerId': 85,
            'Active': 1,
            'Order': 76,
            'Title': 'Hartjesdoos',
            'ImagePath': 'stickers/sticker-85.png',
            'Size': '{Width=929, Height=974}',
            'LastModified': '05/09/2017 07:30:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:41',
            'ProductTypes': []
          },
          {
            'StickerId': 86,
            'Active': 1,
            'Order': 77,
            'Title': 'Wolk rain',
            'ImagePath': 'stickers/sticker-86.png',
            'Size': '{Width=1002, Height=948}',
            'LastModified': '05/09/2017 07:30:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:30:54',
            'ProductTypes': []
          },
          {
            'StickerId': 87,
            'Active': 1,
            'Order': 78,
            'Title': 'Crown',
            'ImagePath': 'stickers/sticker-87.png',
            'Size': '{Width=1025, Height=721}',
            'LastModified': '05/09/2017 07:31:05',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:05',
            'ProductTypes': []
          },
          {
            'StickerId': 88,
            'Active': 1,
            'Order': 79,
            'Title': 'Hartje mama',
            'ImagePath': 'stickers/sticker-88.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:32',
            'ProductTypes': []
          },
          {
            'StickerId': 89,
            'Active': 1,
            'Order': 80,
            'Title': 'Hartje',
            'ImagePath': 'stickers/sticker-89.png',
            'Size': '{Width=886, Height=1004}',
            'LastModified': '05/09/2017 07:31:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:31:42',
            'ProductTypes': []
          },
          {
            'StickerId': 90,
            'Active': 1,
            'Order': 81,
            'Title': 'Wolk donder',
            'ImagePath': 'stickers/sticker-90.png',
            'Size': '{Width=878, Height=998}',
            'LastModified': '05/09/2017 07:40:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:00',
            'ProductTypes': []
          },
          {
            'StickerId': 91,
            'Active': 1,
            'Order': 82,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-91.png',
            'Size': '{Width=1013, Height=1013}',
            'LastModified': '05/09/2017 07:40:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:14',
            'ProductTypes': []
          },
          {
            'StickerId': 92,
            'Active': 1,
            'Order': 83,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-92.png',
            'Size': '{Width=768, Height=1013}',
            'LastModified': '05/09/2017 07:40:44',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:44',
            'ProductTypes': []
          },
          {
            'StickerId': 93,
            'Active': 1,
            'Order': 84,
            'Title': 'Monster',
            'ImagePath': 'stickers/sticker-93.png',
            'Size': '{Width=1009, Height=1022}',
            'LastModified': '05/09/2017 07:40:54',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:40:54',
            'ProductTypes': []
          },
          {
            'StickerId': 94,
            'Active': 1,
            'Order': 85,
            'Title': 'Zwemband',
            'ImagePath': 'stickers/sticker-94.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:41:04',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:04',
            'ProductTypes': []
          },
          {
            'StickerId': 95,
            'Active': 1,
            'Order': 86,
            'Title': 'Plons',
            'ImagePath': 'stickers/sticker-95.png',
            'Size': '{Width=1033, Height=430}',
            'LastModified': '05/09/2017 07:41:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:17',
            'ProductTypes': []
          },
          {
            'StickerId': 96,
            'Active': 1,
            'Order': 87,
            'Title': 'Zwemdiploma',
            'ImagePath': 'stickers/sticker-96.png',
            'Size': '{Width=1019, Height=121}',
            'LastModified': '05/09/2017 07:41:29',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:29',
            'ProductTypes': []
          },
          {
            'StickerId': 97,
            'Active': 1,
            'Order': 88,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-97.png',
            'Size': '{Width=719, Height=1044}',
            'LastModified': '05/09/2017 07:41:41',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:41',
            'ProductTypes': []
          },
          {
            'StickerId': 98,
            'Active': 1,
            'Order': 89,
            'Title': 'New home',
            'ImagePath': 'stickers/sticker-98.png',
            'Size': '{Width=835, Height=1042}',
            'LastModified': '05/09/2017 07:41:52',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:41:52',
            'ProductTypes': []
          },
          {
            'StickerId': 99,
            'Active': 1,
            'Order': 90,
            'Title': 'Sportheld',
            'ImagePath': 'stickers/sticker-99.png',
            'Size': '{Width=925, Height=1040}',
            'LastModified': '05/09/2017 07:42:02',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:02',
            'ProductTypes': []
          },
          {
            'StickerId': 100,
            'Active': 1,
            'Order': 91,
            'Title': 'Hoera',
            'ImagePath': 'stickers/sticker-100.png',
            'Size': '{Width=855, Height=1042}',
            'LastModified': '05/09/2017 07:42:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:12',
            'ProductTypes': []
          },
          {
            'StickerId': 101,
            'Active': 1,
            'Order': 92,
            'Title': 'Present',
            'ImagePath': 'stickers/sticker-101.png',
            'Size': '{Width=714, Height=1004}',
            'LastModified': '05/09/2017 07:42:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:21',
            'ProductTypes': []
          },
          {
            'StickerId': 102,
            'Active': 1,
            'Order': 93,
            'Title': 'Bird',
            'ImagePath': 'stickers/sticker-102.png',
            'Size': '{Width=1031, Height=720}',
            'LastModified': '05/09/2017 07:42:31',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:31',
            'ProductTypes': []
          },
          {
            'StickerId': 103,
            'Active': 1,
            'Order': 94,
            'Title': 'Snowflake',
            'ImagePath': 'stickers/sticker-103.png',
            'Size': '{Width=922, Height=1000}',
            'LastModified': '10/11/2022 14:35:16',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:40',
            'ProductTypes': []
          },
          {
            'StickerId': 104,
            'Active': 1,
            'Order': 95,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-104.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:53',
            'ProductTypes': []
          },
          {
            'StickerId': 105,
            'Active': 1,
            'Order': 96,
            'Title': 'Kado',
            'ImagePath': 'stickers/sticker-105.png',
            'Size': '{Width=1415, Height=1533}',
            'LastModified': '05/09/2017 07:42:57',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:42:57',
            'ProductTypes': []
          },
          {
            'StickerId': 106,
            'Active': 1,
            'Order': 97,
            'Title': 'Bat',
            'ImagePath': 'stickers/sticker-106.png',
            'Size': '{Width=1042, Height=315}',
            'LastModified': '10/11/2022 14:35:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:07',
            'ProductTypes': []
          },
          {
            'StickerId': 107,
            'Active': 1,
            'Order': 98,
            'Title': 'Hoera een jongen',
            'ImagePath': 'stickers/sticker-107.png',
            'Size': '{Width=734, Height=1042}',
            'LastModified': '05/09/2017 07:43:21',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:21',
            'ProductTypes': []
          },
          {
            'StickerId': 108,
            'Active': 1,
            'Order': 99,
            'Title': 'Bedankt',
            'ImagePath': 'stickers/sticker-108.png',
            'Size': '{Width=1042, Height=1042}',
            'LastModified': '05/09/2017 07:43:32',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:32',
            'ProductTypes': []
          },
          {
            'StickerId': 109,
            'Active': 1,
            'Order': 100,
            'Title': 'Pumpkin',
            'ImagePath': 'stickers/sticker-109.png',
            'Size': '{Width=1042, Height=763}',
            'LastModified': '10/11/2022 14:35:43',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:43:47',
            'ProductTypes': []
          },
          {
            'StickerId': 110,
            'Active': 1,
            'Order': 101,
            'Title': 'Stoplicht',
            'ImagePath': 'stickers/sticker-110.png',
            'Size': '{Width=288, Height=1032}',
            'LastModified': '05/09/2017 07:44:00',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:00',
            'ProductTypes': []
          },
          {
            'StickerId': 111,
            'Active': 1,
            'Order': 102,
            'Title': 'Hoera rijbewijs',
            'ImagePath': 'stickers/sticker-111.png',
            'Size': '{Width=1040, Height=632}',
            'LastModified': '05/09/2017 07:44:14',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:14',
            'ProductTypes': []
          },
          {
            'StickerId': 112,
            'Active': 1,
            'Order': 103,
            'Title': 'Geslaagd',
            'ImagePath': 'stickers/sticker-112.png',
            'Size': '{Width=997, Height=997}',
            'LastModified': '05/09/2017 07:44:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:44:25',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 17,
        'Name': '3D-cake-1740x1740',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 739,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-739.png',
            'Order': 9,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:32:56',
            'Categories': [],
            'Created': '07/24/2017 10:30:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 742,
            'EditorSpecificImagePath': 'backgrounds/editor/background-742.png',
            'ImagePath': 'backgrounds/background-742.png',
            'Order': 2,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_ster',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'LastModified': '09/11/2023 11:08:03',
            'Categories': [],
            'Created': '07/24/2017 10:33:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 749,
            'EditorSpecificImagePath': 'backgrounds/editor/background-749.png',
            'ImagePath': 'backgrounds/background-749.png',
            'Order': 1,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_streep',
            'LastModifiedBy': 'HEMALOCAL\\kooia',
            'LastModified': '01/08/2018 12:49:37',
            'Categories': [],
            'Created': '07/24/2017 10:37:03',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 754,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-754.png',
            'Order': 22,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_streepzw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:34:25',
            'Categories': [],
            'Created': '07/24/2017 10:40:58',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 780,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-780.png',
            'Order': 48,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_stipzw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:34:33',
            'Categories': [],
            'Created': '07/24/2017 11:37:48',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 787,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-787.png',
            'Order': 56,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:34:49',
            'Categories': [],
            'Created': '07/24/2017 11:41:06',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 795,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-795.png',
            'Order': 64,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_streepblauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:35:31',
            'Categories': [],
            'Created': '07/24/2017 11:44:42',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 800,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-800.png',
            'Order': 69,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_lichtblauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:35:32',
            'Categories': [],
            'Created': '07/24/2017 11:46:13',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 807,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-807.png',
            'Order': 76,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_stiprood',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:35:43',
            'Categories': [],
            'Created': '07/24/2017 11:49:19',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 821,
            'EditorSpecificImagePath': 'backgrounds/editor/background-821.png',
            'ImagePath': 'backgrounds/background-821.png',
            'Order': 3,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_blaadjes',
            'LastModifiedBy': 'HEMALOCAL\\kooia',
            'LastModified': '01/04/2018 16:21:56',
            'Categories': [],
            'Created': '07/24/2017 11:53:37',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 826,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-826.png',
            'Order': 94,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_lichtgroen',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:00',
            'Categories': [],
            'Created': '07/24/2017 11:57:50',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 836,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-836.png',
            'Order': 104,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:21',
            'Categories': [],
            'Created': '07/24/2017 12:09:01',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 844,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-844.png',
            'Order': 112,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_oranje',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:27',
            'Categories': [],
            'Created': '07/24/2017 12:14:06',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 853,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-853.png',
            'Order': 121,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_lichtroze',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:33',
            'Categories': [],
            'Created': '07/24/2017 12:23:25',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 867,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-867.png',
            'Order': 135,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_zwemdiploma',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:43',
            'Categories': [],
            'Created': '07/24/2017 12:45:48',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 868,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-868.png',
            'Order': 136,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_zwemdiploma_01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:36:51',
            'Categories': [],
            'Created': '07/24/2017 12:46:21',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 877,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-877.png',
            'Order': 145,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_beertje',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:37:00',
            'Categories': [],
            'Created': '07/24/2017 12:49:23',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 887,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-887.png',
            'Order': 155,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_stiproze',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:37:12',
            'Categories': [],
            'Created': '07/24/2017 12:54:11',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 897,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-897.png',
            'Order': 165,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_rijbewijs',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:37:33',
            'Categories': [],
            'Created': '07/24/2017 12:57:35',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 904,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-904.png',
            'Order': 172,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_ruitblauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:38:31',
            'Categories': [],
            'Created': '07/24/2017 12:59:23',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 918,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-918.png',
            'Order': 186,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_geslaagd',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:38:51',
            'Categories': [],
            'Created': '07/24/2017 13:10:18',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 922,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-922.png',
            'Order': 190,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_vogeltje',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:00',
            'Categories': [],
            'Created': '07/24/2017 13:12:17',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 929,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-929.png',
            'Order': 197,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overallr_ijbewijs2',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:20',
            'Categories': [],
            'Created': '07/24/2017 13:15:53',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 940,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-940.png',
            'Order': 208,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_space',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:06',
            'Categories': [],
            'Created': '07/24/2017 13:21:46',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 954,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-954.png',
            'Order': 222,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_nieuwhuis',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:13',
            'Categories': [],
            'Created': '07/24/2017 13:29:55',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 963,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-963.png',
            'Order': 231,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_BFF',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:19',
            'Categories': [],
            'Created': '07/24/2017 13:32:41',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 977,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-977.png',
            'Order': 245,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_hartjes',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:33',
            'Categories': [],
            'Created': '07/24/2017 13:35:12',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 987,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-987.png',
            'Order': 255,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_sportheld',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:44',
            'Categories': [],
            'Created': '07/24/2017 13:36:51',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 988,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-988.png',
            'Order': 256,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_vaderdag',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:39:54',
            'Categories': [],
            'Created': '07/24/2017 13:36:56',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 997,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-997.png',
            'Order': 265,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_spaceboys',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:40:02',
            'Categories': [],
            'Created': '07/24/2017 13:40:13',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1009,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1009.png',
            'Order': 277,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'Taart3d_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:40:16',
            'Categories': [],
            'Created': '07/24/2017 13:43:22',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1015,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1015.png',
            'Order': 283,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_spacegirls',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:40:30',
            'Categories': [],
            'Created': '07/24/2017 13:48:04',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1026,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 294,
            'Size': null,
            'Title': 'taart3d_overall_gras',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:40:35',
            'Categories': [],
            'Created': '07/24/2017 13:58:13',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1032,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1032.png',
            'Order': 300,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_monsters',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:40:41',
            'Categories': [],
            'Created': '07/24/2017 14:04:28',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1060,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1060.png',
            'Order': 328,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_hartjes_wit',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:29',
            'Categories': [],
            'Created': '07/24/2017 14:22:56',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1068,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1068.png',
            'Order': 336,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_piraat',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:36',
            'Categories': [],
            'Created': '07/24/2017 14:29:41',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1079,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1079.png',
            'Order': 347,
            'Size': '{Width=5124, Height=3706}',
            'Title': 'taart3d_overall_confetti',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:43',
            'Categories': [],
            'Created': '07/24/2017 14:37:35',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1081,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1081.png',
            'Order': 349,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'taart3d_overall_stip',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:49',
            'Categories': [],
            'Created': '07/24/2017 14:39:59',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1083,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1083.png',
            'Order': 351,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'taart3d_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:42:55',
            'Categories': [],
            'Created': '07/24/2017 14:41:36',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1085,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1085.png',
            'Order': 353,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'taart3d_overall_ster2',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:43:03',
            'Categories': [],
            'Created': '07/24/2017 14:42:53',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1088,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1088.png',
            'Order': 356,
            'Size': '{Width=1057, Height=1033}',
            'Title': 'taart3d_overall_valentijnwit',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:44:35',
            'Categories': [],
            'Created': '07/24/2017 14:44:02',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1096,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1096.png',
            'Order': 364,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_valentijn',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:44:44',
            'Categories': [],
            'Created': '07/24/2017 14:52:27',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1107,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1107.png',
            'Order': 375,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_herfst',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:44:52',
            'Categories': [],
            'Created': '07/24/2017 15:04:22',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1124,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1124.png',
            'Order': 392,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_kado',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:47:54',
            'Categories': [],
            'Created': '07/24/2017 15:12:31',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1130,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1130.png',
            'Order': 398,
            'Size': '{Width=3569, Height=3569}',
            'Title': 'taart3D_overall_princes',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:05',
            'Categories': [],
            'Created': '07/24/2017 15:15:09',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1136,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1136.jpg',
            'Order': 404,
            'Size': '{Width=1712, Height=1712}',
            'Title': 'taart3d_overall_blauw',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:13',
            'Categories': [],
            'Created': '07/24/2017 15:18:33',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1156,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1156.png',
            'Order': 424,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_kadowit',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:21',
            'Categories': [],
            'Created': '07/24/2017 15:29:12',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1165,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1165.png',
            'Order': 433,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_zomer',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:46:31',
            'Categories': [],
            'Created': '07/24/2017 15:35:41',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1166,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1166.png',
            'Order': 434,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3D_overall_hoera',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:27',
            'Categories': [],
            'Created': '07/24/2017 15:35:46',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1179,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1179.png',
            'Order': 447,
            'Size': '{Width=3567, Height=3567}',
            'Title': '3DTaart_overall_jipjannke',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:36',
            'Categories': [],
            'Created': '07/24/2017 15:41:12',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1187,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1187.png',
            'Order': 454,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_winter',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:45',
            'Categories': [],
            'Created': '07/24/2017 15:44:44',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1199,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1199.png',
            'Order': 464,
            'Size': '{Width=3567, Height=3567}',
            'Title': 'taart3d_overall_lente-01',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:45:55',
            'Categories': [],
            'Created': '07/24/2017 15:56:50',
            'ProductTypes': []
          },
          {
            'Active': 0,
            'BackgroundId': 1211,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1211.png',
            'Order': 55,
            'Size': '{Width=3567, Height=3567}',
            'Title': '3DTaart_overall_jipjanneke2.0',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:34:41',
            'Categories': [],
            'Created': '07/24/2017 16:11:35',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1213,
            'EditorSpecificImagePath': 'backgrounds/editor/background-1213.png',
            'ImagePath': 'backgrounds/background-1213.png',
            'Order': 55,
            'Size': '{Width=1740, Height=1740}',
            'Title': 'TEST MARTIN',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/06/2017 10:49:22',
            'Categories': [],
            'Created': '10/20/2017 07:07:54',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1214,
            'EditorSpecificImagePath': 'backgrounds/editor/background-1214.png',
            'ImagePath': 'backgrounds/background-1214.png',
            'Order': 477,
            'Size': '{Width=1740, Height=1740}',
            'Title': 'Martin Test 2',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'LastModified': '12/13/2017 13:50:23',
            'Categories': [],
            'Created': '12/13/2017 13:50:23',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 16,
            'Title': 'Graduate',
            'ImagePath': 'fonts/font-16.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 3,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:25',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:19:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 18,
            'Title': 'Berkshire Swash',
            'ImagePath': 'fonts/font-18.svg',
            'MaximumFontSize': 200,
            'MinimumFontSize': 40,
            'Order': 6,
            'CorrectionY': 0,
            'DefaultFontSize': 80,
            'LastModified': '07/09/2018 16:57:32',
            'LastModifiedBy': 'ad-acc\\emtbakkum',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:21:55',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 19,
            'Title': 'Playfair Display',
            'ImagePath': 'fonts/font-19.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 4,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:11:59',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:22:45',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 20,
            'Title': 'Gochi Hand',
            'ImagePath': 'fonts/font-20.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 7,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:17',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:23:30',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 21,
            'Title': 'Bangers',
            'ImagePath': 'fonts/font-21.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 8,
            'CorrectionY': 0.4,
            'DefaultFontSize': 20,
            'LastModified': '08/21/2018 12:59:46',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:24:31',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 23,
            'Title': 'Times New Roman',
            'ImagePath': 'fonts/font-23.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 10,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '06/28/2017 08:12:42',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:26:07',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 19,
            'Title': '6333625',
            'Created': '06/16/2017 12:38:18',
            'LastModified': '09/23/2020 14:28:21',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 17,
            'ShapeId': 2,
            'Width': 1063,
            'Height': 1063,
            'DefaultLayoutId': 6,
            'BackgroundClassName': '3d-cake',
            'BackgroundWidth': 1063,
            'BackgroundHeight': 1063,
            'Bleed': 8,
            'DefaultFontId': 13,
            'SideBleedTop': 43,
            'SideBleedRight': 49,
            'SideBleedBottom': 67,
            'SideBleedLeft': 49,
            'SideWidth': 1063,
            'SideHeight': 325,
            'IsMultiDimension': true,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-19.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-19.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': '3d-cake'
          },
          {
            'ProductId': 26,
            'Title': '6333626',
            'Created': '07/21/2017 14:29:47',
            'LastModified': '03/07/2018 14:20:51',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 17,
            'ShapeId': 2,
            'Width': 1063,
            'Height': 1063,
            'DefaultLayoutId': 11,
            'BackgroundClassName': '3d-cake',
            'BackgroundWidth': 1063,
            'BackgroundHeight': 1063,
            'Bleed': 8,
            'DefaultFontId': 13,
            'SideBleedTop': 43,
            'SideBleedRight': 49,
            'SideBleedBottom': 67,
            'SideBleedLeft': 49,
            'SideWidth': 1063,
            'SideHeight': 325,
            'IsMultiDimension': true,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-26.png',
            'BackgroundImagePath': 'products/backgrounds/product-26.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': '3d-cake'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          }
        ],
        'Stickers': [
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 18,
        'Name': 'giftcard-516x324',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1216,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1216.png',
            'Order': 479,
            'Size': '{Width=514, Height=324}',
            'Title': 'cadeau_514x324_overall_beertje',
            'LastModifiedBy': 'ad-acc\\Erica.Ly',
            'LastModified': '06/27/2018 15:22:54',
            'Categories': [],
            'Created': '06/27/2018 15:22:54',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          }
        ],
        'Stickers': [
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 45,
            'Active': 1,
            'Order': 36,
            'Title': 'Janneke kado',
            'ImagePath': 'stickers/sticker-45.png',
            'Size': '{Width=1042, Height=1105}',
            'LastModified': '11/28/2017 14:40:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:21:44',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 19,
        'Name': 'white-wine-921x1276',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          }
        ],
        'Stickers': [
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 21,
        'Name': 'red-wine-921x1276',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          }
        ],
        'Stickers': [
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 22,
        'Name': 'wine-label-champagne',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1215,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1215.png',
            'Order': 478,
            'Size': '{Width=921, Height=1276}',
            'Title': 'wijn_921x1276_overall_beertje',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'LastModified': '04/02/2019 11:49:01',
            'Categories': [],
            'Created': '06/27/2018 15:21:51',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 35,
            'Title': '17329401',
            'Created': '11/20/2018 14:34:24',
            'LastModified': '01/04/2023 10:01:23',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 22,
            'ShapeId': 2,
            'Width': 921,
            'Height': 1276,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'wine-label-champagne',
            'BackgroundWidth': 1120,
            'BackgroundHeight': 4206,
            'Bleed': 0,
            'DefaultFontId': 13,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 921,
            'OptimalHeight': 1276,
            'MinimalWidth': 307,
            'MinimalHeight': 425,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-35.png',
            'BackgroundImagePath': 'products/backgrounds/product-35.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': null,
            'WatermarkOffsetTop': null,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'wine-label-champagne'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          }
        ],
        'Stickers': [
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 23,
        'Name': 'wine-label-red',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1215,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1215.png',
            'Order': 478,
            'Size': '{Width=921, Height=1276}',
            'Title': 'wijn_921x1276_overall_beertje',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'LastModified': '04/02/2019 11:49:01',
            'Categories': [],
            'Created': '06/27/2018 15:21:51',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 33,
            'Title': '17326401',
            'Created': '11/20/2018 14:30:15',
            'LastModified': '09/05/2019 16:27:55',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 23,
            'ShapeId': 2,
            'Width': 921,
            'Height': 1276,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'wine-label-red',
            'BackgroundWidth': 1038,
            'BackgroundHeight': 4144,
            'Bleed': 0,
            'DefaultFontId': 13,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 921,
            'OptimalHeight': 1276,
            'MinimalWidth': 307,
            'MinimalHeight': 425,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-33.png',
            'BackgroundImagePath': 'products/backgrounds/product-33.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': null,
            'WatermarkOffsetTop': null,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'wine-label-red'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          }
        ],
        'Stickers': [
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 24,
        'Name': 'wine-label-white',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1215,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1215.png',
            'Order': 478,
            'Size': '{Width=921, Height=1276}',
            'Title': 'wijn_921x1276_overall_beertje',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'LastModified': '04/02/2019 11:49:01',
            'Categories': [],
            'Created': '06/27/2018 15:21:51',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 34,
            'Title': '17327401',
            'Created': '11/20/2018 14:32:31',
            'LastModified': '04/02/2019 11:44:50',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Active': 1,
            'ProductTypeId': 24,
            'ShapeId': 2,
            'Width': 921,
            'Height': 1276,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'wine-label-white',
            'BackgroundWidth': 1038,
            'BackgroundHeight': 4144,
            'Bleed': 0,
            'DefaultFontId': 13,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 921,
            'OptimalHeight': 1276,
            'MinimalWidth': 307,
            'MinimalHeight': 425,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-34.png',
            'BackgroundImagePath': 'products/backgrounds/product-34.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': null,
            'WatermarkOffsetTop': null,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'wine-label-white'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          }
        ],
        'Stickers': [
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 12,
            'Active': 1,
            'Order': 6,
            'Title': 'Lips',
            'ImagePath': 'stickers/sticker-12.png',
            'Size': '{Width=660, Height=369}',
            'LastModified': '11/20/2018 14:27:12',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:36',
            'ProductTypes': []
          },
          {
            'StickerId': 18,
            'Active': 1,
            'Order': 9,
            'Title': 'Snor',
            'ImagePath': 'stickers/sticker-18.png',
            'Size': '{Width=681, Height=199}',
            'LastModified': '11/20/2018 14:27:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:52',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 25,
        'Name': 'cupcake-319',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 766,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-766.png',
            'Order': 34,
            'Size': '{Width=3446, Height=2296}',
            'Title': 'maxi party cake_overall_streep',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '08/29/2019 13:30:03',
            'Categories': [],
            'Created': '07/24/2017 11:23:56',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1029,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1029.jpg',
            'Order': 297,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_blauw',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:29',
            'Categories': [],
            'Created': '07/24/2017 14:01:39',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1031,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1031.jpg',
            'Order': 299,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_groen',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:46',
            'Categories': [],
            'Created': '07/24/2017 14:03:11',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1034,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1034.jpg',
            'Order': 302,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geel',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:38:13',
            'Categories': [],
            'Created': '07/24/2017 14:05:23',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1042,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1042.jpg',
            'Order': 310,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_rozerood',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:40:53',
            'Categories': [],
            'Created': '07/24/2017 14:09:48',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1069,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1069.png',
            'Order': 337,
            'Size': '{Width=981, Height=744}',
            'Title': 'choco_hart_geslaagd',
            'LastModifiedBy': 'ad-acc\\Ellen.de.Vries',
            'LastModified': '06/18/2019 13:40:32',
            'Categories': [],
            'Created': '07/24/2017 14:29:48',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 24,
            'Title': 'Arial',
            'ImagePath': 'fonts/font-24.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 14,
            'Order': 11,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '05/27/2019 15:03:45',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:27:39',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 38,
            'Title': '6330054',
            'Created': '12/14/2020 13:54:23',
            'LastModified': '12/17/2020 16:40:57',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 25,
            'ShapeId': 2,
            'Width': 319,
            'Height': 319,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-cupcake',
            'BackgroundWidth': 452,
            'BackgroundHeight': 430,
            'Bleed': 24,
            'DefaultFontId': 13,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': 1053,
            'MultiCloneWidth': 1396,
            'IsMultiClone': true,
            'OptimalWidth': 319,
            'OptimalHeight': 319,
            'MinimalWidth': 69,
            'MinimalHeight': 69,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': '{\'Cloning\':{\'Items\':[{\'Left\':24,\'Top\':24},{\'Left\':24,\'Top\':367},{\'Left\':24,\'Top\':710},{\'Left\':367,\'Top\':24},{\'Left\':367,\'Top\':367},{\'Left\':367,\'Top\':710}]}}',
            'ImagePath': 'products/product-38.png',
            'BackgroundImagePath': 'products/backgrounds/product-38.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': null,
            'WatermarkOffsetTop': null,
            'DisplayWatermark': false,
            'RoundedCorners': true,
            'CornerRadius': 160,
            'FontSizeOverride': null,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-cupcake'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 4,
            'Active': 1,
            'ImagePath': 'templates/template-4.svg',
            'ShapeId': 2,
            'Created': '03/22/2017 09:06:24',
            'LastModified': '07/31/2019 15:11:24',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 3,
            'PermittedSides': 'center',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 2, accept: \'photo\', dimension: {w: 50, h: 50}},\r\n{id: 3, accept: \'photo\', dimension: {w: 100, h: 50}}',
            'Title': 'Layout-02'
          },
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          },
          {
            'LayoutTemplateId': 16,
            'Active': 0,
            'ImagePath': 'templates/template-16.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 10:28:35',
            'LastModified': '07/31/2019 15:15:43',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Order': 13,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: \'hidden\', accept: \'\', dimension: {w: 100, h: 33.333333}},\r\n{id: 1, accept: \'text\', dimension: {w: 100, h: 33.333333}}',
            'Title': 'Layout-12'
          }
        ],
        'Stickers': [
          {
            'StickerId': 9,
            'Active': 1,
            'Order': 2,
            'Title': 'Happy',
            'ImagePath': 'stickers/sticker-9.png',
            'Size': '{Width=1034, Height=571}',
            'LastModified': '06/18/2019 13:41:33',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:12:56',
            'ProductTypes': []
          },
          {
            'StickerId': 10,
            'Active': 1,
            'Order': 1,
            'Title': 'Enjoy',
            'ImagePath': 'stickers/sticker-10.png',
            'Size': '{Width=1042, Height=187}',
            'LastModified': '06/18/2019 13:41:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:16',
            'ProductTypes': []
          },
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 113,
            'Active': 2,
            'Order': 104,
            'Title': 'super dad - vaderdag',
            'ImagePath': 'stickers/sticker-113.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:40',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 12:56:49',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 114,
            'Active': 2,
            'Order': 105,
            'Title': 'fijne vaderdag',
            'ImagePath': 'stickers/sticker-114.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '06/08/2022 13:05:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '06/08/2022 13:01:08',
            'ProductTypes': [],
            'ActiveEndDate': '06/21/2022 00:00:00',
            'ActiveStartDate': '06/08/2022 00:00:00'
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 26,
        'Name': 'round-cake-992',
        'Backgrounds': [
          {
            'Active': 1,
            'BackgroundId': 408,
            'EditorSpecificImagePath': null,
            'ImagePath': null,
            'Order': 4,
            'Size': null,
            'Title': 'NoBg',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'LastModified': '10/11/2022 10:00:39',
            'Categories': [],
            'Created': '06/14/2017 12:29:29',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1217,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1217.png',
            'Order': 480,
            'Size': '{Width=3671, Height=3693}',
            'Title': 'rainbow-round',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'LastModified': '11/18/2022 16:26:12',
            'Categories': [],
            'Created': '11/18/2022 16:24:22',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'BackgroundId': 1218,
            'EditorSpecificImagePath': null,
            'ImagePath': 'backgrounds/background-1218.png',
            'Order': 481,
            'Size': '{Width=3871, Height=3894}',
            'Title': 'rond-oranje',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'LastModified': '11/18/2022 17:06:07',
            'Categories': [],
            'Created': '11/18/2022 17:06:07',
            'ProductTypes': []
          }
        ],
        'Fonts': [
          {
            'Active': 1,
            'FontId': 13,
            'Title': 'Barrio',
            'ImagePath': 'fonts/font-13.svg',
            'MaximumFontSize': 500,
            'MinimumFontSize': 18,
            'Order': 0,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:47',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:12:08',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 14,
            'Title': 'Sofia-Chique',
            'ImagePath': 'fonts/font-14.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 16,
            'Order': 1,
            'CorrectionY': 0,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:57:59',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:15:50',
            'ProductTypes': []
          },
          {
            'Active': 1,
            'FontId': 15,
            'Title': 'Amatic SC',
            'ImagePath': 'fonts/font-15.svg',
            'MaximumFontSize': 100,
            'MinimumFontSize': 18,
            'Order': 2,
            'CorrectionY': 0.2,
            'DefaultFontSize': 20,
            'LastModified': '10/11/2022 09:58:11',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'FontFiles': [],
            'Categories': [],
            'Created': '05/08/2017 12:18:01',
            'ProductTypes': []
          }
        ],
        'Products': [
          {
            'ProductId': 43,
            'Title': '6355261',
            'Created': '10/11/2022 14:10:59',
            'LastModified': '02/20/2023 08:58:11',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Active': 1,
            'ProductTypeId': 26,
            'ShapeId': 2,
            'Width': 992,
            'Height': 992,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-rond-cake',
            'BackgroundWidth': 1152,
            'BackgroundHeight': 1152,
            'Bleed': 40,
            'DefaultFontId': 13,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 992,
            'OptimalHeight': 992,
            'MinimalWidth': 300,
            'MinimalHeight': 300,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-43.png',
            'BackgroundImagePath': 'products/backgrounds/product-43.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': true,
            'EnableEnhancement': false,
            'WatermarkImagePath': 'products/logo_overlays/product-43-20221118171623349.png',
            'WatermarkOffsetLeft': -75,
            'WatermarkOffsetTop': -100,
            'DisplayWatermark': false,
            'RoundedCorners': true,
            'CornerRadius': 496,
            'FontSizeOverride': null,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-rond-cake'
          }
        ],
        'LayoutTemplates': [
          {
            'LayoutTemplateId': 6,
            'Active': 1,
            'ImagePath': 'templates/template-6.svg',
            'ShapeId': 2,
            'Created': '04/20/2017 12:20:53',
            'LastModified': '11/22/2022 16:08:53',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Order': 2,
            'PermittedSides': 'center,top,right,bottom,left',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '{id: 1, accept: \'photo\', dimension: {w: 100, h: 100}}',
            'Title': 'Layout-01'
          },
          {
            'LayoutTemplateId': 11,
            'Active': 1,
            'ImagePath': 'templates/template-11.svg',
            'ShapeId': 2,
            'Created': '05/08/2017 09:55:15',
            'LastModified': '10/11/2022 10:01:18',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Order': 0,
            'PermittedSides': 'center,top',
            'Products': [],
            'ProductTypes': [],
            'TemplateXml': '',
            'Title': 'Layout-00'
          }
        ],
        'Stickers': [
          {
            'StickerId': 11,
            'Active': 1,
            'Order': 0,
            'Title': 'Ster',
            'ImagePath': 'stickers/sticker-11.png',
            'Size': '{Width=662, Height=630}',
            'LastModified': '10/11/2022 09:58:26',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:13:26',
            'ProductTypes': []
          },
          {
            'StickerId': 17,
            'Active': 1,
            'Order': 8,
            'Title': 'Oogjes',
            'ImagePath': 'stickers/sticker-17.png',
            'Size': '{Width=693, Height=332}',
            'LastModified': '10/11/2022 09:58:40',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:14:41',
            'ProductTypes': []
          },
          {
            'StickerId': 20,
            'Active': 1,
            'Order': 11,
            'Title': 'Beer',
            'ImagePath': 'stickers/sticker-20.png',
            'Size': '{Width=540, Height=754}',
            'LastModified': '10/11/2022 09:58:53',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:15:37',
            'ProductTypes': []
          },
          {
            'StickerId': 22,
            'Active': 1,
            'Order': 13,
            'Title': 'Hart roze',
            'ImagePath': 'stickers/sticker-22.png',
            'Size': '{Width=524, Height=729}',
            'LastModified': '10/11/2022 09:59:07',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:04',
            'ProductTypes': []
          },
          {
            'StickerId': 25,
            'Active': 1,
            'Order': 16,
            'Title': 'Hoera een meisje',
            'ImagePath': 'stickers/sticker-25.png',
            'Size': '{Width=508, Height=732}',
            'LastModified': '10/11/2022 09:59:22',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:16:39',
            'ProductTypes': []
          },
          {
            'StickerId': 32,
            'Active': 1,
            'Order': 23,
            'Title': 'Flamingo',
            'ImagePath': 'stickers/sticker-32.png',
            'Size': '{Width=368, Height=697}',
            'LastModified': '10/11/2022 09:59:38',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Categories': [],
            'Created': '05/09/2017 07:18:14',
            'ProductTypes': []
          },
          {
            'StickerId': 115,
            'Active': 1,
            'Order': 106,
            'Title': 'halloween-1',
            'ImagePath': 'stickers/sticker-115.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:04:52',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:04:52',
            'ProductTypes': []
          },
          {
            'StickerId': 116,
            'Active': 1,
            'Order': 107,
            'Title': 'halloween-2',
            'ImagePath': 'stickers/sticker-116.png',
            'Size': '{Width=1000, Height=1000}',
            'LastModified': '10/11/2022 14:35:01',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Categories': [],
            'Created': '10/11/2022 14:34:38',
            'ProductTypes': []
          }
        ]
      },
      {
        'ProductTypeId': 32,
        'Name': 'TestProductType',
        'Backgrounds': [],
        'Fonts': [],
        'Products': [],
        'LayoutTemplates': [],
        'Stickers': []
      }
    ],
    'Shapes': [
      {
        'ShapeId': 1,
        'Name': 'Square',
        'Products': [],
        'LayoutTemplates': []
      },
      {
        'ShapeId': 2,
        'Name': 'Rectangle',
        'Products': [
          {
            'ProductId': 6,
            'Title': '6333610',
            'Created': '05/05/2017 13:27:39',
            'LastModified': '06/04/2020 10:09:00',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 690,
            'OptimalHeight': 500,
            'MinimalWidth': 345,
            'MinimalHeight': 250,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-6.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-6.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': true,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 51,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          },
          {
            'ProductId': 7,
            'Title': '6333602',
            'Created': '05/16/2017 13:31:20',
            'LastModified': '08/19/2019 13:13:37',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Active': 1,
            'ProductTypeId': 5,
            'ShapeId': 2,
            'Width': 1636,
            'Height': 1099,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-maxi-party-cake',
            'BackgroundWidth': 2000,
            'BackgroundHeight': 1440,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-7.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-7.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-maxi-party-cake'
          },
          {
            'ProductId': 9,
            'Title': '6311019',
            'Created': '05/16/2017 14:17:12',
            'LastModified': '05/15/2020 15:30:34',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 7,
            'ShapeId': 2,
            'Width': 245,
            'Height': 206,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-mini-tompouce',
            'BackgroundWidth': 275,
            'BackgroundHeight': 236,
            'Bleed': 0,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': 726,
            'MultiCloneWidth': 1124,
            'IsMultiClone': true,
            'OptimalWidth': 137,
            'OptimalHeight': 118,
            'MinimalWidth': 69,
            'MinimalHeight': 59,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-9.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-9.png',
            'OverlayImagePath': 'products/overlays/product-9.png',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 30,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-mini-tompouce'
          },
          {
            'ProductId': 10,
            'Title': '6311018',
            'Created': '05/16/2017 14:18:24',
            'LastModified': '03/24/2020 11:36:36',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 8,
            'ShapeId': 2,
            'Width': 525,
            'Height': 206,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-tompouce',
            'BackgroundWidth': 566,
            'BackgroundHeight': 254,
            'Bleed': 0,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': 726,
            'MultiCloneWidth': 1122,
            'IsMultiClone': true,
            'OptimalWidth': 283,
            'OptimalHeight': 127,
            'MinimalWidth': 142,
            'MinimalHeight': 64,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': true,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-10.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-10.png',
            'OverlayImagePath': 'products/overlays/product-10.png',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-tompouce'
          },
          {
            'ProductId': 11,
            'Title': '6380005',
            'Created': '05/16/2017 14:20:22',
            'LastModified': '03/07/2018 09:31:22',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 9,
            'ShapeId': 2,
            'Width': 957,
            'Height': 662,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-choco-ipad',
            'BackgroundWidth': 1106,
            'BackgroundHeight': 814,
            'Bleed': 14,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 1,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-11.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-11.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-choco-ipad'
          },
          {
            'ProductId': 12,
            'Title': '6380004',
            'Created': '05/16/2017 14:21:37',
            'LastModified': '03/07/2018 09:33:54',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 10,
            'ShapeId': 2,
            'Width': 308,
            'Height': 544,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-choco-iphone',
            'BackgroundWidth': 332,
            'BackgroundHeight': 686,
            'Bleed': 10,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': true,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-12.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-12.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-choco-iphone'
          },
          {
            'ProductId': 13,
            'Title': '6380003',
            'Created': '05/16/2017 14:22:41',
            'LastModified': '03/07/2018 09:36:35',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 13,
            'ShapeId': 2,
            'Width': 957,
            'Height': 662,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-choco-fotolist',
            'BackgroundWidth': 1098,
            'BackgroundHeight': 808,
            'Bleed': 14,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 1,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-13.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-13.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-choco-fotolist'
          },
          {
            'ProductId': 14,
            'Title': '6333601',
            'Created': '05/16/2017 14:23:57',
            'LastModified': '08/19/2019 13:13:50',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Active': 1,
            'ProductTypeId': 11,
            'ShapeId': 2,
            'Width': 993,
            'Height': 762,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-choco-heart',
            'BackgroundWidth': 1108,
            'BackgroundHeight': 822,
            'Bleed': 14,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 1,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': true,
            'CakeMaskPathDefinition': 'M 992.6,182 992.6,180.4 992.5,179 992.2,175 991.3,169.1 991.1,167.6 990.5,164.4 989.9,160.9 988,153.5 988,153.5    986.8,148.8 986.6,148.1 986,146.1 983.3,139 980.6,131.6 980.3,131 979.9,129.7 977.2,123.8 974.5,118 974.1,117.3 973.7,116.4    972.4,114 971.4,112.1 970.6,110.9 969.8,109.4 965.6,101.9 961.3,94.9 957.5,89.4 953.6,84 951.3,81.2 948.6,77.7 943.9,72.3    939.3,67.2 935.8,64.1 929.2,57.8 921.9,51.2 916.5,47.3 913,44.5 912.7,44.3 911.5,43.4 906.1,39.4 900.3,35.9 900.3,35.9    899.1,35.2 898.7,34.9 894.9,32.4 889.1,29.3 880.6,24.6 871.7,20.3 867.3,18.6 866.7,18.4 858.5,14.8 850,12.1 847.2,11.2    844.2,10.2 841.9,9.5 841.5,9.4 840.7,9.2 834.6,7.4 825.3,5.5 823.4,5.1 823.4,5.1 823.4,5.1 815.7,3.5 808.8,2.7 804.4,2    799.4,1.5 796.3,1.2 786.3,0.4 785.1,0.4 775.5,0 766.2,0 761.6,0.2 756.5,0.4 756.1,0.4 748,0.8 739.1,1.6 730.3,2.7 721.8,4.3    720.5,4.6 717.9,5.1 708.6,7.4 704.6,8.6 703.2,9 702.1,9.3 699.4,10.2 689.7,13.3 688.3,13.8 683.9,15.2 676.6,18.3 671.5,20.3    669.3,21.3 665,23 662.6,24.2 653.8,28.5 644.9,33.2 636.4,38.3 632.9,40.6 632.9,40.6 628.3,43.7 619.4,50 610.5,56.2 602.4,63.3    602.3,63.4 598.1,66.8 589.1,75.6 586.5,78.1 578.8,85.9 571.8,94.1 564.9,102.3 558.3,110.9 552.1,119.9 550.9,122 549,124.6    539.4,141 530.9,158.2 524.3,173 522.5,177.6 521.2,180.4 519.7,184.4 518.1,188.3 512.3,203.5 506.5,218.7 505.3,222.5    503.8,226.5 496.5,250 489.2,226.5 487.7,222.4 486.5,218.7 480.7,203.5 474.9,188.3 473.3,184.4 471.8,180.4 470.5,177.6    468.7,173 462.1,158.2 453.6,141 444,124.6 442.1,122 440.9,119.9 434.7,110.9 428.1,102.3 421.2,94.1 414.2,85.9 408.4,80.1    408.4,80.1 408.4,80.1 406.5,78.1 403.9,75.6 394.9,66.8 390.7,63.4 390.6,63.3 382.5,56.2 373.6,50 364.7,43.7 360.1,40.6    360.1,40.6 356.6,38.3 348.1,33.2 339.2,28.5 330.4,24.2 330.4,24.2 328,23 323.7,21.3 321.5,20.3 316.4,18.3 309.1,15.2    304.7,13.8 303.3,13.3 293.6,10.2 290.9,9.4 289.8,9 288.4,8.6 284.4,7.4 275.1,5.1 272.5,4.6 271.2,4.3 262.7,2.7 253.9,1.6    245,0.8 236.9,0.4 236.5,0.4 231.4,0.2 226.8,0 217.5,0 207.9,0.4 206.7,0.4 196.7,1.2 193.6,1.5 188.6,2 184.2,2.7 177.3,3.5    167.7,5.5 158.4,7.4 152.3,9.2 151.5,9.4 151.1,9.5 148.8,10.2 145.8,11.2 143,12.1 134.5,14.8 126.3,18.4 125.7,18.6 121.3,20.3    112.4,24.6 103.9,29.3 98.1,32.4 94.3,34.9 93.9,35.2 92.7,35.9 92.7,35.9 86.9,39.4 81.5,43.4 80.3,44.3 80,44.5 76.5,47.3    71.1,51.2 63.8,57.8 57.2,64.1 53.7,67.2 49.1,72.3 44.4,77.7 41.7,81.2 39.4,84 35.5,89.4 31.7,94.9 27.4,101.9 23.2,109.4    22.4,110.9 21.6,112.1 20.6,114 19.3,116.4 18.9,117.3 18.5,118 15.8,123.8 13.1,129.7 12.7,131 12.4,131.6 9.7,139 7,146.1    6.4,148.1 6.2,148.8 5,153.5 5,153.5 3.1,160.9 2.5,164.4 1.9,167.6 1.7,169.1 0.8,175 0.5,179 0.4,180.4 0.4,182 0,189.4 0,193.3    0,196.8 0,200 0.4,207 0.8,217.2 1.1,220.2 1.2,221.1 1.9,229.7 3.1,238.2 4.6,246.4 7,256.2 9.3,266 11.2,272.6 11.6,274.2    12,275.4 12,275.4 15.1,285.1 17.6,291.5 17.8,292.1 20.9,301.1 24,308.2 24.3,308.9 24.3,308.9 24.3,308.9 27.4,315.2 28.6,317.2    30.1,320.7 35.2,329.6 39.4,337.1 42.2,341.9 47.9,351.9 56,365.6 64.5,379.2 73,392.5 81.9,405.4 86.7,412 92,419.5 100.2,430.3    105.1,437 111.6,445 112.1,445.6 112.7,446.4 117.5,452.3 130.2,467.5 134.6,472.5 144.5,483.9 155.7,496.4 167.3,508.5 181.6,523    195.9,537.4 195.9,537.4 197.8,539.4 212.1,553 226.4,566.3 241.1,579.6 255.8,592.9 270.5,605.8 285.5,618.3 300.6,630.8    316.1,643.3 323.8,649.3 328.4,653 347,667.5 362.8,679.2 368.2,683.1 372.5,686.2 373.9,687.2 379,690.9 395.3,701.9 396.3,702.5    398.7,704.2 411.1,712.4 415.7,715.1 416.9,715.9 426.9,721.9 437,728 450.1,735.8 456.4,739.5 462.1,742.9 470.6,747.9    479.1,752.6 480.2,753.2 482.6,754.6 491.7,759.4 496.5,762 501.3,759.4 510.4,754.6 512.8,753.2 513.9,752.6 522.4,747.9    530.9,742.9 536.6,739.5 542.9,735.8 556,728 566.1,721.9 576.1,715.9 577.3,715.1 581.9,712.4 594.3,704.2 596.7,702.5    597.7,701.9 614,690.9 619.1,687.2 620.5,686.2 624.8,683.1 630.2,679.2 646,667.5 664.6,653 669.2,649.3 676.9,643.3 692.4,630.8    707.5,618.3 722.5,605.8 737.2,592.9 751.9,579.6 766.6,566.3 780.9,553 795.2,539.4 797.1,537.4 797.1,537.4 811.4,523    825.7,508.5 837.3,496.4 848.5,483.9 858.4,472.5 862.8,467.5 875.5,452.3 880.3,446.4 880.9,445.6 881.4,445 887.9,437    892.8,430.3 901,419.5 906.3,412 911.1,405.4 920,392.5 928.5,379.2 937,365.6 945.1,351.9 950.8,341.9 953.6,337.1 957.8,329.6    962.9,320.7 964.4,317.2 965.6,315.2 968.7,308.9 968.7,308.9 968.7,308.9 969,308.2 972.1,301.1 975.2,292.1 975.4,291.5    977.9,285.1 981,275.4 981,275.4 981.4,274.2 981.8,272.6 983.7,266 986,256.2 988.4,246.4 989.9,238.2 991.1,229.7 991.8,221.1    991.9,220.2 992.2,217.2 992.6,207 993,200 993,196.8 993,193.3 993,189.4  Z',
            'BleedMaskPathDefinition': 'M 494.2,733.6 491.8,732.2 490.5,731.5 482.6,727.1 468.4,718.7 462.3,715.1 449.4,707.5 439.2,701.2 429.6,695.5   428.3,694.7 423.9,692.1 412.2,684.3 409.6,682.5 408.5,681.8 392.8,671.2 387.7,667.6 386.4,666.7 382.3,663.6 377,659.8   361.5,648.4 343.3,634.2 338.6,630.4 331,624.5 315.8,612.2 286,587.5 271.8,575 242.6,548.6 228.6,535.6 214.7,522.3 184.5,491.8   173.3,480.1 162.5,468 152.6,456.5 148.4,451.9 136,437 131.2,431.1 130.7,430.5 130.4,430.1 124.1,422.4 119.3,415.9 111.4,405.4   106.3,398 101.5,391.5 93,379.2 84.8,366.4 76.5,353.1 68.7,339.9 63,329.9 60.2,325 56,317.8 51.5,309.8 50,306.4 48.7,304.1   45.7,298 43.2,292.4 40.4,284 40,283.1 37.7,277.2 34.8,267.8 34.6,267.4 34.3,266.3 32.5,259.9 28.1,241.5 26.8,234.4 25.8,227   25.1,219.4 25.1,218.3 24.7,215.3 24.4,205.9 24,199.3 24,190.1 24.4,182.6 24.4,181.8 24.5,181.1 24.7,177.6 25.5,172.5   25.7,171.2 26.2,168.6 26.6,165.9 28.4,159 28.4,158.9 29.2,155.7 29.4,155.1 29.8,153.4 32.1,147.5 34.6,140.6 34.9,140   35.3,138.9 40.1,128.6 40.4,128 40.7,127.3 41.8,125.2 42.6,123.8 43.2,122.7 44.1,121.1 48.1,114.1 51.8,108.1 58.4,98.6   60.4,96.3 63.1,92.9 67.1,88.1 70.6,84.3 73.4,81.7 80.1,75.4 86.2,69.8 90.9,66.4 94.1,63.9 94.4,63.8 95.9,62.6 100.2,59.5   105.7,56.2 106.6,55.5 106.8,55.4 110.4,53.1 115.5,50.3 123.5,45.9 130.8,42.4 135,40.8 136.1,40.3 142.9,37.3 153.5,33.9 156,33   158,32.5 158.2,32.4 158.8,32.3 164.2,30.7 172.5,29 181.2,27.2 187.7,26.4 191.5,25.8 196,25.4 199,25.1 207.6,24.4 208.4,24.4   218,24 226.3,24 230.4,24.2 235,24.4 235.4,24.4 243.4,24.7 251.2,25.4 259,26.4 266.4,27.8 267.5,28.1 269.9,28.5 278,30.6   281.8,31.7 282.9,32 283.8,32.3 286.6,33.1 295.4,35.9 296.8,36.5 300.7,37.7 307.3,40.5 312.2,42.5 314.4,43.4 318.1,44.9   319.7,45.7 328.4,49.9 336.4,54.1 343.8,58.5 351.1,63.5 367.7,75.2 374.7,81.2 375,81.5 378.8,84.6 387.3,92.9 389.6,95.2   396.5,102.2 409.4,117.4 415.2,125 420.8,133 422.1,135.1 423.7,137.5 432.5,152.4 440.4,168.4 446.6,182.4 448.4,186.9   449.6,189.5 451,193.2 452.5,197 463.8,226.7 465,230.3 466.4,234.3 496.5,330.2 526.6,234.3 528,230.3 529.2,226.7 540.5,197   542,193.2 543.4,189.5 544.6,186.9 546.4,182.4 552.6,168.4 560.5,152.4 569.3,137.5 570.9,135.1 572.2,133 577.8,125 583.6,117.4   596.5,102.1 603.4,95.2 605.9,92.8 614.2,84.6 618,81.5 618.3,81.2 625.3,75.2 641.9,63.5 649.2,58.5 656.6,54.1 664.6,49.9   673.3,45.7 674.9,44.9 678.6,43.4 680.8,42.5 685.7,40.5 692.3,37.8 696.2,36.5 697.6,35.9 706.4,33.1 709.2,32.3 710.1,32   711.2,31.7 715,30.6 723.1,28.5 725.5,28.1 726.6,27.8 734,26.4 741.8,25.4 749.6,24.7 757.6,24.4 758,24.4 762.5,24.2 766.7,24   775,24 784.6,24.4 785.4,24.4 794,25.1 797,25.4 801.5,25.8 805.3,26.4 811.8,27.2 820.5,29 828.8,30.7 834.4,32.3 834.8,32.4   835,32.5 837,33 839.5,33.9 850.1,37.3 856.9,40.3 858,40.8 862.2,42.4 869.5,45.9 877.7,50.4 882.6,53.1 886.2,55.4 886.4,55.5   887.3,56.2 892.8,59.5 897.1,62.6 898.7,63.8 898.9,63.9 902,66.4 906.8,69.9 912.9,75.4 919.6,81.7 922.4,84.3 925.9,88.1   929.9,92.9 932.6,96.3 934.6,98.6 941.2,108.1 944.9,114.1 948.9,121.1 949.8,122.7 950.4,123.8 951.4,125.6 952.3,127.3 952.6,128   952.9,128.6 957.7,138.9 958.1,140 958.4,140.6 960.9,147.7 963.2,153.4 963.6,155.1 963.8,155.7 964.8,159.5 966.4,165.9   966.8,168.6 967.3,171.2 967.5,172.5 968.3,177.6 968.5,181.1 968.6,181.8 968.6,182.6 969,190.1 969,199.3 968.6,205.9   968.3,215.3 967.9,218.3 967.9,219.4 967.2,227 966.2,234.4 964.9,241.5 960.5,259.9 958.7,266.3 958.4,267.4 958.1,268.1   955.3,277.2 953,283.1 952.5,284.3 949.8,292.4 947.3,298 944.3,304.1 943,306.4 941.5,309.8 937,317.8 932.8,325 929.9,330.1   924.3,339.9 916.5,353.1 908.2,366.4 900,379.2 891.5,391.5 886.7,398 881.6,405.4 873.5,416.2 868.9,422.4 862.6,430.1   862.3,430.5 861.7,431.2 857,437 844.6,451.9 840.3,456.7 830.5,468 819.7,480.1 808.5,491.8 778.3,522.3 764.4,535.6 750.4,548.6   721.3,575 707,587.5 677.2,612.2 662,624.5 654.2,630.6 649.7,634.2 631.5,648.4 616,659.8 610.6,663.8 606.6,666.7 605.3,667.6   600.2,671.2 584.5,681.8 583.4,682.5 580.8,684.3 569.1,692.1 564.7,694.7 563.4,695.5 553.5,701.4 543.6,707.5 530.7,715.1   524.3,718.9 510.4,727.1 502.5,731.5 501.2,732.2 498.8,733.6 496.5,734.8 Z',
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-14.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-14.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': true,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-choco-heart'
          },
          {
            'ProductId': 15,
            'Title': '6380002',
            'Created': '05/16/2017 14:25:19',
            'LastModified': '07/17/2019 10:29:39',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 12,
            'ShapeId': 2,
            'Width': 331,
            'Height': 331,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-choco-lolly',
            'BackgroundWidth': 396,
            'BackgroundHeight': 396,
            'Bleed': 12,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': 1034,
            'MultiCloneWidth': 739,
            'IsMultiClone': true,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': '{\'Cloning\':{\'Items\':[{\'Left\':0,\'Top\':142,\'Rotation\':-75},{\'Left\':408,\'Top\':0,\'Rotation\':105},{\'Left\':0,\'Top\':703,\'Rotation\':-75},{\'Left\':408,\'Top\':561,\'Rotation\':105}]},\'Masking\':{\'PredefinedShape\':1},\'IsLollyCake\':true}',
            'ImagePath': 'products/product-15.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-15.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': true,
            'CornerRadius': 165,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-choco-lolly'
          },
          {
            'ProductId': 19,
            'Title': '6333625',
            'Created': '06/16/2017 12:38:18',
            'LastModified': '09/23/2020 14:28:21',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 17,
            'ShapeId': 2,
            'Width': 1063,
            'Height': 1063,
            'DefaultLayoutId': 6,
            'BackgroundClassName': '3d-cake',
            'BackgroundWidth': 1063,
            'BackgroundHeight': 1063,
            'Bleed': 8,
            'DefaultFontId': 13,
            'SideBleedTop': 43,
            'SideBleedRight': 49,
            'SideBleedBottom': 67,
            'SideBleedLeft': 49,
            'SideWidth': 1063,
            'SideHeight': 325,
            'IsMultiDimension': true,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-19.jpg',
            'BackgroundImagePath': 'products/backgrounds/product-19.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': '3d-cake'
          },
          {
            'ProductId': 20,
            'Title': '6311027',
            'Created': '07/21/2017 14:15:20',
            'LastModified': '10/25/2017 10:59:50',
            'LastModifiedBy': 'HEMALOCAL\\molenkampm',
            'Active': 1,
            'ProductTypeId': 7,
            'ShapeId': 2,
            'Width': 245,
            'Height': 206,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-mini-tompouce',
            'BackgroundWidth': 275,
            'BackgroundHeight': 236,
            'Bleed': 0,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': 726,
            'MultiCloneWidth': 1124,
            'IsMultiClone': true,
            'OptimalWidth': 137,
            'OptimalHeight': 118,
            'MinimalWidth': 69,
            'MinimalHeight': 59,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': true,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-20.PNG',
            'BackgroundImagePath': 'products/backgrounds/product-20.png',
            'OverlayImagePath': 'products/overlays/product-20.png',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-mini-tompouce'
          },
          {
            'ProductId': 21,
            'Title': '6333600',
            'Created': '07/21/2017 14:18:53',
            'LastModified': '03/25/2022 16:28:33',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 19,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 30,
            'OptimalHeight': 30,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-21.png',
            'BackgroundImagePath': 'products/backgrounds/product-21.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': 'products/logo_overlays/product-21-20220325162832933.png',
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': true,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          },
          {
            'ProductId': 22,
            'Title': '6333604',
            'Created': '07/21/2017 14:20:54',
            'LastModified': '03/07/2018 09:19:50',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-22.png',
            'BackgroundImagePath': 'products/backgrounds/product-22.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          },
          {
            'ProductId': 23,
            'Title': '6333614',
            'Created': '07/21/2017 14:22:13',
            'LastModified': '03/07/2018 09:22:03',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-23.png',
            'BackgroundImagePath': 'products/backgrounds/product-23.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          },
          {
            'ProductId': 24,
            'Title': '6333605',
            'Created': '07/21/2017 14:24:13',
            'LastModified': '04/04/2022 16:22:21',
            'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
            'Active': 1,
            'ProductTypeId': 5,
            'ShapeId': 2,
            'Width': 1636,
            'Height': 1099,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-maxi-party-cake',
            'BackgroundWidth': 2000,
            'BackgroundHeight': 1440,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-24.png',
            'BackgroundImagePath': 'products/backgrounds/product-24.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-maxi-party-cake'
          },
          {
            'ProductId': 25,
            'Title': '6333615',
            'Created': '07/21/2017 14:26:09',
            'LastModified': '08/06/2020 11:53:15',
            'LastModifiedBy': 'ad-acc\\emmhijdra',
            'Active': 1,
            'ProductTypeId': 5,
            'ShapeId': 2,
            'Width': 1636,
            'Height': 1099,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-maxi-party-cake',
            'BackgroundWidth': 2000,
            'BackgroundHeight': 1440,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-25.png',
            'BackgroundImagePath': 'products/backgrounds/product-25.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': true,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-maxi-party-cake'
          },
          {
            'ProductId': 26,
            'Title': '6333626',
            'Created': '07/21/2017 14:29:47',
            'LastModified': '03/07/2018 14:20:51',
            'LastModifiedBy': 'EDITOR02\\editoruser',
            'Active': 1,
            'ProductTypeId': 17,
            'ShapeId': 2,
            'Width': 1063,
            'Height': 1063,
            'DefaultLayoutId': 11,
            'BackgroundClassName': '3d-cake',
            'BackgroundWidth': 1063,
            'BackgroundHeight': 1063,
            'Bleed': 8,
            'DefaultFontId': 13,
            'SideBleedTop': 43,
            'SideBleedRight': 49,
            'SideBleedBottom': 67,
            'SideBleedLeft': 49,
            'SideWidth': 1063,
            'SideHeight': 325,
            'IsMultiDimension': true,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-26.png',
            'BackgroundImagePath': 'products/backgrounds/product-26.png',
            'OverlayImagePath': '',
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': '3d-cake'
          },
          {
            'ProductId': 33,
            'Title': '17326401',
            'Created': '11/20/2018 14:30:15',
            'LastModified': '09/05/2019 16:27:55',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 23,
            'ShapeId': 2,
            'Width': 921,
            'Height': 1276,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'wine-label-red',
            'BackgroundWidth': 1038,
            'BackgroundHeight': 4144,
            'Bleed': 0,
            'DefaultFontId': 13,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 921,
            'OptimalHeight': 1276,
            'MinimalWidth': 307,
            'MinimalHeight': 425,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-33.png',
            'BackgroundImagePath': 'products/backgrounds/product-33.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': null,
            'WatermarkOffsetTop': null,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'wine-label-red'
          },
          {
            'ProductId': 34,
            'Title': '17327401',
            'Created': '11/20/2018 14:32:31',
            'LastModified': '04/02/2019 11:44:50',
            'LastModifiedBy': 'ad-acc\\asja.de.kruif',
            'Active': 1,
            'ProductTypeId': 24,
            'ShapeId': 2,
            'Width': 921,
            'Height': 1276,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'wine-label-white',
            'BackgroundWidth': 1038,
            'BackgroundHeight': 4144,
            'Bleed': 0,
            'DefaultFontId': 13,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 921,
            'OptimalHeight': 1276,
            'MinimalWidth': 307,
            'MinimalHeight': 425,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-34.png',
            'BackgroundImagePath': 'products/backgrounds/product-34.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': null,
            'WatermarkOffsetTop': null,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'wine-label-white'
          },
          {
            'ProductId': 35,
            'Title': '17329401',
            'Created': '11/20/2018 14:34:24',
            'LastModified': '01/04/2023 10:01:23',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 22,
            'ShapeId': 2,
            'Width': 921,
            'Height': 1276,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'wine-label-champagne',
            'BackgroundWidth': 1120,
            'BackgroundHeight': 4206,
            'Bleed': 0,
            'DefaultFontId': 13,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 921,
            'OptimalHeight': 1276,
            'MinimalWidth': 307,
            'MinimalHeight': 425,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-35.png',
            'BackgroundImagePath': 'products/backgrounds/product-35.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': null,
            'WatermarkOffsetTop': null,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 0,
            'LayoutTemplates': [],
            'Backgroundclassname': 'wine-label-champagne'
          },
          {
            'ProductId': 37,
            'Title': '6333635',
            'Created': '06/07/2019 14:20:51',
            'LastModified': '08/28/2023 11:48:00',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Active': 1,
            'ProductTypeId': 6,
            'ShapeId': 2,
            'Width': 1033,
            'Height': 1010,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-heart-cake',
            'BackgroundWidth': 1080,
            'BackgroundHeight': 1060,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 540,
            'OptimalHeight': 530,
            'MinimalWidth': 270,
            'MinimalHeight': 265,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': true,
            'CakeMaskPathDefinition': 'M2.9,307.7L2.9,307.7c0.1,0,0.2,0.1,0.2,0.2c44.3,298.1,230.8,559,498.6,697.6l0.2,0.1c9.1,4.7,20,4.8,29.1,0.2  c0-0.1,0-0.2,0.1-0.2C798.9,867,985.3,606.2,1029.8,308c0,0,0-0.1,0.1-0.1l0.2-0.2c15-100.9-29.6-203.3-113.7-260.9  c-84-57.6-195.6-62.4-284.1-12.2c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.2c-35.1,19.9-75,30.5-115.4,30.5l0,0  c-40.4,0-80.3-10.6-115.4-30.5h-0.1l0,0c-88.7-50.3-200.2-45.6-284.5,12S-12.1,206.7,2.9,307.7z',
            'BleedMaskPathDefinition': 'M516.5,946.6C272.2,815.2,102.6,574.6,61.6,300c-0.2-1.6-0.5-3.3-0.9-4.9c-10-77.5,24.8-155.5,89.4-199.6  c34.9-23.8,76-36.4,118.8-36.4c36.4,0,72.1,9.3,103.3,27l13.5,7.7h1c40.4,20,85,30.5,130,30.5c50.5,0,100.5-13.2,144.5-38.2l7-4  l0.1-0.1C697.8,67,730.8,59,764.4,59c42.9,0,83.9,12.6,118.7,36.4c64.3,44.1,99.1,121.7,89.3,199c-0.4,1.8-0.8,3.7-1,5.6  C930.1,574.6,760.6,815.3,516.5,946.6z',
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-8.png',
            'BackgroundImagePath': 'products/backgrounds/product-8.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': null,
            'WatermarkOffsetTop': null,
            'DisplayWatermark': false,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': 50,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-heart-cake'
          },
          {
            'ProductId': 38,
            'Title': '6330054',
            'Created': '12/14/2020 13:54:23',
            'LastModified': '12/17/2020 16:40:57',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 25,
            'ShapeId': 2,
            'Width': 319,
            'Height': 319,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-cupcake',
            'BackgroundWidth': 452,
            'BackgroundHeight': 430,
            'Bleed': 24,
            'DefaultFontId': 13,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': 1053,
            'MultiCloneWidth': 1396,
            'IsMultiClone': true,
            'OptimalWidth': 319,
            'OptimalHeight': 319,
            'MinimalWidth': 69,
            'MinimalHeight': 69,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': '{\'Cloning\':{\'Items\':[{\'Left\':24,\'Top\':24},{\'Left\':24,\'Top\':367},{\'Left\':24,\'Top\':710},{\'Left\':367,\'Top\':24},{\'Left\':367,\'Top\':367},{\'Left\':367,\'Top\':710}]}}',
            'ImagePath': 'products/product-38.png',
            'BackgroundImagePath': 'products/backgrounds/product-38.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': false,
            'WatermarkImagePath': null,
            'WatermarkOffsetLeft': null,
            'WatermarkOffsetTop': null,
            'DisplayWatermark': false,
            'RoundedCorners': true,
            'CornerRadius': 160,
            'FontSizeOverride': null,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-cupcake'
          },
          {
            'ProductId': 39,
            'Title': '10270050',
            'Created': '08/23/2021 16:39:13',
            'LastModified': '01/18/2022 11:12:41',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 0,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 690,
            'OptimalHeight': 500,
            'MinimalWidth': 345,
            'MinimalHeight': 250,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-39.png',
            'BackgroundImagePath': 'products/backgrounds/product-39.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': true,
            'WatermarkImagePath': 'products/logo_overlays/product-39-20210906150925362.png',
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': true,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': null,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          },
          {
            'ProductId': 40,
            'Title': '10270051',
            'Created': '09/01/2021 11:50:32',
            'LastModified': '09/06/2021 15:09:02',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'hema-giftcard',
            'BackgroundWidth': 1128,
            'BackgroundHeight': 739,
            'Bleed': 0,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': null,
            'OptimalHeight': null,
            'MinimalWidth': null,
            'MinimalHeight': null,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': false,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-40.png',
            'BackgroundImagePath': 'products/backgrounds/product-40.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': true,
            'WatermarkImagePath': 'products/logo_overlays/product-40-20210906150902464.png',
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': true,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': null,
            'LayoutTemplates': [],
            'Backgroundclassname': 'hema-giftcard'
          },
          {
            'ProductId': 41,
            'Title': '6330067',
            'Created': '07/21/2022 10:20:15',
            'LastModified': '07/21/2022 10:20:15',
            'LastModifiedBy': 'ad-acc\\emsgak',
            'Active': 1,
            'ProductTypeId': 4,
            'ShapeId': 2,
            'Width': 1128,
            'Height': 739,
            'DefaultLayoutId': 11,
            'BackgroundClassName': 'cake-party-cake',
            'BackgroundWidth': 1380,
            'BackgroundHeight': 1002,
            'Bleed': 49,
            'DefaultFontId': 24,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 690,
            'OptimalHeight': 500,
            'MinimalWidth': 345,
            'MinimalHeight': 250,
            'SectionPadding': 10,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': false,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-41.png',
            'BackgroundImagePath': 'products/backgrounds/product-41.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': false,
            'EnableEnhancement': true,
            'WatermarkImagePath': 'products/logo_overlays/product-41-20220721102016324.png',
            'WatermarkOffsetLeft': 0,
            'WatermarkOffsetTop': 0,
            'DisplayWatermark': true,
            'RoundedCorners': false,
            'CornerRadius': 0,
            'FontSizeOverride': null,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-party-cake'
          },
          {
            'ProductId': 43,
            'Title': '6355261',
            'Created': '10/11/2022 14:10:59',
            'LastModified': '02/20/2023 08:58:11',
            'LastModifiedBy': 'ad-acc\\jules.pasteuning',
            'Active': 1,
            'ProductTypeId': 26,
            'ShapeId': 2,
            'Width': 992,
            'Height': 992,
            'DefaultLayoutId': 6,
            'BackgroundClassName': 'cake-rond-cake',
            'BackgroundWidth': 1152,
            'BackgroundHeight': 1152,
            'Bleed': 40,
            'DefaultFontId': 13,
            'SideBleedTop': null,
            'SideBleedRight': null,
            'SideBleedBottom': null,
            'SideBleedLeft': null,
            'SideWidth': null,
            'SideHeight': null,
            'IsMultiDimension': false,
            'MultiCloneHeight': null,
            'MultiCloneWidth': null,
            'IsMultiClone': false,
            'OptimalWidth': 992,
            'OptimalHeight': 992,
            'MinimalWidth': 300,
            'MinimalHeight': 300,
            'SectionPadding': 0,
            'Rotation': 0,
            'HasOutline': true,
            'GenerateBiggerPreviewImage': false,
            'IsMaskedCake': false,
            'CakeMaskPathDefinition': null,
            'BleedMaskPathDefinition': null,
            'IsPreviewImageOnTop': true,
            'ImageGenerationData': null,
            'ImagePath': 'products/product-43.png',
            'BackgroundImagePath': 'products/backgrounds/product-43.png',
            'OverlayImagePath': null,
            'ShowClipPathWarning': true,
            'EnableEnhancement': false,
            'WatermarkImagePath': 'products/logo_overlays/product-43-20221118171623349.png',
            'WatermarkOffsetLeft': -75,
            'WatermarkOffsetTop': -100,
            'DisplayWatermark': false,
            'RoundedCorners': true,
            'CornerRadius': 496,
            'FontSizeOverride': null,
            'LayoutTemplates': [],
            'Backgroundclassname': 'cake-rond-cake'
          }
        ],
        'LayoutTemplates': []
      },
      {
        'ShapeId': 3,
        'Name': 'TestShape',
        'Products': [],
        'LayoutTemplates': []
      }
    ]
  };
}